{
    "crowdinImportTest": {
        "newKey": "Crowdin import test",
        "identicalToSource": "Crowdin import test identical"
    },
    "analysisCodes": {
        "AG-1010": "This employee has an unexpectedly low salary compared to the remaining group regarding the group's age profile. This should be explained.",
        "AG-1020": "This employee has an unexpectedly low salary compared to the remaining group in terms of the group's age profile. This should be explained.",
        "AG-1030": "This employee has an unexpectedly low salary compared to the remaining group regarding the group's age profile. This should be explained.",
        "AG-2010": "This employee has an unexpectedly high salary compared to the remaining group in terms of the group's age profile. This should be explained.",
        "AG-2020": "This employee has an unexpectedly high salary compared to the remaining group in terms of the group's age profile. This should be explained.",
        "AG-2030": "This employee has an unexpectedly high salary compared to the remaining group in terms of the group's age profile. This should be explained.",
        "CG-0000": "An employee has moved from another group. Please verify so the employee has the right salary for the group.",
        "CO-1000": "This employee has a salary that is lower than the defined acceptable limit. This should be explained",
        "CO-2000": "This employee has a salary that is higher than the defined acceptable limit. This should be explained.",
        "CT-0000": "This employee has been selected for salary increase by the cost to close feature.",
        "ET-1010": "This employee has an unexpectedly low salary compared to the remaining group regarding the average employment length. This should be explained.",
        "ET-1020": "This employee has an unexpectedly low salary compared to the remaining group regarding the average employment length. This should be explained.",
        "ET-1030": "This employee has an unexpectedly low salary compared to the remaining group regarding the average employment length. This should be explained.",
        "ET-2010": "This employee has an unexpectedly high salary compared to the remaining group regarding the average employment length. This should be explained.",
        "ET-2020": "This employee has an unexpectedly high salary compared to the remaining group regarding the average employment length. This should be explained.",
        "ET-2030": "This employee has an unexpectedly high salary to the remaining group regarding the average employment length. This should be explained.",
        "JG-0010": "Analyze all salaries for women in this group",
        "JG-0020": "Analyze all salaries for men in this group",
        "MH-0000": "This employee lies far from the group's mean calculated by Mahalanobis distance. This should be explained.",
        "NR-0000": "This employee doesn't need to be analyzed",
        "OO-0000": "Other reason.",
        "OU-1000": "This employee has a salary in the group's lower range. This should be explained",
        "OU-2000": "This employee has a salary in the group's higher range. This should be explained.",
        "WG-1010": "This employee's salary is unexpectedly low compared to the remaining group's total salary profile. This should be explained.",
        "WG-1020": "This employee's salary is unexpectedly low compared to the remaining group's total salary profile. This should be explained.",
        "WG-1030": "This employee's salary is unexpectedly low compared to the remaining group's total salary profile. This should be explained.",
        "WG-2010": "This employee's salary is unexpectedly high compared to the remaining group's total salary profile. This should be explained.",
        "WG-2020": "This employee's salary is unexpectedly high compared to the remaining group's total salary profile. This should be explained.",
        "WG-2030": "This employee's salary is unexpectedly high compared to the remaining group's total salary profile. This should be explained."
    },
    "test": {
        "newNestedKey": "New nested key"
    },
    "bankIdStatus": {
        "2": "BankID login could not be completed.",
        "4": "An error occurred when logging in.",
        "5": "The BankID app is not responding. Please check that the program has started and your internet connection is working. You can get one from your bank if you don’t have a valid BankID.",
        "6": "The BankID you are trying to use is revoked.",
        "7": "Action cancelled.",
        "8": "Action cancelled."
    },
    "betaFlags": {
        "additionalSalaryBenefits": "Additional salary benefits",
        "adjustedSalaryModelMigration": "Adjusted salary model migration",
        "aiReport": "AI Report",
        "analyzeEqualJobs": "Analyze - Equal jobs",
        "analyzeEqualJobsDescription": "In this revamped equal job analysis you’ll be able to try out the brand-new predicted salary analysis. It uses the power of regression analysis to simply and efficiently allow you to analyze more thoroughly but with less effort.",
        "apiKeyManagement": "API key management",
        "automatedAnalsysis": "Automated analysis",
        "costToFix": "Cost to close",
        "costToFixDescription": "The cost to close functionality attempts to reduce the adjusted pay gap in your organisation to the tolerated pay gap by applying salary increases to employees found to be underpaid when your selected pay factors are taken into consideration.",
        "costToFixV2": "Cost to close V2",
        "employeeTransparencyReportCountryOverview": "Employee Transparency Report export from Country Overview",
        "employmentInsights": "Employment insights",
        "featureAvailable": "There is a new labs feature for this module 🧪 Go to labs to activate it.",
        "friends": "Friends",
        "gdpr": "GDPR",
        "involveBaseSalary": "Base salary sections in the employee dashboard",
        "modelInsights": "Model Insights",
        "normalisationOfSalaries": "Normalisation of Salaries",
        "partner": "Partner platform",
        "payGapMigration": "Pay gap migration",
        "payManagementMigration": "Pay Management Migration",
        "payPhilosophy": "Pay Philosophy",
        "payPhilosophyDescription": "The updated pay philosophy page now breaks down your regression analysis in plain language. It shows which pay factors are accounted for, how much each one contributes, and what remains unexplained after those factors are removed. The unexplained portion is what drives your adjusted pay gap, so you can see the reasoning behind the number rather than the result alone.",
        "scim": "SCIM",
        "scimDescription": "Automate user and role provisioning in Sysarb via SCIM. Connect your Identity Provider (e.g. Microsoft Entra, Okta, or Google Workspace) as the single source of truth — changes are automatically reflected in Sysarb without manual intervention.",
        "sectionManagerV2Dashboard": "Section Manager V2 dashboard",
        "agentChat": "Operator (AI assistant)",
        "sftpIntegrationV2": "SFTP integration V2",
        "statutoryGrade": "Statutory grade and occupational classification",
        "statutoryGradeInvolve": "Statutory grade section in Involve settings",
        "yourActiveFlagsInModule": "Your active functions in this module"
    },
    "budgetOutComeTypes": [
        "Salary increase budget",
        "Salary priority",
        "Individual guarantee"
    ],
    "charts": {
        "boxplot": {
            "10Percentile": "10th percentile",
            "20Percentile": "20th percentile",
            "25Percentile": "25th percentile",
            "40Percentile": "40th percentile",
            "60Percentile": "60th percentile",
            "75Percentile": "75th percentile",
            "80Percentile": "80th percentile",
            "90Percentile": "90th percentile",
            "amount": "Amount",
            "max": "Max",
            "mean": "Mean",
            "median": "Median",
            "min": "Min",
            "q1": "Q1"
        },
        "groups": "Groups",
        "noData": "No data",
        "status": "Status:"
    },
    "component": {
        "adjustedPayGapChart": {
            "adjustedPayGap": "Adjusted pay gap",
            "fiveToTenPercent": "5-10%",
            "payFactorsDifferences": "Many employees could not be included in the calculation of your adjusted pay gap because data was missing for one or more of the selected pay factors.",
            "share": "Share",
            "unadjustedPayGap": "Unadjusted pay gap",
            "unexplained": "Unexplained"
        },
        "checkList": {
            "match": "Match",
            "noMatch": "Does not match"
        },
        "involveSettings": {
            "averagePayGapsTotalSalaryDescription": "Total salary is the sum of your base salary and variable pay. The mean salary is 47,000 SEK/month for women and 49,500 SEK/month for men. This results in a 5.1% mean pay gap. For median salaries the pay gap is 4.0%.",
            "averagePayGapsTotalSalaryTitle": "Total salary in average pay levels and pay gaps",
            "averagePayGapsVariablePayDescription": "Variable pay includes all compensation and benefits provided by your employer. The variable pay gap between men and women is 38%. Of all women in your organisation, 71.2% of them receives variable pay while 97.3% of men do. The mean variable pay is 4,000 SEK for women and 6,500 SEK for men.",
            "averagePayGapsVariablePayTitle": "Variable pay in average pay levels and pay gaps",
            "badgeArticle9": "Article 9",
            "careerSectionDescription": "In your latest salary review you had a 4% salary increase. Your average increase the last few years is 2.4% per year. ",
            "careerSectionTitle": "Your career",
            "errorState": "There was an error getting the settings. Please try again by refreshing the page. If that does not help, please contact an administrator about this issue.",
            "gdprThresholdDescription": "Applies to all aggregated data on the Involve employee and manager profiles. The value is checked per sub-group, not on the total. With a value of 6, both the male and female group must each contain at least 6 people (minimum 12 in total) for that dataset to be shown. If any sub-group falls below the value, that sub-group and the dataset's totals are hidden to prevent individuals from being identified. The same value applies to every sub-group and cannot be set separately per gender. Set to 0 to disable suppression.",
            "gdprThresholdInputLabel": "Don't show aggregated data under this threshold",
            "gdprThresholdInvalid": "Enter a whole number, 0 or higher",
            "gdprThresholdTitle": "GDPR Threshold",
            "genderEQDescription": "The EU has, with the introduction of the with the pay transparency directive, made it mandatory for organizations to share details regarding pay between men and women to employees if requested. In the following sections you’ll see a breakdown of the data.",
            "genderEQLegend": "Gender equality settings",
            "genderEQTitle": "Gender equality in your organisation",
            "gradeAveragePayLevelsBadge": "Article 7",
            "gradeAveragePayLevelsDescription": "For jobs that are equally as complex as yours (Grade 6) women earn 42,500 SEK/month and men 43,000 SEK/month. Which results in a pay gap of 1.2%.",
            "gradeAveragePayLevelsBaseSalaryTitle": "Average pay levels for your grade (base salary)",
            "gradeAveragePayLevelsTitle": "Average pay levels for your grade",
            "gradeAveragePayLevelsTotalSalaryTitle": "Average pay levels for your grade (total salary)",
            "jobDescriptionTitle": "Job description",
            "jobProfileBadge": "IC6",
            "jobProfileDescription": "A job profile is a group of position titles with similar work assignments. As a Developer you’re a/an Individual Contributor (IC) in grade 6. Grade determines how complex your job is and a higher grade means a more complex job.",
            "jobProfileDescriptionDesc": "As a Developer, you will design, code, and maintain software applications to meet user needs. Your role includes collaborating with cross-functional teams, troubleshooting issues, and optimizing performance. Strong problem-solving skills and proficiency in programming languages are essential. You’ll contribute to all phases of the development lifecycle, ensuring high-quality and scalable solutions...",
            "jobProfileDescriptionDescLink": "Read more about this job description",
            "jobProfileLegend": "Jobprofile settings",
            "jobProfileTitle": "Your job profile: Developer",
            "monthlyTotalSalarySectionDescription": "Total salary includes all compensation and benefits provided by your employer before any deductions. Here is a breakdown of your total salary.",
            "monthlyTotalSalarySectionLegend": "Your monthly total salary",
            "monthlyTotalSalarySectionTitle": "Your monthly total salary",
            "noSettingsVisible": "Looks like there’s nothing for you to set on this page. There is no technical issue, just nothing to set because none of the sections with settings are enabled in your instance.",
            "pageDescription": "Edit which sections that should be visible for employees and managers when they log into their employee portals. You must save your changes in order to update what data the employees and managers have access to.",
            "pageName": "Involve settings",
            "pageTitle": "Manage your employee portals",
            "payLevelProfileDescription": "In your job profile women earn 40,000 SEK/month on average while men earn 42,500 SEK/month on average. This results in a 4.8% pay gap between men and women.",
            "payLevelProfileBaseSalaryTitle": "Average pay levels for your job profile (base salary)",
            "payLevelProfileTitle": "Average pay levels for your job profile",
            "payLevelProfileTotalSalaryTitle": "Average pay levels for your job profile (total salary)",
            "payQuartileGenderDistributionBadge": "Article 9",
            "payQuartileGenderDistributionDescription": "Here are all salaries ranked from highest to lowest and then divided into four equally sized groups (quartiles). In the upper quartile (top 25% highest paid employees), 35% are women and 65% are men. And for the lower quartile (least paid employees), 55% are women and 45% are men.",
            "payQuartileGenderDistributionTitle": "Gender distribution in pay quartilies",
            "payRangeBadge": "Article 6",
            "payRangeDescription": "'Developer in grade 6 earn between 30,000 and 50,000 SEK/month. The mean salary is 41,000 SEK/month and you currently earn 37,000 SEK/month. Below you can find your pay range and the mean salaries broken down by gender for grade 6. *Mean salaries are based on total salary.",
            "payRangeTitle": "Payrange",
            "performanceSectionDescription": "You scored 57% out of 100% in this performance review. Scores between 50% and 69% are considered “average”. In your self-evaluation, you rated your performance at 67%. Ask your manager if you want to learn more about their reasoning.",
            "performanceSectionTitle": "Your performance",
            "saveModal": {
                "content": "Below you can see the changes you have made since last time you saved what should be visible in the employee dashboards. Once you save the changes it will update what your employees sees on their employee dashboard.",
                "firstSaveContent": "These settings haven't been saved yet. Once you save, they apply and employees will see their employee dashboard with the settings on this page.",
                "gdprThresholdContent": "The GDPR threshold will be set to {threshold}.",
                "gdprThresholdHeader": "GDPR threshold",
                "header": "Save changes to employee portal",
                "noChangesMade": "No changes have been made",
                "startHidingHeader": "What you'll start hiding",
                "startShowingHeader": "What you'll start showing"
            },
            "targetsSectionDescription": "This year you have set 1 target for yourself. You have currently finished 0 of them. Your closest deadline for your next target is 31st December 2025. Talk with your manager if you think you have finished a target that’s yet to be marked as completed.",
            "targetsSectionTitle": "Your targets"
        },
        "jobArchitecture": {
            "compactCards": {
                "helpText": "Show bare minimum data on each item",
                "title": "Compact"
            },
            "detailedCards": {
                "helpText": "Show more data on each item",
                "title": "Detailed"
            },
            "matchEmployeeInJobProfile": "matches employees` in the job profile",
            "selectHowToCreateJobProfiles": {
                "createFromEmploymentDataInfo1": "Select fields from your employments already imported via the salary file import or an integration.",
                "createFromEmploymentDataInfo2": "We’ll create the minimum and maximum grade based on your job profiles’ grades.",
                "createFromEmploymentDataInfo3": "If your job architecture data is provided by an integration you won’t be able to edit it directly in Sysarb.",
                "fileImportInfo1": "Import your job profiles and their basic details.",
                "fileImportInfo2": "We’ll create the minimum and maximum grade based on your job profiles’ grades.",
                "option1": "File import",
                "option2": "Create job profiles via employment data"
            },
            "selectJobEvaluation": {
                "option1": "Sysarb",
                "option2": "Other",
                "otherInfo1": "Import your current job architecture via files or integrations.",
                "otherInfo2": "Make sure you have the possibility to get the criteria for the job evaluation since it’s needed for compliance.",
                "otherInfo3": "You won’t be able to access our benchmarking data.",
                "sysarbInfo1": "Able to benchmark your data with other Sysarb users.",
                "sysarbInfo2": "Guaranteed compliance with Swedish and EU legislation"
            }
        },
        "mappingsOverview": {
            "mappingAdjustedSalaryFactors": {
                "payFactorDetails": "Pay factor details",
                "somethingWentWrong": "Something went wrong when calculating the pay gap. Please try deselecting some pay factors."
            }
        },
        "payEquityAudit": {
            "above": "above",
            "access": "Access",
            "accessSetting": {
                "admin": {
                    "description": {
                        "1": "Import, delete or edit all employment data within the audit.",
                        "2": "Edit the factor plan and job evaluation.",
                        "3": "Analyze all employees in the equal job analysis and comparative job analysis.",
                        "4": "Create reports or export data from the audit.",
                        "title": "Administrators have access to:"
                    },
                    "listHeader": "Administrators with access to this audit",
                    "noUsers": "You have no administrators added to the audit."
                },
                "hrBusinessPartners": {
                    "description": {
                        "1": "View audit's dashboard with general metrics.",
                        "2": "Edit the job evaluation.",
                        "3": "View employment data.",
                        "4": "Names of employees outside their organizational unit are anonymous.",
                        "5": "Group employees within their organizational unit.",
                        "6": "Analyze employees within their organizational unit.",
                        "7": "Edit audit's settings.",
                        "title": "HR Business partners have access to:"
                    },
                    "noUsers": "You have no HR Business partners added to the audit."
                },
                "operationalAdmin": {
                    "addOpAdmin": "Add operational admin",
                    "description": {
                        "1": "Import, delete or edit all employment data within the audit.",
                        "2": "Edit the factor plan and job evaluation.",
                        "3": "View Employment data.",
                        "4": "Names of employees outside their organizational unit are anonymous.",
                        "5": "Analyze employees within their organizational unit in the equal job analysis and comparative job analysis.",
                        "6": "Create reports or export data from the audit.",
                        "title": "Operational administrators have access to:"
                    },
                    "noOperationalAdminsToSelect": "No available Operational administrators to select",
                    "noUsers": "You have no operational administrators added to the audit."
                },
                "readOnly": {
                    "description": {
                        "1": "View audit's dashboard with general metrics.",
                        "2": "View the audit's job evaluation and result of job evaluation.",
                        "3": "View completed equal and comparative job analysis.",
                        "4": "Names of employees are anonymous.",
                        "5": "View employment data in the equal and comparative job analysis."
                    },
                    "descriptionHeader": "Read-only have access to:",
                    "noUsers": "You have no read-only users added to the audit."
                }
            },
            "action": "Action",
            "actionPlanNewSalary": "New salary",
            "actualBonus": "Short-term incentive",
            "addExplanations": "Add explanations",
            "additionalData1": "Additional data 1",
            "additionalData2": "Additional data 2",
            "additionalData3": "Additional data 3",
            "adjustments": "Adjustments",
            "affectedByClusterTags": "Will create jobs based on cluster tags you have assigned in the job architecture module.",
            "age": "Age",
            "aiReport": {
                "audienceTargeting": {
                    "customPromptHint": "If provided, this overrides the education level and target audience settings above.",
                    "customPromptLabel": "Custom Audience Description",
                    "customPromptPlaceholder": "Describe your target audience and how the report should be tailored for them...",
                    "educationLevel": "Reader's Education Level",
                    "targetGroup": "Target Audience",
                    "title": "Audience Targeting"
                },
                "buttonLabel": "Generate AI Report",
                "description": "Generate an AI-powered pay equity analysis report. The report will be downloaded as a Word document.",
                "documentTitle": "Pay Equity Analysis Report",
                "downloadHint": "The report will be automatically downloaded as a Word document (.docx) once generation is complete.",
                "educationLevel": {
                    "higher": "Bachelor's degree",
                    "masters": "Master's degree",
                    "none": "No higher education",
                    "phd": "PhD / Doctoral"
                },
                "errors": {
                    "failed": "Failed to generate report",
                    "noAudit": "No pay equity audit selected"
                },
                "filePrefix": "AI Report",
                "generate": "Generate & Download",
                "loading": {
                    "analyzing": "Running statistical analysis...",
                    "creating": "Creating Word document...",
                    "generating": "Generating report with AI...",
                    "hint": "This may take a minute depending on the data size...",
                    "preparing": "Preparing analysis data..."
                },
                "organization": "Organization",
                "period": "Period",
                "reportLength": "Report Detail Level",
                "reportLengthInfo": "Controls how detailed and lengthy the generated report will be",
                "sections": {
                    "aliasing": "Aliasing",
                    "analysisTags": "Analysis Tags",
                    "cautions": "Cautions",
                    "completeness": "Completeness",
                    "conclusion": "Conclusion",
                    "correlationInsights": "Correlation Insights",
                    "dataQualityNotes": "Data Quality Notes",
                    "directMethod": "Direct Method",
                    "executiveSummary": "Executive Summary",
                    "expectedOutcome": "Expected Outcome",
                    "extendedSummary": "Extended Summary",
                    "factorHandling": "Factor Handling",
                    "groupDifferences": "Group Differences",
                    "groupIndividualAnalysis": "Group & Individual Analysis",
                    "hotspotGroups": "Hotspot Groups",
                    "hotspotsExplanation": "Hotspots Explanation",
                    "individualFlags": "Individual Flags",
                    "keyNegativeLinks": "Key Negative Links",
                    "keyPositiveLinks": "Key Positive Links",
                    "limitations": "Limitations",
                    "methodology": "Methodology",
                    "modelQuality": "Model Quality",
                    "nonSignificant": "Non-Significant Factors",
                    "oaxacaBlinder": "Oaxaca-Blinder Analysis",
                    "overview": "Overview",
                    "populationOverview": "Population Overview",
                    "prioritisationSummary": "Prioritisation Summary",
                    "reasonsForAnalysis": "Reasons for Analysis",
                    "regressionModelEvaluation": "Regression Model Evaluation",
                    "salaryIncreases": "Salary Increases",
                    "scenarioEfficient": "Efficient Adjustment Scenario",
                    "significance": "Significance",
                    "stepsInitiated": "Steps Initiated"
                },
                "selectedLevel": "Selected",
                "targetGroup": {
                    "employee": "General employees",
                    "executive": "Executives and board members",
                    "manager": "Managers and team leads"
                },
                "title": "AI Report",
                "wordBudget": {
                    "comprehensive": "Comprehensive",
                    "concise": "Concise",
                    "detailed": "Detailed",
                    "standard": "Standard"
                }
            },
            "aiReportV2": {
                "analysisSection": {
                    "actionPlanCategoryEqualWork": "Equal work",
                    "actionPlanCategoryEquivalentWork": "Equivalent work",
                    "actionPlanCategoryStructuralMethods": "Structural methods",
                    "actionPlanColumnAction": "Action",
                    "actionPlanColumnCost": "Cost",
                    "actionPlanFallback": "The action plan to resolve the pay gap has been decided on for {nActionEmployees} employees ({nMale} male, {nFemale} female).",
                    "adjustedGapDefault": "This leaves an adjusted pay gap of {adjustedGap} that will be fixed using the action plan.",
                    "adjustedGapInversion": "After applying gender-neutral criteria, the remaining adjusted pay gap of {adjustedGap} is in favour of women, so no further action is needed.",
                    "equalWorkCommonExplanation": "The most common explanation in the analysis was {explanation}.",
                    "equalWorkDefault": "Equal work was defined by {definition}, creating {nGroups} groups. This produced {nOver5} groups with a pay gap over 5%, requiring JPA action. We marked that {nUrgent} were urgent with pay gaps over 10%.",
                    "equalWorkNoneOver5": "Equal work was defined by {definition}, creating {nGroups} groups. None show a pay gap over 5%, so no JPA action is required.",
                    "equivalentWorkDefault": "Using gender-neutral criteria, {nCategories} equivalent work categories were created; {femDominated} were female-dominated. Of these, {nOver5} show a pay gap above 5% requiring JPA action under EU Directive 2023/970 and will be reviewed accordingly.",
                    "equivalentWorkNoneOver5": "Using gender-neutral criteria, {nCategories} equivalent work categories were created; {femDominated} were female-dominated. None show a pay gap above 5%, so no JPA action is required under EU Directive 2023/970.",
                    "explanationFactors1": "{factor1} was the only significant explanation of the pay gap, causing a {pct1} gap.",
                    "explanationFactors2": "{factor1} was the largest explanation of the pay gap, causing a {pct1} gap. {factor2} caused a further {pct2}.",
                    "explanationFactors3": "{factor1} was the largest explanation of the pay gap, causing a {pct1} gap. {factor2} caused {pct2}, and {factor3} caused {pct3}.",
                    "individualAnalysis": "Individual analysis explained a further {individualExplainedPct} based on gender-neutral criteria of performance, experience, and historical salary, the most common reason being {commonExplanation}.",
                    "mathsModelIndividualAnalysis": "{nIndividual} ({nMale} male, {nFemale} female) employees were individually analysed and either explained or had an action planned for them.",
                    "mathsModelInverted": "Female employees earned an average of {meanGap} more than men. We turned the chosen gender-neutral qualifications into an equation to predict salaries of employees. After this, women still appeared overpaid by {adjustedGap}.",
                    "mathsModelMixed": "The unadjusted gender pay gap is {meanGap} and the adjusted gap is {adjustedGap}. After applying gender-neutral criteria, the gap reverses direction — see the appendix table for details.",
                    "mathsModelStandard": "Female employees earned an average of {meanGap} less than men. We turned the chosen gender-neutral qualifications into an equation to predict salaries of employees. Even with this, they were still underpaid by a further {adjustedGap}.",
                    "noPreviousActions": "No actions from a previous survey have been recorded.",
                    "quartileBiasFemaleAdvantage": "Women are notably more represented at the top of the pay scale than the bottom.",
                    "quartileBiasMaleAdvantage": "This may indicate a bias toward promoting males or a historical hiring practice.",
                    "quartileBottomFemale": "Of the lowest paid employees (lowest 25%), {q1FemalePct} were female.",
                    "quartileTopFemaleNeutral": "{q4FemalePct} of the highest paid employees (top 25%) were female.",
                    "quartileTopFemaleOnly": "Only {q4FemalePct} of the highest paid employees (top 25%) were female.",
                    "variablePayDefault": "Variable pay has an unadjusted variable pay gap of {gap}. The participation rate is {malePct} of males and {femalePct} of females.",
                    "variablePayInversion": "Variable pay has an unadjusted variable pay gap of {gap} in favour of women. The participation rate is {malePct} of males and {femalePct} of females.",
                    "variablePayNone": "No variable pay has been reported for this audit."
                },
                "appendixLegalSection": {
                    "burdenOfProofBody": "In accordance with EU Directive 2023/970, where a pay difference cannot be explained by objective, gender-neutral criteria, this organisation accepts the obligation to demonstrate that such differences do not constitute a breach of the equal pay principle.",
                    "burdenOfProofHeading": "Burden of Proof Acknowledgement",
                    "discriminationActLabel": "Swedish Discrimination Act (Chapter 3, Sections 8–10, and Chapter 3a)",
                    "euDirectiveLabel": "EU Directive 2023/970",
                    "jointPayAssessmentLabel": "Joint Pay Assessment",
                    "wageMappingHeading": "Wage Mapping According to the Discrimination Act",
                    "wageMappingPara1After": " on Pay Transparency.",
                    "wageMappingPara1Before": "The following documents constitute the mapping and analysis of wage differences between women and men under the ",
                    "wageMappingPara1Between": " and ",
                    "wageMappingPara2": "The purpose is to map and analyse whether wage differences between women and men are attributable to gender or have factual, objective explanations. Where differences cannot be objectively justified, they must be remedied.",
                    "wageMappingPara3After": " will be conducted in cooperation with employee or trade union representatives.",
                    "wageMappingPara3Before": "Where an unjustified gap of 5% or more is identified in any category of workers, a ",
                    "wageMappingPara4": "The employer bears the burden of demonstrating that any remaining pay differences do not constitute a breach of the equal pay principle."
                },
                "appendixMathSection": {
                    "accuracyConclusionHigh": "This is very confident, but must be verified graphically — R² values alone are insufficient (cf. Anscombe's quartet).",
                    "accuracyConclusionHighV2": "This is very confident, but must be verified graphically — R² values alone are insufficient.",
                    "accuracyConclusionLow": "This shows limited fit; R² values should be verified graphically and treated with caution (cf. Anscombe's quartet).",
                    "accuracyConclusionLowV2": "This shows limited fit; R² values should be verified graphically and treated with caution.",
                    "accuracyConclusionModerate": "This shows moderate fit; R² values should still be verified graphically — they are insufficient on their own (cf. Anscombe's quartet).",
                    "accuracyConclusionModerateV2": "This shows moderate fit; R² values should still be verified graphically — they are insufficient on their own.",
                    "accuracyLabel": "accuracy",
                    "accuracyParaPrefix": "The ",
                    "accuracyParaSuffix": " of the model is represented by the R² value (0 to 1, where 1 is a perfect fit). The model achieved R² = {r2Male} and {r2Female} when fitting to male and female data respectively. ",
                    "confidenceConclusionHigh": "meaning the results are strongly statistically significant and thus the result is very confident in its findings.",
                    "confidenceConclusionLow": "meaning the results are not statistically significant; the findings should be treated with caution.",
                    "confidenceConclusionModerate": "meaning the results are statistically significant and the result is confident in its findings.",
                    "confidenceLabel": "confidence",
                    "confidenceParaPrefix": "The ",
                    "confidenceParaSuffix": " of the model is represented by the p-value: the probability that the calculated factor arose by chance. A p-value below 0.05 indicates statistical significance. The model returned a p-value of {pValue}, ",
                    "linearRegressionLabel": "linear regression",
                    "linearRegressionPrefix": "The pay gap is identified via ",
                    "linearRegressionSuffix": ": the fitting of an equation that best represents the input data. The pay gap is the difference between this equation for men and women, expressed as both an unadjusted and an adjusted (factor-explained) figure.",
                    "oaxacaBlinderLabel": "Oaxaca-Blinder (OB) decomposition",
                    "oaxacaBlinderSuffix": " is a mathematical model that finds the percentage of the pay gap that can be explained by pre-chosen factors. The analysis found that {explainedGap} of the {meanGap} gap is explained by the input factors. The breakdown is presented in the data tables appendix.",
                    "r2AccuracySentenceHigh": "Our model fit is very accurate at ",
                    "r2AccuracySentenceLow": "Our model fit has limited accuracy at ",
                    "r2AccuracySentenceModerate": "Our model fit is moderately accurate at ",
                    "r2AccuracySentenceSuffix": " for men and women respectively, and is graphed in the data tables appendix. ",
                    "r2ConfidenceSentenceHigh": "Its confidence (p-value) is {pValue}, meaning it is very confident in its prediction.",
                    "r2ConfidenceSentenceLow": "Its confidence (p-value) is {pValue}, meaning it is not statistically confident in its prediction.",
                    "r2ConfidenceSentenceModerate": "Its confidence (p-value) is {pValue}, meaning it is moderately confident in its prediction.",
                    "r2Expression": "R² = {r2Male} and {r2Female}",
                    "r2IntroPrefix": "The ",
                    "r2IntroSuffix": " is how well our model fits your data, scaled from 0 to 1 where 0.5 is a good fit. A higher value indicates a more accurate model. ",
                    "r2ValueLabel": "R² value",
                    "r2ValueLabelV2": "The R² value",
                    "stdThresholdPara": "The spread of wages was defined at {stdThreshold} standard deviations. Any workers who fell out of this range were flagged for attention."
                },
                "appendixTablesSection": {
                    "equalWorkColumnAnalysed": "Individuals analysed",
                    "equalWorkColumnGap": "Pay gap",
                    "equalWorkColumnGroup": "Equal work group",
                    "equalWorkEmpty": "No equal work groups available for this audit.",
                    "equalWorkHeading": "Equal Work Group Pay Gaps",
                    "equivalentWorkColumnGap": "Pay gap",
                    "equivalentWorkColumnGrade": "Grade",
                    "equivalentWorkEmpty": "No equivalent work groups available for this audit.",
                    "equivalentWorkHeading": "Equivalent Work Group Pay Gaps",
                    "gradeColumnBaseSalary": "Base Salary Gap",
                    "gradeColumnGrade": "Grade",
                    "gradeColumnMean": "Mean Pay Gap",
                    "gradeColumnMedian": "Median Pay Gap",
                    "gradeColumnVariable": "Variable Pay Gap",
                    "gradeEmpty": "No grade-based data available for this audit.",
                    "gradeHeading": "Grade-Based Pay Gaps",
                    "jobFamilyColumnBaseSalary": "Base Salary Gap",
                    "jobFamilyColumnHeader": "Job Family (% Male)",
                    "jobFamilyColumnMean": "Mean Pay Gap",
                    "jobFamilyColumnMedian": "Median Pay Gap",
                    "jobFamilyColumnVariable": "Variable Pay Gap",
                    "jobFamilyEmpty": "No job family data available for this audit.",
                    "jobFamilyHeading": "Job Family-Based Pay Gaps",
                    "quartileAllRow": "All quartiles",
                    "quartileColumnBracket": "Quartile pay bracket",
                    "quartileColumnFemale": "Female",
                    "quartileColumnMale": "Male",
                    "quartileColumnTotal": "Total",
                    "quartileHeading": "Quartile Pay Bracket by Gender",
                    "totalGapColumnFactor": "Factor",
                    "totalGapColumnMean": "Mean Pay Gap",
                    "totalGapColumnMedian": "Median Pay Gap",
                    "totalGapHeading": "Total Pay Gap and Explained Factors",
                    "totalGapRowExplained": "Explained:",
                    "totalGapRowTotal": "Total",
                    "totalGapRowUnexplained": "Unexplained",
                    "variablePayColumnDifference": "Difference",
                    "variablePayColumnFemale": "Female",
                    "variablePayColumnHeader": "Variable pay",
                    "variablePayColumnMale": "Male",
                    "variablePayHeading": "Variable Pay Gaps",
                    "variablePayNone": "No variable pay reported for this audit.",
                    "variablePayRowMean": "Mean pay",
                    "variablePayRowMedian": "Median pay",
                    "variablePayRowParticipation": "Participation"
                },
                "claudeGlossary": {
                    "actionPlan": "action plan",
                    "adjustedPayGap": "adjusted pay gap",
                    "baseSalary": "base salary",
                    "equalWork": "equal work",
                    "equivalentWork": "equivalent work",
                    "higherPay": "higher pay",
                    "lowerPay": "lower pay",
                    "payGap": "pay gap",
                    "payMapping": "pay equity audit",
                    "requiresInvestigation": "requires investigation",
                    "salaryAdjustment": "salary adjustment",
                    "salarySupplement": "salary supplement",
                    "unadjustedPayGap": "unadjusted pay gap",
                    "variablePay": "variable pay"
                },
                "conclusionSection": {
                    "fallbackDefault": "In conclusion, we have identified gender neutral explanations for {explainedGap} of the pay gap, leaving {adjustedGap} unexplained. We have analysed equal and equivalent work groups, and individuals to find any biases. Finally, we have produced an action plan to remedy any problematic findings.",
                    "fallbackInversion": "In conclusion, we have identified gender neutral explanations for {explainedGap} of the pay gap; the remaining {adjustedGap} is in favour of women, requiring no further pay action. We have analysed equal and equivalent work groups, and individuals to find any biases, and produced an action plan to remedy any problematic findings."
                },
                "confidentialityNotice": "This report contains confidential information and is intended solely for the named recipient(s).",
                "description": "Generate the new AI-powered pay equity analysis report. The report will be downloaded as a Word document.",
                "documentTitle": "Pay Equity Analysis Report",
                "errors": {
                    "failed": "Failed to generate report",
                    "noAudit": "No pay equity audit selected"
                },
                "filePrefix": "AI Report",
                "generate": "Generate & Download",
                "jobGroupingPicker": {
                    "label": "How are your jobs grouped?",
                    "optionGrade": "Grade",
                    "optionJobArchitecture": "Job architecture",
                    "optionJobProfile": "Job profile",
                    "optionJobProfileFamily": "Job profile and job family",
                    "optionOther": "Other",
                    "optionStatisticalCode": "Statistical code",
                    "otherLabel": "Custom grouping",
                    "otherPlaceholder": "Describe how you grouped jobs (max 40 characters)"
                },
                "loading": {
                    "creating": "Creating Word document..."
                },
                "methodologySection": {
                    "equalWorkGroupsIntro": "were defined by",
                    "equalWorkGroupsLabel": "Equal work groups",
                    "equivalentWorkCategoriesIntro": "were defined using the following commonly accepted gender neutral qualifications:",
                    "equivalentWorkCategoriesLabel": "Equivalent work categories",
                    "intro": "This analysis was done with the {softwareName} software, following the well-established global model MIA methodology, analysing the Market, the Individual, and the Assignment. The steps taken for this analysis were as follows:",
                    "introV2": "This analysis was done with the {softwareName} software, following the MIA methodology, which analyses the Market, the Individual, and the Assignment. The steps taken for this analysis were as follows:",
                    "step1BaseSalary": "Base salary",
                    "step1EquivalentAndEqual": "Equivalent and equal work categories",
                    "step1Intro": "Review of pay policy and practice. All pay affecting practices are reviewed and assessed for gender neutrality. This includes, but is not limited to:",
                    "step1VariableSalary": "Variable salary (e.g. bonuses)",
                    "step3": "Pay gap analysis. A mathematical approach (explained in the Appendix) comparing equal and equivalent work done to find pay differences between male and female workers.",
                    "step4": "Action plan. All pay gap findings are addressed with concrete actions.",
                    "step5": "Sign off. The final report is discussed and signed off by the appropriate representative."
                },
                "placeholder": "(Section content will be added in a follow-up task.)",
                "preparedByLabel": "Prepared by",
                "reportDateLabel": "Report date",
                "sections": {
                    "analysis": "Analysis",
                    "analysisSubsections": {
                        "adjustedGap": "Adjusted pay gap",
                        "equalWorkGap": "Equal work pay gap",
                        "equivalentWorkGap": "Equivalent work pay gap",
                        "mathsModel": "Maths model",
                        "newActionPlan": "New action plan",
                        "previousActions": "Actions completed from previous survey",
                        "quartileRepresentation": "Quartile representation",
                        "variablePay": "Variable pay"
                    },
                    "appendixLegal": "Appendix: Legal Requirements",
                    "appendixMath": "Appendix: Mathematical Explanations",
                    "appendixTables": "Appendix: Data Tables and Graphs",
                    "conclusion": "Conclusion",
                    "cover": "Cover Page",
                    "methodology": "Methodology",
                    "summary": "Summary"
                },
                "summarySection": {
                    "adjustedGap": "Adjusted pay gap",
                    "adjustmentsParagraphV2": "The result of this year's pay equity survey shows that {salaryAdjusts} individuals over {adjustmentGroupCount} groups need to be adjusted for pay equity. This has been estimated to cost {adjustmentCost} over 3 years.",
                    "equalGroups": "Equal work groups",
                    "equalGroupsOver10": "Equal work groups exceeding 10%",
                    "equalGroupsOver5": "Equal work groups exceeding 5%",
                    "equalWorkSentence": "Equal work ({definition}) gave {nGroups} groups, {nOver5} of them showing a pay gap over 5%. All gaps over 5% require remediation or objective justification within 6 months.",
                    "equivalentCategories": "Equivalent work categories",
                    "equivalentCategoriesOver5": "Equivalent work categories exceeding 5%",
                    "equivalentWorkSentence": "Equivalent work ({definition}) produced {nCategories} categories, {nOver5} of them showing a pay gap over 5%.",
                    "explainedGap": "Explained gap",
                    "individualsAnalysed": "Individuals flagged for analysis",
                    "keyFiguresHeading": "Key figures",
                    "payGapParagraph": "The unadjusted mean gender pay gap is {meanGap}, and median: {medianGap} for {nEmployees} employees. A {explainedGap} pay gap was explained using gender neutral criteria, leaving an adjusted pay gap of {adjustedGap} which should be remedied.",
                    "payGapParagraphInversion": "The unadjusted mean gender pay gap is {meanGap}, and median: {medianGap} for {nEmployees} employees. A {explainedGap} pay gap was explained using gender-neutral criteria, leaving an adjusted pay gap of {adjustedGap} in favour of women.",
                    "q1FemalePct": "Female representation in lowest quartile",
                    "q4FemalePct": "Female representation in highest quartile",
                    "q4ReasonableRepresentation": "reasonable representation among the highest paid",
                    "q4Underrepresentation": "significant underrepresentation among the highest paid",
                    "quartileSentence": "Out of the 25% most paid employees, only {femalePct} were female and {malePct} were male, representing a {representation}.",
                    "quartileSentenceBalanced": "Of the 25% most paid employees, {femalePct} are female and {malePct} are male — close to gender parity in the top quartile. The analysis of equivalent work has resulted in {salaryAdjusts} salary adjustments.",
                    "quartileSentenceMenUnder": "Of the 25% most paid employees, {femalePct} are female and {malePct} are male — an atypical pattern with men under-represented in the top quartile. The analysis of equivalent work has resulted in {salaryAdjusts} salary adjustments.",
                    "quartileSentenceWomenUnder": "Out of the 25% most paid employees, only {femalePct} are female and {malePct} are male, representing a significant under-representation of women among the highest paid. The analysis of equivalent work has resulted in {salaryAdjusts} salary adjustments.",
                    "salaryAdjustments": "Salary adjustments",
                    "surveyParagraph": "The pay equity survey for {year} was carried out by a working group of representatives. The person with overall responsibility was {preparedBy}, who together with a consultant from Sysarb worked through the various steps of the survey.",
                    "unadjustedMeanGap": "Unadjusted mean pay gap",
                    "unadjustedMedianGap": "Unadjusted median pay gap"
                },
                "title": "AI Report V2"
            },
            "all": "All jobs",
            "analysis": "Analysis",
            "analyticalFocusSettingComponent": {
                "comparisonDesc": "In the equal job analysis you can determine if you want to compare employees' salaries or compa-ratios.",
                "comparisonTitle": "1. Select what to compare between employees",
                "salaryCompDesc": "The salary you compare in equal job and comparative job analysis can be either based on employees' base salary or total salary.",
                "salaryCompTitle": "2. Select between base or total salary",
                "salarytypeDesc": "We'll convert all employees' salaries and all metrics to the selected salary type. Select the salary type you want to use for this audit.",
                "salarytypeTitle": "Select salary type to analyze salaries in",
                "stepTitle": "Analytical focus",
                "title": "Your analytical focus",
                "totalSalaryInfoDesc": "Select what should be included in the total salary. Changes to total salary will only apply for this pay equity audit."
            },
            "analyze": {
                "actualSalary": "Actual salary",
                "age": "Age",
                "analysisComplete": "Analysis complete",
                "analyze": "Analyze",
                "baseSalary": "Base salary",
                "categories": "Categories:",
                "chartSettings": "Chart settings",
                "chartType": "Chart type:",
                "city": "City",
                "comingSoon": "Coming soon",
                "companyTenure": "Company tenure",
                "configureChart": "Configure chart",
                "costSaved": "Cost saved from explanations",
                "dataVisualization": "Data Visualization",
                "employeesWithoutStandardDeviation": "We couldn't calculate predicted salary for all employees. They might lack data related to your pay factors.",
                "employment": "Employment",
                "employments": "Employments",
                "explanation": "Explanation",
                "explanations": "Explanations",
                "explanationsAndAdjustments": {
                    "description": "Here are all your explanations and adjustments gathered from your analysis."
                },
                "explanationsGroupedByGender": "Explanations for employees grouped by gender",
                "explanationsMen": "Explanations {'|'} Men",
                "explanationsWomen": "Explanations {'|'} Women",
                "explore": {
                    "description": "Here you can explore on your own by changing axises, chart type and data groupings. Try to find trends in the data if you have remaining pay discrepancies.",
                    "markersWithNullDataCount": "{count} employees are missing data for the selected category and can't be displayed"
                },
                "filter": "Filter",
                "flaggedForAnalysis": "Flagged for analysis",
                "freezeSalary": "Freeze salary",
                "gender": "Gender",
                "groupBy": "Group by:",
                "groupMeanSalary": "Group mean salary",
                "groupMedianSalary": "Group median salary",
                "groupMetricsHeading": "A brief overview of your group",
                "groups": "Group analysis",
                "individuals": "Individual analysis",
                "jobTenure": "Job tenure",
                "keyValues": {
                    "employees": "Employees",
                    "estimatedPayGap": "Est. pay gap after analysis",
                    "estimatedPayGapMean": "Est. mean pay gap after explanations",
                    "estimatedPayGapMedian": "Est. median pay gap after explanations",
                    "estimatedPayGapTooltip": "If you have marked an employee as analyzed and applied an explanation, comment, or adjustment, we’ll assume their salary is fully explained and will recalculate the pay gap using their predicted salary instead. This will show you an indicative adjusted pay gap based on your analysis.",
                    "meanUnadjustedPayGap": "Mean unadj. pay gap",
                    "medianUnadjustedPayGap": "Median unadj. pay gap",
                    "men": "Men",
                    "outliers": "Employees outside pay range",
                    "total": "Total",
                    "women": "Women"
                },
                "lineChart": "Linechart",
                "lineChartHighlightInfo": "Highlights do not affect the line chart since it displays aggregated data.",
                "loading": "Loading analysis data, please wait...",
                "markedForAnalysis": "Marked for analysis",
                "meanUnadjustedPayGap": "Mean unadjusted pay gap",
                "medianUnadjustedPayGap": "Median unadjusted pay gap",
                "noAdjustments": "No adjustments have been added to any of your employees",
                "noExplainations": "No explanations have been added to any of your employees",
                "noGroup": "No group",
                "noStructuralExplainations": "No structural explanations have been added to the equal job",
                "noValue": "No value",
                "none": "None",
                "openExplore": "Open Explore",
                "openPredictedSalary": "Open Predicted salary",
                "openStructure": "Open Structure",
                "organization": "Organization",
                "outliers": "Outlier",
                "outsidePayRange": "Outside pay range",
                "performance": "Performance",
                "popup": {
                    "benchmark": "Benchmark",
                    "displayedPayRange": "Displayed pay range",
                    "distanceToAverage": "Distance to average salary",
                    "distanceToAverageDescription": "Show all salaries as a percentage of the distance to the group’s average salary.",
                    "distanceToMean": "Distance to mean",
                    "distanceToMedian": "Distance to median",
                    "equation": "Equation",
                    "general": "General",
                    "noBenchmarkData": "No benchmark has been added for this equal job",
                    "noPayRangeData": "You had no pay range data for this equal job's grade when you created the audit",
                    "payRange": "Pay range",
                    "rSquared": "r²-value",
                    "rValue": "r-value",
                    "regression": "Regression",
                    "regressionDescription": "This regression is based on the group in contrast to “predicted salary” which is based on the organization.",
                    "showBenchmark": "Show benchmark",
                    "showMeanSalary": "Show mean salary",
                    "showMedianSalary": "Show median salary",
                    "showPayRange": "Show pay ranges",
                    "showRegression": "Show regression",
                    "showdistanceToAverage": "Show distance to average salary",
                    "standardError": "Standard error"
                },
                "positionLevel": "Position level",
                "positionTitle": "Position title",
                "predictedSalary": {
                    "description": "Upper and lower bounds shows the acceptable salary range based on pay philosohopy. Outliers outside these bounds should be analyzed for potential disparities. Are women underpaid or men overpaid?"
                },
                "readMore": "Read more",
                "rightClickToCycleEmployees": "to switch between overlapping employees ({current}/{total})",
                "salaryDistribution": "Salary distribution",
                "salaryIncrease": "Salary increase",
                "salaryType": "Salary type:",
                "scatterPlot": "Scatterplot",
                "search": "Search for an employee's name...",
                "showEmployees": "Show employees",
                "sidebar": {
                    "exploreSettings": {
                        "categories": "Categories",
                        "chartType": "Chart type",
                        "groupBy": "Group by",
                        "salaryType": "Salary type",
                        "title": "Configure your chart"
                    }
                },
                "simulateSalaries": "Simulate salaries",
                "simulateSalariesInfo": "The data below is simulated with all of the added increases applied. To see actual salaries, untoggle “simulate salaries”.",
                "simulatingSalaries": "Simulating salaries",
                "standardDeviation": "Standard deviation",
                "statisticalCode": "Statistical code",
                "structuralExplanations": "Structural explanations",
                "structure": {
                    "description": "Structure analysis is meant to identify problems in how salaries are set. Problems you identify here is not fixed here but rather in the job architecture or your policies and praxis.",
                    "disableDistanceToAverage": "Disable Distance to Average",
                    "distanceToAverageNotAvailable": "This chart is not able to show the distance to average, therefore the chart is hidden. Disable the distance to average setting to show the chart.",
                    "explanationAndAdjustments": {
                        "Adjustments": "Adjustments",
                        "frozenSalary": "Frozen salaries",
                        "noOfAdjustments": "No. of adjustments",
                        "title": "Action plan"
                    },
                    "genderDistribution": "Gender distribution",
                    "paybandMax": "Upper pay range",
                    "paybandMin": "Lower pay range",
                    "salaryDistributionOverview": "Your employees' salaries from lowest to highest",
                    "salaryDistributionOverviewDescription": "A brief overview of all employees salaries in order to help you spot outliers and general distribution.",
                    "salaryDistributionWithinGroup": "Salary distribution within the group",
                    "salaryDistributionWithinGroupDescription": "Upper and lower bounds shows the acceptable salary range based on your pay ranges from the job architecture. Outliers outside these bounds should be analyzed for potential disparities. Are women underpaid or men overpaid?",
                    "table": {
                        "baseSalary": "Base salary",
                        "eightiethPercentile": "80th percentile",
                        "meanSalary": "Mean salary",
                        "meanUnadjustedPayGap": "Mean unadj. pay gap",
                        "medianSalary": "Median salary",
                        "medianUnadjustedPayGap": "Median unadj. pay gap",
                        "ninetiethPercentile": "90th percentile",
                        "salaryComponents": "Salary components",
                        "salaryType": "Salary type",
                        "tenthPercentile": "10th percentile",
                        "totalSalary": "Total salary",
                        "twentythPercentile": "20th percentile"
                    }
                },
                "structureExploreTable": {
                    "count": "Count",
                    "eightyPercentile": "80th percentile",
                    "maxSalary": "Max salary",
                    "meanAge": "Mean age",
                    "meanCompanyTenure": "Mean company tenure",
                    "meanSalary": "Mean salary",
                    "medianAge": "Median age",
                    "medianCompanyTenure": "Median company tenure",
                    "medianSalary": "Median salary",
                    "minSalary": "Min salary",
                    "ninetyPercentile": "90th percentile",
                    "outsidePayRange": "Outside pay range",
                    "ratio": "Ratio",
                    "tenthPercentile": "10th percentile",
                    "twentyPercentile": "20th percentile"
                },
                "tabs": {
                    "explanationsAndAdjustments": "Explanations & adjustments",
                    "explore": "Explore",
                    "more": "More",
                    "predictedSalary": "Predicted salary",
                    "recommended": "Recommended",
                    "structure": "Structure"
                },
                "total": "Total",
                "totalSalary": "Total salary",
                "turnOffPresentationModeToSeeAdjustmentDetails": "Turn off presentation mode to see adjustment details",
                "unableToFetchAnalysisData": "An error occurred while attempting to fetch analysis data. Please refresh the page.",
                "unableToFetchAnalysisDataFilterValues": "An error occurred while attempting to fetch available filter values. Please refresh the page.",
                "unableToFetchEmploymentData": "An error occurred while attempting to fetch selected employment. Please refresh the page.",
                "unableToFetchEmploymentInsights": "An error occurred while attempting to fetch insights for employment. Please refresh the page.",
                "unableToFetchEmploymentToAnalyzeData": "An error occurred while attempting to fetch employments. Please refresh the page.",
                "unableToFetchEqualJobData": "An error occurred while attempting to fetch the job. Please refresh the page.",
                "unableToFetchInsightVariables": "An error occured while attempting to fetch insight information. Please refresh the page."
            },
            "analyzeStatus": "Analysis status",
            "analyzed": "Analyzed",
            "applySalaryIncreasesError": "An unexpected error occurred while attempting to update salary increases",
            "averageSalary": "Average salary",
            "baseSalary": "Base salary",
            "baseSalaryInfo": "When you only want to compare employees' base salaries.",
            "beenIsOnParentalLeave": "Been/Is on parental leave",
            "below": "below",
            "benefitsInKind": "Benefits in kind",
            "betaNotice": {
                "buttonText": "Go to Settings",
                "message": "Beta mode activates the new version of the pay equity audit under construction. Therefore, everything may look and work differently than it usually does. You can just turn off the beta mode in settings to return to the standard pay equity audit.",
                "title": "You’re in beta mode"
            },
            "birthDate": "Birth date",
            "carAllowance": "Car allowance",
            "chart": "Chart | Charts",
            "city": "City",
            "clearFilter": "Clear {filterName} filter",
            "comment": "Comment",
            "commentAndExplanation": "Comment/explanation",
            "commentSaved": "Saved",
            "comments": "Comments",
            "compaRatio": "Compa-ratio",
            "compaRatioInfo": {
                "1": "When you want to avoid the impact on salary from market factors when comparing salaries.",
                "2": "Is not compliant with EU Pay Transparency reporting."
            },
            "companyTenure": "Company Tenure",
            "comparativeWorks": "Comparative jobs",
            "compilation": "Compilation",
            "contract": "Contract",
            "copilotSettings": {
                "bullets": {
                    "appliesToComparative": "Filter applies to comparative job analysis.",
                    "appliesToEqual": "Filter applies to equal job analysis."
                },
                "description": "Copilot automates your workflow by adding a pre-made analysis when it meets one of your selected criteria below. This saves you time and allows you to focus on more critical jobs and get back to review these jobs later.",
                "disclaimerText": "While Copilot analysis is helpful, it doesn't ensure compliance with the EU's Pay Transparency. It's up to you to review the jobs.",
                "jobsWithFewEmployees": {
                    "analysisText": "Analysis text that should be applied to jobs with fewer than {count} employees",
                    "bullet": "Filters jobs that have fewer than the specified number of employees.",
                    "description": "Systematic salary differences are hard to identify when these are only a few employees in a job. You can add a pre-made analysis for jobs with few employees in them and review these jobs later.",
                    "subHeader": "For jobs with fewer employees than",
                    "title": "Jobs with few employees"
                },
                "lowUnadjustedPayGaps": {
                    "analysisText": "Analysis text that should be applied to jobs with an unadjusted pay gap lower than {count}%",
                    "bullet": "Filters jobs that have a smaller unadjusted pay gap than the specified pay gap threshold.",
                    "description": "Salary differences in jobs with low unadjusted pay gaps can often be explained by individual salary settings practices within your organisation. You can add a pre-made analysis for jobs with low unadjusted pay gaps in the equal jobs analysis and review these jobs later.",
                    "subHeader": "For jobs with smaller unadjusted pay gap than",
                    "title": "Low Unadjusted pay gaps"
                },
                "numberOfAnalysis": {
                    "jobsWithFewEmployees": "No. of analysis for jobs with few employees",
                    "jobsWithSmallerPayGaps": "No. of analysis for jobs with small unadjusted pay gaps",
                    "singleGenderedJobs": "No. of analysis for single gendered jobs"
                },
                "singleGenderedJobs": {
                    "analysisText": "Analysis text that should be applied to single gendered jobs",
                    "bullet": "Filters jobs where only one gender is represented.",
                    "description": "It's not possible to derive salary differences between genders if it's a single-gendered job.",
                    "title": "Single gendered jobs"
                },
                "title": "Copilot",
                "totalNumberOfAnalysis": "Total number of analysis"
            },
            "costCenter": "Cost center",
            "costToFix": "Cost to close",
            "costYear1": "Year 1",
            "costYear2": "Year 2",
            "costYear3": "Year 3",
            "count": "Count",
            "country": "Country",
            "coworkers": "Employees",
            "create": "Create",
            "currency": "Currency",
            "currentSalary": "Current salary",
            "customFieldOptions": {
                "contract": "Contract",
                "contractType": "Contract type",
                "formOfEmployment": "Form of employment",
                "legalEntity": "Legal entity",
                "localJobFamily": "Local job family",
                "localJobProfile": "Local job profile",
                "localJobProfileLevel": "Local job profile level",
                "localSubFamily": "Local sub family",
                "locality": "City",
                "managerCode": "Manager code",
                "positionLevel": "Position level",
                "positionTitle": "Position title",
                "salaryType": "Salary Type",
                "statisticalCode": "Statistical code"
            },
            "customWorkSplitCard": {
                "1": "Create your own job structure by combining one or more fields.",
                "addField": "Add field",
                "fields": "Fields",
                "jobProfilesTheOrderDetermines": "(The order will determine the name)",
                "jobProfilesTitles": "The job profiles’ titles",
                "selectedUpToFields": "(Add up to 3 fields)"
            },
            "dashboard": {
                "equalPayAudit": "Pay equity audit",
                "gridHeaders": {
                    "audit": "Audit",
                    "auditAppliesFrom": "Audit applies from",
                    "date": "Date"
                }
            },
            "delete": "Delete",
            "deleteEmptyWorks": "Delete empty jobs",
            "description": "Description",
            "differenceIsCausedBy": "Difference in salary is caused by...",
            "distanceFromMeanSuffix": " (distance from mean)",
            "distanceFromMedianSuffix": " (distance from median)",
            "download": "Download",
            "duplicates": "Duplicates",
            "employee": "Employee",
            "employeeComparedToPeersHas": "Employee compared to peers has...",
            "employeeIsOutsideOrganization": "This employee is not part of your organization. Sidebar access is restricted.",
            "employeeSalaryAffectedBy": "Employee's salary is affected by...",
            "employees": "Employees",
            "employeesComparedToPeersHas": "Employees compared to peers has...",
            "employeesSalaryAffectedBy": "Employees' salaries are affected by...",
            "employment": "Employment",
            "employmentDate": "Company tenure start date",
            "employmentNumber": "Employment number",
            "employmentRate": "Employment rate",
            "employmentTime": "Employment tenure",
            "employmentWithinPayRange": "Employee’s salary can be explained with the pay factors you set in the pay philosophy.",
            "employmentsToInclude": "Employments to include",
            "emptyListSearch": "No results for \"{query}\"",
            "equalJobAnalysis": {
                "all": "All",
                "completed": "Completed",
                "deactivate": "Deactivate",
                "description": "In the equal job analysis you'll be analysing pay discrepancies internally within each job. We will help you find employees whose salaries doesn't match their expected salary according to your pay philosophy.",
                "emptyJobsAll": "You have analyzed all your equal jobs. Move on to comparative job analysis.",
                "emptyJobsAllAll": "You have no equal jobs. Go back to Organize and assign your employees to equal jobs.",
                "emptyJobsAllCompleted": "You haven't finished an analysis on any jobs.",
                "emptyJobsFiltered": "No jobs have been filtered out. Adjust your filter settings to hide jobs that meet certain criteria.",
                "emptyJobsOverPayGap": "All jobs with more than {percentage} pay gap has been analyzed. Feel free to to continue analyzing the remaining jobs with less than {percentage} pay gap.",
                "emptyJobsOverPayGapAll": "You have no equal jobs with more than {percentage} pay gap.",
                "emptyJobsOverPayGapCompleted": "You haven’t analyzed any jobs with more than {percentage} pay gap.",
                "emptyJobsUnderPayGap": "All jobs with less than {percentage} pay gap has been analyzed. You are obligated to analyze the equal jobs over {percentage} pay gap.",
                "emptyJobsUnderPayGapAll": "You have no equal jobs with less than {percentage} pay gap.",
                "emptyJobsUnderPayGapCompleted": "You haven’t analyzed any jobs with less than {percentage} pay gap.",
                "emptyList": "{queryValue} not found...",
                "errorState": "An error occurred. Failed to fetch the equal jobs list. Please contact you administrator.",
                "filtered": "Filtered",
                "filters": {
                    "salaryDifference": "Low salary gap",
                    "singleGender": "Single gender",
                    "smallGroups": "Small group"
                },
                "goBackToOldJobAnalysis": "Do you want to go back to the old equal job analysis for this audit?",
                "jobsOverPayGapTitle": "Jobs with more than {percentage} pay gap",
                "jobsUnderPayGapTitle": "Jobs with less than {percentage} pay gap",
                "keyValues": {
                    "employees": "Employees: {value}",
                    "employeesAmount": "{value} employees",
                    "employeesOutsideOfPayRange": "{value} employees outside of pay range",
                    "flaggedForAnalysis": "{value} flagged for analysis",
                    "meanSalary": "{value} mean salary",
                    "meanUnadjustedPayGap": "{value} mean unadjusted pay gap",
                    "medianUnadjustedPayGap": "{value} median unadjusted pay gap",
                    "requiresFurtherAnlysis": "{value} requires further analysis",
                    "unAdjustedPayGap": "Unadjusted Pay gap: {value}",
                    "womenPercentage": "{value} women"
                },
                "notStarted": "Not started",
                "ongoing": "Ongoing",
                "openFilterSettings": "Open filter settings",
                "overFivePercentPayGap": "Over 5% pay gap",
                "requiredToAnalyze": "Required to analyze",
                "search": "Search for a job, employee or position title...",
                "searchNotPerformed": "No search performed yet.",
                "sortBy": "Sort by",
                "sortByItems": {
                    "equalJobTitle": "Equal job title",
                    "payGap": "Pay gap"
                },
                "title": "Equal job analysis"
            },
            "equalPayAudit": "Pay equity audit",
            "equalWorks": "Equal jobs",
            "equity": "Long-term incentive",
            "equivalentWork": "Comparative Job | Comparative Jobs",
            "errorOccurred": "An error occurred",
            "ethnicity": "Ethnicity",
            "exclude": "Exclude",
            "executiveSummary": {
                "description": "An executive summary on the annual pay equity audit",
                "mensMeanSalary": "Men's mean salary",
                "title": "Executive summary",
                "unadjustedPayGap": "Unadjusted pay gap*",
                "unexplained": "Unexplained",
                "womensMeanSalary": "Women's mean salary"
            },
            "executiveSummaryExport": {
                "actionPlan": {
                    "amountOfMeasures": "No. of measures",
                    "amountOfSalaryIncreases": "No. of salary increases",
                    "frozenSalaries": "Frozen salaries",
                    "measuresIndividuals": "Measures for individuals",
                    "measuresWorks": "Measures for jobs",
                    "month": "mon",
                    "summary": "Here, the costs of the measures identified in the analysis are reported. The figures show costs for individuals, jobs, and the total sum. Smaller measures should be implemented immediately, and more extensive measures should be implemented within three years. Gender equality work is essential because it positively affects productivity, job satisfaction, and the willingness to stay in the organization.",
                    "title": "Action plan",
                    "total": "Total",
                    "yearOne": "Year 1",
                    "yearThree": "Year 3",
                    "yearTwo": "Year 2"
                },
                "addLogo": "Add your company logo to the report",
                "comparativeWorks": {
                    "amountOfMeasures": "No. of measures in\ncomparative jobs",
                    "analysisSummary": "In the comparative jobs analysis, we compare women-dominated jobs that are less paid relative to non-women-dominated jobs at the same (or lower) level. Usually, the pay differences between women-dominated jobs and non-women-dominated ones can be explained by market and individual factors. If the explanation lies in differences in difficulty, then the respective job needs to be reevaluated in the job architecture or the job evaluation.",
                    "analyzedWomenDominated": "Analyzed women\ndominated jobs",
                    "analyzedWomenDominatedJobs": "Analyzed women dominated jobs",
                    "comparativeJobs": "Comparative jobs",
                    "footer": "Analysis",
                    "noOfMeasures": "No. of measures in comparative jobs",
                    "preparationPhaseSummary": "In the preparation phase, we categorize jobs into different levels based on their difficulty, where jobs at level 1 correspond to the simplest jobs and jobs at level 16 to the most difficult ones. If jobs are at the same level, they are considered comparative and should also have similar salaries.",
                    "unadjustedPayGap": "Unadjusted pay gap",
                    "womenDominated": "Women dominated\njobs",
                    "womenDominatedJobs": "Women dominated jobs"
                },
                "create": "Create executive summary",
                "description": "Executive summary summarises the process and presents key findings to give the reader a brief understanding of the current situation and your work.",
                "equalWorks": {
                    "amountOfMeasures": "No. of measures",
                    "amountOfMeasuresPersons": "No. of measures (applied to persons)",
                    "amountOfSalaries": "No. of analyzed salaries",
                    "amountOfWorks": "No. of jobs in the analysis",
                    "amountOfWorksMen": "No. of jobs where men\nearn more than women",
                    "amountOfWorksMenEarnMore": "No. of jobs where men earn more than women",
                    "amountOfWorksWomen": "No. of jobs where women\nearn more than men",
                    "amountOfWorksWomenEarnMore": "No. of jobs where women earn more than men",
                    "analysis": "Analysis",
                    "description": "In equal jobs, we look at salary ratios within a job. It is common to have salary ratios within a group, but the important thing is to find the salary differences that do not have a justified explanation. That is, a salary ratio that cannot be explained based on market, performance, and assignment factors.",
                    "equalJobs": "Equal jobs",
                    "explainedSalaryDifferences": "Explained salary ratios based on the MIA model",
                    "explainedSalaryDifferencesSummary": "Number of salaries explained by Market, Individual or Assignment related factors.",
                    "keyNumbers": "Key numbers",
                    "measuresInEqualWorks": "No. of measures in\nequal jobs",
                    "otherExplanations": "Other explanations",
                    "summary": "In equal jobs, we look at salary ratios within a\njob. It is common to have salary ratios within a\ngroup, but the important thing is to find the salary\ndifferences that do not have a justified explanation. That\nis, a salary ratio that cannot be explained based\non market, performance, and assignment factors",
                    "tableRow": {
                        "amount": "Amount",
                        "assignment": "Tags {'|'} Assignment",
                        "individual": "Tags {'|'} Individual",
                        "market": "Tags {'|'} Market",
                        "measures": "No. of measures"
                    }
                },
                "exported": "Executive summary exported!",
                "fileName": "Executive summary.pdf",
                "insights": {
                    "age": "Age",
                    "employmentTime": "Company tenure",
                    "footer": "Insights",
                    "genderDistribution": "Gender distribution in the organization",
                    "genderDistributionSalary": "Gender distribution based on salary level",
                    "grade": "Grade",
                    "gradesOverFivePercent": "Grades over 5% pay gap",
                    "insightsShort": "Insights",
                    "jobFamily": "Job family",
                    "jobTenure": "Job tenure",
                    "managerCode": "Manager code",
                    "meanPayGap": "Mean pay gap",
                    "meanUnadjustedPayGap": "Mean unadjusted pay gap",
                    "meanUnadjustedPayGapUnexplained": "Mean unadjusted pay gap (unexplained)",
                    "medianUnadjustedPayGap": "Median unadjusted pay gap",
                    "ourPayPhilosophy": "Our pay philosophy",
                    "payFactors": "Pay factors",
                    "payGap": "Pay gap",
                    "payGapDescription": "By June 2026, new legislation across Europe will mandate how organizations must work with and report on pay gaps. Any pay gap of 5% or more within equal or comparable roles will require explanation or corrective action. {Company}’s goal is to achieve pay equity by eliminating these gaps, striving for an adjusted pay gap of 0%.",
                    "payGapInsights": "Insights about your pay gap",
                    "payGapInsightsDescription": "A pay gap happens when men and women are paid differently. There are two different types of pay gaps, unadjusted- and adjusted pay gaps. The unadjusted pay gap is the difference between men's and women's salaries. Adjusted pay gap considers the pay factors to explain parts of the unadjusted pay gap. What can't be explained by the pay factors is the adjusted pay gap.",
                    "payGapInsightsUnavailable": "A pay gap happens when men and women are paid differently. The unadjusted pay gap is the difference between men's and women's salaries.",
                    "payGapMean": "Pay gap {'|'} Mean",
                    "payGapMedian": "Pay gap {'|'} Median",
                    "payPhilosophyDescription": "{company} aims to set fair salaries that reflect our core values as an organization. A salary should never be affected by one's gender, ethnicity, religion or sexual orientation. However, what should affect one's salary is our pay factors. Factors that we can proudly communicate internally as well as externally to explain why one has a specific salary. Below you can see our pay factors:",
                    "performance": "Performance",
                    "positionLevel": "Position level",
                    "salaryLevels": "Salary levels in the organization",
                    "salaryRatioDescription": "The gender pay gap is the difference between men's and women's salaries. Our goal is to eliminate the gender pay gap, that is, achieve a 0% pay gap. Under the upcoming Pay Transparency Directive from EU, pay gaps over 5% must be explained or addressed. \nThe numbers show how much more men earn than women based on mean and median salaries at {company}.",
                    "salaryRatioInsights": "Insights on salary ratios",
                    "summary": "The gender pay gap is the difference between men's and women's salaries. Our goal is to eliminate the gender pay gap, that is, achieve a 0% pay gap. Under the upcoming Pay Transparency Directive from EU, pay gaps over 5% must be explained or addressed.\n\nThe numbers show how much more men earn than women based on mean and median salaries at {company}.",
                    "timeInCurrentPosition": "Job tenure",
                    "title": "Insights on salary ratios",
                    "unadjustedPayGapMedian": "Unadjusted pay gap | Median",
                    "valuation": "Valuation"
                },
                "introduction": {
                    "companyNamePlaceholder": "Your organization",
                    "howMuchMoreMen": "*How much more men earn than women in your organisation",
                    "menEarnMore": "*Men earn {payGap} more than women in your organization.",
                    "menEarningMore": "*How much more men earn than women in your organisation",
                    "menEarnsMore": "How much more men earn\nthan women in your organisation",
                    "summary": "{company} aims to become an equal opportunity employer, where all employees are fairly compensated based on their job responsibilities, skills, performance, and contributions to the organization. In this report, we will review our annual gender equality work, highlight wage disparities based on gender, position in the organization, ethnicity, and other demographic factors. The report concludes with recommendations on how {company} can become a more equal opportunity employer.",
                    "title": "Introduction",
                    "womenEarnMore": "*Women earn {payGap} more than men in your organization.",
                    "womenEarningMore": "*How much more women earn than men in your organisation",
                    "womenEarnsMore": "How much more women earn\nthan men in your organisation"
                },
                "method": {
                    "dataCollection": {
                        "summary": "Factors influenced by the individual's performance, evaluated based on our salary criteria.",
                        "title": "Data collection and analysis"
                    },
                    "footer": "Process",
                    "miaModel": {
                        "assignment": {
                            "summary": "Factors that describe the demands and complexity of the job based on difficulty level, level of responsibility, and requirements for competence.",
                            "title": "Assignment"
                        },
                        "individual": {
                            "summary": "Factors influenced by the individual's performance, evaluated based on our salary criteria.",
                            "title": "Individual"
                        },
                        "market": {
                            "summary": "Factors that are affected by the salary level on the labor market as well as the organization's ability to recruit and retain the correct competence.",
                            "title": "Market"
                        },
                        "summary": "We use the MIA model in our analyses to determine whether the pay gap is justified or not.",
                        "title": "The MIA model",
                        "typesOfExplanations": "What types of explanations are used in the analysis?"
                    },
                    "order": "{order}.",
                    "preparationStep": {
                        "summary": "The gender equality job begins by grouping employees with the same or similar positions into so-called jobs. Each job is divided into a level based on its level of difficulty.",
                        "title": "Preparation"
                    },
                    "results": {
                        "summary": "For each identified pay difference, it is determined whether there is an explanation or if an action should be taken to adjust the pay difference. Lastly, all actions are compiled into an action plan.",
                        "title": "Results and conclusions"
                    },
                    "title": "The process divided into three steps"
                },
                "process": "Process",
                "title": "Export executive summary",
                "uploadedLogo": "Your uploaded company logo that will be visible in the report"
            },
            "explanationsInfo": "Explanations will only affect employees in your sphere of responsibility.",
            "factor": "Factor",
            "factorPlanPreviewBox": {
                "factorCount": "Factors",
                "maxScore": "Maximum score",
                "minScore": "Minimum score",
                "title": "Factor plan preview"
            },
            "factorValue": "Factor value",
            "failedToLoadDraft": "Failed to load the pay equity audit draft. Refresh the page or go back to the audit list.",
            "field": "Field",
            "fileCouldNotBeImported": "File could not be imported, please try again! If the problem persists contact customer success.",
            "fileExtension": {
                "dynamic": "(.{extension})",
                "excel": "(.xlsx)",
                "pdf": "(.pdf)",
                "pptx": "(.pptx)",
                "word": "(.docx)"
            },
            "fileImported": "Import finished successfully",
            "fileIsEmpty": "File does not conatin any data",
            "flaggedForAnalysis": "Flagged for analysis",
            "formOfEmployment": "Form of employment",
            "freezingInfo": "Freezing salaries will only affect employees in your sphere of responsibility.",
            "fteWorkHoursPerMonth": "FTE work hours per month",
            "gender": "Gender",
            "general": "General",
            "grade": "Grade",
            "gradeCard": {
                "1": "Employees are only grouped by their evaluated grade level.",
                "2": "Will create the largest job size."
            },
            "grades": "Grades",
            "group": "Group | Groups",
            "groupEmployeeSalaryAffectedBy": "Employees’ salary are affected by...",
            "groupEmployments": "Group employments",
            "groupHeader": "Group",
            "groups": "Groups",
            "hasDuplicates": "Has duplicates",
            "helptext": "Valuation help",
            "higher": "Higher",
            "holidays": "Holidays",
            "hourlySalaries": "Hourly salaries",
            "importComments": "Import comments",
            "importPerformance": "Import performance",
            "importTags": "Import tags",
            "include": "Include",
            "includedIn": "Included in",
            "incompleteEvaluations": "Incomplete evaluations",
            "increment": {
                "1": "Increment 1",
                "2": "Increment 2",
                "3": "Increment 3"
            },
            "individual": "Individual",
            "individualTag": "Individual tags",
            "individualWorkValuation": "Individual Work Valuation",
            "insightDescription": "Employees with {value} have {direction} salaries {preposition} their peers. There is a {strength} correlation between {field} and salary.",
            "insightDescriptionParentalLeave": "Employees that's {value} have {direction} salaries {preposition} their peers. There is a {strength} correlation between {field} and salary.",
            "insightVariables": {
                "different-salary-year": "Different salary year",
                "differentSalaryYearTooltip": "The employee has a different salary year compared to the majority of employees in the organization.",
                "has-bonus": "Has bonus",
                "hasBonusTooltip": "The employee receives a short-term incentive.",
                "high-performance": "High performer",
                "highPerformanceTooltip": "The employee is among the 10% highest performers in the organization.",
                "is-manager": "Manager",
                "isManagerTooltip": "The employee has a manager code.",
                "low-performance": "Low performer",
                "lowPerformanceTooltip": "The employee is among the 10% lowest performers in the organization.",
                "new-to-job": "New to job",
                "newToJobTooltip": "The employee has worked less than 6 months in the organization.",
                "older": "Older",
                "olderTooltip": "The employee is among the 10% oldest employees in the organization.",
                "parental-leave": "Parental leave",
                "parentalLeaveTooltip": "The employee has been on parental leave.",
                "younger": "Younger",
                "youngerTooltip": "The employee is among the 10% youngest employees in the organization."
            },
            "insightsDescription": "When something have a strong correlation it doesn't necessarily mean that it affects salary. But although these may or may not affect salaries they can give you insights into areas to investigate further.",
            "insightsHeading": "What could potentially affect their salary?",
            "interval": "Interval",
            "invalidImport": {
                "factorNotNumber": "{ factor } is used as a pay factor. Convert your { factors } to numbers before continuing.",
                "invalidImportCurrentCurrency": "Current currency: { currency }",
                "invalidImportNewCurrency": "Currencies that don't match: { currency }",
                "invalidNewFactorValues": "The following { factors } need to be converted: { values }",
                "missmatch": "Unable to add the employees to the selected pay equity audit. The currencies don't match. To import them, convert the salaries that don't match the currency of the pay equity audit.",
                "multiple": "Every pay equity audit can only have one currency, but the selection contains multiple."
            },
            "jobArchitectureCard": {
                "1": "If you want to use your pre-made structure from the job architecture.",
                "2": "Jobs are already evaluated.",
                "3": "Get direct feedback on your pay structures.",
                "disabledTooltip": "You have no job profiles in your job architecture and can’t therefore create any jobs for the pay equity audit.",
                "title": "Job architecture"
            },
            "jobEvaluationCard": {
                "1": "Create jobs from employment data.",
                "2": "Do your own job valuation.",
                "title": "Job evaluation"
            },
            "jobEvaluationPreviewBox": {
                "title": "Job evaluation preview",
                "unevaluated": "Left to valuate",
                "valuated": "Jobs valuated"
            },
            "jobFamily": "Job family",
            "jobFamilyAndLevelCard": {
                "1": "Employees will have less similar job assignments.",
                "2": "Will create the target job size."
            },
            "jobPreviewBox": {
                "averageJobSize": "Average job size",
                "emptyJobs": "Add fields to see examples of your custom jobs",
                "jobListTitle": "Preview of your first 5 jobs",
                "jobNumber": "{num}.",
                "jobPreview": "Job preview",
                "numberOfJobs": "No. of jobs",
                "payDifference": "Largest pay difference in a job"
            },
            "jobProfileAndLevelCard": {
                "1": "Employees will have the same job assignments.",
                "2": "Will create the smallest job size."
            },
            "jobTenure": "Job tenure",
            "jobValuationSelectionComponent": {
                "createFactorPlanLater": "Create factor plan later",
                "createJobEvaluationLater": "Create job evaluation later",
                "disabledFactorPlanTooltip": "Can't be used since it has an incomplete factor plan",
                "disabledJobarchitectureTooltip": "Can't be used since it was started based on the job architecture",
                "importJobEvaluation": {
                    "1": "Save time and effort by using your old evaluation.",
                    "2": "Able to do changes to the evaluation.",
                    "title": "Import job evaluation from previous audit"
                },
                "newJobEvaluation": {
                    "1": "Useful when you have made large job restructures throughout the organization.",
                    "title": "Do a new job evaluation"
                },
                "preparing": "Preparing your Job Valuation Selection",
                "previousAuditHaveNoFactorPlan": "Job evaluation cannot be imported because the selected previous audit doesn't have a factor plan.",
                "selectJobEvaluation": {
                    "description": "Each job needs an evaluation to determine its complexity. In the comparative job analysis you’ll compare jobs with similar complexity.",
                    "title": "3. Select job evaluation"
                },
                "selectValuation": {
                    "description": "A job is a group of employees with same or similar job assignments. It’s within these groups that you’ll check for potential pay discrepancies. Decide whether to use your structure from your job architecture or not.",
                    "title": "1. Select valuation system"
                },
                "selectWorkSplit": {
                    "description": "You should aim for moderately sized jobs to analyze. Small enough that their job and job assignments are similar but large enough to have enough data points for proper comparisons.",
                    "selectionHeader": "Create jobs based on",
                    "title": "2. Create jobs"
                },
                "title": "Create the jobs you’ll analyse"
            },
            "keyValueSearch": "Search on fields...",
            "keyValues": "Key values",
            "lastPayIncrease": "Last pay increase",
            "lastSalaryIncrease": "Last salary increase",
            "legalEntity": "Legal entity",
            "less": "Less",
            "lessThanOneMonth": "Less than a month",
            "level": "Grade",
            "loadingEmploymentList": "Loading employment list",
            "loadingPreview": "Loading preview...",
            "loadingPreviewError": "An error occurred while fetching preview data.",
            "localCareer": "Local career",
            "localJobCode": "Local job code",
            "localJobFamily": "Local job family",
            "localJobProfile": "Local job profile",
            "localSubFamily": "Local sub family",
            "longTermIncentive": "Long term incentive",
            "lower": "Lower",
            "managerCode": "Manager code",
            "markAsAnalyzedInfo": "Marking employees as analyzed will only affect employees in your sphere of responsibility.",
            "market": "Market",
            "marketTag": "Market tags",
            "mean": "Mean",
            "median": "Median",
            "medianSalary": "Median Salary",
            "migrationModal": {
                "confirmButton": "I understand",
                "howThisAffectsYouLink": "The previous results are still available here",
                "howThisAffectsYouPara1": "All calculations in this audit have been refreshed using the improved model, giving you sharper, more reliable numbers. Your adjusted pay gap may look different from before, since it now reflects a more accurate calculation.",
                "howThisAffectsYouPara2After": ", also accessible from the pay philosophy page.",
                "howThisAffectsYouPara2Before": "This audit can't be reverted to the previous model. ",
                "howThisAffectsYouTitle": "How this affects you",
                "intro": "This audit has been upgraded to the same calculation model powering our most accurate pay equity results. You'll now get a clearer, more precise picture of your adjusted pay gap, with support for a wider range of pay factors than before.",
                "questionsOutro": "If you have any questions feel free to reach out to us.",
                "title": "This audit now runs on our most accurate calculation model yet",
                "whatsImproved": "We strengthened the math model behind your adjusted pay gap calculation. It now handles more factors at once, and does so more reliably, so your results better reflect the real drivers behind pay differences in your organization.",
                "whatsImprovedTitle": "What's improved",
                "whyNowBulletCostToClose": "Audits using the cost to close feature",
                "whyNowBulletEqualJobAnalysis": "Audits using the equal job analysis feature",
                "whyNowBulletRecent": "Audits created within the last two years",
                "whyNowIntro": "The updated model has already been in use for:",
                "whyNowOutro": "This audit is now catching up, and joins the rest of your audits running on our best available model.",
                "whyNowTitle": "Why now"
            },
            "monthlySalaries": "Monthly salaries",
            "more": "More",
            "multipleCurrencies": "Your selection includes multiple currencies. Please add a filter to select a single currency.",
            "multipleSalaryTypes": "Your selection includes multiple salary types. Please add a filter to select a single salary type.",
            "name": "Name",
            "new": "New",
            "newSalary": "New salary",
            "newTotalSalary": "New total salary",
            "no": "no",
            "noAuditSelected": "No audit selected",
            "noDataAvailableToFilterOn": "No data available for this filter",
            "noExplanation": "No explanation",
            "noFactorPlanSelected": "No factor plan selected",
            "noFilterMatchesSearch": "No filters found",
            "noFurtherAnalysis": "This data visualization is purely a summery and no further analysis is made here.",
            "noIncompleteEvaluations": "No incomplete job evaluations found",
            "noInsights": "This employee has no insights.",
            "noJobsInGrade": "No jobs exist in this grade",
            "noResultsFound": "No search results for {searchTerm}",
            "nonFemaleDominatedWorks": "Non-female-dominated jobs",
            "notAffectedByClusterTags": "Will not be affected by cluster tags.",
            "notDeclared": "Not declared",
            "notEnoughValuesForFilter": "Not enough distinct values to filter",
            "note": "Note",
            "occupationalPension": "Occupational pension",
            "onLeave": "On leave",
            "onboarding": {
                "createJobs": "Create jobs",
                "deleteDraft": "Delete draft",
                "deleteDraftInfo": "You will lose all progress from this draft if you delete it. Are you sure you want to delete the draft? ",
                "emptySection": "This section is empty...",
                "goToPublishedAudit": "Go to published audit",
                "missingUsername": "Missing user name",
                "payPhilosophyV2": {
                    "columns": {
                        "coverage": "Coverage",
                        "distinctValues": "Distinct values"
                    }
                },
                "review": {
                    "accessSection": {
                        "subHeader": "People with access to the audit:",
                        "title": "Access"
                    },
                    "analyticalFocusSection": {
                        "compareBetweenEmployees": "Compare between employees",
                        "salaryComponents": "Salary components",
                        "title": "Your analytical focus"
                    },
                    "copilotSection": {
                        "copilotNotActivated": "Copilot analysis hasn't been activated.",
                        "selectedSettings": "Selected Copilot settings:",
                        "subHeaders": {
                            "jobsWithFewEmployees": "Jobs with less than {count} employees",
                            "lowUnadjustedPayGaps": "Jobs with lower than {count}% unadjusted pay gaps",
                            "singleGenderedJobs": "Single gendered jobs"
                        }
                    },
                    "createdJobsSection": {
                        "jobsAreCreatedFrom": "Jobs are created from",
                        "title": "Created Jobs"
                    },
                    "employmentSelectionSection": {
                        "filterCriteria": "Filter Criteria",
                        "importedEmployees": "Imported Employees"
                    },
                    "generalSection": {
                        "auditAppliesFrom": "Audit applies from",
                        "comparativeJobAnalysis": "Comparative Job Analysis",
                        "preferredSalaryDifference": "Preferred Salary Difference",
                        "title": "Title"
                    },
                    "payPhilosophySection": {
                        "noPayFactors": "No pay factors have been selected. You won’t be able to see adjusted pay gap and other metrics without pay factors.",
                        "subHeader": "Selected pay factors:",
                        "title": "What should drive salaries?"
                    },
                    "selectedEmployees": "Selected Employees",
                    "title": "Review",
                    "yourAnalyticalFocus": "Your analytical focus"
                }
            },
            "oneTimeBonus": "One time bonus",
            "openIncompleteEqualJob": "Open incomplete equal job",
            "openOngoingJobs": "Open ongoing jobs",
            "organisation": "Organisation",
            "organisationLevel": "Organization level {level}",
            "organisationNode": "Organisation node",
            "organization": "Organization",
            "organizationLevelFive": "Organization level 5",
            "organizationLevelFour": "Organization level 4",
            "organizationLevelOne": "Organization level 1",
            "organizationLevelSix": "Organization level 6",
            "organizationLevelThree": "Organization level 3",
            "organizationLevelTwo": "Organization level 2",
            "organizationalLevels": "Organizational Level {level}",
            "organize": {
                "allEmployments": "All employments",
                "benchmark": "Benchmark",
                "benchmarkLower": "Lower",
                "benchmarkMiddle": "Middle",
                "benchmarkUpper": "Upper",
                "createAndMove": "Create and move ({count})",
                "employmentsToGroup": "Employments to group",
                "enterDescription": "Enter a description of the job",
                "enterWorkName": "Enter job name",
                "enterWorkNo": "Enter job number",
                "hideSearchBar": "Hide search bar",
                "newWorkName": "New job",
                "newWorkNo": "New job code",
                "showSearchBar": "Show search bar",
                "userGuideContent": "Here you group the employments in each job. The system helps with suggestions to facilitate the work.",
                "workCreated": "Job was successfully created",
                "workName": "Job name",
                "workNo": "Job code",
                "workNoAlreadyInUse": "{workNo} in use, please choose another"
            },
            "organizeGroup": {
                "addToSelection": "Add matching employments to selection",
                "chooseWork": "Choose job...",
                "confirmDeleteEmptyWorks": "Do you want to delete all empty jobs?",
                "exactMatchingEmploymentsDescription": "The following employments match the chosen employment's statistical code and position. ",
                "moveOriginal": "Move original selection",
                "moveWithSelected": "Move with additionally selected rows",
                "noCompaRatio": "No compa-ratio",
                "noEmptyWorksToRemove": "There are no empty jobs to remove.\nAll jobs contains one or more employments.",
                "noLocality": "No locality",
                "noOrganization": "No organization",
                "noPosition": "No position title",
                "noStatisticalCode": "No statistical code",
                "noWork": "No job",
                "removeEmployees": "Remove employees from the pay equity audit",
                "removeEmployeesConfirmation": "Are you sure you want to remove {number} employees from the pay equity audit?",
                "wantToAddToSelection": "Do you want to add them to the selection?",
                "wantToMove": "Do you want to move them as well?",
                "worksToRemove": "The following jobs will be removed:"
            },
            "other": "Other",
            "otherSalaryInformation": "Other salary information",
            "overtime": "Overtime",
            "overview": {
                "activeMeasures": "Active measures.",
                "additionalErrorInfo": "Or turn off the lab features \"cost to close\" and \"new equal job analysis\" via system settings.",
                "adjustedPayGap": "Adjusted pay gap",
                "agreeToReplace": "I agree to replace my existing analysis reason codes and salary adjustments with those generated by the cost to close analysis",
                "analyzingFactors": "Analyzing factors",
                "applyCostToClose": "Add cost to close to analysis",
                "compaRatioChart": {
                    "title": "Salary Compa-ratio",
                    "xAxisLabel": "Compa-ratio"
                },
                "cost": "Cost",
                "costToFix": "Cost to close pay gap ",
                "costToFixAnalysis": "Cost to close to analysis",
                "costToFixAnalysisText": "When you add cost to close to analysis we’ll add the following for the selected employees:",
                "costToFixAnalysisWarning": "The current audit contains employees with chosen analysis reason codes and/or pay adjustments. These may be overwritten if you chose to apply the cost to close adjustments",
                "costToFixDescription": "The cost to close functionality attempts to reduce the adjusted pay gap in your organisation to the tolerated pay gap by applying salary increases to employees found to be underpaid when your selected pay factors are taken into consideration.",
                "costToFixErrorText": "This usually happens when our statistical models don't align with your data, but it doesn't affect our calculations for your pay gaps and other metrics.",
                "costToFixErrorTextE003": "The adjusted pay gap already falls within the range of your selected value. Please refine your settings to make further adjustments.",
                "costToFixErrorTitle": "We couldn’t calculate your cost to close",
                "costToFixTolerated": "Cost to reach tolerated pay gap",
                "costToFixWomenEarnMoreText": "In your results, women earn more than men. Our model is built to calculate cost-to-close amounts only when men are the higher-earning group. In this situation, the calculation doesn't work reliably, so we can't show a cost-to-close figure.",
                "costToFixWomenEarnMoreTitle": "We couldn't calculate your cost to close",
                "costToFixZeroPercent": "Cost to reach 0% pay gap",
                "costToFixZeroPercentTooltip": "The cost to reach 0% adjusted pay gap with the same cost to close calculations.",
                "downloadCostToFixReport": "Download",
                "editFactors": "Edit factors",
                "emptyState": {
                    "buttonText": "Select employees",
                    "message": "To display the charts on this page, select which employees to include in the analysis.",
                    "title": "You haven't imported any data yet"
                },
                "erroeDownloadingCostToFixReport": "Error downloading the cost to close report. Please try again",
                "errorState": {
                    "buttonTextReloadChart": "Reload chart",
                    "buttonTextReloadKeyValues": "Reload key values",
                    "messageChart": "We failed to load your data. Do you want to reload the chart?",
                    "messageKeyValues": "We failed to load your data. Do you want to reload the key values?"
                },
                "genderDistributions": "Gender distributions",
                "grade": "Grade",
                "infoTooltip": "Adjusted pay gap is the difference between men's and women's salaries but takes different factors that affect pay into account. When a pay gap is negative, women earn more than men.",
                "largetRaise": "Largest raise (tolerated adjusted pay gap)",
                "lowerPercentile": "Lower quartile",
                "maxSalary": "Max salary",
                "meanSalary": "Mean salary",
                "meanSalaryMen": "Mean salary {'|'} Men",
                "meanSalaryWomen": "Mean salary {'|'} Women",
                "meanSalaryWomenAfter": "Mean salary {'|'} Women (After salary corrections)",
                "mensMeanSalary": "Men’s mean salary",
                "minSalary": "Min salary",
                "modifyCostToClose": "Modify cost to close to analysis",
                "mostAffectedGrades": "10 most affected grades",
                "mostAffectedGradesText": "This list is based on the cost to reach tolerated adjusted pay gap.",
                "mostAffectedJobs": "10 most affected equal jobs",
                "mostAffectedJobsText": "This list is based on the cost to reach tolerated adjusted pay gap.",
                "multipleCurrenciesWithoutCompaRatio": "We can’t calculate all values when your employees have different currencies. Either remove all employees with the different currencies or toggle compa-ratio in settings.",
                "newUnadjustedPayGap": "New unadjusted pay gap",
                "numberOfRaises": "Number of raises",
                "numberOfRaisesTolerated": "No. of raises (tolerated)",
                "numberOfRaisesZeroPercent": "No. of raises (0%)",
                "numberOfRolesTolerated": "No. of raises (tolerated)",
                "originalUnadjustedPayGap": "Unadjusted pay gap",
                "overview": "Overview",
                "overviewIsNotAvailable": "Overview is not available!",
                "payFactorsDifferences": "Many employees could not be included in the calculation of your adjusted pay gap because data was missing for one or more of the selected pay factors. Open the pay philosophy for more information",
                "payGapPerGradeChart": "Unadjusted pay gap after cost to close per grade",
                "payGapsLinkText": "How are pay gaps calculated?",
                "percentageFemale": "Percentage women",
                "percentageMale": "Percentage men",
                "percentageNotDeclared": "Percentage not declared",
                "quartilesChart": "Cost to close per salary quartile",
                "quartilesChartText": "Data is based on the cost to reach tolerated adjusted pay gap.",
                "raises": "1 raise | {count} raises",
                "raisesButton": "Raises",
                "reasonForAnalysis": "Reason for analysis.",
                "removeCostToFix": "Remove cost to close actions from analysis",
                "removeCostToFixAnalysis": "Remove cost to close from analysis",
                "removeCostToFixAnalysisText": "We’ll remove all actions applied when you added the cost to close to analysis. We’ll update employees’: ",
                "removeCostToFixConfirm": "Remove cost to close from analysis",
                "salary": "Salary",
                "salaryStrcuturePerGradeChart": "Pay structures per grade",
                "selectFactors": "Select pay factors",
                "selectPayFactors": "Select pay factors you want to influence your salaries in order to see your adjusted pay gap",
                "selectPayFactorsToSeeEqualityTimer": "Select pay factors you want to influence your salaries in order to see the adjusted pay gap equality timer",
                "share": "Share",
                "smallestRaise": "Smallest raise (tolerated adjusted pay gap)",
                "toleratedPayGap": "Tolerated pay gap",
                "toleratedPayGapSerries": "New unadjusted pay gap (after cost to close tolerated)",
                "toleratedPayGapTooltip": "The tolerated pay gap",
                "unadjustedPayGap": "Unadjusted pay gap",
                "unexplained": "Unexplained",
                "updateCostToFix": "Update cost to close to analysis",
                "updateCostToFixAnalysis": "Update cost to close to analysis",
                "updateCostToFixAnalysisText": "We’ll update all actions applied when you added the cost to close to analysis based on the current tolerated pay gap. We’ll update employees’:",
                "updateCostToFixConfirm": "Update cost to close to analysis",
                "upperPercentile": "Upper Quartile",
                "womensMeanSalary": "Women’s mean salary",
                "womensToleratedMeanSalary": "Women’s mean salary after cost to close (tolerated adjusted pay gap)",
                "yourPayGaps": "Your pay gaps",
                "zeroPayGap": "New unadjusted pay gap (after cost to close 0%)"
            },
            "paidSickDays": "Paid sick days",
            "parentLeave": "Parental leave",
            "parentalLeaveEndDate": "Parental leave end date",
            "parentalLeaveStartDate": "Parental leave start date",
            "payBand": "Pay band",
            "payGrade": "Pay grade",
            "payPhilosophy": {
                "factorToggledMessage": "You’ll receive more data and insights once the audit has been created.",
                "payFactors": "Pay factors",
                "payFactorsDescription": "Select which pay factors you want to affect a employee's salary. What can't be explained by your pay factors will be your adjusted pay gap.",
                "title": "Pay philosophy"
            },
            "payRatio": "Pay ratio",
            "perMonth": "/mo",
            "percentile": "{percentile}-percentile",
            "performance": "Performance | Performances",
            "points": "Points",
            "position": "Position title",
            "positionLevel": "Position Level",
            "positionTitle": "Position title",
            "positionTitleWorkSplitCard": {
                "1": "If you don’t want to use any of the options above and instead analyse employees with the same position."
            },
            "predictedSalary": "Predicted salary",
            "predictedSalaryTooltip": "Can't be applied if the current salary is above the predicted salary.",
            "preview": "Preview",
            "previousAuditCard": {
                "1": "If you want to group employees same as you did previous years in Sysarb.",
                "2": "Able to compare analysis and results from previous years."
            },
            "previousResultModal": {
                "adjustedPayGap": "Adjusted pay gap",
                "calculationErrorMessage": "Couldn't calculate the adjusted pay gap with the selected factors.",
                "errorMessage": "We failed to load your previous result. Try refreshing the page. If the error persists, contact our technical support team.",
                "howThisAffectsYou": "All calculations in this audit have been redone using the updated model. Your adjusted pay gap numbers may differ from before. You cannot revert this audit to the previous model.",
                "howThisAffectsYouTitle": "How this affects you",
                "intro": "This audit was created before we updated the math model used to calculate your adjusted pay gap. To keep all audits running on the same, actively maintained model, we're migrating the remaining older audits now, including this one.",
                "payFactors": "Pay factors",
                "selectedPayFactors": "Selected pay factors",
                "title": "Previous result",
                "unadjustedPayGap": "Unadjusted pay gap",
                "whatChanged": "The calculation logic for your adjusted pay gap has been updated. The new model supports a wider range of factors and runs more reliably when several factors are selected at once.",
                "whatChangedTitle": "What changed",
                "whyNowBulletCostToClose": "Audits using the cost to close feature",
                "whyNowBulletEqualJobAnalysis": "Audits using the equal job analysis feature",
                "whyNowBulletRecent": "Audits created within the last two years",
                "whyNowIntro": "The updated model has already been in use for:",
                "whyNowOutro": "This audit didn't fall into any of those categories, which is why it ran on the older model until now. All your other ongoing audits are unaffected.",
                "whyNowTitle": "Why now"
            },
            "quartile": {
                "lower": "Lower Quartile",
                "lowerMiddle": "Lower Middle Quartile",
                "lowerMiddleShort": "Lower Middle",
                "lowerShort": "Lower",
                "unknown": "Unknown",
                "upper": "Upper Quartile",
                "upperMiddle": "Upper Middle Quartile",
                "upperMiddleShort": "Upper middle",
                "upperShort": "Upper"
            },
            "quota": "Quota",
            "reasonForAnalysis": "Reason for analysis",
            "removeAdjustmentsInfo": "You will remove all adjustments, including \"frozen salaries\" added to the employees. You can't undo this action. Are you sure you want to remove all adjustments for the selected employees?",
            "removeExplanations": "Remove explanations",
            "removeExplanationsInfo": "You will remove all explanations, including \"Other explanations\" added to the employee. You can't undo this action. Are you sure you want to remove all explanations for the selected employees?",
            "report": {
                "comparativeWorkAdjustments": "Comparative Work Adjustments",
                "equalWork": "Equal works",
                "equalWorkAdjustment": "Equal work adjustments",
                "equivalentWork": "Comparative works",
                "exportActionPlanV2": "Action plan",
                "exportFromAnalyse": {
                    "adjustedPayGap": "Adjusted Pay Gap",
                    "adjustedPayGapMaleFemale": "Pay gap (F/M)",
                    "analyseEqualWorks": "Analyze equal jobs",
                    "analyseEquivalentWorks": "Analyze comparative jobs",
                    "analyzeCompilation": {
                        "averageAge": "Average age",
                        "averageYearsOfEmployment": "Average company tenure",
                        "comparedWith": "Compared with",
                        "connectedWork": "Comparative job",
                        "eightiethPercentile": "80th salary percentile",
                        "eightiethSalaryComponentPercentile": "Salary component 80th percentile",
                        "employmentQuotaOnSalaryYear": "Employment quota of {count} years salary",
                        "employmentQuotaWithoutSalaryYear": "Employment quota without salary year",
                        "excludeSingleEthnicity": "and ethnicity",
                        "femaleDominatedWork": "Female dominated job",
                        "femaleDominatedWorks": "Groups of female dominated jobs in equal jobs",
                        "femaleDominatedWorksToAnalyse": "Female dominated jobs to analyze",
                        "fileName": "Key values - compilation",
                        "filteredValuesEqualWorks": "Filtered values equal analyze",
                        "filteredValuesEquivalentWorks": "Filtered values comparative analyze",
                        "groupsEqualWorks": "Groups of equal jobs",
                        "groupsEqualWorksToAnalyse": "Groups of equal jobs to analyze (excluding single gender {ethnicityString})",
                        "groupsMenEarnsMore": "Groups where men earn more than women(excluding single gender)",
                        "groupsMenEarnsMoreMean": "Groups where men earn more than women (mean, excluding single gender)",
                        "groupsMenEarnsMoreMedian": "Groups where men earn more than women (median, excluding single gender)",
                        "groupsNoSalaryDiff": "Groups without salary ratio between gender(excluding single gender)",
                        "groupsWomenEarnsMore": "Groups where women earn more than men(excluding single gender)",
                        "groupsWomenEarnsMoreMean": "Groups where women earn more than men (mean, excluding single gender)",
                        "groupsWomenEarnsMoreMedian": "Groups where women earn more than men (median, excluding single gender)",
                        "hideGroups": "Hide groups with less than {count} employees",
                        "hideGroupsInactive": "Hide small groups filter is inactive.",
                        "hideSalaryDifferences": "Hide salary ratio below {count} %",
                        "hideSalaryDifferencesInactive": "Hide salary ratio filter is inactive.",
                        "hideSingleGender": "Hide single gender works",
                        "hideSingleGenderInactive": "Hide single gender works filter is inactive.",
                        "incompleteEvaluation": "Incomplete Evaluation",
                        "keyValueAllEmployees": "Key values for all employees",
                        "keyValueFilteredData": "Key values - filtered data",
                        "keyValueFilteredEmployees": "Key values for filtered employees",
                        "maxSalary": "Max Salary",
                        "meanSalary": "Mean Salary",
                        "meanSalaryCurrency": "Mean salary ratio {currency}",
                        "meanSalaryPercent": "Mean unadjusted pay gap %",
                        "meanSalaryRatio": "Mean unadjusted pay gap %",
                        "meanUnadjustedPayGapCurrency": "Mean unadjusted pay gap {currency}",
                        "meanUnadjustedPayGapPercent": "Mean unadjusted pay gap %",
                        "medianSalary": "Median Salary",
                        "medianSalaryCurrency": "Median salary ratio {currency}",
                        "medianSalaryPercent": "Median salary ratio %",
                        "medianSalaryRatio": "Median salary ratio %",
                        "medianUnadjustedPayGapCurrency": "Median unadjusted pay gap {currency}",
                        "medianUnadjustedPayGapPercent": "Median unadjusted pay gap %",
                        "menQuota": "Men quota",
                        "minSalary": "Min salary",
                        "ninetiethPercentile": "90th salary percentile",
                        "ninetiethSalaryComponentPercentile": "Salary component 90th percentile",
                        "numberOfEmployees": "Number of employees",
                        "salaryComponentMax": "Salary component max salary",
                        "salaryComponentMean": "Salary component mean salary",
                        "salaryComponentMeanUnadjusted": "Salary component unadjusted (Mean)",
                        "salaryComponentMedian": "Salary component median salary",
                        "salaryComponentMedianUnadjusted": "Salary component unadjusted (Median)",
                        "salaryComponentMin": "Salary component min salary",
                        "salaryData": "Salary data",
                        "salaryDifference": "Salary ratio (F/M)",
                        "salaryDifferenceMean": "Salary ratio (Mean)",
                        "salaryDifferenceMedian": "Salary ratio (Median)",
                        "salarySpread": "Salary spread",
                        "selectedFilters": "Selected filters:",
                        "singleGenderDifference": "Single gendered ratio",
                        "smallGroups": "Small groups",
                        "smallGroupsConnectedWorks": "Small groups - comparative jobs",
                        "smallGroupsFemaleDominated": "Small groups - female dominated",
                        "smallSalaryDifference": "Small salary ratio",
                        "tenthPercentile": "10th salary percentile",
                        "tenthSalaryComponentPercentile": "Salary component 10th percentile",
                        "twentiethPercentile": "20th salary percentile",
                        "twentiethSalaryComponentPercentile": "Salary component 20th percentile",
                        "unadjustedSalaryDifference": "Unadjusted pay gap (F/M)",
                        "ungroupedEmployeesRemoved": "1 employee has been filtered because it doesnt have a connected job | {count} employees has been filtered because they dont have any connecting job",
                        "valuationBox": "Grade",
                        "valuationGrade": "Grade",
                        "valuationPoints": "Valuation points",
                        "womenQuota": "Women quota"
                    },
                    "compilationEmployees": "Compilation - Employees",
                    "exportActiveMeasures": {
                        "actionPlan": "Actionplan",
                        "activeMeasures": "Active measures",
                        "comparativeWorks": "Comparative jobs",
                        "costYear1": "Cost year 1",
                        "costYear2": "Cost year 2",
                        "costYear3": "Cost year 3",
                        "employeesTotalCost": "Total cost employees",
                        "totalCost": "Total cost",
                        "totalCostInclEmployments": "Total cost (incl. employees)"
                    },
                    "header": "Export from analyse",
                    "noEqualWorksToExport": "You have no completed equal job analysis to export",
                    "noEquivalentWorksToExport": "You have no completed comparative job analysis to export",
                    "payGapAfterExplanation": "Est. pay gap after explanations",
                    "structureTags": "Structure tags",
                    "summary": "Summary",
                    "unadjustedSalaryDifferenceMean": "Unadjusted pay gap (Mean)",
                    "unadjustedSalaryDifferenceMedian": "Unadjusted pay gap (Median)"
                },
                "exportFromOrganize": {
                    "benchmark": "Benchmark",
                    "benchmarkLower": "Lower",
                    "benchmarkMiddle": "Middle",
                    "benchmarkUpper": "Upper",
                    "employee": {
                        "contract": "Contract",
                        "managerCode": "Manager code",
                        "name": "Name",
                        "organisationNode": "Organisation node",
                        "position": "Position title",
                        "socialSecurityNumber": "Unique-ID",
                        "statisticalCode": "Statistical code",
                        "totalSalary": "Total salary"
                    },
                    "exportEqualPayAuditWorks": {
                        "equalPayAuditWorks": "Pay equity audit jobs",
                        "fileName": "Pay equity audit jobs, employments",
                        "notes": "Notes"
                    },
                    "exportFactorPlan": {
                        "description": "Description",
                        "factorLevels": "Factor levels",
                        "factorPoints": "points",
                        "factorWeight": "Factor weight",
                        "overview": "Overview",
                        "valuationHelpText": "Evaluation help-text"
                    },
                    "exportWorkValuation": {
                        "box": "Grade: ",
                        "grade": "Grade",
                        "points": "Points",
                        "valuationResultSheetName": "Valuation result",
                        "workFactorLevelSheetName": "Job - Factor - Level",
                        "workFactorValuationSheetName": "Job - Factor - Points",
                        "workValuation": "Job evaluation & evaluation result"
                    },
                    "factorPlan": "Factor plan",
                    "header": "Export from organize"
                },
                "exportTemplates": {
                    "finishedReport": "Final report template",
                    "header": "Report templates"
                },
                "grade": "Grade",
                "gradeSummary": "Grade summary",
                "individualAdjustments": "Individual adjustments",
                "individuals": "Individuals",
                "jobSummary": "Job summary",
                "premadeReports": "Premade reports",
                "storeDocument": "Store document",
                "totals": "Total",
                "userGuideContent": "Here you will find all the reports that you can generate from the system. Choose which layout you want and what the reports should contain."
            },
            "requiredField": "You need to add a {title}",
            "requiredToAnalyze": "Required to analyze",
            "review": "Review",
            "salary": "Salary",
            "salaryAdjustmentsInfo": "Salary adjustments will only affect employees in your sphere of responsibility.",
            "salaryComponents": "Salary components",
            "salaryDate": "Salary date",
            "salaryDifference": "Salary ratio (F/M)",
            "salaryDifferenceCurrency": "Salary ratio {currency}",
            "salaryDifferencePercent": "Salary ratio %",
            "salaryEffectedBy": "Salary effected by",
            "salaryEffectedByTags": "Salary effected by *amount of employees with tag",
            "salaryExchange": "Salary exchange",
            "salaryIncreaseGroup": "Salary increase, group",
            "salaryIncreaseIndividual": "Salary increase, individual",
            "salaryIncrement1": "Salary increment 1",
            "salaryIncrement2": "Salary increment 2",
            "salaryIncrement3": "Salary increment 3",
            "salaryInfo": {
                "1": "The default way of analysing pay discrepancies.",
                "2": "Able to make a comparative job analysis.",
                "3": "Compliant with EU Pay Transparency reporting."
            },
            "salarySpan": "Salary span",
            "salaryType": "Salary type",
            "salaryYear": "Salary year",
            "searchWork": "Search job",
            "selectAudit": "Select Audit",
            "selectExplanations": "Select explanations to apply...",
            "selectFactorPlan": "Select factor plan",
            "selectFactorPlanOptional": "Select factor plan (optional)",
            "selectJobEvaluation": "Select job evaluation",
            "selectPayFactors": "Select pay factors you want to influence your salaries in order to see your adjusted pay gap",
            "selected": "selected",
            "settings": {
                "filterForWorks": {
                    "equalWork": "Equal job:",
                    "filterBelow": "Filter below",
                    "general": "General",
                    "oneGender": "Hide single gendered groups",
                    "oneGenderOneEthnicity": "Hide single gendered groups with only one ethnicity",
                    "people": "people",
                    "salaryDifferenceText": "Groups with an unadjusted pay gap lower than the given percentage will be hidden in the analysis of Equal jobs.\nThe pay gap in Equal jobs is calculated between genders within the group.\nThe pay gap in comparative jobs is calculated between female-dominated and non-female-dominated jobs.",
                    "salaryDifferenceTextEthnicity": "Groups with an unadjusted pay gap lower than the given percent will be hidden in the analysis of Equal jobs. \nThe pay gap in Equal jobs is calculated between genders and ethnicities within the group. \nThe pay gap in comparative jobs is calculated between female-dominated and non-female-dominated jobs.",
                    "salaryRatio": "unadjusted pay gap",
                    "singleGenderAndEthnicityText": "Groups that include only employees of a single gender and the same ethnicity will be hidden in the analysis of Equal jobs.",
                    "singleGenderText": "Groups that include only employees of a single gender will be hidden in the analysis of Equal jobs.",
                    "smallGroupText": "Groups that include fewer than the given number of employees will be hidden in the Equal and Comparative jobs analysis."
                },
                "operationalAdministrator": "Operational administrator",
                "overview": {
                    "acceptableDistance": "Automated analysis {'|'} Acceptable distance",
                    "analysis": "Analysis",
                    "automatedAnalysis": "Automated analysis",
                    "automatedAnalysisCustomOutlierOver": "Acceptable distance over median",
                    "automatedAnalysisCustomOutlierUnder": "Acceptable distance under median",
                    "automatedAnalysisInfoText": "Automated analysis is a tool for identifying individuals within groups of equal jobs that should be analyzed.\nThe tool is currently in alpha and should only be used as guidance in your analysis work.",
                    "costToFix": "Cost to close",
                    "country": "Country",
                    "equalWorkAnalysisType": "New equal jobs",
                    "general": "General",
                    "hideEquivalentWorkAnalysis": "Hide comparative jobs analysis features",
                    "legalEntity": "Legal Entity",
                    "maxCharacters": "Max 50 characters.",
                    "scope": "Scope",
                    "scopeText": "Which country and legal entity your employees primarily belong to",
                    "startDate": "Pay equity audit start date",
                    "title": "Title",
                    "toleratedPayGap": "Tolerated pay gap"
                },
                "security": {
                    "addOperationalAdministrator": "Add Operational administrator",
                    "addOperationalAdministratorHelptext": "Add users with the role \"Operational administrator\" to give them access to the current pay equity audit.",
                    "noOperationalAdministrators": "You have no operational administrators. You can add the operational administrator role to employees in the registry.",
                    "registry": "Registry"
                }
            },
            "shortTermIncentive": "Short term incentive",
            "similar": "similar",
            "socialSecurityNumber": "Unique-ID",
            "sortedBy": "Sorted by:",
            "standardDeviationDistance": "Standard deviation",
            "state": {
                "active": "Active",
                "completed": "Completed",
                "draft": "Draft"
            },
            "statisticalCode": "Statistical code",
            "statisticalCodeName": "Statistical code name",
            "statisticalCodeWorkSplitCard": {
                "1": "If you’re using statistical codes to categorise jobs and want to more easily compare with other organisations using the same statistical codes."
            },
            "statutoryGradeWorkSplitCard": {
                "1": "Employees with the same statutory grade will be grouped together for analysis"
            },
            "strong": "strong",
            "subFamilyAndLevelCard": {
                "1": "Employees will have similar job assignments.",
                "2": "Will create the second largest job size."
            },
            "suggestionMatch": {
                "employmentsInDifferentGroups": "Suggestions are unavailable because the selected employees have different positions/statistical codes.",
                "loading": "Loading suggestions…",
                "matchRatio": "{number}/{total}",
                "noSuggestions": "Select employees to get job suggestions based on matching position titles and statistical code.",
                "noSuggestionsAvailable": "No suggestions are available for the selected employees.",
                "subTitle": "This employment matches:",
                "workMatch": "Position title matches job title"
            },
            "suggestions": "Suggestions",
            "summary": "Summary",
            "switchToStructure": "Switch to structure",
            "sysarbdStandardFactors": {
                "10Levels": "Sysarb Standard (including responsibility for people)",
                "9Levels": "Sysarb Standard (excluding responsibility for people)"
            },
            "tagLevel": "Tag level",
            "tagName": "Tag name",
            "tags": "Tags",
            "targetBonus": "Target bonus",
            "than": "than",
            "thePredictedSalary": "the predicted salary",
            "timeInCurrentPosition": "Job tenure",
            "to": "to",
            "toleratedPayGap": "New unadjusted pay gap (after cost to close tolerated)",
            "total": "Total",
            "totalSalary": "Total salary",
            "totalSalaryComparisonInfo": "When you want to include salary increments, salary exchanges or similar when you compare salaries between employees.",
            "unableToCalculateModel": "We couldn't calculate your predicted salaries. Select a different data visualization to continue your analysis.",
            "unableToCalculateModelAlt": "An illustration of a hand clicking on orange square",
            "unableToCalculateModelSidebar": "With no predicted salaries we can’t show you the list on who to analyze.",
            "unableToFlagForAnalysis": "An unexpected error occurred while attempting to update the flag status.",
            "unableToUpdateEmploymentAnalysisState": "An error occurred while updating the employment analysis state. Please try again later.",
            "unableToUpdateExplanation": "An unexpected error occurred while attempting to update the explanation",
            "unadjustedPayGapCurrency": "Unadjusted pay gap {currency}",
            "unadjustedPayGapPercent": "Unadjusted pay gap %",
            "unknown": "Unknown",
            "valuationBox": "Valuation box",
            "valuationBoxes": "Grades",
            "valuationHelp": "Valuation help",
            "weak": "weak",
            "womenRatio": "Women ratio",
            "work": "Job",
            "workTag": "Job tags",
            "workTags": {
                "competence": "Competence",
                "competingLaborMarket": "Competing labor market",
                "experience": "Experience",
                "heterogenousGroup": "Heterogeneous group",
                "historicalSalary": "Historical salary",
                "marketSalaryWhenRecruiting": "Market salary when recruiting",
                "other": "Other",
                "performance": "Performance",
                "responsibility": "Responsibility",
                "unknown": "Unknown"
            },
            "workValuation": "Job evaluation",
            "yearlyPayouts": "Yearly payouts",
            "yearlySalaries": "Yearly salaries",
            "zeroSalaryConversionWarning": "Some employees will have a base salary of 0 after conversion. This may be due to missing values for 'Yearly payouts' or 'Full-time working hours per month', or because their current base salary is already 0. Update any missing values to ensure accurate salary conversion."
        },
        "pdfAdjustedPayGap": {
            "adjustedPayGapMean": "Adjusted pay gap {'|'} Mean",
            "adjustedPayGapMedian": "Adjusted pay gap {'|'} Median",
            "payFactors": "Pay factors",
            "unexplained": "Unexplained"
        },
        "settings": {
            "formErrorsTooltip": "You still have fields that require your attention. Check the warning icons for more information."
        },
        "unadjustedPayGap": {
            "meanMedianToggleTitle": "mean/median",
            "menMeanSalary": "Men mean salary",
            "menMedianSalary": "Men median salary",
            "tooltipInfo": "Unadjusted pay gap is the difference between men's and women's salaries expressed as a percentage of men's salary. When a pay gap is negative, women earn more than men.",
            "unadjustedPayGap": "Unadjusted pay gap",
            "unadjustedPayGapMean": "Unadjusted pay gap {'|'} Mean",
            "unadjustedPayGapMedian": "Unadjusted pay gap {'|'} Median",
            "womenMeanSalary": "Women mean salary",
            "womenMedianSalary": "Women median salary"
        }
    },
    "components": {
        "activities": {
            "count": "You have {count} {type}",
            "error": "Unable to fetch activities.",
            "latestDueDate": "First due at {date}",
            "noOngoingActivities": "You have no ongoing activities."
        },
        "activityType": {
            "assessment": "Assessment | Assessments",
            "discussion": "Discussion | Discussions",
            "performanceReview": "Performance Review | Performance Reviews",
            "salaryReview": "Salary Review | Salary Reviews",
            "target": "Target | Targets",
            "targetsReached": "{completedCount} / {totalCount} targets reached"
        },
        "adjustedPayGapChart": {
            "payFactors": "Pay factors"
        },
        "adjustedPayGapEqualityTimer": {
            "adjustedEqualityTimer": "Adjusted equality timer",
            "calculatedOnAdjustedAverage": "Calculated with an adjusted mean salary ",
            "calculatedOnAdjustedMedian": "Calculated with an adjusted median salary "
        },
        "adminSettings": {
            "settings": "Settings"
        },
        "administrator": {
            "active": "Active | Active",
            "analyze": "Analyze",
            "analyzeAlpha": "Analyze (Alpha)",
            "archived": "Archived",
            "baseRegister": "Base register",
            "costCenter": "Cost center",
            "createEmployee": "Create employee",
            "customerInformation": "Customer information",
            "dashboard": "Dashboard",
            "discussion": "Discussion",
            "done": "Done",
            "draft": "Draft",
            "employee": "Employees",
            "employment": "Employments",
            "featureFlags": "Feature flags",
            "file": "Files",
            "fileImportFailed": "Salary file \"{name}\" could not be imported, please try again. If the problem persists, contact support.",
            "fileImported": "Salary file \"{name}\" was imported successfully",
            "friends": "Friends",
            "importSalaryFile": "Import salary file",
            "imported": "Imported",
            "importedPercent": "Importing...",
            "importing": "Importing salary file",
            "inactive": "Inactive",
            "job-architecture": "Job Architecture",
            "mappings": "Pay equity",
            "matchColumns": "Match columns",
            "new": "NEW",
            "newAnalysis": "New analysis",
            "newDiscussion": "New discussion",
            "newDraft": "New salary review",
            "newSalaryFile": "New salary file",
            "newSalaryFileAlpha": "New salary file (Alpha)",
            "noAnalysis": "No saved analysis",
            "noName": "- no name -",
            "noRows": "No rows are imported",
            "oldImports": "Old imports",
            "ongoing": "Ongoing",
            "organisation": "Organisation",
            "organisationStructure": "Employee management",
            "partnerPlatform": "Partner platform",
            "preparations": "Preparations",
            "private": "Private",
            "report": "Report",
            "salary": "Salary",
            "salaryCriteria": "Salary criteria",
            "salaryReview": "Salary review",
            "salaryStructure": "Import data",
            "security": "System & Security",
            "settings": "Settings",
            "ssoSettings": "Single sign-on",
            "statisticalCode": "Statistical code",
            "system": "System",
            "templates": "Templates",
            "union": "Union",
            "uploadedFailed": "Failed file upload",
            "user": "User",
            "users": "Users",
            "validateValues": "Validate values",
            "verified": "The file is validated",
            "verifying": "Validating values",
            "work": "Job"
        },
        "agListTooltip": {
            "empty": "There are currently no items to display",
            "error": "Couldn't load data, please try again."
        },
        "agSelectJobClusterDropdown": {
            "add": "Add",
            "noJobCluster": "No job cluster",
            "noMatches": "No matches",
            "searchOrCreate": "Search for or create a job cluster by entering its name"
        },
        "agentChat": {
            "visualWomen": "Women",
            "visualMen": "Men",
            "visualGap": "{gap} gap",
            "visualGenderCounts": "{women} women · {men} men",
            "visualBreakdownOf": "of {total}",
            "modelLabel": "Model: {model}. Choose the model for this conversation",
            "modelDefault": "default",
            "modelOpus55": "Claude Opus 5.5",
            "modelOpus55Detail": "The most capable model, for most questions",
            "modelOpus48": "Claude Opus 4.8",
            "modelOpus48Detail": "The previous model, to compare answers",
            "modelSonnet55": "Claude Sonnet 5.5",
            "modelSonnet55Detail": "Faster and cheaper, for quick questions",
            "modelSwitchTitle": "Start a new conversation?",
            "modelSwitchBody": "One model answers a whole conversation. Switching to {model} starts a new one, and this conversation stays in your history.",
            "modelSwitchConfirm": "Start new conversation",
            "stepsToggle": "Steps",
            "questionAnsweredOwnWords": "Answered in your own words",
            "questionOther": "Something else",
            "questionSkip": "Skip",
            "questionReplyDirectly": "Or reply directly…",
            "historyTitle": "Your conversations",
            "historyCollapse": "Hide conversations",
            "historyNew": "New conversation",
            "historyRecent": "Recent",
            "historyPrevious": "Previous",
            "historyEmpty": "No conversations yet",
            "historyEmptyBody": "Ask a question and the conversation is saved here for you to pick up later.",
            "historyNoMatch": "No conversations match your search",
            "historyNoMatchBody": "Try another word from the question you asked.",
            "historyUntitled": "Untitled conversation",
            "historyError": "Your conversations could not be loaded",
            "historyHide": "Delete “{title}”",
            "suggestionsGapsHeading": "Pay gaps",
            "askGapOverall": "What is the pay gap between men and women?",
            "askGapOverallDetail": "The unadjusted gap for each country you operate in, and the population behind it.",
            "askGapByPosition": "Where are the largest pay differences by position?",
            "askGapByPositionDetail": "Ranks the jobs with enough people of both genders to compare.",
            "askGapUnexplained": "Which groups account for most of the unexplained pay gap?",
            "askGapUnexplainedDetail": "Attributes the adjusted gap to the combinations of factors it sits in.",
            "askHeadcount": "How many employees are included, and by country?",
            "askHeadcountDetail": "What every figure rests on, including who falls outside it.",
            "askSuppressed": "Which groups are too small to report on?",
            "askSuppressedDetail": "Where the disclosure floor withheld figures, and how many it covered.",
            "suggestionsArchitectureHeading": "Job architecture",
            "askArchitecture": "How complete is our job architecture?",
            "askArchitectureDetail": "How much of the workforce has been placed in it, and how much is left.",
            "askFamilies": "Which job families do we have, and how large are they?",
            "askFamiliesDetail": "Every family, with the jobs and sub-families under it.",
            "askProfiles": "Which job profiles carry the most employees?",
            "askProfilesDetail": "The profiles in use, and how many people hold each one.",
            "askUnevaluated": "Which job profiles are missing a job evaluation?",
            "askUnevaluatedDetail": "Profiles with no grade, whose predicted pay cannot be calculated.",
            "suggestionsStructureHeading": "Pay structure",
            "askRanges": "What do our pay ranges look like per level?",
            "askRangesDetail": "The range published for each level of the job architecture.",
            "askRangePosition": "Who sits outside their pay range?",
            "askRangePositionDetail": "Where employees fall against the range for their own level.",
            "askCompression": "Is pay compressed anywhere?",
            "askCompressionDetail": "Screens comparable jobs for extra years bringing little extra pay.",
            "askTenure": "How does pay track length of service?",
            "askTenureDetail": "Average pay by service band, within groups that compare.",
            "askTopEarners": "Who are the highest paid in Sweden?",
            "askTopEarnersDetail": "The top of the pay distribution for one country.",
            "suggestionsMarketHeading": "Market comparison",
            "askMarketBiggestRole": "How does our pay compare with the market for our biggest role?",
            "askMarketBiggestRoleDetail": "Market pay for the job title most people here hold, beside what we pay for it.",
            "askMarketConfidence": "How much data sits behind the market figures we are shown?",
            "askMarketConfidenceDetail": "The record counts on each side. The smaller of the two governs how much the comparison can carry.",
            "suggestionsReportingHeading": "Reporting",
            "askReportLeadership": "Prepare a detailed pay equity briefing for our leadership team",
            "askReportLeadershipDetail": "The headline figures, where the largest differences sit, and the population behind each one.",
            "askReportReadiness": "What do we need in place before we can report?",
            "askReportReadinessDetail": "Coverage, unevaluated roles and groups too small to disclose.",
            "askReportByCountry": "Break the headline figures down by country",
            "askReportByCountryDetail": "Each country on its own, in its own currency — never combined.",
            "askReportExplain": "How do I explain our pay gap figure to employees?",
            "askReportExplainDetail": "What the measure does and does not show, in plain words.",
            "suggestionsMethodHeading": "Method and law",
            "askMeasure": "How is the adjusted pay gap calculated?",
            "askMeasureDetail": "The reviewed definition, the population it uses and what it cannot establish.",
            "askThresholds": "Which thresholds does the analysis use, and where do they come from?",
            "askThresholdsDetail": "The screening cut-offs, their units, and who owns each one.",
            "askCountryRules": "What does Sweden require of us this year?",
            "askCountryRulesDetail": "Our written guidance on one country’s pay-transparency rules.",
            "askDirective": "How is the directive being transposed where we operate?",
            "askDirectiveDetail": "Country by country, what is already law and what is still proposed.",
            "askSalaryBasis": "Do these figures include bonus and pension?",
            "askSalaryBasisDetail": "Which pay definition the analysis used, and what it leaves out.",
            "askEqualValue": "Are we comparing equal work or work of equal value?",
            "askEqualValueDetail": "Which job grouping the comparisons came from, and what that can support.",
            "allSuggestions": "All suggestions",
            "proposalUnrenderable": "Operator proposed something this version cannot display. Reload the page, or contact support if it persists.",
            "failedAction": "Sorry — I couldn't do that for you right now.",
            "failedJobProfile": "Sorry — I couldn't put together a valid job profile for you right now.",
            "stepDrafting": "Drafting a proposal for you to approve…",
            "proposalCriteria": "Criteria",
            "proposalFactorLevel": "Factor level",
            "proposalLevelPending": "The level is set during calibration; the factor sum positions the profile but does not decide it.",
            "proposalCurrentProfile": "Current profile",
            "proposalNewlyHired": "None – newly hired",
            "proposalSuggestedProfile": "Suggested profile",
            "proposalEmployments": "Employments",
            "proposalAssignedAsDraft": "{count} employments assigned as a draft",
            "proposalAutoShort": "Auto",
            "proposalAutoStop": "Stop approving automatically",
            "proposalAutoJobProfile": "Approve this and all future job profiles",
            "proposalAutoAssign": "Approve this and all future profile assignments",
            "proposalRetry": "Run again",
            "proposalAskJobProfile": "Do you want to create the job profile “{name}”?",
            "proposalAskAssign": "Do you want to assign {count} employments to “{profile}”?",
            "proposalAskNote": "Do you want to record this analysis note?",
            "proposalAssignBody": "Suggested by the Job Architecture Copilot from job title wording. Approving assigns the profile as a draft; publishing the job architecture is a separate step.",
            "proposalNoteHeading": "Analysis note",
            "proposalTypeJobProfile": "Job profile",
            "proposalTypeAssignment": "Profile assignment",
            "proposalEmploymentsCount": "{count} employments",
            "proposalPager": "{position} of {total}",
            "proposalPrevious": "Previous proposal",
            "proposalNext": "Next proposal",
            "proposalShowDetails": "Show details",
            "proposalHideDetails": "Hide details",
            "proposalInvalid": "This proposal does not match your data and cannot be approved as it stands.",
            "proposalDecisionFailed": "That didn't go through — please try again.",
            "proposalDeny": "Reject",
            "proposalApprove": "Approve",
            "statusPending": "Awaiting approval",
            "statusApproved": "Approved",
            "statusExecuting": "In progress",
            "statusExecuted": "Done",
            "statusDenied": "Declined",
            "statusExpired": "Expired",
            "statusFailed": "Did not complete",
            "statusInvalid": "Cannot be approved",
            "visualRowsShown": "Showing {shown} of {total} rows",
            "visualQuoteCitation": "{title}, last changed {date}",
            "flag": "Report a problem",
            "flagged": "Reported — thank you.",
            "flagFailed": "Your report could not be sent. Please try again.",
            "flagTitle": "Report a problem with this answer",
            "flagIntro": "Tell us what went wrong, so the answers can be improved. Only problems are collected here.",
            "flagReasonLabel": "What was wrong with it?",
            "flagReasonFigure": "A figure looks wrong",
            "flagReasonCausal": "It claimed a cause, or judged whether pay was fair",
            "flagReasonRefusal": "It refused something it should be able to answer",
            "flagReasonMisread": "It answered a different question to the one I asked",
            "flagReasonOther": "Something else",
            "flagNoteLabel": "What happened?",
            "flagNoteInfo": "Optional. The question, the answer and the data it read are already attached to this report.",
            "flagNotePlaceholder": "For example: the Sweden figure does not match the employee register.",
            "flagSubmit": "Send report",
            "sources": "Sources",
            "sourcesTitle": "Sources",
            "sourcesIntro": "Everything below is exactly what the data tools returned. The answer above may only use figures that appear here.",
            "sourcesForTool": "Show the sources for {tool}",
            "sourcesRawTitle": "Unparsed response",
            "sourcesEmptyColumns": "Columns with no values in any row: {columns}",
            "readMoreAboutSource": "about this source",
            "sourceSysarbAnalysisFor": "Sysarb analysis – {country}",
            "sourceBriefFor": "Source brief – {country}",
            "limitationsTitle": "What these figures cannot tell you",
            "limitationsIntro": "Reported by the tools that produced this data. These limits apply to every figure in the answer.",
            "calculatedFigures": "Calculated figures",
            "calculatedFiguresIntro": "Figures the assistant worked out rather than read directly. Each was recalculated and checked against the data.",
            "figure": "Figure",
            "workingOut": "Calculation",
            "checkedAgainst": "Checked against",
            "auditSummaryShort": "{toolCalls} data lookups · {dataSubjects} individuals",
            "toolOverview": "the pay overview",
            "toolPayGap": "the pay gap breakdown",
            "toolJobArchitecture": "the job architecture",
            "toolJobFamilies": "the job families",
            "toolJobProfiles": "the job profiles",
            "toolPayRanges": "the pay ranges",
            "toolRangePosition": "positions against the pay ranges",
            "toolTenureProfile": "pay against length of service",
            "toolTopEarners": "the top of the pay distribution",
            "toolPayCompression": "the pay structure for compression",
            "toolAdjustedGap": "the adjusted-gap attribution",
            "toolCountryGuidance": "our written country guidance",
            "toolExplainMeasure": "the measure definitions",
            "toolMarketComparison": "the market comparison",
            "toolPayFactors": "which factors move pay",
            "toolPayChangepoints": "where pay changes across a factor",
            "toolUnassignedEmployments": "the employees left to group",
            "toolFactorPlan": "the factor plan",
            "toolJobEvaluation": "the job evaluation",
            "sourceGuidanceFor": "Our written guidance – {country}",
            "stepPlanning": "Planning the answer…",
            "stepLookingUp": "Looking up reference information…",
            "checking": "Reading your data…",
            "writing": "Writing the answer…",
            "toolMarketJobProfile": "the market job profile",
            "toolSearchJobFamilies": "the job family catalogue",
            "composerLabel": "Ask Operator a question",
            "name": "Operator",
            "send": "Ask",
            "stop": "Stop",
            "working": "Working…",
            "disclaimer": "Operator is an AI assistant and can make mistakes. Check the figures before acting on them.",
            "failed": "Something went wrong. Please try again.",
            "tookSeconds": "Took {seconds}s",
            "greetingLookAt": "What would you like to look at?",
            "greetingStart": "Where shall we start?",
            "greetingLookInto": "What can I look into for you?",
            "greetingFindOut": "What are you looking into today?",
            "greetingFirst": "What should we look at first?",
            "greetingFigures": "What are you working on?",
            "greetingUnderstand": "What can I help you with?",
            "greetingBegin": "Where would you like to begin?",
            "greetingNeedToKnow": "What would you like to know?",
            "greetingReview": "What would you like to review?"
        },
        "analytics": {
            "activeKeyValues": "Activate key values",
            "addKeyValue": "Add key values",
            "addOption": "Add",
            "addSegment": "New segment",
            "age": "Age",
            "analysis": "Analysis",
            "analysisName": "Name of analysis",
            "analytics": "Analyze",
            "averageHoursWorked": "Average hours worked",
            "baseRegister": "Base register",
            "chartError": "Error while fetching data",
            "chartTitle": "Chart title",
            "chooseData": "Choose data to analyze",
            "compaRatio": "Compa-ratio",
            "confirmLeave": "You have unsaved changes, do you want to continue?",
            "contract": "Contract",
            "contractedHours": "Contracted hours",
            "copyOf": "Copy of",
            "copySegment": "Copy segment",
            "costCenter": "Cost center",
            "createNewAnalysis": "Create new analysis",
            "currency": "Currency",
            "dateOfBirth": "Age",
            "delete": "Delete",
            "deleteSegment": "Remove segment",
            "editTitle": "Edit title",
            "employeesInternal": "Employees Internal",
            "employeesMarket": "Employees Market",
            "employmentDate": "Company tenure start date",
            "employmentEndDate": "Company tenure end date",
            "employmentRate": "Employment rate",
            "employmentTime": "Company tenure",
            "enterName": "Enter name...",
            "equity": "Long-term incentive",
            "ethnicity": "Ethnicity",
            "export": "Export",
            "false": "False",
            "female": "Female",
            "formOfEmployment": "Form of employment",
            "friends": "Friends",
            "gender": "Gender",
            "genders": "Gender",
            "global": "Sysarb templates",
            "groupBy": "Group by",
            "hideFilters": "Hide filters",
            "hourly": "Employed hourly",
            "hourlySalary": "Hourly salary",
            "individual": "Individual",
            "individualWorkValuation": "Individual job evaluation",
            "insights": "Insights",
            "internalFilters": "Internal filters",
            "keyValueHeader": "Key values",
            "keyValues": {
                "averageAge": "Average age",
                "averageSalary": "Average salary",
                "count": "Count",
                "internal": "Internal",
                "maxSalary": "Max salary",
                "meanYearsOfEmployment": "Average company tenure",
                "medianSalary": "Median Salary",
                "medianYearsOfEmployment": "Median company tenure",
                "minSalary": "Min salary",
                "percentileSalary10": "10th salary percentile",
                "percentileSalary20": "20th salary percentile",
                "percentileSalary80": "80th salary percentile",
                "percentileSalary90": "90th salary percentile",
                "total": "Total"
            },
            "lastPayIncrease": "Last pay increase",
            "male": "Male",
            "manager": "Manager",
            "managerCode": "Manager code",
            "mapping": "Pay equity audit",
            "market": "Market",
            "marketFilters": "Market filters",
            "marketStatisticsSeries": "Market - {seriesName}",
            "modifyKeyValues": "Edit key values",
            "newAnalysis": "New analysis",
            "noGroup": "No group",
            "noValueSelected": "No value selected",
            "organization": "Organisation",
            "organizationLevel": "Organization level",
            "performance": "Performance",
            "position": "Position title",
            "positionLevel": "Position level",
            "private": "Private",
            "promptPlaceholder": "Describe what you want to analyse",
            "promptTitle": "What do you want to analyze?",
            "rankOnYAxis": "Rank on employments",
            "removeFilter": "Remove filter",
            "report": "Report",
            "resetKeyValues": "Reset key values",
            "salary": "Salary",
            "salaryDate": "Salary date",
            "salaryExchange": "Salary exchange",
            "salaryIncrement": "Salary Increment",
            "salaryIncrementSecond": "Salary increment second",
            "salaryIncrementThird": "Salary increment third",
            "salaryReview": "Salary review",
            "save": "Save",
            "saveAnalysisChanges": "Save changes for",
            "saveAs": "Save as",
            "saveType": "Choose how you want to save the analysis",
            "saved": "Saved!",
            "segment": "Segment | Segments",
            "showFilters": "Show filters",
            "showMarketDataNo": "Hide market data",
            "showMarketDataYes": "Show market data",
            "statisticalCode": "Statistical code",
            "subdomain": "Organisation",
            "switchDatasourceWarning": "Switching data source will reset filters on the segment",
            "timeInCurrentPosition": "Job tenure",
            "totalSalary": "Total salary",
            "true": "True",
            "unknownField": "Unknown field",
            "user": "Private",
            "whatDoYouWantToCreate": "What do you want to analyze today?",
            "work": "Job",
            "workName": "Job title",
            "workNo": "Job code",
            "yearsOfEmployment": "Company tenure"
        },
        "analyticsChart": {
            "advanced": {
                "regression": "Regression",
                "showEQ": "Equation",
                "showLinearRegression": "Linear regression analysis",
                "showR": "r-value",
                "showR2": "r²-value",
                "showSE": "Standard error"
            },
            "age": "Age",
            "all": "All",
            "analysis": "Analysis",
            "analysisHelperSectionOne": "I want to analyze employees'",
            "analysisHelperSectionThree": "with the data grouped by",
            "analysisHelperSectionTwo": "by their",
            "bucketSize": "X Axis count",
            "chart": "Chart types",
            "clickToSort": "Click to sort.",
            "columns": "Columns",
            "count": "Count",
            "diagramTitle": "Diagram",
            "disabledHideSalary": "Presentation mode has salaries toggled off",
            "disabledLegalEntity": "Cannot group on legal entity on segments not using pay equity audit or base registry as the data source",
            "disabledLocalCareerBand": "Cannot group on local career band if segments contain data source with market",
            "disabledLocalJobFamily": "Cannot group on local job family if segments contain data source with market",
            "disabledLocalJobProfile": "Cannot group on local job profile if segments contain data source with market",
            "disabledLocalJobProfileLevel": "Cannot group on local job profile grade if segments contain data source with market",
            "disabledOrganisationLevel": "Cannot group on organisation level if segments contain data source with market",
            "disabledPayGrade": "Cannot group on pay grade if segments contain data source with market",
            "disabledPositionLevel": "Cannot group on position level if segments contain data source with market",
            "disabledRegion": "Cannot group on region if segments contain data source other than market",
            "disabledStatutoryGrade": "Cannot group on statutory grade on segments not using pay equity audit or base registry as the data source",
            "disabledValuationBoxes": "Cannot group on valuation boxes on segments not using pay equity audit as the data source",
            "disabledWork": "Cannot group on the job on segments not using pay equity audit as the data source",
            "dragToRearrangeClickToSort": "Drag to order columns.\nClick to sort.",
            "editTitle": "Edit title",
            "employmentTime": "Company tenure",
            "employmenttime": "Company tenure",
            "error": {
                "1000": "Missing subdomain",
                "1001": "Invalid data source",
                "1002": "Missing X or Y axis",
                "1003": "BucketSize need to be higher than 0",
                "1004": "Relative Y axis is not supported for market data",
                "1005": "Invalid Y axis",
                "1006": "Missing filter",
                "1007": "Missing percentile. Percentile should be a value between 0 and 0.5 non inclusive",
                "1008": "Relative Y axis is not supported for box plot",
                "1009": "Percentile should be a value between 0 and 0.5 non inclusive",
                "1010": "useBuckets is true but no argument for number of buckets is supplied or the number of buckets is set to 0 which is not supported",
                "1011": "Missing key values in request",
                "1012": "Missing groupby field in request",
                "1013": "Can not rank on y in line charts",
                "1014": "Missing fields property",
                "1015": "No ID field",
                "1016": "Could not find any employee matching the given id",
                "1017": "Response too large",
                "1027": "An error occurred while fetching data. Contact Customer Success",
                "activateSelectionToShowData": "Activate a segment to display data in the chart",
                "chartSelectionHasNoData": "Segment has no results",
                "filterNotComplete": "Cannot load data as filters are not ready",
                "noSelections": "There are no segments to show in the diagram",
                "notOnlyMarketInScatter": "Cannot show scatter plot for market data only"
            },
            "friends": "Friends",
            "gender": "Gender",
            "group": "Group",
            "groupBy": "Group by",
            "groupSeries": "Show top",
            "groupSeriesBy": "largest groups",
            "grouping": "Group",
            "internal": "Internal",
            "jobArchitecture": "Job architecture",
            "jobFamily": "Job family",
            "jobGrade": "Job grade",
            "legalEntity": "Legal entity",
            "localCareerBand": "Local career band",
            "localJobArchitecture": "Local job architecture",
            "market": "Market",
            "marketDataTooltip": "You need to activate market data in order to show market data in the chart",
            "modifyColumns": "Modify columns",
            "name": "Name",
            "noGroup": "No group",
            "noRowsToShow": "There is no data to show",
            "open": "Open",
            "organisation1": "Organisation level 1",
            "organisation2": "Organisation level 2",
            "organisation3": "Organisation level 3",
            "organisation4": "Organisation level 4",
            "organisation5": "Organisation level 5",
            "organisation6": "Organisation level 6",
            "organization": "Organisation",
            "otherGroups": "Merged groups",
            "payGrade": "Pay grade",
            "percentileSalary10": "10th salary percentile",
            "percentileSalary20": "20th salary percentile",
            "percentileSalary80": "80th salary percentile",
            "percentileSalary90": "90th salary percentile",
            "performance": "Performance",
            "position": "Position title",
            "positionLevel": "Position level",
            "rankOnYAxis": "Rank on employments",
            "region": "Region",
            "resetCustomHeaders": "Reset columns",
            "salary": "Salary",
            "salaryRelativeMean": "Average salary (%)",
            "salaryRelativeMedian": "Median salary (%)",
            "search": "Search...",
            "searchPlaceholder": "Search...",
            "sector": "Sector",
            "segment": "Segment | Segments",
            "selectColumns": "Select columns",
            "settings": "Settings",
            "showMarketData": "Show market data",
            "showSegment": "Show data for segment",
            "softLines": "Soft diagram lines",
            "statisticalCode": "Statistical code",
            "timeInCurrentPosition": "Job tenure",
            "toolbar-icon": {
                "bar": "Bar chart",
                "box": "Box plot",
                "excel-export": "Export to a Excel file",
                "expand": "Expand",
                "line": "Line chart",
                "scatter": "Scatter plot",
                "settings": "Settings",
                "table": "Table",
                "zoom": "Reset zoom level",
                "zoom-disabled": "Zoom level is already reset"
            },
            "totalSalary": "Total salary",
            "unknown": "unknown",
            "unknownError": "An error occurred",
            "valuationBox": "Grade",
            "valuationPoints": "Valuation points",
            "work": "Job",
            "yourSegments": "Your segments"
        },
        "analyticsFilterFieldHelper": {
            "absolute": "Absolute",
            "age": "Age",
            "analysisComplete": "Analyzed",
            "averageHoursWorked": "Average hours worked",
            "compaRatio": "Compa-ratio",
            "contract": "Contract",
            "contractedHours": "Contracted hours",
            "costCenter": "Cost center",
            "country": "Country",
            "currency": "Currency",
            "dateOfBirth": "Birthdate",
            "employmentDate": "Company tenure start date",
            "employmentEndDate": "Company tenure end date",
            "employmentRate": "Employment rate",
            "equity": "Long-term incentive",
            "ethnicity": "Ethnicity",
            "female": "Female",
            "fieldNames": {
                "accessstate": "User state",
                "additionaldataone": "Additional data 1",
                "additionaldatasecond": "Additional data 2",
                "additionaldatathird": "Additional data 3",
                "age": "Age",
                "analysiscomplete": "Analyzed",
                "averagehoursworked": "Average hours worked",
                "bonusactualbonus": "Short-term incentive",
                "bonusbenefitsinkind": "Benefits in kind",
                "bonusonetimebonus": "One time bonus",
                "bonustargetbonus": "Target bonus",
                "companycarallowance": "Car allowance",
                "comparatio": "Compa-ratio",
                "contract": "Contract",
                "contractedhours": "Contracted hours",
                "contracttype": "Contract type",
                "costcenter": "Cost center",
                "country": "Country",
                "currency": "Currency",
                "dateofbirth": "Birthdate",
                "employmentdate": "Company tenure start date",
                "employmentenddate": "Company tenure end date",
                "employmentrate": "Employment rate",
                "employmenttime": "Company tenure",
                "equity": "Long-term incentive",
                "ethnicity": "Ethnicity",
                "formofemployment": "Form of employment",
                "gender": "Gender",
                "globaljobfamilyid": "Job family",
                "hasemail": "Have email",
                "hasphonenumber": "Have phonenumber",
                "haveconnectedjob": "Has assigned job profile",
                "haveemployee": "Has employee",
                "haveuser": "Has user",
                "holidayspaidholiday": "Paid holiday",
                "holidayspaidsickDays": "Paid sick days",
                "holidayspaidsickdays": "Paid sick days",
                "hourly": "Employed hourly",
                "hourlysalary": "Hourly salary",
                "id": "Employee",
                "importDate": "Import date",
                "individualworkvaluation": "Individual job evaluation",
                "industry": "Industry",
                "jobcode": "Job code",
                "jobfamily": "External job family",
                "jobgroup": "Job group",
                "jobtitle": "Job profile",
                "jobvaluationlevel": "Job grade",
                "lastimported": "Latest import",
                "lastpayincrease": "Last pay increase",
                "legalentitycode": "Legal entity code",
                "legalentityname": "Legal entity name",
                "localcareerband": "Local career band",
                "locality": "Locality",
                "localjobcode": "Local job code",
                "localjobfamily": "Local job family",
                "localjobprofile": "Local job profile",
                "localjobprofilelevel": "Local job profile grade",
                "localsubfamily": "Local subfamily",
                "logintype": "Login type",
                "managercode": "Manager code",
                "managername": "Manager",
                "mappingdate": "Pay equity audit date",
                "mappingname": "Pay equity audit",
                "name": "Name",
                "occupationalclassification": "Occupational classification",
                "organisation1": "Organisation level 1",
                "organisation2": "Organisation level 2",
                "organisation3": "Organisation level 3",
                "organisation4": "Organisation level 4",
                "organisation5": "Organisation level 5",
                "organisation6": "Organisation level 6",
                "organisationnodename": "Organisation",
                "organisationnodeunitnumber": "Unit number",
                "overtime": "Overtime",
                "parentalleaveenddate": "Parental leave end date",
                "parentalleavestartdate": "Parental leave start date",
                "payBand": "Pay band",
                "payGrade": "Pay grade",
                "pensionoccupationalpension": "Occupational pension",
                "performance": "Performance",
                "position": "Position title",
                "positionlevel": "Position level",
                "region": "Region",
                "resultintervalid": "Result interval",
                "role": "Role",
                "salary": "Salary",
                "salarydate": "Salary date",
                "salaryexchange": "Salary exchange",
                "salaryincrement": "Salary increment",
                "salaryincrementsecond": "Salary increment 2",
                "salaryincrementthird": "Salary increment 3",
                "salaryreviewdate": "Salary review date",
                "salaryreviewname": "Salary review",
                "salarytype": "Salary type",
                "salaryyear": "Salary year",
                "sector": "Sector",
                "sentwelcomeemailboolean": "Sent welcome email",
                "sharestatistics": "Share statistics",
                "statisticalcodecode": "Statistical code",
                "statisticalcodename": "Statistical code name",
                "status_value": "Employment status",
                "statutorygrade": "Statutory grade",
                "subdomain": "Friends",
                "timeincurrentposition": "Job tenure",
                "totalsalary": "Total salary",
                "union": "Union",
                "valuationbox": "Valuation box",
                "valuationboxnumber": "Grade",
                "valuationpoints": "Valuation points",
                "workname": "Job",
                "worknumber": "Job code",
                "yearlypayouts": "Yearly payouts"
            },
            "finished": "Finished",
            "formOfEmployment": "Form of employment",
            "gender": "Gender",
            "hourly": "Employed hourly",
            "hourlySalary": "Hourly salary",
            "individual": "Individual",
            "individualWorkValuation": "Individual job evaluation",
            "lastPayIncrease": "Last pay increase",
            "male": "Male",
            "managerCode": "Manager code",
            "mappingDate": "Pay equity audit date",
            "mappingName": "Pay equity audit | Pay equity audits",
            "misc": "Misc",
            "mostCommonFilters": "The most common filters",
            "name": "Name",
            "notFinished": "Not finished",
            "operator": {
                "after": " after ",
                "before": " before ",
                "beginsWith": " begins with ",
                "between": " between ",
                "contains": " contains ",
                "endsWith": " ends with ",
                "equalTo": " is ",
                "exactly": " exactly ",
                "greaterThan": " greater than ",
                "greaterThanOrEqualTo": " greater than or equal to ",
                "in": " is one of ",
                "isFalse": " is false ",
                "isNotNull": "is not null",
                "isNull": "is null",
                "isTrue": " is true ",
                "lesserThan": " lesser than ",
                "lesserThanOrEqualTo": " lesser than or equal to ",
                "moreThan": " more than ",
                "notContains": " doesn't contain ",
                "notEndsWith": " doesn't end with ",
                "notEqualTo": " is not ",
                "notIn": " is not one of ",
                "notStartsWith": " doesn't start with ",
                "on": " on "
            },
            "organisation1": "Organisation level 1",
            "organisation2": "Organisation level 2",
            "organisation3": "Organisation level 3",
            "organisation4": "Organisation level 4",
            "organisation5": "Organisation level 5",
            "organisation6": "Organisation level 6",
            "other": "Other filters",
            "performance": "Performance",
            "position": "Position title",
            "positionLevel": "Position level",
            "relative": "Relative",
            "salary": "Salary",
            "salaryDate": "Salary date",
            "salaryExchange": "Salary exchange",
            "salaryIncrement": "Salary increment",
            "salaryIncrementSecond": "Salary increment 2",
            "salaryIncrementThird": "Salary increment 3",
            "salaryReviewDate": "Salary review date",
            "salaryReviewName": "Salary review | Salary reviews",
            "statisticalCode": "Statistical code",
            "statisticalCodeName": "Statistical code name",
            "status_value": "Employment status",
            "timeInCurrentPosition": "Job tenure",
            "totalSalary": "Total salary",
            "valuationBox": "Grade",
            "work": "Work",
            "years": " years"
        },
        "analyticsKeyValues": {
            "activeKeyValues": "Activate key values",
            "addKeyValue": "Add key values",
            "addToShow": "Activate a segment or add a new segment to view key values",
            "editTitle": "Edit title",
            "keyValues": "Key Values",
            "modifyKeyValues": "Edit key values",
            "noKeyValues": "No key values are selected",
            "resetKeyValues": "Reset key values",
            "settings": "Settings",
            "showSegment": "Show data for segment"
        },
        "analyzeEmploymentList": {
            "analyzeEmployee": "Analyze employee",
            "employmentTags": "Tags",
            "groupBy": "Group by",
            "hidden": "Hidden",
            "name": "Name",
            "organisationNode": "Organisation node",
            "organization": "Organisation",
            "otherAnalysis": "Other analysis",
            "position": "Position title",
            "salary": "Salary",
            "salaryIncrement": "Salary increment",
            "salaryIncrementSecond": "Salary increment second",
            "salaryIncrementThird": "Salary increment third",
            "showHide": "Show/hide",
            "shown": "Shown",
            "socialSecurityNumber": "Unique-ID",
            "statisticalCode": "Statistical code",
            "toggleEmployee": "Shown/hidden",
            "totalSalary": "Total salary",
            "workEmployments": "Employments in group {work}"
        },
        "analyzeEmploymentSidebar": {
            "analyze": {
                "addAdjustments": "Add adjustments",
                "adjustSalary": "3. Adjust salary",
                "adjustSalaryDescription": "If employee is underpaid, you increase their salary.",
                "adjustYearIndexValue": "Year {index} ({value})",
                "adjustYearYearNumber": "Year {yearNumber}",
                "adjustments": "Adjustments",
                "apply": "Apply",
                "applyPredictedSalary": "Apply predicted salary",
                "companyPerformance": "Company performance",
                "competingLaborMarket": "Competing labor market",
                "employeeSalaryAffectedBy": "Employee's salary is affected by...",
                "explainCurrentSalaries": "2. Explain current salaries",
                "explainCurrentSalary": "2. Explain current salary",
                "explanations": "Explanations",
                "failedToUpdateYearly": "Failed to update yearly increase.",
                "freezeSalary": "Freeze salary",
                "freezeSalaryDescription": "If employee is overpaid, you freeze their salary.",
                "freezeSalaryError": "An unexpected error occurred while attempting to freeze or unfreeze the salary",
                "higherPerformance": "Higher performance",
                "historicalAnalysis": "Historical analysis",
                "lessCompetence": "Less competence",
                "lessResponsibility": "Less responsibility",
                "lowerPerformance": "Lower performance",
                "moreCompetence": "More competence",
                "moreResponsibility": "More responsibility",
                "newTotalSalary": "New total salary",
                "noHistoricalDataAvailable": "This employee has no previous explanations or adjustments.",
                "noHistoricalDataAvailableForGroup": "This group has no previous explanations or adjustments.",
                "noHistoricalGroupExplanations": "This work has no previous historical explanations.",
                "noTags": "No explanations have been added.",
                "otherExplanation": "Other explanation",
                "previousEmployment": "Previous employment",
                "previousSalaryAdjustments": "Previous salary adjustments",
                "previouslyOtherExplanationsUsed": "Previously \"other explanations\" used",
                "previouslyUsedExplanations": "Previously used explanations",
                "previouslyUsedGroupExplanations": "Previously used group explanations",
                "previouslyUsedOtherAssessments": "Previously \"other\" used assessments",
                "reviewHistoricalAnalysis": "1. Review historical analysis",
                "reviewHistoricalGroupAnalysis": "1. Review historical group analysis",
                "salaryIsFrozen": "Salary is frozen",
                "summaryOfYourAnalysis": "Summary of your analysis",
                "totalIncrease": "Total increase"
            },
            "analyzed": "Analyzed",
            "applyExplanationError": "Explanation could not be applied",
            "closeEmploymentSidebar": "Close employment sidebar",
            "explanationApplied": "Explanation applied",
            "flagForAnalysis": "Flag for analysis",
            "loadingMessage": "Loading employee analysis data, please wait...",
            "markEmployeeAsAnalyzed": "Mark employee as analyzed",
            "readonlyHistoricalGroupAnalysis": "Historical analysis",
            "roleDisabledAnalyzeButton": "Disabled due to current User role",
            "unflagForAnalysis": "Remove flag for analysis",
            "usedIn": "Used in:",
            "usedInPreviousAudits": "Used in {count} previous audits"
        },
        "analyzeSideBar": {
            "accordions": {
                "analyzed": {
                    "emptyState": {
                        "description": "You haven't analyzed any employees yet.",
                        "imageAlt": "No analyzed employees"
                    },
                    "title": "Analyzed employess"
                },
                "manuallyAnalyzed": {
                    "emptyState": {
                        "description": "You haven't finished any individual analysis. Select an employee in the lists above or click on an employee in the chart.",
                        "imageAlt": "An illustration of a hand clicking on orange square"
                    },
                    "title": "Analyzed employees"
                },
                "notAnalyzed": {
                    "emptyState": {
                        "description": "All employees have been analyzed.",
                        "imageAlt": "All employees analyzed"
                    },
                    "title": "Not analyzed employess"
                },
                "outsidePayRange": {
                    "description": "Employees in this list have higher or lower salary than the given pay range but with a predicted salary within tolerated distances.",
                    "emptyState": {
                        "description": "All employees who are outside the pay range have been analyzed.",
                        "imageAlt": "An illustration of a checkmark inside a green circle"
                    },
                    "title": "Outside pay range"
                },
                "requiresAnalysis": {
                    "description": "Employees in this list are outliers and their salaries need to be explained or adjusted.",
                    "emptyState": {
                        "action": "Complete analysis",
                        "description": "You've analyzed all outliers. Remaining discrepancies are within your pay factors' parameters.",
                        "imageAlt": "An illustration of a checkmark inside a green circle"
                    },
                    "title": "Requires further analysis (σ > 1.50)"
                },
                "withinScope": {
                    "description": "Employees in this list have salaries that are explained by your organization’s pay philosophy.",
                    "emptyState": {
                        "description": "All employees within scope of pay philosophy have been analyzed.",
                        "imageAlt": "An illustration of a checkmark inside a green circle"
                    },
                    "title": "Within scope of pay philosophy (σ < 1.50)"
                }
            },
            "adjust": "Adjust",
            "analyze": "Analyze",
            "analyzedEmployments": "Analyzed employess",
            "clearFilters": "Clear",
            "commentExplanation": "Comment explanation",
            "completeAnalysis": "Complete analysis",
            "employees": "Employees",
            "employeesToBeAnalyzed": "Number of employees",
            "employeesVisible": "Employees visible",
            "explain": "Explain",
            "filtersAndBatch": "Filters and batch explanations",
            "freezeSalaries": "Freeze salaries",
            "frozenSalaries": "Frozen salaries",
            "groupAnalysis": "Group analysis",
            "individualAnalysis": "Individual analysis",
            "loadingMessage": "Loading analyze data, please wait...",
            "manualSalaryIncreases": "Manual salary increases",
            "markAsAnalyzed": "Mark as analyzed",
            "noSearchResults": "No matching employees found.",
            "notAnalyzedEmployments": "Not analyzed employees",
            "predictedSalaryIncreases": "Predicted salary increases",
            "readMore": "Read more",
            "removeAdjustments": "Remove adjustments",
            "removeMarkAsAnalyzed": "Remove mark as analyzed",
            "search": "Search",
            "summary": "Summary",
            "toolBarMessagePopup": {
                "flaggedForAnalysis": "{employeeCount} employees were flagged for analysis.",
                "freezeSalary": "Salaries were frozen for {employeeCount} employees",
                "manualSalaryIncrease": "Salaries were increased by {totalSalaryIncrease} for {employeeCount} employees",
                "markAsAnalyzed": "{employeeCount} employees were marked as analyzed",
                "multipleExplanations": "{explanationCount} explanations were added to {employeeCount} employees",
                "noExplanation": "No explanations were added",
                "predictedSalaryIncreasesAdded": "Predicted salary increases were added to {employeeCount} employees",
                "singleExplanation": "{explanationValue} was added to {employeeCount} employees",
                "unflaggedForAnalysis": "Removed flag for analysis from {employeeCount} employees."
            },
            "updating": "Updating...",
            "workComplete": "Work complete"
        },
        "analyzeToolbar": {
            "deleteEmploymentAnalysisError": "An unexpected error occurred while attempting to remove explanations",
            "freezeSalariesError": "An unexpected error occurred while attempting to freeze salaries",
            "markAsAnalyzedError": "An unexpected error occurred while attempting to mark employees as analyzed",
            "removeAdjustmentsError": "An unexpected error occurred while attempting to remove adjustments",
            "removeMarkAsAnalyzedError": "An unexpected error occurred while attempting to remove mark as analyzed from employees"
        },
        "article9Report": {
            "categoryName": "Category name",
            "employees": "Employees",
            "femaleEmployees": "Female",
            "grade": "Grade",
            "maleEmployees": "Male",
            "noStatutoryGrade": "No statutory grade",
            "nonDeclaredEmployees": "Non-disclosed",
            "payGapsMean": "Pay gaps (Mean)",
            "payGapsMedian": "Pay gaps (Median)",
            "totalEmployees": "Total",
            "variablePay": "Variable pay"
        },
        "automatedAnalysisSettingsComponent": {
            "ageWeight": "Age",
            "all": "All",
            "automatedAnalysis": "Automated analysis {'|'} Settings",
            "colourGradiant": "Color",
            "employmentTimeWeight": "Company tenure",
            "highlight": "Highlight",
            "highlightLimitInfo": "Highlight limit",
            "mahalanobisCutoff": "Outlier benchmark",
            "mahalanobisCutoffInfo": "Max distance from group mean to not be considerd an outlier. The distances are calculated based on the Mahalanobis distance equation.",
            "salaryWeight": "Salary",
            "visulizationOptions": "Visulization options",
            "weight": "Weight",
            "weightInfo": "Weighting of problem factors"
        },
        "baseRegistry": {
            "CREATE": {
                "employee": "Creating employees",
                "employment": "Creating employments",
                "organisation-node": "Creating organisation nodes",
                "user": "Creating users"
            },
            "DELETE": {
                "employee": "Deleting employees",
                "employment": "Deleting employments",
                "organisation-node": "Deleting organisation nodes",
                "user": "Deleting users"
            },
            "ForcePasswordChangeCount": "You are about to force password change for: Employees",
            "IoImport": "IO import",
            "IoImportInfoText": "You will replace all data on the employees with data from the file you upload",
            "IoSalaryImportInfoText": "Only allows for importing new salaries, expects a file with at least 2 columns in csv format with the names (id, salary). Where id is the id you get when doing an io export of the data.",
            "UPDATE": {
                "employee": "Updating employees",
                "employment": "Updating employments",
                "organisation-node": "Updating organisation nodes",
                "users": "Updating users"
            },
            "acceptSimulation": "Grant access",
            "accessStateOption": {
                "activate": "Activate"
            },
            "accessStateOptions": {
                "0": "Unknown",
                "1": "Active",
                "2": "Inactive",
                "3": "Blocked",
                "null": "Unknown"
            },
            "account": "Account",
            "activate": "Activate",
            "activateEmployees": "Activate employees",
            "activateEmployeesCount": "You will activate:",
            "activateEmployeesText": "You will activate the selected employees, are you sure you want to activate these employees?",
            "activateEmployment": "Activate employment",
            "activating": "Activating...",
            "active": "Active",
            "activeEmployments": "Active employments",
            "add": "Add",
            "addToMapping": "Add to mapping",
            "addToMappingInfoText": "You will add the employees you selected to any active pay equity audit",
            "addToSalaryMapping": "Add employees to pay equity audit",
            "addToSalaryMappingCount": "You are about to add: Employments",
            "areYouSureActivate": "Are you sure you want to activate this employment?",
            "areYouSureDelete": "Are you sure you want to delete this employment?",
            "areYouSureInactivate": "Are you sure you want to inactivate this employment?",
            "bankID": "Swedish BankID",
            "bankId": "BankID",
            "cannotDelete": "Employee and manager roles cannot be deleted",
            "changeCode": "Change code",
            "changeEmploymentsCount": "You are about to change: Employments",
            "changeJobProfile": "Change job profile",
            "changeJobProfileInfoText": "You will change the job profile on the employees' active employments to a job profile of your choice",
            "changeOrgNode": "Change unit",
            "changeOrgNodeInfoText": "You will move the employees' active employments to a unit of your choice",
            "changePassword": {
                "changePassword": "Change password",
                "confirmPassword": "Confirm password",
                "newPassword": "New Password",
                "notAllowedToChangePassword": "You are not allowed to reset the users password. only the user can change it.",
                "setPassword": "Save",
                "unknownError": "Couldn't set password. Try making it more complex."
            },
            "changeStatisticalCodeInfoText": "You will change the statistical code on the employees' active employments to a statistical code of your choice",
            "changeUnionWarning": "The union will be changed on all union roles",
            "chooseActiveEmployments": "One or more of your employees have two or more employments. Select which employments you want to activate.",
            "chooseFileFormat": "Choose file format",
            "chooseInactiveEmployments": "One or more of your employees have two or more employments. Select which employments you want to inactivate.",
            "city": "City",
            "clearInactivateDate": "Clear",
            "common": "Common",
            "country": "Country",
            "create": "Create",
            "createFailText": "See and fix which employees we can't create users for",
            "createNewEmployment": "Create new employment",
            "createNewEmploymentError": "The employment could not be created. Check that all required fields, including legal entity, are filled in.",
            "createNewEmploymentInfo": "In this view, you will create a new employment for your employee",
            "createNewExternalUser": "Create user",
            "createNewExternalUserInfo": "In this view you will create a user",
            "createOrLinkUser": "Create or link user",
            "createUser": "Create user",
            "createUserErrors": {
                "hasUser": "The employee already has a connected user.",
                "invalidSsn": "Invalid social security number.",
                "invalidUsername": "Invalid username.",
                "none": "None",
                "ssnExists": "The social security number already exists.",
                "usernameExists": "Something went wrong, contact Technical Support"
            },
            "createUserTooltip": "E-Legitimation (not required)",
            "createUsers": "Create users",
            "createUsersCount": "You are about to create:",
            "createUsersFailed": "You have {failed} employees for whom we cannot create users. This is normally due to a missing social security number or email. You can fix these now or ignore them and create users for the remaining {createCount} employees. Employees who do not have users will not be able to log in to Sysarb.",
            "createUsersInfoText": "You will create users on the selected employees",
            "creatingRoleJunction": "Creating role junction...",
            "creatingUser": "Creating user...",
            "currentEmployment": "Current employment",
            "dateOfBirth": "Date of birth",
            "delete": "Delete",
            "deleteEmployees": "Delete employees",
            "deleteEmployeesCount": "You are about to delete: Employees",
            "deleteEmployeesInfoText": "You will delete the employees and all data associated with them. You will not be able to restore employees you remove.",
            "deleteEmployment": "Delete employment",
            "deleteEmployments": "Delete employments",
            "deleteEmploymentsCount": "You will remove:",
            "deleteEmploymentsInfoText": "You will delete the employees' employments",
            "deleteOrgNodeError": "You must move all employments out of the organisation nodes before deleting them.",
            "deleteRole": "Delete role",
            "deleteUsers": "Delete users",
            "deleteUsersInfoText": "You will delete the users and all data associated with them. You will not be able to restore users you remove.",
            "deleting": "Deleting...",
            "downloadFile": "Download file",
            "email": "Email",
            "employed": "Employed",
            "employees": "Employees",
            "employment": "Employment",
            "employmentDate": "Employment date",
            "employmentNumber": "Employment number",
            "employmentStatus": "Employment status",
            "employmentTime": "Employment time",
            "employments": "Employments",
            "emptyUserLog": "The employee has no activity registered in Sysarb",
            "exportFileInfoText": "You will download a file containing all data linked to the employees' user and account",
            "exportPdf": "Export employee portal",
            "exportPdfAriaLabel": "for {employee}",
            "exportPdfNoEmployment": "The employee needs an employment to be able to export the employee portal",
            "extendedRoles": "Extended roles",
            "externalUsers": "Users without employee",
            "failedSyncJob": "Cancel changes",
            "female": "Female",
            "fieldDisabledScimTooltip": "This field cannot be changed when using SCIM",
            "firstName": "Forename",
            "fixRequiredFields": "You need to fill in the invalid fields on the employees in the list or these employees already have a user created on them",
            "forceChangePasswordFailed": "Failed to force password change",
            "forcePasswordChange": "Force password change",
            "forcePasswordChangeInfo": "You are about to force a password change for an employee. \nThe employee is logged out and will have to change password the next time they log into Sysarb.",
            "forcePasswordChangeInfoText": "The selected employees will be logged out, they have to change their password the next time they log in to Sysarb",
            "forgotPasswordEmailFailed": "Failed to send forgot password email",
            "forgotPasswordEmailSent": "Forgot password email was sent!",
            "historicalEmploymentFor": "Historical employment for",
            "history": "History",
            "ignoreFailed": "Ignore {count} employee | Ignore {count} employees",
            "importAll": "Create all",
            "inactivate": "Inactivate",
            "inactivateAt": "Inactivate account as of",
            "inactivateEmployees": "Inactivate employees",
            "inactivateEmployeesCount": "You will inactivate:",
            "inactivateEmployeesText": "You will inactivate employees and their active employments. The employees' data is saved among inactive employees until you delete the employees.",
            "inactivateEmployment": "Inactivate employment",
            "inactivateEmploymentsCount": "You are about to inactivate: Employments",
            "inactivating": "Inactivating...",
            "inactiveEmployments": "Inactive employments",
            "inputError": "The unit number is already in use on another organisation node",
            "integrationWarning": "This employee is being managed trough an integration.",
            "invalidInputFields": "One or more of your input fields is not valid",
            "ioExport": "IO export",
            "jobArchitecture": {
                "filterSubfamily": "Filter sub-families"
            },
            "jobProfileEmptyState": "No published job profiles yet. Publish job profiles in the job architecture module to be able to select them here.",
            "jobTenure": "Job tenure",
            "language": "Language",
            "lastForgotPasswordSent": "Last forgot password mail",
            "lastName": "Surname",
            "lastPasswordChange": "Last password change",
            "linkUser": "Connect user",
            "linkUserExplanation": "There isn't any user connected to the employee. Select among your unconnected users or create a new user.",
            "login": "Login",
            "loginType": "Login type",
            "loginTypes": {
                "0": "BankID + Password",
                "1": "2-Factor Authentication",
                "2": "BankID"
            },
            "male": "Male",
            "mapping": "Pay equity audit",
            "moveOrgNodeCount": "You are about to move:",
            "multipleEmployments": "of your employees have two or more employments. Choose which employments you want to move.",
            "multipleEmploymentsToDelete": "of your employees have two or more employments. Choose which employments you want to delete.",
            "never": "Never",
            "newEmployment": "New employment",
            "newRole": "New role",
            "newSalary": "New salary",
            "newSalaryInfoText": "When you create a new salary, the employee's current salary will be saved as a historical salary. After you have created a new salary, you will be able to update other employment data for the new salary.",
            "noActiveEmployments": "The employee has no employments. Create a new one or import it via the file import/integration.",
            "noEmployee": "Missing employee",
            "noEmployeesFound": "No employees found",
            "noEmployeesInfoText": "There were no employees matching your filter and search results.\nTry changing filters or your search to see your employees.",
            "noFieldsMatching": "No fields is matching your search",
            "noHistory": "There is no history to show for this employment",
            "noMoreFieldsToShow": "There are no fields to show.",
            "noUnitsFound": "No organizations found",
            "noUnitsInfoText": "There were no organizations matching your filter and search results.\nTry changing filters or your search to see your organizations.",
            "noUser": "No user exists",
            "noUserCreateOne": "There is no user created on the employee. When an employee receives user rights, the employee will be able to log in and see their salary, performance review, conversations and goals.",
            "noValueSpecified": "No value specified",
            "none": "None",
            "notEmployed": "Not employed",
            "olRoutes": {
                "gotoOld": "Old base registry"
            },
            "oldRoutes": {
                "gotoEmployees": "Employees",
                "gotoEmployments": "Employments",
                "gotoOrganisation": "Organisation",
                "gotoUser": "Accounts"
            },
            "options": {
                "IO": "IO",
                "IOoptions": {
                    "employees": "Employees",
                    "employments": "Employments",
                    "export": "Export",
                    "import": "Import",
                    "users": "Users"
                },
                "activateEmployees": "Activate employees",
                "activateNode": "Activate",
                "addToSalaryMapping": "Add to pay equity audit",
                "change": "Change",
                "changes": {
                    "disabledOnExternalUsers": "This function is only available for employees",
                    "employmentRate": "Employment rate",
                    "jobProfile": "Job profile",
                    "jobTitle": "Job title",
                    "organisationNode": "Organisation node",
                    "position": "Position title",
                    "positionLevel": "Position Level",
                    "salary": "Salary",
                    "statisticalCode": "Statistical code",
                    "status": "Status"
                },
                "createUser": "Create user",
                "delete": "Delete",
                "deleteEmployee": "Employees",
                "deleteEmployments": "Employments",
                "deleteNode": "Delete",
                "deleteUser": "Delete user",
                "deleteUsers": "Delete users",
                "forcePasswordChange": "Force password change",
                "inactivateEmployees": "Inactivate employees",
                "inactivateNode": "Inactivate",
                "inactiveParent": "You cannot change the status of nodes that have an inactive parent node",
                "newEmployee": "New employee",
                "newExternalUser": "New user",
                "noRowsSelected": "No rows are selected",
                "noSelectedEmployee": "You need to select at least one employee",
                "noSelectedEmployeeTitle": "No employee selected",
                "sendWelcomeMail": "Send welcome email",
                "setStatus": "Change status",
                "title": "Options"
            },
            "orgDetailsEmployments": {
                "contractType": "Contract type",
                "country": "Country",
                "currency": "Currency",
                "dateOfBirth": "Date of birth",
                "employmentDate": "Employment date",
                "employmentNumber": "Employment number",
                "employmentStatus": "Employment status",
                "jobCode": "Job code",
                "jobProfile": "Job profile",
                "locality": "Locality",
                "name": "Name",
                "position": "Position title",
                "positionLevel": "Position level",
                "salary": "Salary",
                "statisticalCode": "Statistical code",
                "totalSalary": "Total salary",
                "work": "Work",
                "workNo": "Work number"
            },
            "orgTree": {
                "activate": {
                    "messageBulk": "Are you sure you want to activate this node?\n\nIf you activate the node, all subnodes will also be activated | Are you sure you want to activate 1 node?\n\nIf you activate the node, all subnodes will also be activated | Are you sure you want to activate {n} nodes?\n\nIf you activate the node, all subnodes will also be activated",
                    "title": "Activate"
                },
                "active": "Status",
                "activeStatus": "Active",
                "addDeputyManager": "Add deputy manager",
                "childCount": "Emplyments in sub nodes",
                "common": "General",
                "count": "Employments",
                "create": {
                    "active": "Active",
                    "activeOptions": {
                        "active": "Active",
                        "inactive": "Inactive"
                    },
                    "addAssistant": "Add deputy manager",
                    "create": "Add",
                    "delete": "Remove",
                    "deputyManagerTitle": "Deputy manager",
                    "deputyManagerTitleDescription": "For employees who assist the manager in their work regarding salary review, discussions and development",
                    "findOrganisation": "Filter organizations",
                    "headNode": "Head node",
                    "headOrganisationNode": "Head node",
                    "managerRoles": "Manager roles",
                    "managerTitle": "Manager",
                    "managerTitleDescription": "For employees who have responsibility over other employees in salary review, negotiations and development",
                    "name": "Name",
                    "no-parent": "No parent",
                    "noMatchingNodes": "Nothing matches you search query",
                    "organisation": "Organisation",
                    "status": "Status",
                    "unitNumber": "Unit number"
                },
                "createNode": "Create organisation node",
                "deleteNode": {
                    "messageBulk": "Are you sure you want to delete 1 node? | Are you sure you want to delete {n} nodes?",
                    "title": "Delete"
                },
                "employments": "Employments",
                "failedToDelete": "Failed to delete 1 node | Failed to delete {n} nodes",
                "inactivate": {
                    "message": "If you disable the node, all subnodes with associated employments will also be disabled.",
                    "messageBulk": "Are you sure you want to inactivate this node?\n\nIf you inactivate the node, all subnodes will also be inactivated | Are you sure you want to inactivate 1 node?\n\nIf you inactivate the node, all subnodes will also be inactivated | Are you sure you want to inactivate {n} nodes?\n\nIf you inactivate the node, all subnodes will also be inactivated",
                    "title": "Inactivate"
                },
                "inactiveStatus": "Inactive",
                "manager": "Manager",
                "managerDeputies": "Deputies",
                "managerSelect": {
                    "isManager": "Manager"
                },
                "managers": "Managers",
                "mustEnterName": "You must enter a name",
                "mustSelectNode": "You must select a node",
                "name": "Name",
                "organisation": "Organisation",
                "path": "Position in tree",
                "salary": "Salary review",
                "settings": {
                    "addNode": "New unit",
                    "excelExport": "Export to Excel",
                    "onlyActive": "Only active",
                    "title": "Settings",
                    "tooltip": "Options"
                },
                "unitNumber": "Unit number"
            },
            "organisation": "Organisation",
            "organisationStatus": "Organisation status",
            "organization": "Organisation",
            "organizationLevel": "Organisation level {level}",
            "organizationLockedForAdministrator": "Administrators always have access to the whole organisation, so the head node is used and can't be changed.",
            "organizationNode": "Organization node",
            "otherActiveEmployments": "Other active employments",
            "otherSalaryFields": "Other salary fields",
            "password": "Password",
            "passwordChangeEmailFailed": "Failed to send force password change email",
            "passwordChangeEmailSent": "Force password change email was sent!",
            "passwordChangeFor": "You will force a password change for:",
            "phoneNumber": "Phone number",
            "position": "Position title",
            "positionLevel": "Position level",
            "quickFilters": {
                "clearInfo": "This action will clear the current filter. Do you want to proceed?",
                "clearTitle": "Clear filters",
                "last3days": "Last 3 days",
                "last60days": "Last 60 days",
                "noJob": "No Job profile",
                "noUser": "No User",
                "title": "Quick filters:"
            },
            "remove": "Remove",
            "removeInactivateDate": "Remove the Incativation date",
            "removeRoleJunction": "Remove role junction",
            "role": "Role",
            "roleJunction": "New role junction",
            "roles": "Roles",
            "rolesInfoText": "You will add an extended role to the employee, which gives the employee access to various functions in the platform",
            "rowShiftClick": "Selecting a row and holding down shift while clicking a second row will select the range",
            "salary": "Salary",
            "salaryProperties": "Salary properties",
            "selectJobProfile": "Select job profile",
            "selectOrgNode": "Select organisation node to move to.",
            "selectOrganisation": "Select organisation",
            "selectStatisticalCode": "Select statistical code",
            "selectUnlinkedUser": "Select unconnected user",
            "selectedOutOf": "selected out of",
            "send": "Send",
            "sendForgotPassword": "Forgot password",
            "sendForgotPasswordInfo": "You are about to send forgot password email to an employee",
            "sendWelcomeEmailTo": "You will send welcome email to:",
            "sendWelcomeMail": "Send welcome email",
            "sendWelcomeMailCount": "You will send a welcome email to the employees that they can log in and set up their account in Sysarb with",
            "sendWelcomeMailInfo": "You are about to send welcome email to an employee",
            "showActiveNodes": "Show only active nodes",
            "showAdditionalColumn": "Show tools",
            "showHierarchical": "Show in hierarchical order",
            "simulateUser": {
                "email": "Email",
                "execute": "Simulate",
                "password": "Password",
                "reason": "Reason for simulating user",
                "simulateUserDisabled": "The function to simulate a user is not available because the user's account may be inactive, blocked, or their email address has not been verified.\n\nAn administrator cannot simulate another administrator either.",
                "text": "When you simulate users, you will see everything from the simulated user's perspective. Any changes you make logged in as a simulated user will be saved",
                "title": "Simulate user"
            },
            "simulation": "Simulation of user",
            "simulationError": "Simulation failed",
            "simulationFailed": "Unable to simulate user",
            "simulationNoUser": "Cannot find account to simulate",
            "skipNewGroups": "Don't create new groups",
            "specificUnion": "Limit reading rights to employees from a specific union",
            "ssn": "Unique-ID",
            "sso": "SSO",
            "status": "Status",
            "table": {
                "BR-EM-1000": "Duplicate email.",
                "BR-EM-2000": "Invalid or empty email.",
                "BR-EM-3000": "Something went wrong, contact Technical Support.",
                "BR-SS-1000": "Duplicated social security number.",
                "BR-SS-2000": "Invalid or empty social security number.",
                "BR-SS-3000": "Something went wrong, contact Customer Success.",
                "BR-US-1000": "Employee already has a user connected.",
                "accessState": "User state",
                "averageHoursWorked": "Average hours worked",
                "bankID": "Swedish BankID",
                "comparatio": "Compa-ratio",
                "contract": "Contract",
                "contractType": "Contract type",
                "contractedHours": "Contracted hours",
                "costCenter": "Cost center",
                "country": "Country",
                "currency": "Currency",
                "currentPositionStartDate": "Start date current job",
                "date": "Date",
                "dateOfBirth": "Date of birth",
                "email": "Email",
                "employmentDate": "Employment date",
                "employmentNumber": "Employment number",
                "employmentRate": "Employment rate",
                "employmentStatus": {
                    "0": "Inactive",
                    "1": "Active"
                },
                "equity": "Long-term incentive",
                "ethnicity": "Ethnicity",
                "expirationDate": "Inactivate automatically",
                "externalJobFamily": "External job family",
                "forename": "Firstname",
                "formOfEmployment": "Form of employment",
                "gender": "Gender",
                "globalJobFamily": "Job family",
                "hasEmployee": "Has employment",
                "hasOptions": {
                    "has": " Has",
                    "hasNot": "Hasn't",
                    "no": "No",
                    "yes": "Yes"
                },
                "hasUser": "Has user",
                "hourlySalary": "Hourly salary",
                "hours": "h",
                "importDate": "Import date",
                "importedBy": "Imported by",
                "importedByTooltip": "This user was created by an integration.",
                "inactive": "Inactive",
                "individualWorkValuation": "Individual job evaluation",
                "isManager": "Is manager",
                "jobCode": "Job code",
                "jobFamily": "Job family",
                "jobGroup": "Job group",
                "jobProfile": "Job profile",
                "jobTitle": "Job title",
                "language": "Language",
                "lastImported": "Latest import",
                "lastLoginTime": "Latest login",
                "lastPayIncrease": "Last pay increase",
                "legalEntity": "Legal entity",
                "legalEntityCode": "Legal entity code",
                "legalEntityName": "Legal entity name",
                "localCareerBand": "Local career band",
                "localJobCode": "Local job code",
                "localJobFamily": "Local job family",
                "localJobProfile": "Local job profile",
                "localJobProfileLevel": "Local job profile grade",
                "localSubFamily": "Local subfamily",
                "locality": "Locality",
                "loginType": "Login type",
                "loginTypeOptions": {
                    "0": "Unknown",
                    "1": "Password",
                    "2": "Password and two step verification",
                    "3": "BankId",
                    "null": "Unknown"
                },
                "manager": "Manager",
                "managerCode": "Manager code",
                "name": "Name",
                "noGroup": "No group",
                "noPosition": "Missing position",
                "occupationalClassification": "Occupational classification",
                "organisation1": "Organisation Level 1",
                "organisation2": "Organisation Level 2",
                "organisation3": "Organisation Level 3",
                "organisation4": "Organisation Level 4",
                "organisation5": "Organisation Level 5",
                "organisation6": "Organisation Level 6",
                "organisationNode": "Organisation node",
                "passwordChangeTime": "Latest password change",
                "phoneNumber": "Phone number",
                "position": "Position title",
                "positionLevel": "Position level",
                "reason": "Reason",
                "role": "Role",
                "salary": "Base salary",
                "salaryDate": "Salary date",
                "salaryExchange": "Salary exchange",
                "salaryIncrement": "Salary Increment",
                "salaryIncrementSecond": "Salary increment 2",
                "salaryIncrementThird": "Salary increment 3",
                "salaryType": "Salary type",
                "salaryYear": "Salary year",
                "sentWelcomeMail": "Sent welcome email",
                "sentWelcomeMailOptions": {
                    "notSent": "Not sent",
                    "sent": "Sent"
                },
                "simulateUser": "Simulate user",
                "socialSecurityNumber": "Unique-ID",
                "statisticalCode": "Statistical code",
                "status": "Employee status",
                "statutoryGrade": "Statutory grade",
                "surname": "Lastname",
                "sysarbJobFamily": "Sysarb job family",
                "totalSalary": "Total salary",
                "uniqueID": "Unique-ID",
                "unit": "Unit",
                "unitNumber": "Unit number",
                "userAction": {
                    "1": "Login",
                    "2": "Failed Login",
                    "3": "Sign out",
                    "4": "New Password",
                    "5": "Simulated user"
                },
                "userMeasure": "User action",
                "username": "Username",
                "verifiedEmail": "Verified email",
                "work": "Work",
                "workNo": "Work number",
                "yearlyPayouts": "Number of yearly payouts"
            },
            "tip": "Tip:",
            "toJobProfile": "To job profile",
            "toMapping": "to pay equity audit",
            "toStatisticalCode": "To statistical code:",
            "toUnit": "To unit",
            "totalMatchesFilter": "matches to your filters",
            "twoStepAuth": "Two step authentication",
            "undeclared": "Not declared",
            "union": "Union",
            "uniqueID": "Unique-ID",
            "unit": "Unit",
            "update": "Update",
            "updatingManager": "Updating organisation node manager",
            "userAlreadyExist": "Users already exist on the selected employees",
            "userLog": "User log",
            "userMustChangePassword": "User will be required to change password on next login",
            "userStatus": "User status",
            "userStatusBlockedInfo": "Blocked due to many failed login attempts",
            "userStatusMultipleInstancesInfo": "To change status on this account, please contact customer success.",
            "username": "Username",
            "users": "Users",
            "verifyDelete": "Are you sure you want to remove this role junction?",
            "welcomeMailFailed": "Failed to send welcome email",
            "welcomeMailNoAccount": "This employee does not have an account yet.",
            "welcomeMailNoEmail": "This employee's account does not have an email address.",
            "welcomeMailSent": "Welcome email was sent!",
            "youWillAdd": "You will add:",
            "youWillChange": "You will change:"
        },
        "baseView": {
            "chatWithUs": "Chat with us",
            "collapseMenu": "Collapse menu",
            "expandMenu": "Expand menu",
            "navigation": "Main navigation",
            "simulatingUser": "You are simulating a user",
            "stopSimulatimg": "Exit",
            "syncError": "Something went wrong when synchronizing your data",
            "userButton": "User profile"
        },
        "bulkCreteJobProfilesTheOrderDetermines": "The order will determine the name",
        "bulkCreteJobProfilesTitles": "The job profile titles",
        "cardChecklist": {
            "loadingSteps": "Loading steps",
            "stepsComplete": "{stepsComplete} of {totalSteps} steps completed",
            "stepsCompleteOnDate": "{stepsComplete} of {totalSteps} steps completed on {date}"
        },
        "chart": {
            "automatedAnalysisWarningNoDefinedGender": "Warning: Automated analysis doesn't take non declared genders into account.",
            "benchmark": {
                "benchmark": "Benchmark",
                "showBenchmark": "Hide/show"
            },
            "boxPlotNotSupported": "Not supported for box plot",
            "chartNoData": "No data",
            "chartTypeDisabledForLargeGroup": "The group is too large to show this type of chart",
            "chartTypeDisabledOnThisMode": "Line chart is not available on this setting",
            "chartTypes": "Chart types",
            "charts": "Chart",
            "chooseXAxis": "Choose x-axis",
            "chooseYAxis": "Choose y-axis",
            "disabledMessage": "This axis has no diagrams with these settings. Please choose another axis in the bottom right corner.",
            "download": "Download",
            "downloadImage": "Download image",
            "downloadPdf": "Download PDF",
            "groupBy": "Group by",
            "max": "Max salary",
            "meanSalary": "Mean salary",
            "medianSalary": "Median salary",
            "minSalary": "Min salary",
            "percentileSalary10": "10th salary percentile",
            "percentileSalary20": "20th salary percentile",
            "percentileSalary80": "80th salary percentile",
            "percentileSalary90": "90th salary percentile",
            "regression": {
                "advanced": "Advanced",
                "dataWarning": "Warning: Group consists of too few members for accurate results",
                "regression": "Regression",
                "regressionAnalysis": "Regression analysis",
                "showEQ": "Equation",
                "showLinearRegression": "Hide/show",
                "showR": "r value",
                "showR2": "r² value",
                "showSE": "Standard error"
            },
            "severalPersons": "Switch employee",
            "showMeanPlotLines": "Show Mean",
            "showMedianPlotLines": "Show Median",
            "toolbar-icon": {
                "bar": "Bar",
                "box": "Box plot",
                "download": "Download",
                "expand": "Expand",
                "line": "Line",
                "scatter": "Scatter plot",
                "settings": "Settings",
                "table": "Table",
                "zoom": "Reset zoom level"
            },
            "xAxis": "X-axis",
            "yAxis": "Y-axis",
            "yAxisDisabled": "Simualte mode activated, not possible to change y-axis"
        },
        "chartGenderDistribution": {
            "amount": "Amount",
            "ratio": "Ratio"
        },
        "chartSalaryDistribution": {
            "amount": "Amount",
            "ratio": "Ratio"
        },
        "chartSimple": {
            "expand": "Expand",
            "zoom-out": "Zoom out"
        },
        "checkBoxList": {
            "noFilesToExport": "No files to export."
        },
        "checkboxGroupFilter": {
            "emptyList": "No options available",
            "emptyListSearch": "No results for \"{query}\"",
            "toggleHighlight": "Toggle highlight"
        },
        "collapsibleText": {
            "readMoreAboutJobDescription": "about job description"
        },
        "common": {
            "actionList": {
                "data": "Data",
                "export": "Export",
                "functions": "Functions",
                "import": "Import",
                "openMenu": "Open menu"
            },
            "dataTable": {
                "addNewRow": "Add new row",
                "change": "Change",
                "customHeadersReset": "Due to changes in available columns your choice of custom columns has been reset.",
                "false": "No",
                "filter": "Filter",
                "mainColumns": "Main columns",
                "modifyColumns": "Modify columns",
                "noData": "There is no data at the moment",
                "resetCustomHeaders": "Reset columns",
                "search": "Search",
                "selectMainColumns": "Select main columns",
                "selectSubColumns": "Select sub columns",
                "subColumns": "Sub columns",
                "true": "Yes"
            },
            "dataTableFilters": {
                "chosen": "Chosen",
                "false": "No",
                "fromTo": "From {min} to {max}",
                "moreFilters": "More filters",
                "noValue": "No value",
                "search": "Search...",
                "true": "Yes"
            },
            "dynamicDropdownSelect": {
                "emptyList": "No selected values",
                "notSelectedValues": "Not selected",
                "searchFilter": "Search...",
                "selected": "Selected"
            },
            "dynamicFilter": {
                "addFilterGroup": "Create new filter group",
                "addFilterToGroup": "Add filter to group",
                "after": " after ",
                "before": " before ",
                "choose": "Choose",
                "conditionOperator": "Match by",
                "done": "Done",
                "equalTo": " is ",
                "missingValue": "lacks a value",
                "newFilter": "New filter",
                "noValueSelected": "A filter is missing a value",
                "notEqualTo": " is not ",
                "on": " on ",
                "removeFilter": "Remove filter",
                "resetFilter": "Reset filter",
                "searchFilter": "Search filter",
                "setValue": "Set a value to filter by",
                "years": "years"
            },
            "dynamicFilters": {
                "addFilterGroup": "Create new filter group",
                "newFilter": "New filter",
                "newGroup": "New group",
                "noValueSelected": "A filter is missing a value",
                "resetFilters": "Reset filters"
            },
            "editors": {
                "addFile": "Add file",
                "confirmDeleteFile": "Are you sure you want to delete the file?",
                "invalidDAteRange": "Date can't be further than today",
                "maxValueError": "Maximum valid value is: {value}",
                "minDateError": "Date before today or set date is invalid.",
                "minLengthError": "Field must contain atleast {length} characters",
                "minValueError": "Minimum valid value is: {value}",
                "noDecimal": "Enter numbers",
                "noInteger": "Enter an integer",
                "noOptions": "List is empty.",
                "noSearchResult": "No matches found...",
                "noValidDate": "Enter a valid date (YYYY-MM-DD)",
                "noValidTime": "Enter a valid time (HH:mm)",
                "none": "None",
                "requiredField": "You need to add a {title}"
            },
            "entityList": {
                "verifyDelete": "Are you sure that you want to delete {entity}?"
            },
            "hour": "Hour",
            "lessThanAMonth": "Less than a month",
            "month": "Month",
            "months": "Months",
            "year": "Year",
            "years": "Years"
        },
        "costCenterList": {
            "addCostCenter": "Create cost center",
            "code": "Code",
            "costCenter": "Cost center",
            "create": "Create",
            "enterCode": "Enter code",
            "newCode": "New code",
            "noData": "There are no cost centers created"
        },
        "countryOverview": {
            "auditName": "Pay equity audit {year}",
            "completedAudits": "Completed pay equity audits",
            "complianceResource": "Global Pay Transparency Tracker",
            "coworkers": "Employees",
            "export": "Export",
            "finishedWithAudits": "Good job finishing all your audits for {country}!",
            "goToOverview": "To overview",
            "helpArticle": "Help article",
            "helpButtonAriaLabel": "Help - Country overview information",
            "helpButtonTitle": "Get help with country overview",
            "keyValueHeader": "Current years pay equity audits",
            "noCompleteAudits": "You have no Pay equity audits completed",
            "noCountrySelected": "You haven't selected a country. Go back to the overview to choose one.",
            "noCoworkers": "You have no employees in this country, and therefore, there is no need to create a pay equity audit",
            "ongoingAudits": "Ongoing pay equity audits"
        },
        "countryOverviewV2": {
            "all": "All",
            "atRiskForJointAssessment": "At risk for joint pay assessment",
            "auditStatus": "Audit status",
            "categoryOfWorkers": "Category of worker",
            "companyName": "Company name",
            "companyRegistrationNumber": "Company registration number",
            "completed": "Completed",
            "csrdCurrencyConversionInfo": "Selecting a currency conversion adds a global pay gap to your report. Employees in currencies not covered by the conversion are excluded from the global calculation.",
            "csrdCurrencyConversionLabel": "Currency conversion (optional)",
            "csrdCurrencyConversionNone": "No conversion — skip global pay gap",
            "csrdCurrencyConversionPlaceholder": "Select a currency conversion",
            "csrdReport": "CSRD report",
            "csrdReportSalaryTypeDescription": "Please select which salary type to use for the CSRD report.",
            "draft": "Draft",
            "employeeDistributionPerGrade": "Employee distribution per grade",
            "employeeDistributionPerGradeTooltip": "Your employees salary distribution on each grade.",
            "employeeTransparencyReportEmpty": "No employees found",
            "employeeTransparencyReportSelectPrompt": "Select employee",
            "employees": "Employees",
            "euPayTransparencyFileName": "EU Pay Transparency Report (9)",
            "euPayTransparencyReporting": "EU Pay Transparency reporting (Article 9)",
            "euPayTransparencyReportingDescription": "In article 9 (g) you need to report on your category of workers. A category of worker is a group of employees performing the same job or job of equal value. It should be the same grouping as your equal jobs you analyze in the pay equity audit.",
            "explainAndAdjustSalaries": "Explain and adjust salaries to avoid joint pay assessments.",
            "exportAnotherReport": "Export another report",
            "exportArticleNine": "Export Article 9",
            "exportEmployeeTransparencyReport": "Export Employee Transparency Report",
            "exportRequiresInvolvePackage": "Requires the Involve package",
            "exportedOn": "Exported on",
            "field": "Field",
            "fullTime": "% Full-time",
            "fullTimeEmployees": "% Full-time employees",
            "fullTimeEmployeesEmptyState": "Import employment rate to your employees to see how large proportion is working fulltime.",
            "fullTimeEmployeesTooltip": "How large proportion of employees of each gender that works fulltime.",
            "genderPayGaps": "Gender pay gaps",
            "genderRatioHighQuartile": "Gender ratio upper quartile",
            "genderRatioLowQuartile": "Gender ratio lower quartile",
            "genderRatioMiddleHighQuartile": "Gender ratio upper middle quartile",
            "genderRatioMiddleLowQuartile": "Gender ratio lower middle quartile",
            "globalKeyInsights": "Global key insights",
            "grade": "Grade",
            "gradesOverFivePercent": "Grades over 5%",
            "gradesOverFivePercentPayGap": "Grades over 5% pay gap",
            "gradesOverFivePercentTooltip": "The number of grades with a mean unadjusted pay gap exceeding 5%, based on total salary.",
            "gradesOverFivePercentUnadjustedPayGap": "Grades over 5% unadjusted pay gap",
            "gradesUnderFivePercentUnadjustedPayGap": "Grades under 5% unadjusted pay gap",
            "gradesWithHigherSalary": "{count} grade that has higher salary than their following grade | {count} grades that has higher salary than their following grade",
            "groupCategoryOfWorkersOn": "Group category of workers on",
            "informationHeader": "Information",
            "jobArchitectureNoAccess": "You don't have access to view this data. Contact your administrator if you need access to the job architecture.",
            "jobArchitectureNotEnabled": "In order to report on the category of workers (9-g), you need to evaluate each job’s complexity, typically done in our job architecture. Contact Sales if you’re interested in our Structure package.",
            "jobFamilyAndGrade": "Job family & grade",
            "jobProfileAndGrade": "Job profile & grade",
            "keyInsights": "Key insights",
            "legalEntity": "Legal entity",
            "lower": "Lower",
            "lowerMiddle": "Lower-middle",
            "meanSalaryMen": "Mean salary {'|'} Men",
            "meanSalaryWomen": "Mean salary {'|'} Women",
            "meanUnadjustedPayGap": "Mean unadjusted pay gap",
            "meanUnadjustedPayGapTooltip": "Unadjusted pay gap is the difference between men's and women's salaries expressed as a percentage of men's salary. When a pay gap is negative, women earn more than men.",
            "meanUnadjustedVariablePayGap": "Mean unadjusted variable pay gap",
            "medianUnadjustedPayGap": "Median unadjusted pay gap",
            "medianUnadjustedVariablePayGap": "Median unadjusted variable pay gap",
            "newAudit": "New audit",
            "noAuditsAccess": "There are no ongoing audits with employments you have access to",
            "noJobArchitecture": "You haven't created or imported a job architecture yet. We need it to create your category of workers. The report will be incomplete until you have created/imported and published your job architecture.",
            "noJobArchitectureCreated": "In order to report on category of workers (9-g), you need to have created/imported and published your job architecture first. Click on the button to get started.",
            "noJobArchitectureGrades": "In order to report on category of workers (9-g), you need to have evaluated your job profiles and published your job architecture first.",
            "noOngoingAudits": "You have no ongoing audits for this year",
            "noSalariesToDisplayHeader": "No salaries to display",
            "noSalariesToDisplayText": "Every employee in this country shows 0 salary after converting to the selected salary type. This happens when  \"Full-time working hours per month\" or \"Yearly payouts\" is set to 0. Update these values or switch to a different salary type.",
            "normalSalaryDistribution": "Normal salary distribution",
            "notStarted": "Not started",
            "numberOfCategoriesOfWorkers": "Number of categories of workers",
            "numberOfEmployees": "Number of employees",
            "numberOfEmployeesWithNonDisclosedGender": "Number of employees with non-disclosed gender",
            "numberOfFemaleEmployees": "Number of female employees",
            "numberOfMaleEmployees": "Number of male employees",
            "ongoing": "Ongoing",
            "ongoingAudits": "Ongoing audits",
            "openJobArchitecture": "Open job architecture",
            "organizationInformation": "Organisation Information",
            "payGap": "Your pay gaps",
            "payGaps": "Pay gaps",
            "payQuartiles": "Pay Quartiles",
            "payStructuresPerGrade": "Pay structures per grade",
            "payStructuresPerGradeTooltip": "How many from each gender receives any of the variable pay components that's included in total salary.",
            "pleaseSelectAGroup": "Please select a group",
            "potentiallyProblematic": "Potentially problematic salary distribution",
            "proportionReceivingVariablePay": "Proportion receiving variable pay",
            "proportionsReceivingVariableComponents": "Proportions receiving variable pay",
            "ratio": "Ratio",
            "ratioAboveMedianSalary": "Ratio between max to median salary per gender",
            "ratioAboveMedianSalaryTooltip": "The ratio between a gender's max salary in a grade compared to the median salary of the grade. The median salary is at 100% in the chart.",
            "ratioBelowMedianSalary": "Ratio between min to median salary per gender",
            "ratioBelowMedianSalaryTooltip": "The ratio between a gender's min salary in a grade compared to the median salary of the grade. The median salary is at 100% in the chart.",
            "salaryDifference": "Salary difference",
            "salaryType": "Show employees with salary type",
            "salaryTypeDropdownLabel": "Salary type: {value}",
            "salaryTypeNormalised": "Display salaries as",
            "selectSalaryType": "Select salary type",
            "subFamilyAndGrade": "Sub-family & grade",
            "totalCompensationMean": "Total Compensation (mean)",
            "totalCompensationMedian": "Total Compensation (median)",
            "totalSalary": "Total salary",
            "unadjustedPayGap": "Unadjusted pay gap",
            "unadjustedPayGapBaseSalary": "Unadjusted pay gap (base salary)",
            "unadjustedPayGapPerGrade": "Unadjusted pay gap per grade",
            "unadjustedPayGapPerGradeAlert": "{count} grade with over {threshold} pay gap | {count} grades with over {threshold} pay gap",
            "unadjustedPayGapPerGradeTooltip": "The unadjusted pay gap between men and women for each grade. Grades over 5% or under -5% are marked in red and should be investigated further.",
            "unadjustedPayGapTotalSalary": "Unadjusted pay gap (total salary)",
            "unadjustedPayGapVariable": "Unadjusted variable pay gap",
            "upper": "Upper",
            "upperMiddle": "Upper-middle",
            "variableComponentsMean": "Variable components (mean)",
            "variableComponentsMedian": "Variable components (median)",
            "womenRatio": "Women ratio",
            "workerCategory": "Categories of workers",
            "yourPayGaps": "Your pay gaps"
        },
        "countryView": {
            "analyze": "Analyze",
            "analyzeWorksTitle": "Analyze pay discrepancies within jobs",
            "assign": "Assign",
            "compareWorksTitle": "Cross-compare comparative jobs",
            "create": "Create",
            "createTitle": "Create a pay equity audit",
            "evaluate": "Valuate",
            "evaluateJobs": "Evaluate jobs’ complexity",
            "evaluateTitle": "Valuate jobs complexity",
            "goToAudit": "Open audit",
            "import": "Import",
            "importTitle": "Import employees to audit",
            "mapEmployees": "Assign employments to jobs",
            "markAsDone": "Mark as done",
            "markAsDoneTitle": "Mark your pay equity audit as done",
            "report": "Upload",
            "reportTitle": "Upload your final report to Sysarb",
            "valuate": "Valuate"
        },
        "createDiscussion": {
            "missingManagers": "List of units with missing managers",
            "missingManagersHelptext": "You must select at least one unit. | You have 1 unit that is missing a manager. You will not be able to publish until you have added a manager to this unit as there must be a manager to complete a discussion. | You have {count} units that are missing a manager. You will not be able to publish until you have added a manager to these units as there must be a manager to complete a discussion.",
            "missingUsers": "List of employees with missing users",
            "missingUsersHelptext": "You must select at least one employee. | You have 1 employee that is missing a user. You will not be able to publish until you have added a user to this employee as there must be a user to complete a discussion. | You have {count} employees that are missing users. You will not be able to publish until you have added a user to these employees as there must be a user to complete a discussion.",
            "previewLinkText": "Join the discussion round",
            "previewPublishForManagersAndCoworkersBodyText": "Hi {name}!<br /><br />{companyName} has started a discussion round in Sysarb and it is now time for you to log in to Sysarb and participate. There is a questionnaire for you to fill in.<br /><br />You can log into Sysarb by clicking the button below.<br /><br />Good luck!",
            "previewPublishForManagersBodyText": "Hi {name}!<br /><br />{companyName} have started a round of discussions in Sysarb and it's now time for you to log into Sysarb and participate.<br /><br />The questions have been prepared and here's a short to-do list:<br />- Add your own questions (optional)<br />- Invite your employees<br />- Answer the questions on your employees<br /><br />You can log into Sysarb by clicking the button below.<br /><br />Good luck!",
            "previewPublishTitle": "You have been invited to a discussion"
        },
        "createEmployeeComponent": {
            "addEmployee": "Add new employee",
            "addingEmployee": "Adding {name} to the system. Please wait...",
            "allUnions": "All unions",
            "cancel": "Cancel",
            "continue": "Continue",
            "createPerson": "Create employee",
            "creatingEmployee": "Creating employee...",
            "dateOfBirth": "Age",
            "employee": "Personal info",
            "employment": "Employment",
            "errorEmployee": "We failed to add information of your employee at the Person step. Take a look and see if you can find any problem that we might have missed. If there are still problems, you can contact our support and we will help you.",
            "errorEmployment": "We failed to add information of your employee at the Employment step. Take a look and see if you can find any problem that we might have missed. If there are still problems, you can contact customer success and we will help you.",
            "errorExtendedRole": "We failed to add information of your employee at the Extended role step. Take a look and see if you can find any problem that we might have missed. If there are still problems, you can contact our support and we will help you.",
            "errorOccurred": "An error has occurred...",
            "errorUser": "We failed to add information of your employee at the User step. Take a look and see if you can find any problem that we might have missed. If there are still problems, you can contact our support and we will help you.",
            "extendedRole": "Extended roles",
            "forename": "Firstname",
            "goToDashboard": "Exit",
            "isAdded": "{name} is added!",
            "password": "Password",
            "personalIdentityNumber": "Unique-ID",
            "salary": "Salary",
            "summary": "Summary",
            "surname": "Lastname",
            "to": "To",
            "twoStepVerification": "Two step verification",
            "user": "User"
        },
        "createEmployeeStep": {
            "dateOfBirth": "Date of birth",
            "employee": "Person",
            "female": "Female",
            "forename": "Firstname",
            "gender": "Gender",
            "male": "Male",
            "notDeclared": "Not declared",
            "personalIdentityNumber": "Unique-ID",
            "stepDescription": "In this step, you fill in general information about the employee",
            "summary": "Summary",
            "surname": "Lastname"
        },
        "createEmployeeUserStep": {
            "bankIDOnly": "BankID",
            "bankId": "BankID",
            "bankIdAndPassword": "BankID and password",
            "bankIdAndTwoStepVerification": "BankID, password and two step verification",
            "cannotCreateUsers": "Creating new users is prohibited on this instance",
            "email": "Email",
            "extendedRole": "Extended role",
            "language": "Language",
            "loginType": "Login type",
            "password": "Password",
            "phoneNumber": "Phone number",
            "socialSecurityNumber": "Swedish social security number",
            "socialSecurityNumberPattern": "YYYYMMDDXXXX",
            "stepDescription": "In this step, you fill in information about the user and which user rights the person is entitled to",
            "templateInstance": "Template",
            "twoStepVerification": "Two step verification",
            "user": "User",
            "username": "Username"
        },
        "createEmploymentStep": {
            "age": "Age",
            "cannotSelectWork": "Work cannot be selected when job architecture is available.",
            "compaRatio": "Compa-ratio",
            "contract": "Contract",
            "contractType": "Contract type",
            "costCenter": "Cost center",
            "country": "Country",
            "createEmploymentInfo": "In the following step you add information about the persons employment",
            "currency": "Currency",
            "detailedInfo": "More info",
            "email": "Email",
            "employment": "Employment",
            "employmentDate": "Company tenure start date",
            "employmentNumber": "Employment number",
            "employmentRate": "Employment rate",
            "equalityTimer": "Equality Timer",
            "equalityTimerHelpText": "{name} needs to work {hours} hours, {minutes} minutes and {seconds} seconds {negativeOrPositiveTranslation} every day to recieve the same salary as employees of the opposite gender",
            "equity": "Long-term incentive",
            "formOfEmployment": "Form of employment",
            "hourly": "Employed hourly",
            "hourlySalary": "Hourly salary",
            "lastPayIncrease": "Last pay increase",
            "less": "less",
            "managerCode": "Manager code",
            "misc": "More",
            "monthlySalary": "Montly salary",
            "more": "more",
            "no": "No",
            "noSalary": "You must enter a salary that is more than 0 for the calculation to work",
            "optional": "(Optional)",
            "organization": "Organization",
            "position": "Position title",
            "positionLevel": "Position Level",
            "required": "Required",
            "salary": "Salary",
            "salaryDate": "Salary date",
            "salaryExchange": "Salary exchange",
            "salaryIncrement": "Salary increment",
            "salaryIncrementSecond": "Salary increment 2",
            "salaryIncrementThird": "Salary increment 3",
            "salaryType": "Salary type",
            "salaryYear": "Salary year",
            "statisticalCode": "Statistical code",
            "timeInCurrentPosition": "Job tenure",
            "work": "Work",
            "yearlyPayouts": "Number of yearly payouts",
            "yes": "Yes"
        },
        "createExtendedRole": {
            "addRole": "Add role",
            "administrator": "Administrator",
            "allUnions": "All unions",
            "chooseCategory": "Choose a category",
            "chooseExtendedRole": "Choose a role",
            "edit": "Edit",
            "examination": "Review",
            "extendedRole": "Create user roles",
            "extendedRoleInfo": "In this step you can add roles to the user.",
            "manager": "Manager",
            "managerDeputy": "Deputy manager",
            "mapping": "Pay equity audit",
            "newRoles": "Added roles",
            "operationalAdministrator": "Operational administrator",
            "organisation": "Organisation",
            "readOnly": "Read only",
            "replace": "Replace",
            "replaceManager": "{manager} is already manager for {organisation}. Are you sure you want to change manager to {name}?",
            "replaceUnion": "You have previously chosen another union, your new choice will affect all union roles. Are you sure you want to switch from \"{oldUnion}\" to \"{newUnion}\"?",
            "replaceUnionWarning": "You have previously chosen another union. One person cannot represent different unions.",
            "rights": {
                "adminEmploymentReview": "Administer employment reviews",
                "adminPerformanceReview": "Administer performance reviews",
                "adminSalarySet": "Administer salaries",
                "allSalarySurvey": "All pay equity audits",
                "analyze": "Analyze and document pay equity audits",
                "analyzeSalarySet": "Analyze salary review results",
                "employmentReview": "Perform employment reviews",
                "performanceReview": "Perform performance reviews",
                "readOnly": "Read only",
                "salaryFileImport": "Import salary file",
                "salarySet": "Set salaries",
                "selectedSalarySurvey": "Selected pay equity audits",
                "systemData": "Administer system data"
            },
            "role": "Role",
            "roleRights": "{role} has access to",
            "salarySurveyAnalyst": "HR Business Partner",
            "sectionManager": "Section manager",
            "selectUnion": "You need to choose a union",
            "singleRoleOnly": "You can only add one of this type of role.",
            "system": "System",
            "union": "Union",
            "unionAccess": "Union representative has access to"
        },
        "createSalaryReviewButton": {
            "createError": "An error occurred when trying to create \"{item}\"!\n If the problem persists, contact Customer Success",
            "createSalaryReview": "New salary review",
            "salaryReview": "Pay management review"
        },
        "createSalaryReviewComponent": {
            "activateAttest": "Activate attest {role}",
            "allowUnionSuggestSalaryText": "Allow union users to suggest a salary for managers, section managers and HR.",
            "applyMinimumSalaryOn": "Apply minimum salary on",
            "attest": "Attest",
            "attestInfo": "What roles need to attest a employee's salary before salary is sent to your employees.",
            "chooseEmployments": "Employments",
            "continue": "Continue",
            "create": "Create",
            "createInfo": "It might take a while to create the salary review, so go ahead and take a coffee or a small break, and we’ll notify you when it’s completed",
            "createperformance": "Performance",
            "creatingHeader": "Good job!",
            "currencyGroup": "Currency group",
            "currencyGroupInfo": "If you put employees which salaries are of different currencies in the same budget we need to know how to convert each currency to the primary currency.",
            "delete": "Delete",
            "deleteDraft": "Delete draft",
            "deleteDraftInfo": "You will lose all progress from this draft if you delete it. Are you sure you want to delete the draft?  ",
            "deleteUnionData": "Remove union",
            "deleteUnionDataInfo": "Delete data on which unions your employees belong to",
            "description": "Description",
            "descriptionInfo": "So that you know – any notes will be shown to you and other administrators when you open the salary review.",
            "dueDate": "Due date",
            "dueDateInfo": "Date for managers to set new salaries before they take effect.",
            "employee": "employee",
            "error": "Oops!",
            "errorInfo": "Something went wrong!\nPlease try again.\n\nIf you continue to receive errors, please contact Customer Success",
            "filter": "Filter",
            "general": "General",
            "goToSalarySetting": "Go to the salary review",
            "importUnionData": "Import union",
            "importUnionDataInfo": "Import which unions your employees belong to",
            "manager": "manager",
            "minimumSalary": "Minimum salary",
            "minimumSalaryInfo": "Certain groups have regulations regarding acceptable minimum salaries, and we’ll help you add the necessary amount if necessary. With this setting, you can decide when you want us to help fill in the blanks.",
            "name": "Salary review name",
            "nameInfo": "Decide what name will be shown for managers and employees for the salary review.",
            "optionSelectHeader": "Decide what happens if rating haven’t met all the passing grades",
            "performanceInfo": "You can decide whether we should automatically give 0 as the final score for employees that fails one or more of their assessment levels regardless of their overall score.",
            "performanceReview": "Performance review",
            "routed": "You will be taken to the salary review in 5 seconds.",
            "salaryIncrease": "Salary increase",
            "salaryLift": "Salary increase",
            "salaryRaiseOne": "Increase 1",
            "salaryRaiseTwo": "Increase 2",
            "salarySetAndBudget": "Salary review and budget",
            "salaryYear": "Salary review year",
            "salaryYearInfo": "In which year should the salary and performance reviews be conducted? The reviews will be used to create progression for employees' salaries.",
            "sectionManager": "section manager",
            "settings": "Settings",
            "success": "Salary review { name } was created successfully. You will be moved shortly.\nOr click the button below",
            "union": "union",
            "unionSuggestSalary": "Union salary suggestions",
            "useAverage": "Use their average score",
            "workHoursPerMonth": "Work hours per month",
            "workHoursPerMonthInfo": "If you put hourly-paid workers and monthly-paid workers in the same budget we need to know how to recalculate hourly salaries to monthly salaries.",
            "workHoursPerMonthInput": "Work hours per month (optional)",
            "zeroPercent": "0%"
        },
        "createSalaryReviewEmploymentStep": {
            "coworkers": "employees",
            "createYourSelection": "Create your selection",
            "createYourSelectionInfo": "You can create filters to decide which employees you want to add to the salary review. We will save the filter and notify you when employees match it.",
            "employees": "Matching employees",
            "employments": "The following {count} employments will be imported to your salary set",
            "formOfEmployment": "Form of employment",
            "managers": "Managers",
            "mixedSalaryTypeWarning": "You have mixed salary types that includes yearly salary type. Make sure all salary types are the same and try again.",
            "name": "Name",
            "organizationalLevel1": "Organization level 1",
            "organizationalLevel2": "Organization level 2",
            "organizationalLevel3": "Organization level 3",
            "organizationalLevel4": "Organization level 4",
            "organizationalLevel5": "Organization level 5",
            "organizationalLevel6": "Organization level 6",
            "position": "Position title",
            "salaryType": "Salary type",
            "salaryYear": "Salary year",
            "selectionIncludes": "Your selection includes"
        },
        "currencyGroupList": {
            "addAllCurrencies": "Fetch currencies",
            "addAllCurrenciesVerify": "Do you want to add all currencies from the base register?",
            "addAllValues": "You must enter name and choose currency",
            "addCurrency": "You must choose currency",
            "addCurrencyGroup": "Create",
            "addCurrencyGroupRow": "Create currency conversion",
            "conversion": "Currency conversion",
            "create": "Create",
            "createError": "Failed to create \"{item}\"!",
            "currencies": "Currency conversions",
            "currency": "Currency",
            "currencyGroup": "Currency conversion group",
            "currencyGroupRow": "Currency conversion",
            "defaultCurrency": "Standard currency",
            "deleteError": "Failed to remove \"{item}\"!",
            "enterName": "Enter name",
            "is": "is",
            "locked": "This group is used in one or more salary reviews and cannot be changed.",
            "name": "Name",
            "noData": "There are no currency groups created",
            "overview": "Overview",
            "verifyDelete": "Are you sure that you want to delete the currency conversion?"
        },
        "customerInformation": {
            "GDPRContact": "Email to GDPR contact person",
            "HRsystem": "HR-system",
            "active": "Active",
            "aiFeatures": "AI features",
            "analyzePackage": "For you that want to do pay equity analysis.",
            "analyzerLevel": "Analyzer",
            "buyModules": "Would you like to activate a module? Contact our technical support team!",
            "companyLogo": "Company logo",
            "companyName": "Company name",
            "contactInformation": "Contact persons",
            "contactInformationInfo": "Which persons we should contact regarding questions related to GDPR and access in your organization",
            "country": "Country",
            "currentPackage": "Current package",
            "customPackage": "You have a customized package. Contact technical support to inquire what exactly is included.",
            "customerInformation": "Customer information",
            "customerPackage": "Customer package",
            "emailError": "Email has an invalid format",
            "general": "General",
            "hrSystemList": {
                "HRM": "HRM",
                "SAPSuccessFactors": "SAP SuccessFactors",
                "SDWorxHR": "SD Worx HR",
                "alexisHR": "AlexisHR",
                "catalystOne": "CatalystOne",
                "cornerstoneOnDemand": "Cornerstone OnDemand",
                "deltekTalentManagement": "Deltek Talent Management",
                "eposHR": "Epos HR",
                "flexHRM": "Flex HRM",
                "gradeTalent": "Grade Talent",
                "haileyHR": "Hailey HR",
                "heartpace": "Heartpace",
                "hiBob": "HiBob",
                "huma": "Huma",
                "kontek": "Kontek",
                "oracleCloudHCM": "Oracle Cloud HCM",
                "personio": "Personio",
                "simployer": "Simployer",
                "softOneHR": "SoftOne HR",
                "sympa": "Sympa",
                "talentech": "Talentech",
                "talentsoft": "Talentsoft",
                "totaraPerform": "Totara Perform",
                "verismoHR": "Verismo HR",
                "vismaTalentSolutions": "Visma Talent Solutions",
                "workdayHCM": "Workday HCM"
            },
            "impacterLevel": "Impacter",
            "inactive": "Inactive",
            "industry": "Industry",
            "industryList": {
                "agriCultureAndForestry": "Agriculture & Forestry",
                "construction": "Construction",
                "consultantOperation": "Consultant operation",
                "cultureAndEntertainment": "Culture and entertainment",
                "education": "Education",
                "electricitySupplier": "Electricity supplier",
                "financeAndInsurance": "Finance and Insurance",
                "healthAndSocialWork": "Health and Social Work",
                "hotelAndRestaurants": "Hotel and restaurants",
                "informationAndCommunication": "Information and communication",
                "lawEconomicsAndScience": "Law, economics and science",
                "manufacturing": "Manufacturing",
                "mining": "Mining",
                "municipality": "Municipality",
                "realEstate": "Real estate",
                "region": "Region",
                "retail": "Retail",
                "stateAgency": "State Agency",
                "tech": "Tech",
                "transportation": "Transportation"
            },
            "involvePackage": "For you that want to involve employees and managers.",
            "jobArchitecture": "Job architecture",
            "jobArchitectureText": "Would you like to add Job architecture to your package? Contact our Technical Support team!",
            "legacyPackage": "You have one of our older package. Contact technical support to inquire what exactly is included.",
            "other": "Other",
            "otherInformation": "Other information",
            "payManagement": "Pay Management",
            "payManagmentText": "Would you like to add Pay Management to your package? Contact our customer success team!",
            "region": "Region",
            "salarySystem": "Salary system",
            "salarySystemList": {
                "4Human": "4Human",
                "BL": "Björn Lundén",
                "Caspeco": "Caspeco",
                "HRM": "HRM",
                "HRPlus": "HR-Plus",
                "Hogia": "Hogia",
                "POL": "POL",
                "SAP": "SAP SuccessFactors",
                "SDWorx": "SDWorx",
                "SoftOneGo": "SoftOne Go",
                "agdaPS": "Agda PS",
                "alexisHR": "AlexisHR",
                "crona": "Crona lön",
                "eCompanion": "eCompanion",
                "flex": "Flex",
                "fortnox": "Fortnox",
                "heroma": "Heroma",
                "kontek": "Kontek",
                "maxPA": "MaxPA",
                "nmbrs": "Visma Nmbrs",
                "other": "Övrig",
                "personalKollen": "Personal Kollen",
                "personec": "Visma P",
                "primula": "Primula",
                "sympa": "Sympa",
                "tempura": "Tempura",
                "vismaP": "Visma P"
            },
            "sector": "Sector",
            "sectorList": {
                "banking": "Banking",
                "commerce": "Commerce",
                "consultation": "Consultation",
                "eduction": "Education",
                "governmentOperations": "Government operations",
                "health": "Health",
                "manufacturing": "Manufacturing",
                "nonProfit": "Non profit",
                "private": "Private",
                "public": "Public",
                "publicSector": "Public sector",
                "research": "Research",
                "serviceIndustry": "Service industry",
                "technology": "Technology"
            },
            "starterLevel": "Starter",
            "structurePackage": "For you that want to secure a great job- and pay structure.",
            "subscriptionLevel": "Package",
            "subscriptionLevelText": "Contact sales if you want to upgrade your package. Read more about our packages here.” Add a hyperlink to the last sentence that links to our pricing page",
            "systemLanguage": "Default language",
            "systemOwnerContact": "Email to system owner at your company",
            "yourSysarbPackage": "Your Sysarb package is",
            "yourSysarbPackageInfo": "Each upgrade in package offer access to more functionality and modules to help you in your fair pay journey",
            "yourSystems": "Your systems",
            "yourSystemsInfo": "We can help you adapt exports and integrations to your salary and HR-systems"
        },
        "dashboard": {
            "analyze": "Analyze",
            "customerInformationPrompt": {
                "newSettings": "New settings for you!"
            },
            "discussion": "Discussion",
            "employee": "Employees",
            "genderDistribution": "Gender distribution",
            "goToCoworkers": "Open employees",
            "integrationSyncError": "Daily sync has failed",
            "jobArchitecture": "Job Architecture",
            "mapping": "Pay equity",
            "men": "Men",
            "organisation": "Organization",
            "salaryReview": "Salary review",
            "salaryStructure": "Import data",
            "user": "Users",
            "welcome": "Welcome",
            "welcomeMessageFirstLine": " Nice to see that you're also working to create a gender equal workplace!",
            "welcomeMessageSecondLine": "Here at Sysarb, you'll get the tools and assistance to review salaries in your organization and create conditions for a gender equal workplace.",
            "women": "Women"
        },
        "dataImport": {
            "autoSyncDaily": "Automatically sync data daily.",
            "continue": "Continue",
            "csvImport": "CSV Import",
            "howDoYouWantToImport": "How do you want to import your data?",
            "importDataDirectly": "Import data directly from your salary or HR systems.",
            "importDataFromCsv": "Import data from a CSV-file.",
            "importDataFromMultiple": "Import data from multiple integrations at once.",
            "integrations": "Integrations",
            "legalEntitiesDisabled": "All employees needs a legal entity before you can analyze per legal entity.",
            "organizationGroupingTypeTitle": "Analysis scope"
        },
        "dateRange": {
            "from": "From",
            "to": "To"
        },
        "dateRangeFilter": {
            "after": "After",
            "before": "Before"
        },
        "discussion": {
            "discussion": "Discussion",
            "overview": "Overview",
            "publishTooltip": "You cannot publish until you have selected a unit that has a manager connected to it"
        },
        "discussionAttachments": {
            "addAttachment": "Add attachment",
            "attachments": "Attachments",
            "deleteAttachment": "Delete attachment",
            "downloadAttachment": "Download attachment",
            "noAttachments": "No files have been attached yet"
        },
        "discussionQuestions": {
            "createNewQuestion": "Add question",
            "deleteHeader": "There exists answers to this question",
            "deleteTooltip": "Delete question",
            "deleting": "Deleting question...",
            "description": "Description",
            "descriptionPlaceholder": "Add a description",
            "doYouWantToDelete": "that have answered this question. If you delete this question you will remove their answers. Are you sure you want to delete this question?",
            "employees": "1 employee | {count} employees",
            "openingText": "Opening text",
            "sortQuestion": "Drag to change the sort order",
            "title": "Question",
            "titlePlaceholder": "Enter question",
            "youHave": "You have"
        },
        "discussions": {
            "active": "Active",
            "add": "Add",
            "archived": "Archived",
            "autoCloseWindow": "This window will close automatically in {countdown} seconds",
            "choosePublishOption": "Who do you want to publish the discussion for?",
            "companyPlaceholder": "Your organization",
            "continue": "Continue",
            "delete": "Delete",
            "deleteDiscussion": "Delete discussion",
            "discussionIsArchived": "This discussion round is archived and can no longer be edited.",
            "doYouWantToDelete": "Do you want to delete the discussion?",
            "doYouWantToDeleteDiscussion": "Are you sure you want to delete the discussion? \nThe discussion cannot be restored.",
            "employees": "Employees",
            "enterTitle": "Enter title",
            "finished": "The discussion has been published",
            "general": "General",
            "generalSettings": "General settings",
            "importQuestions": "Import questions",
            "importQuestionsTemplate": "Import questions from template",
            "mailSendout": "Email sendout",
            "managers": "Managers",
            "managersAndEmployees": "Managers and employees",
            "markAsDone": "Archive",
            "message": "Include your own message in the email",
            "namePlaceholder": "name",
            "new": "Draft",
            "preview": "Preview",
            "publish": "Publish",
            "publishDiscussion": "Publish discussion",
            "publishFor": "You will publish the discussion for:",
            "publishLater": "Publish later",
            "questionnaire": "Questionnaire",
            "questions": "Questions",
            "review": "Review",
            "saveDraft": "Save draft",
            "searchDiscussion": "Search discussions",
            "searchEmploymentDiscussion": "Search for a discussion...",
            "selectPublish": "You must choose who you want to publish to",
            "selectTemplate": "Select template",
            "selectUnits": "Select units",
            "sendReminder": "Send reminder",
            "unarchiveDiscussion": "Restore discussion",
            "unit": "Unit",
            "units": "Units",
            "unpublish": "Unpublish",
            "unpublishFor": "You will unpublish the discussion for:",
            "unpublishText": "When you unpublish the discussion you will hide it from all managers and employees.\nThey won't be able to view or edit their answers until the discussion have been republished."
        },
        "discussionsCreateButton": {
            "createDiscussion": "Create discussion"
        },
        "discussionsGeneralSettings": {
            "deadline": "Recommended last response date",
            "deadlineInfo": "Decide the recommended deadline for this year's discussion. We’ll use the deadline in the reminders for employees and managers.",
            "enterTitle": "Name of discussion",
            "generalSettings": "General settings",
            "title": "Name"
        },
        "discussionsHeader": {
            "discussionSettings": "Settings"
        },
        "discussionsNavbar": {
            "archiveDiscussion": "Archive discussion",
            "archiveError": "Error archiving discusison",
            "archiveInfo": "When you mark a discussion as finished, you will change ongoing discussions' status to completed. Your employees and managers will not be able to edit them afterwards.\n\nOnce the discussion has been archived, you cannot undo your archiving, are you sure you want to archive the discussion?",
            "archiveNotification": "The discussion round has been archived",
            "archivedAndCompleted": "This discussion round is completed and archived, do you want to delete the discussion round?",
            "coworkers": "Employees",
            "deleteError": "Error deleting discussion.",
            "discussionUnarchived": "The discussion has been restored",
            "employees": "Employees",
            "errorFetchingCoworks": "Couldn't fetch coworker count",
            "ongoingDiscussions": "Ongoing discussions",
            "overview": "Overview",
            "previewDeleteBodyText": "Hi {name}!<br /><br />You have been removed from the discussion “{discussionName}” in Sysarb.<br /><br />Most common reasons are:<br />- You have changed position within your organisaiton<br />- The discussion have been removed<br />- You have quit",
            "previewDeleteTitle": "Your discussion have been removed",
            "previewUnpublishBodyText": "Hi {name}!<br /><br />The discussion have been temporarily hidden due to modification and maintenance. Do not worry though! Your answers are saved and you will be able to view and edit them once the discussion have been republished. You will get another mail when it is time to log in again and answer the questions.<br /><br />Hope you have an amazing day!",
            "previewUnpublishTitle": "Your discussion have been unpublished",
            "publishError": "Error publishing discussion",
            "questionnaire": "Questionnaire",
            "revertDiscussionFor": "You will revert discussions for:",
            "unarchive": "Restore",
            "unarchiveError": "Error unarchiving discusison",
            "unarchiveInfo": "When you restore the discussion, all your employees' discussions will revert to their previous status. \nYou will be able to continue the discussion process as usual.",
            "unpublishError": "Error unpublishing discussion"
        },
        "discussionsQuestions": {
            "addAttachment": "Add attachment",
            "alreadyPublished": "Your discussion is already published",
            "attachments": "Attachments",
            "budgetIsPublishedWarning": "The budget is already published. Any changes will affect all managers’ and employees’ budget that meets the selection criteria",
            "cancelEdit": "Cancel editing",
            "edit": "Edit",
            "editModalMessage": "Any changes made now will automatically update all ongoing discussions. Editing a question won't affect existing answers so beware of changing the context of your questions.\n\nAre you completely sure you want to edit the questionnare for an ongoing discussion?",
            "mustSelectTemplate": "You must select a template",
            "needToCompletePreviousStep": "You need to finish the previous step to unlock this step.",
            "questionnarePublished": "The questionnare is published. Any changes will affect all published discussions.",
            "questionnareUnpublished": "Some of your employees have already answered the questions. Be careful of changing the context of the existing questions as your employees' answers will remain.",
            "questions": "Questions"
        },
        "discussionsSelectOrganisationNodes": {
            "activateHierarchical": "Toggle to enable group selection of nodes",
            "disableHierarchical": "Toggle to enable individual selection of nodes",
            "employments": "Employments",
            "hierarchicalSelection": "Hierarchical selection",
            "manager": "Manager",
            "managers": "Managers",
            "noOfEmployments": "Number of employments",
            "selectionIncludes": "Your selection includes"
        },
        "employee": {
            "baseSalary": {
                "monthly": "Base salary is the fixed portion of your salary before variable pay and other additions. Here is a breakdown of your base salary.",
                "title": "Your {salaryType} base salary"
            },
            "discussions": "Discussions",
            "employeeHasNoDiscussions": "You haven't been invited to any discussions.",
            "error": "Failed to get the employment data. Please contact your administrators.",
            "genderEquality": {
                "baseSalaryInAveragePayLevelsAndPayGaps": "Base salary in average pay levels and pay gaps",
                "baseSalaryPayGapsText": "Base salary is a fixed, regular compensation an employee receives for performing their assignments, excluding any additional variable pay or compensation. The mean salary is {meanWomen} {currency}/{salaryType} for women and {meanMen} {currency}/{salaryType} for men. {meanPayGapSentence} For median salaries {medianPayGapSentence}",
                "baseSalaryPayGapsTextSingleGender": "Base salary is a fixed, regular compensation an employee receives for performing their assignments, excluding any additional variable pay or compensation. Only {onlyGender} are included here, and their mean salary is {onlyGenderMean} {currency}/{salaryType}. {meanPayGapSentence} For median salaries {medianPayGapSentence}",
                "baseSalaryPayGapsTitle": "Base salary in average pay levels and pay gaps",
                "baseSalaryQuartilesText": "Here are all salaries ranked from highest to lowest according to their base salary and then divided into four equally sized groups (quartiles). In the upper quartile (top 25% highest paid employees), {upperWomen} are women and {upperMen} are men. And for the lower quartile (least paid employees), {lowerWomen} are women and {lowerMen} are men.",
                "baseSalaryQuartilesTitle": "Gender distribution in base salary quartiles",
                "description": "Here you can see breakdown of the pay gap, the difference in pay, between men and women. In your organisation {employmentHighEarner} earn {employmentPayGap} more than {employmentLowEarner}.",
                "descriptionWithJobGrade": "Here you can see breakdown of the pay gap, the difference in pay, between men and women. In your organisation {employmentHighEarner} earn {employmentPayGap} more than {employmentLowEarner} while at grade {level} {jobGradeHighEarner} earn {jobGradePayGap} more than {jobGradeLowEarner}.",
                "emptyState": "You'll see pay gaps for your grade once your HR manager assigns you to an evaluated job profile.",
                "genderDistribution": "Gender distribution",
                "genderDistributionInPayQuartiles": "Gender distribution in pay quartilies",
                "genderDistributionInPayQuartilesText": "Here are all salaries ranked from highest to lowest and then divided into four equally sized groups (quartiles). In the upper quartile (top 25% highest paid employees), {upperWomen} are women and {upperMen} are men. And for the lower quartile (least paid employees), {lowerWomen} are women and {lowerMen} are men.",
                "genderEqualityIntroduction": "{legalEntity} is committed to pay transparency and openly share how compensation compares between men and women. In line with the EU Pay Transparency Directive, the following sections give you a breakdown of the data across the whole organization.",
                "introduction": "The EU has, with the introduction of the with the pay transparency directive, made it mandatory for organizations to share details regarding pay between men and women to employees if requested. In the following sections you’ll see a breakdown of the data.",
                "legalEntityPlaceholder": "Legal entity",
                "levelHeader": "Grade {level} (your current grade)",
                "meanTotalSalary": "Mean total salary",
                "meanVariablePay": "Mean variable pay",
                "meanVariablePayGap": "Mean variable pay gap",
                "medianTotalSalary": "Median total salary",
                "medianVariablePay": "Median variable pay",
                "medianVariablePayGap": "Median variable pay gap",
                "mensVariablePay": "Men's variable pay",
                "noPayGapsData": "No pay gap data available",
                "noPayQuartilesData": "There is currently no available data for pay quartiles within your organisation.",
                "noVariablePayData": "No variable pay gap data available",
                "organisation": "Organisation",
                "payGap": "Pay gap",
                "payGapsMeanPayGapResult": "This results in a {meanPayGap} mean pay gap.",
                "payGapsMeanPayGapSingleGender": "A mean pay gap cannot be calculated when only one gender has data.",
                "payGapsMeanPayGapSuppressed": "The mean pay gap is hidden for privacy.",
                "payGapsMedianPayGapResult": "the pay gap is {medianPayGap}.",
                "payGapsMedianPayGapSingleGender": "the pay gap cannot be calculated when only one gender has data.",
                "payGapsMedianPayGapSuppressed": "the median pay gap is hidden for privacy.",
                "payGapsText": "Total salary is the sum of your base salary and variable pay. The mean salary is {meanWomen} {currency}/{salaryType} for women and {meanMen} {currency}/{salaryType} for men. This results in a {meanPayGap} mean pay gap. For median salaries the pay gap is {medianPayGap}.",
                "payGapsTextWithSentences": "Total salary is the sum of your base salary and variable pay. The mean salary is {meanWomen} {currency}/{salaryType} for women and {meanMen} {currency}/{salaryType} for men. {meanPayGapSentence} For median salaries {medianPayGapSentence}",
                "payGapsTextWithSentencesSingleGender": "Total salary is the sum of your base salary and variable pay. Only {onlyGender} are included here, and their mean salary is {onlyGenderMean} {currency}/{salaryType}. {meanPayGapSentence} For median salaries {medianPayGapSentence}",
                "receivesVariablePay": "Receives variable pay",
                "doesNotReceiveVariablePay": "Doesn't receive variable pay",
                "title": "Gender equality for your organisation",
                "totalSalaryInAveragePayLevelsAndPayGaps": "Total salary in average pay levels and pay gaps",
                "totalSalaryPayGapsText": "Total salary is the complete compensation an employee receives from an employer, including base salary plus all additional payments and benefits. The mean salary is {meanWomen} {currency}/{salaryType} for women and {meanMen} {currency}/{salaryType} for men. {meanPayGapSentence} For median salaries {medianPayGapSentence}",
                "totalSalaryPayGapsTextSingleGender": "Total salary is the complete compensation an employee receives from an employer, including base salary plus all additional payments and benefits. Only {onlyGender} are included here, and their mean salary is {onlyGenderMean} {currency}/{salaryType}. {meanPayGapSentence} For median salaries {medianPayGapSentence}",
                "totalSalaryQuartilesText": "Here are all salaries ranked from highest to lowest according to their total salary and then divided into four equally sized groups (quartiles). In the upper quartile (top 25% highest paid employees), {upperWomen} are women and {upperMen} are men. And for the lower quartile (least paid employees), {lowerWomen} are women and {lowerMen} are men.",
                "totalSalaryQuartilesTitle": "Gender distribution in total salary quartiles",
                "variablePayGapResult": "is {variablePayGap}.",
                "variablePayGapSingleGender": "cannot be calculated when only one gender has data.",
                "variablePayInAveragePayLevelsAndPayGaps": "Variable pay in average pay levels and pay gaps",
                "variablePayText": "Variable pay includes all compensation and benefits provided by your employer. The variable pay gap between men and women is {variablePayGap}. Of all women in your organisation, {femaleProportion} of them receives variable pay while {maleProportion} of men do. The mean variable pay is {femaleMeanVariablePay} {currency} for women and {maleMeanVariablePay} {currency} for men.",
                "variablePayTextWithSentences": "Variable pay includes all compensation and benefits provided by your employer. The variable pay gap between men and women {variablePayGapSentence} Of all women in your organisation, {femaleProportion} of them receives variable pay while {maleProportion} of men do. The mean variable pay is {femaleMeanVariablePay} {currency} for women and {maleMeanVariablePay} {currency} for men.",
                "variablePayTextWithSentencesSingleGender": "Variable pay includes all compensation and benefits provided by your employer. The variable pay gap between men and women {variablePayGapSentence} Only {onlyGender} are included here: {onlyGenderProportion} of them receive variable pay, and their mean variable pay is {onlyGenderMeanVariablePay} {currency}/{salaryType}.",
                "variablePayTextBaseAndTotal": "Variable pay excludes base salary but includes all other compensation and benefits provided by your employer. It can differ between employees due to factors like overtime, performance bonuses, hire date or time off. The variable pay gap between men and women {variablePayGapSentence} Of all women in your organisation, {femaleProportion} receive variable pay, while {maleProportion} of men do. The mean variable pay is {femaleMeanVariablePay} {currency}/{salaryType} for women and {maleMeanVariablePay} {currency}/{salaryType} for men.",
                "variablePayTextBaseAndTotalSingleGender": "Variable pay excludes base salary but includes all other compensation and benefits provided by your employer. It can differ between employees due to factors like overtime, performance bonuses, hire date or time off. The variable pay gap between men and women {variablePayGapSentence} Only {onlyGender} are included here: {onlyGenderProportion} of them receive variable pay, and their mean variable pay is {onlyGenderMeanVariablePay} {currency}/{salaryType}.",
                "womensVariablePay": "Women’s variable pay"
            },
            "jobProfile": "Your job profile",
            "loadingDashboard": "Loading employee dashboard...",
            "notFound": "We couldn’t load the employment. Try refreshing the page and if the problem persists contact your Administrator.",
            "salary": "{salary} {currency}/{salaryType}",
            "totalSalary": {
                "empty": "Salary breakdown is empty.",
                "error": "Failed to fetch salary breakdown.",
                "monthly": "Total salary includes all compensation and benefits provided by your employer before any deductions. Here is a breakdown of your total salary.",
                "title": "Your {salaryType} total salary",
                "total": "Total salary"
            },
            "unit": "Your unit",
            "yourBaseSalary": "Your base salary",
            "yourEmployment": "Your employment",
            "yourTotalSalary": "Your total salary",
            "yourPerformance": {
                "criteria": "Criteria",
                "descriptionManager": "You scored {actual} out of 100% in your latest performance review. Scores between {start} and {end} are considered \"{name}\".",
                "descriptionSelfEval": "In your self-evaluation, you rated your performance at {selfEvaluation}.",
                "evaluation": "Evaluation",
                "managerQuery": "Ask your manager if you want to learn more about their reasoning.",
                "managersEvaluation": "Manager’s evaluation",
                "noManager": "Your manager hasn't completed your evaluation yet.",
                "noSelfEval": "You haven't completed your self-evaluation yet.",
                "selfEvaluation": "Self-evaluation",
                "title": "Your performance",
                "yourSelfEvaluation": "Your self-evaluation"
            }
        },
        "employeeCareer": {
            "averageSalaryIncreaseValue": "Average increase ({value})",
            "baseSalaryChartTitle": "Your base salary progression",
            "baseSalaryText": "In your latest salary review you had a {latestIncrease} base salary increase. Your average increase the last few years is {averageIncrease} per year.",
            "baseSalaryTitle": "Base salary progression",
            "description": "In your latest salary review you had a {latestIncrease} salary increase. Your average increase the last few years is {averageIncrease} per year. ",
            "emptyCareerProgress": "We don't have any data on your prior employments so we can't display any progressions for your career.",
            "notApplicable": "N/A",
            "salaryAverage": "Salary average",
            "salaryIncreaseValue": "Salary increase ({value})",
            "title": "Your career",
            "totalSalaryChartTitle": "Your total salary progression",
            "totalSalaryText": "In your latest salary review you had a {latestIncrease} total salary increase. Your average increase the last few years is {averageIncrease} per year.",
            "totalSalaryTitle": "Total salary progression"
        },
        "employeeDashboard": {
            "contractedSalary": "Contracted",
            "displaySalariesAs": "Display salaries as:",
            "employeePortal": "employee portal",
            "employeePortalDescription": "All you need to know about the current state of gender equality in your organization",
            "emptyState": "Your employer is working on setting up your pay transparency data. Eventually, you’ll be able to see more information about your salary and pay transparency data.",
            "emptyStateManager": "No sections have been enabled for the Involve page. Contact an administrator to configure the Involve settings.",
            "exportPdf": "Export",
            "exportPdfAriaLabel": " {your}'s employee portal",
            "fileGeneratedOn": "This file was generated on {date} at {time}",
            "hourlySalaries": "Hourly salaries",
            "logo": "logo",
            "monthlySalaries": "Monthly salaries",
            "yearlySalaries": "Yearly salaries"
        },
        "employeeJobProfile": {
            "AveragePayLevels": "Average pay levels for your job profile and its grade",
            "AveragePayLevelsEmpty": "No statistics are available for this job.",
            "AveragePayLevelsGrade": "Average pay levels for your grade",
            "AveragePayLevelsGradeTotalSalary": "Average total pay levels for your grade",
            "AveragePayLevelsJobProfile": "Average pay levels for your job profile",
            "AveragePayLevelsJobProfileTotalSalary": "Average total pay levels for your job profile",
            "AveragePayLevelsLabelGradeBaseSalary": "Grade {grade} - Base salary",
            "AveragePayLevelsLabelGradeTotalSalary": "Grade {grade} - Total salary",
            "AveragePayLevelsLabelJobProfileBaseSalary": "{jobName} ({grade}) - Base salary",
            "AveragePayLevelsLabelJobProfileTotalSalary": "{jobName} ({grade}) - Total salary",
            "AveragePayLevelsText": "In your job profile women earn {averageWomenJob} {salaryTypeText} on average while men earn {averageMenJob} {salaryTypeText} on average. This results in a {jobPayGap}% pay gap between men and women. For jobs that are equally as complex as yours (Grade {grade}) women earn {averageWomenGrade} {salaryTypeText} and men {averageMenGrade} {salaryTypeText}. Which results in a pay gap of {gradePayGap}.",
            "AveragePayLevelsTextGrade": "For jobs that are equally as complex as yours (Grade {grade}) women earn {averageWomenGrade} and men {averageMenGrade}. Which results in a pay gap of {gradePayGap}.",
            "AveragePayLevelsTextGradeBaseSalary": "For jobs that are equally as complex as yours (Grade {grade}), women's base salary is {averageWomenGrade} on average while men earn {averageMenGrade} on average. This results in a {gradePayGap} pay gap between men and women.",
            "AveragePayLevelsTextGradeTotalSalary": "For jobs that are equally as complex as yours (Grade {grade}), women's total salary is {averageWomenGrade} on average while men earn {averageMenGrade} on average. This results in a {gradePayGap} pay gap between men and women.",
            "AveragePayLevelsTextJobProfile": "In your job profile women earn {averageWomenJob} on average while men earn {averageMenJob} on average. This results in a {jobPayGap} pay gap between men and women.",
            "AveragePayLevelsTextJobProfileBaseSalary": "Base salary is a fixed, regular compensation an employee receives for performing their assignments, excluding any additional variable pay or compensation. In your job profile women's base salary is {averageWomenJob} on average while men earn {averageMenJob} on average. This results in a {jobPayGap} pay gap between men and women.",
            "AveragePayLevelsTextJobProfileSingleGender": "In your job profile, women earn {averageWomenJob} on average while men earn {averageMenJob} on average. A pay gap cannot be calculated when the job profile has only one gender.",
            "AveragePayLevelsTextJobProfileTotalSalary": "Total salary is the complete compensation an employee receives from an employer, including base salary plus all additional payments and benefits. In your job profile women's total salary is {averageWomenJob} on average while men earn {averageMenJob} on average. This results in a {jobPayGap} pay gap between men and women.",
            "currentSalaryWithoutMean": "You currently earn {currentSalary} {userSelectedSalaryTypeText}. Pay range and salaries are shown as base salary.",
            "emptyState": "You haven’t been assigned to a job profile yet.\nTalk to your manager or HR to get help.",
            "grade": "Grade",
            "gradeDescriptionWithCareer": "A job profile groups position titles that share common characteristics, such as similar assignments, responsibilities, and competency requirements. As a {title} you're a/an {career} ({careerShort}) in grade {grade}. Grade determines how complex your job is and a higher grade means a more complex job.",
            "gradeDescriptionWithCareerBand": "A job profile groups position titles that share common characteristics, such as similar assignments, responsibilities, and competency requirements. As a {title} you're a/an {career} in grade {grade}. Grade determines how complex your job is and a higher grade means a more complex job.",
            "gradeDescriptionWithoutCareer": "A job profile groups position titles that share common characteristics, such as similar assignments, responsibilities, and competency requirements. As a {title} you're in grade {grade}. Grade determines how complex your job is and a higher grade means a more complex job.",
            "jobDescription": "Job description",
            "jobDescriptionEmpty": "No description has been added for this job.",
            "jobGradeAndCareerBandDescription": "A job profile is a group of position titles with similar work assignments. As a {title} you’re a/an {career} in grade {grade}. Grade determines how complex your job is and a higher grade means a more complex job.",
            "jobGradeAndCareerDescription": "A job profile is a group of position titles with similar work assignments. As a {title} you’re a/an {career} ({careerShort}) in grade {grade}. Grade determines how complex your job is and a higher grade means a more complex job.",
            "jobGradeDescription": "A job profile is a group of position titles with similar work assignments. As a {title} you’re in grade {grade}. Grade determines how complex your job is and a higher grade means a more complex job.",
            "jobLevelEmpty": "Your job profile hasn’t been given a grade yet.",
            "jobPayBandRange": "{jobTitle} in grade {jobLevel} earn between {minPay} and {maxPay} {currency}/{salaryType}.",
            "meanComparedToSalary": "The mean salary is {meanSalary} {userSelectedSalaryTypeText} and you currently earn {currentSalary} {userSelectedSalaryTypeText}. Below you can find your pay range and the mean salaries broken down by gender for {jobTitle}. *Mean salaries are based on total salary.",
            "medianComparedToSalary": "The median salary for the grade is {median} {currency}/{salaryType} and you currently earn {salary} {currency}/{salaryType}.",
            "noPayGapsData": "There is currently no data for pay gaps for your organisation",
            "noPayRange": "No pay range has been added for the grade.",
            "noVariablePayData": "There is currently no data for variable pay gaps for your organisation",
            "payGap": "Pay Gap",
            "payRange": "Pay range",
            "sideBarJobLevelEmpty": "You haven’t been assigned to a job profile",
            "yourCurrentSalary": "You currently earn {salary} {currency}/{salaryType}",
            "yourJobProfile": "Your job profile"
        },
        "employeePerformance": {
            "averageInYearPerformance": "Your average performance ({min}-{max})",
            "averagePerformance": "Your average performance is at {average}% from the last 5 years. You have {trend} your score with {trendValue}% compared to last year.",
            "criteria": "Criteria",
            "decreased": "decreased",
            "descriptionManager": "You scored {actual} out of 100% in your latest performance review. Scores between {start} and {end} are considered \"{name}\".",
            "descriptionSelfEval": "In your self-evaluation, you rated your performance at {selfEvaluation}.",
            "differenceInYearPerformance": "Difference in performance {previousYear}-{latestYear}",
            "emptyPerformanceReview": "You haven’t been part of a performance review yet. Talk to your manager if you want to know more.",
            "evaluation": "Evaluation",
            "increased": "increased",
            "managerQuery": "Ask your manager if you want to learn more about their reasoning.",
            "managersEvaluation": "Manager’s evaluation",
            "noAssessment": "You haven’t been part of an assessment yet. Talk to your manager if you want to know more.",
            "noComparablePerformanceReview": "You have no prior performance reviews so we can’t show your progression over time.",
            "noEvaluation": "No evaluation",
            "noManager": "Your manager hasn't completed your evaluation yet.",
            "noSelfEval": "You haven't completed your self-evaluation yet.",
            "ongoingEvaluation": "The assessment of your performance is still ongoing. Talk to your manager if you want to know more.",
            "performanceOverTime": "Your performance over time",
            "selectPerformanceReview": "Select performance review",
            "selfEvaluation": "Self-evaluation",
            "title": "Your performance",
            "yourSelfEvaluation": "Your self-evaluation"
        },
        "employeeStatutoryGrade": {
            "baseSalaryLabel": "{grade} - Base salary",
            "baseSalaryText": "In your statutory grade women's base salary is {averageWomenGrade} on average while men earn {averageMenGrade} on average. This results in a {gradePayGap} pay gap between men and women.",
            "baseSalaryTitle": "Average pay levels for your statutory grade (base salary)",
            "description": "Statutory grade is a representation of your job's complexity agreed by the collective agreement or statutory pay framework. The statutory grade your job belongs to is {grade}.",
            "emptyState": "You haven’t received a statutory grade.",
            "singleGenderBaseSalary": "In your statutory grade, {gender}'s base salary is {salary} on average. A pay gap cannot be calculated when the statutory grade has only one gender.",
            "singleGenderTotalSalary": "In your statutory grade, {gender}'s total salary is {salary} on average. A pay gap cannot be calculated when the statutory grade has only one gender.",
            "title": "Average pay levels for your statutory grade",
            "totalPayLevelsTitle": "Average total pay levels for your statutory grade",
            "totalSalaryLabel": "{grade} - Total salary",
            "totalSalaryText": "In your statutory grade women's total salary is {averageWomenGrade} on average while men earn {averageMenGrade} on average. This results in a {gradePayGap} pay gap between men and women.",
            "totalSalaryTitle": "Average pay levels for your statutory grade (total salary)"
        },
        "employeeTargets": {
            "closestDeadline": "Your closest deadline for your next target is {date}.",
            "completedTargets": "You have currently finished none of them. | You have currently finished {count} of them. | You have currently finished {count} of them.",
            "contactManager": "Talk with your manager if you think you have finished a target that’s yet to be marked as completed.",
            "createTarget": "Create target",
            "emptyState": "You haven’t created any targets for this year yet.",
            "goToTargets": "Go to targets",
            "ongoing": "Ongoing, due {date}",
            "setTargets": "This year you have set no targets for yourself. | This year you have set {count} target for yourself. | This year you have set {count} targets for yourself.",
            "yourTargets": "Your targets"
        },
        "employment": {
            "assignment": "Assignment",
            "editUser": "Edit user",
            "failedToLoad": "Failed to load employment. Refresh the page and try again. if the problem persist contact Technical support.",
            "noteVisibleFor": "Notes are visible for: ",
            "notes": "Notes",
            "userDetails": "User details"
        },
        "employmentInformationsView": {
            "assignment": "Assignment",
            "createUser": "Create user",
            "creatingUser": "Creates user...",
            "deleteUser": "Delete user",
            "deletingUser": "Deletes user...",
            "email": "Email",
            "employmentNumber": "Employment number",
            "firstName": "First name",
            "lastName": "Last name",
            "organisation": "Organisation",
            "placement": "Placement",
            "position": "Position title",
            "userMissing": "(User missing)"
        },
        "employmentPerformanceReview": {
            "addQuestion": "Add question",
            "deleteEmploymentPerformanceReview": "Delete discussion",
            "employeeHasAnswered": "The employee has started to answer.",
            "saveErrorCallout": "Failed to save your answers for this session. Save the answers you wrote during this session elsewhere before refreshing or leaving the page.",
            "verifyDelete": "Are you sure that you want to delete the discussion?"
        },
        "employmentPerformanceReviewAnswer": {
            "addMultipleLines": "Add multiple lines",
            "answer": "Answer by",
            "archivedByManagerName": "Manager",
            "cannotSeeAnswer": "{name} has not shared this answer yet",
            "description": "Description",
            "managerNote": "Managers personal notes",
            "notVisibleForEmployee": "The answer is not shown to the employee",
            "notVisibleForManager": "The answer is not shown to the manager",
            "questionIsLocked": "The question is locked for changes",
            "questionTitle": "Question",
            "showManagerNote": "Show managers personal notes",
            "verifyDelete": "Are you sure that you want to delete the question?",
            "visibleForEmployee": "The answer is shown to the employee",
            "visibleForManager": "The answer is shown to the manager"
        },
        "employmentPerformanceReviewAttachments": {
            "addAttachment": "Add attachment",
            "attachments": "Attachments",
            "emptyState": "No attachments have been added yet."
        },
        "employmentPerformanceReviewBox": {
            "addEmploymentPerformanceReviewTitle": "Add discussion name...",
            "all": "- All -",
            "chooseDiscussion": "Choose discussion:",
            "completed": "Completed",
            "discussion": "Discussion",
            "edit": "Edit",
            "employmentPerformanceReviewTitle": "Discussion name",
            "lock": "Lock discussion",
            "newPerformanceReview": "New discussion",
            "noTitleTooltip": "The discussion is missing a title",
            "notStarted": "Not started",
            "openDiscussion": "Open discussion",
            "performanceReview": "Performance reviews",
            "started": "Started",
            "startedDiscussions": "This will also affect the discussions that you have already started!",
            "unlock": "Unlock and edit discussion",
            "userGuideContent": "Here you can find discussions that your organization has started, or those that you have created, that apply to all your employees. You can easily make simple adjustments or send invite emails to the whole group.",
            "userGuideLinkText": "guide",
            "verifyCreate": "Press proceed to create a new discussion group.",
            "verifyEdit": "Are you sure that you want to edit the discussion?",
            "waiting": "Waiting on OK"
        },
        "employmentPerformanceReviewConversation": {
            "activity": "Activity",
            "addComment": "Add comment",
            "comments": "Comments",
            "noComments": "There are no comments written",
            "sendComment": "Send comment",
            "uourEmployee": "Your employee",
            "you": "You",
            "yourManager": "Your manager"
        },
        "employmentPerformanceReviewEmploymentTargets": {
            "addTarget": "Add employee target",
            "addTargetCustom": "Add employee activity",
            "decidedTargets": "Agreed upon employee targets",
            "decidedTargetsCustom": "Agreed upon employee activities",
            "emptyState": "No targets have been added yet."
        },
        "employmentPerformanceReviewManager": {
            "addEmployments": "Add employment...",
            "addQuestion": "Add question",
            "basedOnTemplate": "Based on template",
            "chooseTemplate": "Choose template...",
            "deleteAll": "Delete all",
            "deleteEmploymentPerformanceReview": "Delete discussion",
            "deleteKeepStarted": "Keep started",
            "employments": "Employments",
            "invitationSent": "An invitation has been sent to all employments in the list.",
            "lastResponseDate": "Last response date",
            "lastResponseDateTooltip": "Please check that the last response date is correct",
            "noEmployment": "You must add one or more employments",
            "questions": "Questions",
            "sendInvitation": "Send discussion invitation",
            "sendInvitationTooltip": "You must add a title and choose at least one employment to be able to send the discussion invitation",
            "sendingInvitations": "Sending invitations...",
            "startedDiscussions": "This will also affect the discussions that you have already started!",
            "verifyAddQuestion": "Are you sure that you want to add a new question?",
            "verifyDelete": "Are you sure that you want to delete the discussion?"
        },
        "employmentPerformanceReviewManagerQuestion": {
            "addMultipleLines": "Add multiple lines",
            "addedByAdmin": "Added by admin",
            "description": "Description",
            "questionIsLocked": "The question is locked for changes by the administrator",
            "questionTitle": "Question",
            "startedDiscussions": "This will also affect the discussions that you have already started!",
            "verifyDelete": "Are you sure that you want to delete the question?"
        },
        "employmentPerformanceReviewNavigation": {
            "afterLastRespnseDate": "The manager has the possibility to show answers after last response date.",
            "answerQuestions": "Answer questions",
            "answerQuestionsDone": "Questions answered",
            "answersAreShownToManager": "Your aswers are shown to the manager",
            "approveByEmployeeDescription": "To close the discussion, you need to approve the answers and comments.",
            "approveDiscussion": "Approve discussion",
            "approveDiscussionByEmployee": "Approve discussion",
            "approveDiscussionDescription": "This will approve, archive and close the discussion. It will not be possible to add any more comments after this.\nDo you want to continue?",
            "approved": "Approved",
            "archive": "Archive",
            "archiveDiscussionByManager": "Archive discussion",
            "archiveDiscussionByManagerDescription": "This will close and lock the entire discussion without the employee approving the answers and notes.\nIt will no longer be possible to write comments.\n\nDo you want to continue?",
            "archived": "Archived",
            "closeReview": "Send the discussion for approval",
            "closeReviewDescription": "When you approve the discussion, your employee will have the opportunity to approve the discussion.\nAfter both you and your employee have approved the discussion, the discussion will be archived and you will not be able to make any changes.\n\nDo you want to send the discussion for approval?",
            "comment": "Comment",
            "createEmploymentPerformanceReview": "Create discussion",
            "discussionDone": "Discussion done",
            "forApproval": "For approval",
            "forceLockAnswers": "Lock the employee's answers",
            "forceLockAnswersDescription": "This will lock the answers for the employee, and make them visibile to you. The employee will not be able to continue answering the questions.\nDo you want to continue?",
            "invitationSent": "Invitation sent",
            "lockAnswers": "Lock answers",
            "lockAnswersDescriptionEmployee": "This will lock your answers on the questions and later on make them visible for your manager.\nDo you want to continue?",
            "lockAnswersDescriptionManager": "This will lock your answers on the questions and later on make them visible for the employee.\nDo you want to continue?",
            "noEmail": "The employee is missing email address. To be able to start the discussion you need to add this.",
            "onGoing": "Discussion ongoing",
            "pastDueDate": "Past due date!",
            "reSendMail": "Sending mail...",
            "resetToSent": "Reset to invitation sent",
            "send": "Send",
            "sendAnswer": "Send answer",
            "sendForApproval": "Send for approval",
            "sendInvitation": "Send invitation",
            "sendInvitationDescription": "It will not be possible to change any settings or questions after this.\nLast response date will also be locked.",
            "sendInvitationHeading": "Are you sure you want to send the invitation?",
            "sendInvitationTooltip": "You must add title to be able to send discussion invitation",
            "showAnswersForManager": "Show answers for manager",
            "showAnswersToManagerDescription": "This will make your answers visible to your manager.\nDo you want to continue?",
            "showEmployeeAnswers": "Show the employees answers",
            "showEmployeeAnswersDescription": "This will make the employees answer visible for you as a manager.\nDo you want to continue?",
            "statusOfTheEmploymentPerformanceReview": "Status of the discussion",
            "waitForEmployeeAnswers": "Wait for employee to aswers questions.",
            "waitingForApproveByEmployeeDescription": "Waiting for the employee to approve discussion.",
            "writeFirstComment": "Write the first comment to the discussion here."
        },
        "employmentPerformanceReviewPrintout": {
            "cannotSeeAnswer": "{name} has not shared this answer yet",
            "discussion": "Discussion",
            "downloadDiscussion": "Download discussion"
        },
        "employmentPerformanceReviewSettings": {
            "basedOnTemplate": "Based on template",
            "chooseTemplate": "Choose template...",
            "lastResponseDate": "Last response date",
            "lastResponseDateTooltip": "Please check that the last response date is correct",
            "publish": "Publish",
            "shareEmploymentPerformanceReview": "Share discussion with (separate the addresses with comma)",
            "status": "Employee status"
        },
        "employmentPerformanceReviews": {
            "addEmploymentPerformanceReviewTitle": "Add discussion name...",
            "employmentPerformanceReviewTitle": "Discussion name",
            "employmentPerformanceReviews": "Discussions",
            "errorInfo": "Something went wrong!\nPlease try again.\n\nIf you continue to receive errors, please contact Customer Success",
            "lastResponseDate": "Last response date",
            "newEmploymentPerformanceReview": "New discussion",
            "noEmploymentPerformanceReviews": "There are no discussions for the current year.",
            "noTitleTooltip": "The discussion is missing title",
            "titleMissing": "Title missing"
        },
        "employmentSalaryReviewAssessmentCard": {
            "completed": "Completed",
            "markAsDone": "Mark as done",
            "ratePerformance": "Rate performance"
        },
        "employmentSalaryStructureCharts": {
            "employee": "Employee",
            "female": "Female",
            "male": "Male",
            "salaryAgeChart": "Salary/Age",
            "salaryEmploymentLengthChart": "Salary/Employment",
            "salarySpread": "Salary spread"
        },
        "employmentTarget": {
            "clickToApprove": "Click to approve the target",
            "clickToApproveCustom": "Click to approve the activity",
            "clickToDecline": "Click to decline the target",
            "clickToDeclineCustom": "Click to decline the activity",
            "deleteTarget": "Delete target",
            "deleteTargetCustom": "Delete activity",
            "lock": "Lock",
            "newTarget": "New target",
            "setTargetStatus": "Choose status for the target",
            "setTargetStatusCustom": "Choose status for the activity",
            "targetApproved": "Target is approved",
            "targetApprovedCustom": "Activitiy us approved",
            "targetCompletion": "When should the target be completed?",
            "targetCompletionCustom": "When should the activity be completed?",
            "targetCreatedBy": "Target created by {name}.",
            "targetCreatedByManager": "Target created by your manager.",
            "targetDeclined": "Target is declined",
            "targetDeclinedCustom": "Activity is declined",
            "targetDescription": "Describe target",
            "targetDescriptionCustom": "Describe activity",
            "targetEvaluation": "How are we judging the target?",
            "targetEvaluationCustom": "How are we judging the activity?",
            "targetLocked": "{name} has locked this target for editing",
            "targetName": "Name of the target",
            "targetNameCustom": "Name of the activity",
            "targetStatus": "Status of the target",
            "targetTasks": "Activities along the road?",
            "targetTasksCustom": "Activities along the road?",
            "unlock": "Unlock",
            "verifyDelete": "Are you sure that you want to delete the target?",
            "verifyDeleteCustom": "Are you sure that you want to delete the activity?"
        },
        "employmentTargetBox": {
            "ongoing": "Ongoing",
            "targetFulfillment": "Target fulfillment",
            "targetFulfillmentCustom": "Activity fulfillment",
            "targetsFulfilled": "Targets fulfilled",
            "targetsFulfilledCustom": "Activities fulfilled"
        },
        "employmentTargets": {
            "newEmploymentTarget": "New target",
            "newEmploymentTargetCustom": "New activity",
            "noTargets": "There are no targets for the current year.",
            "noTargetsCustom": "There are no activities for the current year.",
            "targets": "Targets",
            "targetsCustom": "Activities",
            "titleMissing": "Title missing",
            "whenReady": "When ready?"
        },
        "employmentsSummary": {
            "allEmployments": "All employees",
            "multipleCurrenciesMessage": "Salary charts are not available when employees have different currencies",
            "noEmployments": "There are no employees connected to this role, please contact your administrator",
            "overview": "Overview"
        },
        "employmentsUser": {
            "createUsers": "Create users",
            "creatingUsers": "Creating users",
            "employeesWithUserAccoount": "Number of employees with an user account:",
            "missingUserAccount": "(Employees without a user account will not be able to answer discussions)",
            "verifyAddUsers": "Are you sure you want to create a user account for all employees that are listed below?"
        },
        "equalityTimer": {
            "calculatedOnAverage": "Calculated with a mean salary ",
            "calculatedOnMedian": "Calculated with a median salary ",
            "equalityTimer": "Equality Timer",
            "excludesNonDeclaredGenders": "(Employees with non declared genders are excluded from the calculation)",
            "explainationText": "of {averageSalaryMale} for men and {averageSalaryFemale} for women. \n\nThe time is caculated to show how much longer the average woman must work compared to the average man, in order to reach the same average salary. \n\n{nonDeclaredString} \n\nWomen in your organisation must work {hours} hours, {minutes} minutes and {seconds} seconds {negativeOrPositiveTranslation} every day to recieve the same salary as men",
            "explainationTextGroup": "of {averageSalaryMale} for men and {averageSalaryFemale} for women. \n\nThe time is caculated to show how much longer the average woman must work compared to the average man, in order to reach the same average salary. \n\n{nonDeclaredString} \n\nWomen in your group must work {hours} hours, {minutes} minutes and {seconds} seconds {negativeOrPositiveTranslation} every day to recieve the same salary as men",
            "explainationTextSingleGender": "The group consists of only a single gender.",
            "hours": "Hours",
            "includesNonDeclaredGenders": "(Employees with non declared genders are included in the calculation)",
            "individualNeedToWorkLessThanGroup": "{employee} can work {hours} hours, {minutes} minuter and {seconds} seconds less every day to recieve the same salary as {medianGender} in this group. \n\n{nonDeclaredString}",
            "individualNeedToWorkMoreThanGroup": "{employee} must work {hours} hours, {minutes} minuter and {seconds} seconds longer every day to recieve the same salary as {medianGender} in this group. \n\n{nonDeclaredString}",
            "less": "less",
            "minutes": "Minutes",
            "more": "longer",
            "seconds": "Seconds",
            "title": "Equality timer",
            "unadjustedEqualityTimer": "Unadjusted equality timer"
        },
        "existingDiscussionEmployments": {
            "answerQuestions": "Answer questions",
            "archived": "Archived",
            "confirmationPending": "Confirmation pending",
            "employees": "Employees",
            "noEmployeeSelected": "No employee selected",
            "ongoingDiscussion": "Ongoing discussion",
            "position": "Position title",
            "selectedAmount": "No employees selected | 1 employee selected | {n} employees selected",
            "sendInvitation": "Send invitation",
            "sendReminderText": "We will be sending an email with a reminder to the selected employees who have not finished thier discussion yet.",
            "sendReminderTo": "You will send reminder to:",
            "statusDiscussion": "Status discussion",
            "uniqueId": "Unique-ID"
        },
        "existingDiscussionManagers": {
            "addNewEmployments": "Newly added employees in units",
            "addOrganisationHelptext": "Adding units to an already published discussion will automatically publish the newly added units with the same settings and questionnaire. Meaning, if you only published to managers previously the manager will have to invite their employees.",
            "addUnitTooltip": "Select a unit in the table that has a manager connected to it",
            "alreadyStarted": "The discussion have already started. If you remove the units from this discussion,\nall managers' and employees' answers in the discussion will be deleted.",
            "completedDiscussions": "Finished discussions",
            "coworkersDone": "Questionnaires filled",
            "coworkersDoneTooltip": "How many employees have finished answering the questionnaire",
            "discussions": "Discussions",
            "finished": "Finished",
            "finishedTooltip": "How many discussions that are marked as finished",
            "ignore": "Ignore",
            "invitationsSent": "Invitations sent",
            "invitationsSentTooltip": "How many employees have been invited to the discussion",
            "manager": "Manager",
            "managerMissing": "Manager missing",
            "managersDone": "Discussions",
            "managersDoneTooltip": "How many discussions the manager and employee have compiled their answers for",
            "newEmployments": "have been added to your selected organisation nodes. Do you want to add this employee to the ongoing discussion round? | have been added to your selected organisation nodes. Do you want to add these employees to the ongoing discussion round?",
            "newEmploymentsAmount": "1 new employee | {n} new employees",
            "newEmploymentsInfo": "When you add new employees they will be placed in a published discussion with the same settings and questionnaire you choose when you published the discussion. Meaning, if you choose to only publish to managers, the managers will have to invite the new employees.",
            "noUnitSelected": "No unit selected",
            "noUnitsSelected": "No units selected",
            "organisation": "Organisation",
            "previewSendReminderTitle": "You have unfinished discussions",
            "previewSendReminderToManagersAndCoworkersBodyText": "Hi {name}!<br /><br />You have an unfinished discussion in Sysarb that you need to complete. The deadline, {deadline}, is approaching and we want to remind you to finish your discussion.<br /><br />You can log into Sysarb by clicking the button below.<br /><br />Good luck!",
            "previewSendReminderToManagersBodyText": "Hi {name}!<br /><br />You have unfinished discussions in Sysarb that you need to complete. The deadline, {deadline}, is approaching and we want to remind you to finish your discussions.<br /><br />You can log into Sysarb by clicking the button below.<br /><br />Good luck!",
            "removeUnits": "Remove units from discussion",
            "selectedAmount": "1 selected unit out of {total} | {n} selected units out of {total}",
            "selectedEmploymentsAmount": "1 selected employee out of {total} | {n} selected employees out of {total}",
            "sendReminder": "Send reminder",
            "sendReminderInfo": "We will be sending an email with a reminder to the selected employees and managers who have not finished their discussions yet.",
            "sendReminderSelection": "Who do you want to send reminder to?",
            "sendReminderTo": "You will send reminder to:",
            "status": "Status",
            "unpublishedMessage": "This discussion is unpublished. In order to follow this round of discussions' progress you'll have to publish the discussion.",
            "youWillRemove": "You will remove:"
        },
        "exportKeyFigures": {
            "analyseEqualWorks": "Analyze equal jobs",
            "analyseEquivalentWorks": "Analyze comparative jobs",
            "averageAge": "Average age",
            "averageYearsOfEmployment": "Average company tenure",
            "budget": "Budget",
            "comment": "Comment",
            "comparedWith": "Compared with",
            "connectedWork": "Comparative jobs",
            "count": "Count",
            "eighteenthPercentile": "80th salary percentile",
            "employmentQuotaOnSalaryYear": "Employment quota of {count} years salary",
            "employmentQuotaWithoutSalaryYear": "Employment quota without salary year",
            "excludeSingleEthnicity": "and ethnicity",
            "excludesNonDeclaredGenders": "Employees with non declared genders are excluded from the calculation below",
            "femaleDominatedWork": "Female dominated work",
            "femaleDominatedWorks": "Female dominated jobs",
            "femaleDominatedWorksToAnalyse": "Female dominated jobs to analyze",
            "fileName": "Key values - compilation",
            "filteredValuesEqualWorks": "Filtered values equal analyze",
            "filteredValuesEquivalentWorks": "Filtered values comparative analyze",
            "firstQuartile": "Quartile 1 (low)",
            "fourthQuartile": "Quartile 4 (high)",
            "groups": "Groups",
            "groupsEqualWorks": "Groups of equal jobs",
            "groupsEqualWorksToAnalyse": "Groups of equal jobs to analyze (excluding single gender {ethnicityString})",
            "groupsMenEarnsMore": "Groups where men earn more than women (excluding single gender)",
            "groupsMenEarnsMoreMean": "Groups where men earn more than women (mean, excluding single gender)",
            "groupsMenEarnsMoreMedian": "Groups where men earn more than women (median, excluding single gender)",
            "groupsNoSalaryDiff": "Groups without a pay gap between genders (excluding single gender)",
            "groupsWomenEarnsMore": "Groups where women earn more than men (excluding single gender)",
            "groupsWomenEarnsMoreMean": "Groups where women earn more than men (mean, excluding single gender)",
            "groupsWomenEarnsMoreMedian": "Groups where women earn more than men (median, excluding single gender)",
            "hideGroups": "Hide groups with less than {count} employees",
            "hideGroupsInactive": "Hide small groups filter is inactive.",
            "hideSalaryDifferences": "Hide pay gap below {count} %",
            "hideSalaryDifferencesInactive": "Hide pay gap filter is inactive.",
            "keyValue": "Key values",
            "keyValueAllEmployees": "Key values for all employees",
            "keyValueFilteredData": "Key values - filtered data",
            "keyValueFilteredEmployees": "Key values for filtered employees",
            "maxSalary": "Max salary",
            "mean": "Mean",
            "meanSalary": "Mean salary",
            "meanSalaryCurrency": "Mean unadjusted pay gap {currency}",
            "meanSalaryPercent": "Mean unadjusted pay gap %",
            "median": "Median",
            "medianSalary": "Median salary",
            "medianSalaryCurrency": "Median unadjusted pay gap {currency}",
            "medianSalaryPercent": "Median unadjusted pay gap %",
            "men": "Men",
            "menQuota": "Men quota",
            "minSalary": "Min salary",
            "ninetiethPercentile": "90th salary percentile",
            "notDeclared": "Not declared",
            "notDeclaredQuota": "Not declared quota",
            "numberOfEmployees": "Number of emoployees",
            "quartileCountTotal": "Total staff",
            "quartileGenderRepresentation": "Percentage gender | Quartile",
            "quartileSalaryRatio": "Unadjusted pay gap | Quartile",
            "quota": "Quota",
            "salaryData": "Salary data",
            "salaryDifference": "Unadjusted pay gap (F/M)",
            "salaryDifferenceMean": "Unadjusted pay gap (Mean)",
            "salaryDifferenceMedian": "Unadjusted pay gap (Median)",
            "salarySpread": "Salary spread",
            "secondQuartile": "Quartile 2 (low to medium)",
            "selectedFilters": "Selected filters:",
            "smallGroups": "Small groups",
            "smallGroupsConnectedWorks": "Small groups - comparative jobs",
            "smallGroupsFemaleDominated": "Small groups - female dominated",
            "smallSalaryDifference": "Small pay gap",
            "tags": "Tags",
            "tenthPercentile": "10th salary percentile",
            "thirdQuartile": "Quartile 3 (medium to high)",
            "total": "Total",
            "twentiethPercentile": "20th salary percentile",
            "ungroupedEmployeesRemoved": "1 employee has been filtered because it doesnt have a connected work | {count} employees has been filtered because they dont have any connecting work",
            "valuationBox": "Grade",
            "valuationPoints": "Valuation points",
            "women": "Women",
            "womenQuota": "Women quota",
            "work": "Work"
        },
        "exportSalaryReviewSummaryReport": {
            "adminComment": "HR comment",
            "averageHoursWorked": "Average hours worked",
            "comment": "Comment",
            "contractedHours": "Contracted hours",
            "country": "Country",
            "currency": "Currency",
            "currencyLocal": "Local currency",
            "currentSalary": "Current salary",
            "currentSalaryLocal": "Current salary (local)",
            "employedHourly": "Employed hourly",
            "employedMonthly": "Employed monthly",
            "employees": "Employees",
            "employmentNumber": "Employment number",
            "employmentType": "Employment type",
            "excluded": "Excluded",
            "fileName": "Summary",
            "minimumNewSalary": "Min new salary",
            "minimumNewSalaryCost": "Min new salary cost",
            "name": "Name",
            "newSalary": "New salary",
            "newSalaryLocal": "New salary (local)",
            "no": "No",
            "organisation": "Organisation",
            "percentageRaise": "Salary increase (%)",
            "performance": "Performance",
            "position": "Position title",
            "salaryLift": "Salary increase",
            "salaryLiftLocal": "Salary increase (local)",
            "salaryRaiseOne": "Salary raise 1",
            "salaryRaiseOneLocal": "Salary raise 1 (local)",
            "salaryRaiseTwo": "Salary raise 2",
            "salaryRaiseTwoLocal": "Salary raise 2 (local)",
            "salaryType": "Salary type",
            "sectionManagerComment": "Section Manager Comment ",
            "socialSecurityNumber": "Unique-ID",
            "statisticalCode": "Statistical code",
            "suggestedSalaryIncrease": "Suggested salary increase",
            "union": "Union",
            "unionComment": "Union comment",
            "uniqueID": "Unique-ID",
            "yearlyPayouts": "Yearly payouts",
            "yes": "Yes"
        },
        "exportWorks": {
            "analysis": "Analysis",
            "averageCompaRatio": "Average compa-ratio",
            "averageSalary": "Average salary",
            "charts": "Charts",
            "compaRatio": "Compa-ratio",
            "connectedWorks": "Non female-dominated jobs",
            "count": "Count",
            "employments": "Employments",
            "equalWorks": "Equal jobs",
            "equivalentWorks": "Comparative jobs",
            "femaleAverageCompaRatio": "Women | Average compa-ratio",
            "femaleMedianCompaRatio": "Women | Median compa-ratio",
            "keyValues": "Key values",
            "maleAverageCompaRatio": "Men | Average compa-ratio",
            "maleMedianCompaRatio": "Men | Median compa-ratio",
            "maxCompaRatio": "Max compa-ratio",
            "medianCompaRatio": "Median compa-ratio",
            "medianSalary": "Median salary",
            "minCompaRatio": "Min compa-ratio",
            "pieces": "pcs",
            "salary": "Salary",
            "salaryDifference": "Unadjusted pay gap (F/M)",
            "salaryDifferenceCurrency": "Unadjusted pay gap {currency}",
            "salaryDifferenceMean": "Unadjusted pay gap (Mean)",
            "salaryDifferenceMedian": "Unadjusted pay gap (Median)",
            "salaryDifferencePercent": "Unadjusted pay gap %",
            "salaryEffectedBy": "Salary affected by *amount of employees with tag",
            "salaryExplainedBy": "Salary affected by",
            "shortIndividual": "I",
            "shortMarket": "M",
            "shortWork": "W",
            "timeInCurrentPosition": "Job tenure",
            "totalSalary": "Salary",
            "womenRatio": "Women ratio",
            "work": "Work"
        },
        "exportWorksSettings": {
            "analyzeText": "Analyze text",
            "chart": "Chart",
            "compaRatio": "Compa-ratio",
            "connectedWorks": "Non female dominated jobs",
            "ethnicity": "Ethnicity",
            "export": "Export",
            "exporting": "Exporting report",
            "includeInReport": "Include in report",
            "none": "None",
            "one": "One",
            "position": "Position title",
            "reportSettings": "Report settings",
            "salary": "Salary",
            "statisticalCode": "Statistical code",
            "tags": "Tags",
            "timeInCurrentPosition": "Job tenure",
            "two": "Two"
        },
        "featureFlagsSettings": {
            "flags": {
                "enableOnPageMessages": "Enable users on the same page to send messages to eachother",
                "simulateFromEmployeeList": "Show tools column switcher in employment list"
            },
            "info": "Changing these flags will affect all customers.",
            "title": "Feature flags"
        },
        "fieldToggle": {
            "cancel": "Cancel",
            "change": "Edit",
            "save": "Save"
        },
        "fileEditor": {
            "addFile": "Add file",
            "confirmDeleteFile": "Are you sure you want to delete the file?",
            "delete": "Delete",
            "download": "Download",
            "imageFormat": "Supported: .jpg, .jpeg and .png",
            "maxSize": "The file cannot be larger than",
            "profileImage": "Profile image",
            "uploadProfileImage": "Drag and drop or click to add an image"
        },
        "fileEditorDragAndDrop": {
            "allowedFileFormats": "Allowed file formats: {formats}",
            "deletingFile": "Deleting file...",
            "dragOrDrop": "Drag and drop file or click to browse file on your computer",
            "fileFormat": {
                "csv": "CSV (UTF-8)",
                "docx": "DOCX",
                "json": "JSON",
                "pdf": "PDF"
            },
            "fileUploaded": "File has been uploaded!",
            "uploadDifferentFile": "Upload a different file from computer",
            "uploadingFile": "Uploading file..."
        },
        "fileList": {
            "addFile": "Add file",
            "fileName": "File name",
            "files": "Files",
            "noData": "There are no uploaded files",
            "uploadDate": "Upload date",
            "uploadedBy": "Uploaded by"
        },
        "filter": {
            "noValue": "Missing value",
            "reset": "Reset filter"
        },
        "filterAccordion": {
            "clear": "Clear"
        },
        "friends": {
            "add": "Add",
            "info": "Manage your friends",
            "placeholder": "Friend subdomain",
            "remove": "Remove",
            "title": "Friends"
        },
        "genderDistributionChart": {
            "coworkers": "Employees",
            "wholeOrganisation": "Whole pay equity audit"
        },
        "genderValuationBoxDistributionChart": {
            "box": "Box",
            "genderDistPerBox": "Gender distribution per valuation grade",
            "genderDistPerGrade": "Gender distribution per grade",
            "share": "Share",
            "valuationBox": "Grade"
        },
        "general": "General",
        "generalSettingComponent": {
            "auditAppliesFrom": "Audit applies from",
            "auditSelectionInitialDescription": "We offer two types of pay equity audits where the compliant version more thoroughly analyses pay discrepancies in your organisation.",
            "auditSelectionInitialQuestion": "How thorough analysis do you want to do?",
            "averageSalaryDifferenceSelectionInitialDescription": "The preferred salary difference will be used to determine which jobs to analyse in the comparative job analysis.",
            "averageSalaryDifferenceSelectionInitialQuestion": "How do you want to calculate the average salary difference?",
            "equalWorkAnalysisTypeDescription": "This setting affects how equal jobs are displayed and interacted with during analysis.",
            "equalWorkAnalysisTypeHeading": "How do you want to analyze equal jobs?",
            "equalWorkAnalysisTypeLegacy": "I want to manually find unjustified salary differences",
            "equalWorkAnalysisTypeLegacyLine1": "Traditional equal work analysis layout.",
            "equalWorkAnalysisTypeLegacyLine2": "Add explanations and adjustments on employees or jobs.",
            "equalWorkAnalysisTypeLegacyLine3": "This is purely manual analysis and you receive no help finding unjustified differences.",
            "equalWorkAnalysisTypeNew": "I want to use predicted salaries to find unjustified differences",
            "equalWorkAnalysisTypeNewLine1": "Highlight salaries that differs greatly from their predicted salary based on your pay factors.",
            "equalWorkAnalysisTypeNewLine2": "Get quick insights on deviating data.",
            "equalWorkAnalysisTypeNewLine3": "Tailored layouts for various analysis.",
            "equalWorkAnalysisTypeNewLine4": "Add explanations and adjustments on employees or jobs.",
            "fieldRequired": "Field is required",
            "legalEntity": "Which legal entity are you analyzing in this audit?",
            "legalEntityDescription": "If your organisation contains multiple legal entities it’s common that you create a pay equity audit per legal entity. Select which legal entities’ employees you’ll analyze in this audit.",
            "lite": "Lite",
            "meanSalaryDifferences": "Mean salary differences",
            "medianSalaryDifferences": "Median salary differences",
            "nameTooLong": "name too long: maximum characters allowed is {count}.",
            "noLegalEntitySelected": "No legal entity",
            "standard": "Standard"
        },
        "globalOverview": {
            "adjustedPayGap": "Adjusted pay gap",
            "averageAdjustedPayGap": "Average adjusted pay gap",
            "averageCompaRatio": "Average compa-ratio",
            "averageEqualityTimer": "Equality timer {'|'} Mean",
            "averageUnAdjustedPayGap": "Unadjusted pay gap {'|'} Mean",
            "compaRatio": "Compa-ratio",
            "creatingAudit": "Creating analysis",
            "equalPayAuditStatus": "Pay equity audit",
            "globalOverview": "Global overview",
            "map": "Map",
            "newAudit": "New analysis",
            "noData": "Welcome to the start of your pay equity journey! To begin, import your employee data into our base registry. Choose either to integrate with our data providers or directly import a salary file using the provided link. We're here to assist you at every step – feel free to reach out if you have any questions.",
            "noLegalEntity": "No legal entity selected",
            "payEquityAudit": "Pay equity audit",
            "selectLegalEntity": "Select legal entity",
            "startImportingData": "Start importing data",
            "table": "Table",
            "unAdjustedPayGap": "Unadjusted pay gap",
            "workForce": "Amount of employees"
        },
        "globalOverviewV2": {
            "aboveTwentyPercent": "≥ 20%",
            "all": "All",
            "almostCompleted": "Almost completed",
            "auditStatus": "Audit status",
            "completed": "Completed",
            "complianceIndex": "Compliance index",
            "complianceIndexAllDone": "You have completed all your audits for this year",
            "complianceIndexAllDoneAlt": "A green checkbox",
            "complianceIndexTooltip": "Shows the number of countries where you have completed your annual pay equity audit.",
            "complianceResource": "Global Pay Transparency Tracker",
            "countriesFocusOn": "Countries you need to focus on",
            "country": "Country",
            "employees": "Employees",
            "employeesAndGrades": "Employees and grades",
            "errorCountryOverviewGeneric": "Something went wrong while loading the country overview. Try refreshing the page.",
            "errorGlobalOverviewGeneric": "Something went wrong while loading the global overview. Try refreshing the page.",
            "export": "Export",
            "exportFileName": "Global overview",
            "fifteenToTwentyPercent": "15-20%",
            "fiveToTenPercent": "5-10%",
            "genderDistribution": "Gender distribution",
            "globalOverview": "Global overview",
            "globalOverviewTooltip": "Your unadjusted pay gaps for each country. The unadjusted pay gaps are based on total salaries.",
            "gradesOverFivePercent": "Grades over 5%",
            "gradesOverFivePercentPayGap": "Grades over 5% pay gap",
            "gradesOverFivePercentTooltip": "The number of grades with a mean unadjusted pay gap exceeding 5%, based on total salary.",
            "gradesWithEmployees": "Grades with employees",
            "helpArticle": "Help article",
            "helpButtonAriaLabel": "Help - Global overview information",
            "helpButtonTitle": "Get help with global overview",
            "legalEntity": "Legal entity",
            "meanUnadjustedVariablePayGap": "Mean unadjusted variable pay gap",
            "medianUnadjustedVariablePayGap": "Median unadjusted variable pay gap",
            "needsImprovement": "Needs improvement",
            "noData": "No data",
            "noDataForSalaryType": "Employees in {country} don't currently have data for your chosen salary type ({salaryType}).",
            "noDataForSalaryTypeSuggestion": "Try changing your chosen salary type to see their data.",
            "noDataForSelectedSalaryType": "No data for this salary type",
            "noSalaryTypeSelected": "Select salary type",
            "notStarted": "Not started",
            "onTrack": "On track",
            "ongoing": "Ongoing",
            "percentageReceivingSalaryComponents": "% Recieving salary components",
            "percentageReceivingSalaryComponentsTooltip": "How many from each gender receives any of the variable pay components that's included in total salary.",
            "requiresAnalysis": "{count} countries that requires analysis",
            "salaryType": "Show employees with salary type",
            "status": "Status",
            "tenToFifteenPercent": "10-15%",
            "unadjustedPayGap": "Unadjusted pay gap",
            "welcome": "Welcome",
            "womenRatio": "Women ratio",
            "zeroToFivePercent": "0-5%"
        },
        "globalPEASettings": {
            "adminOverview": "Global overview",
            "adminOverviewDescription": "Discover pay equity audits worldwide, uncovering each country's progress. Customize your view by legal entities for tailored insights and stay updated on the path to pay equity globally. 🌍✨",
            "equalPayAuditStatus": "Equal pay audit",
            "globalPEASettings": "Pay equity audit settings",
            "legalEntitiesDisabled": "Assign a legal entity to all employees to analyze legal entities separately.",
            "legalEntitiesFirstLine": "You have multiple legal entities and want them to be analyzed separately.",
            "legalEntitiesSecondLine": "Your administrators are only allowed to access data within their legal entity.",
            "legalEntitiesThirdLine": "Each legal entity has its own pay structures",
            "legalEntitiesTitle": "Analyze legal entities by themselves",
            "legalEntityConfirmModalCancelButton": "Cancel",
            "legalEntityConfirmModalMessageToCountry": "When changing back to \"Keep organization whole in Sysarb\" we'll reset all legal entity based settings to the system's default settings. This means the following settings pages will be affected:\n• Employee portal\n\nEmployees won't see any details on their employee dashboard until you have saved the settings for each country.",
            "legalEntityConfirmModalMessageToLegalEntity": "When changing to \"Divide organization into legal entities in Sysarb\" we'll apply the country's settings to all its legal entities. This means the following settings pages will be affected:\n• Employee portal\n\nEmployees won't see any details on their employee dashboard until you have saved the settings for each legal entity.",
            "legalEntityConfirmModalSaveButtonToCountry": "Unify legal entities",
            "legalEntityConfirmModalSaveButtonToLegalEntity": "Divide into legal entities",
            "legalEntityConfirmModalSaveError": "We couldn't save the change. Please try again.",
            "legalEntityConfirmModalTitleToCountry": "Change to unify legal entities in Sysarb",
            "legalEntityConfirmModalTitleToLegalEntity": "Change to divide into legal entities in Sysarb",
            "legalEntityDesciptionText": "A legal identity is similar to an official ID of a company. It’s treated as its own entity in terms of legislation and income. It's not rare that subsidiaries are their own legal entities, separate from the parent organization",
            "legalEntityDesciptionTitle": "What does legal entity mean?",
            "legalEntityPageDescription": "We'll help you keep track of progress and compliance on either legal entity level or country level. Pay equity audit, Global and Country overview are the modules that will get affected.",
            "legalEntityPageQuestion": "Do you want to divide your organisation into legal entities in Sysarb?",
            "legalEntityPageTitle": "Legal entity settings",
            "legalEntityTooltipTrigger": "What is a legal entity?",
            "newLegalEntitiesFirstLine": "Include employees from a legal entity and country per pay equity audit.",
            "newLegalEntitiesSecondLine": "Global and country overview will help you track audit progress for each country and legal entity.",
            "newLegalEntitiesThirdLine": "Some of your settings can be customized per legal entity",
            "newLegalEntitiesTitle": "Divide organisation into legal entities in Sysarb",
            "newWholeOrganizationFirstLine": "Include all employees from a country per pay equity audit.",
            "newWholeOrganizationSecondLine": "Global and country overview will help you track audit progress for each country.",
            "newWholeOrganizationThirdLine": "All legal entities will follow the same settings for a country.",
            "newWholeOrganizationTitle": "Keep organisation whole in Sysarb",
            "organizationGroupingTypeTitle": "Analysis scope",
            "wholeOrganizationFirstLine": "You want everyone from the same country to be analyzed together, disregarding legal entities.",
            "wholeOrganizationSecondLine": "Your administrators’ are allowed to access all employment data from your organization.",
            "wholeOrganizationThirdLine": "Your whole organization follows the same pay structures",
            "wholeOrganizationTitle": "Analyze your whole organization as one",
            "workForce": "Global workforce"
        },
        "gridColumnSelector": {
            "modifyColumns": "Modify columns",
            "resetButton": "Reset columns",
            "searchPlaceholder": "Search..."
        },
        "gridExternalFilter": {
            "noData": "No data",
            "noMatchingFilters": "No data matching this filter",
            "resetButton": "Reset filters",
            "searchPlaceholder": "Search..."
        },
        "gridGroupSelector": {
            "noGrouping": "No grouping",
            "selectNone": "None",
            "sortGroup": "Sort"
        },
        "groupEmploymentOptions": {
            "all": "All jobs",
            "alwaysFemaleDominated": "Treat work as female dominated",
            "benchmark": "Benchmark",
            "benchmarkLower": "Lower",
            "benchmarkMiddle": "Middle",
            "benchmarkUpper": "Upper",
            "create": "Create",
            "createAndMove": "Create and move",
            "createWorkAndSelectEmploymentsToMove": "Enter work name and select the employees you want to move.",
            "deleteWorkDisabledTooltip": "Can't delete job with employments",
            "description": "Description",
            "employmentsInDifferentGroups": "Suggestions not avaliable because the selected employments have different positions/statistical codes.",
            "enterDescription": "Enter a description of the work",
            "enterWorkName": "Enter job name",
            "enterWorkNo": "Enter job code",
            "exportWorkBenchmark": "Export benchmark data",
            "femaleDominated": "Female dominated",
            "fileImported": "Import finished successfully",
            "importWorkBenchmark": "Import benchmark data",
            "manageWork": "Manage work",
            "new": "New",
            "newWorkName": "New job",
            "newWorkNo": "New job code",
            "noSuggestionsAvailable": "No suggestions available for the selected employees.",
            "overview": "Overview",
            "searchWork": "Search work...",
            "selectEmploymentsToMove": "Select employees to move first.",
            "selectEmploymentsToMoveOrEditWork": "Select employees to move, or click 'All jobs' or 'New' to add, edit or remove an existing job.",
            "showLess": "show less",
            "showMore": "show more",
            "suggestions": "Suggestions",
            "workName": "Work name",
            "workNo": "Job code",
            "workNoAlreadyInUse": "{workNo} in use, please choose another"
        },
        "importFileModal": {
            "downloadTemplate": "Download template",
            "importInfo": "Upload a CSV file to import data.",
            "importStatisticalCode": "Import statistical code"
        },
        "importMappingWorkData": {
            "analysis": "Analysis",
            "analysisMissing": "- No matching anlaysis found -",
            "commentMissing": "- No matching comment found -",
            "comments": "Comments",
            "deepAnalysis": "Analysis",
            "employees": "Employees",
            "equivalentWorks": "Comparative job",
            "femaleDominatedWork": "Female dominated work",
            "helpText": "In this section, you will find historical data for your selected work. You can choose a pay equity audit from which you want to import data.",
            "import": "Import",
            "importFailed": "Import failed! Please try again.",
            "importHistoryFrom": "Import work history from {mapping}",
            "importWorkHistory": "Import work history",
            "importing": "Importing...",
            "loadingWorkData": "Loading work data",
            "noMatchingEmploymentTagsOrComments": "No employees with tag or comment history could be found.",
            "tags": "Tags",
            "work": "Work"
        },
        "involve": {
            "suppression": {
                "gdprThreshold": {
                    "body": "There's not enough data available to display comparison information.",
                    "label": "Hidden for privacy",
                    "summary": "Some figures in this section are hidden to protect individual privacy because the underlying group is too small.",
                    "title": "Insufficient Comparison Data",
                    "tooltip": "This value is hidden to protect individual privacy. The underlying group is too small to share aggregated figures without risk of identifying individuals."
                }
            }
        },
        "involveReport": {
            "employeeReportExported": "Employee report has been exported!",
            "exportModalDescription": "Please select which salary type to use for the employee report.",
            "exportModalTitle": "Export the employee report",
            "openUnsavedSettings": "Go to country settings",
            "selectEmployment": "Select active employment",
            "selectEmploymentInfo": "Here you can select which active employment to export and which salary type the numbers should be presented in.",
            "selectSalaryType": "Select which salary type the numbers should be presented in.",
            "selectSalaryTypeLabel": "Select salary type",
            "unsavedSettings": "The employee portal settings for this employee's country or legal entity haven't been saved yet, so there's nothing to export. Save them first."
        },
        "jobArchitecture": {
            "SvenskaKyrkan": "Swedish church",
            "accessToBenchmark": "Access to benchmark data for other job architectures created in Sysarb.",
            "addCountry": "Add country",
            "addEmployees": "Add employees",
            "addEmployeesToProfile": "Add employees to the job profile before you can see insights on their gender pay gaps.",
            "aiGeneratedText": "Your AI-generated text:",
            "all": "All",
            "allJobProfiles": "All job profiles",
            "allJobsDeleted": "All job profiles deleted successfully!",
            "allReviewed": "All employees have been reviewed! Click the button below to go back.",
            "alphaConfirm": "I understand",
            "alphaInfo": "Welcome to the Alpha version of Job Architecture. Please feel free to explore its features, but please be aware that all data related to any created job architecture will be reset periodically until its released. Additionally, do not use this with any customer data until its proper release.\n\nBefore its release all data will be completely erased so only use it for testing right now!\n\nIf you find anything hard to use or find a bug please contact the tech team. 😊\nEnjoy!",
            "alphaWarning": "Alpha information",
            "amountOfPayRanges": "Amount of pay ranges",
            "andNew": "and new",
            "askManager": "Ask manager",
            "assign": "Assign",
            "assignAllTo": "Assign { employeeCount } to",
            "assignJobProfile": "Assign a job profile",
            "assignJobProfileConfirmationInfo": "You’re about to assign {count} employees to this job profile. Are you sure you want to assign this job profile to all of the selected employees?",
            "assignJobProfileConfirmationTitle": "Assign job profile to {count} employees",
            "assignLater": "Assign later",
            "assignLevel": "Assign level",
            "assignLevels": "Assign levels",
            "assignToJobProfile": "Assign to job profile",
            "autoMatch": "Auto-match",
            "autoMatchPositionsStatisticalCode": "Auto-match positions with statistical codes",
            "autoMatchPositionsStatisticalCodeHelpText": "All employments with a direct match against one of our sub-families.",
            "autoMatchPositionsStatisticalCodeTooltip": "Select all auto matches you wat to accept and map the rest manually.",
            "averageJobProfileSize": "Average job profile size",
            "backToCopilot": "Back to job architecture copilot",
            "backToOverview": "Back to overview",
            "banksSwe": "Banks Swedish",
            "browseJobProfiles": "Browse job profiles",
            "browseProfiles": "Browse profiles",
            "bulkChangeSubFamilyHelpText": "Change { count } to a new sub-family.",
            "careerType": "Career",
            "changeSubfamily": "Change sub-family",
            "changedEmploymentsPlacement": "You have {count} employees whose employment has been updated. Review whether they should be assigned to a different job profile or not.",
            "chooseCountry": "Choose country",
            "chooseEmploymentsToMatch": "Choose the employments to match.",
            "chooseOrganisation": "Choose organisation",
            "clear": "Reset",
            "code": "Code",
            "collapseEmptyColumns": "Hide grades without job profiles",
            "comment": "Comment",
            "compilationReport": "Compilation Report",
            "compliantWith": "Compliant with pay transparency.",
            "connectEmployments": "Move employees directly to their related job profile.",
            "continueMatchCallout": "{positions} positions haven't been matched to a profile yet and { employments } employments are ready to be assignes a level. Do you wish to continue your work on matching?",
            "copilot": "Copilot",
            "copilotNotifications": "Job architecture Copilot notifications",
            "copilotNotificationsInfo": "We'll compile a to-do list for you with employments that has been updated so that you can determine whether the employee's job profile should be changed or not.",
            "copilotNotificationsInfoOnCreate": "Once you have your job architecture up-and-running we'll notify you about updated employments that requires your attention to review whether the job profile needs to updated or not. Below you can select which fields that you want to be notified of when the they are updated.",
            "copilotSettings": "Copilot settings",
            "couldNotAssign": "An error occurred while attempting to assign employees.",
            "couldNotFindSuggestion": "We couldn't find any suggestions for these employees. You can select job profile on your own or assign them later with other employees without job profiles.",
            "couldNotRetrieveSuggestions": "Could not retrieve suggestions",
            "countSavedInDraft": "{count} changes saved in draft",
            "country": "Country",
            "coworker": "Employees",
            "coworkers": "Employees",
            "coworkersWithoutJobs": "Employees without job family",
            "create": "Create Job architecture",
            "createAudit": "Create audit",
            "createEqualPayAudit": "Create pay equity audit",
            "createInSysarb": "Create in Sysarb",
            "createJob": "Create job profile",
            "createJobArchitecture": "Create job architecture",
            "createJobProfileInfo": "A job profile groups similar roles into a singular group. It outlines the key responsibilities, qualifications, and skills needed for each job profile and its pay structures.\n\nTypically, a job profile is less granular than a job title but more granular than a statistical code. Getting your job profiles right requires you to continuously review and update them to match your organisation’s structure.",
            "createJobProfileManually": "Create job profile manually",
            "createJobProfiles": "Create job profiles",
            "createJobProfilesBasedOnEmplyees": "Create job profiles based on your employees",
            "createJobProfilesFromData": "Create job profiles from data",
            "createWithoutEvaluation": "Create without evaluation",
            "createdJobProfiles": "Created job profiles",
            "createdPayBands": "Created Pay ranges",
            "creatingAudit": "Creating audit...",
            "creatingJobProfilesDone": "Finished creating all job profiles successfully!",
            "currentJobProfile": "Current job profile",
            "custom": "Custom",
            "dataImportButton": "Data import",
            "declineSuggestedJobProfile": "Decline suggested job profile",
            "declineSuggestion": "Decline suggestion",
            "declineSuggestions": "Decline suggestions { employeeCount }",
            "declinedSuggestion": "Job profile suggestion declined for {count} employee. | Job profile suggestion declined for {count} employees.",
            "deleteJobs": "Delete jobs",
            "deleteJobsConfirmation": "This is an irreversible action. Are you sure you want to delete {count} jobs?",
            "deletePayBand": "Delete pay ranges for {country}",
            "deletePayBandInfo": "Are you sure you want to remove the pay ranges for {country}? If you add pay ranges for {country} at a later date you will need to refill all of the ranges.",
            "deletedJobProfiles": "Deleted job profiles",
            "deletedPayBands": "Deleted pay ranges",
            "deselectJobProfile": "No job profile",
            "detectedNewGradesAlert": "New grades were added to your job architecture but await admin approval. You can browse, but the order may change.",
            "detectedNewGradesHeading": "You have new grades to configure",
            "detectedNewGradesText": "From your latest update you have {count} new grades. You need to approve the changes before you can see this overview.",
            "determineJobs": "Determine how equal jobs should be created",
            "determineJobsInfo": "You'll first analyse the salaries internally within each equal job before comparing equal jobs with the same grade. We recommend that equal jobs be medium-sized to make it easier for you to draw conclusions. Too few employees and you can't come to any conclusions. Too many might get overwhelming. The best option depends on the number of employees within your job profiles.",
            "discardChangesInfo": "All changes you have done will be discarded. You can see a list below on changes you have made since last publish.",
            "displaySalariesAs": "Display employees with",
            "doYouAlreadyHave": "Do you already have a job architecture?",
            "draft": "Draft",
            "draftSaved": "Saved",
            "editCareer": "Edit career",
            "editEvaluation": "Edit evaluation",
            "editJobCluster": "Edit job cluster",
            "editJobCode": "Edit job code",
            "editLevel": "Edit level",
            "editMatch": "Edit match",
            "editVisibleFields": "Edit visible fields",
            "editWatchedFields": "Edit watched fields",
            "employeeCopilot": "Job architecture Copilot",
            "employeeCount": "No. of employees",
            "employees": "Employees",
            "employeesToReview": "Employees to review",
            "employeesWithNew": "Employees with new",
            "employmentToConnect": "Employment to connect",
            "employments": "Employments",
            "employmentsLeftToAssignLevel": "Employments to assign grades",
            "employmentsLeftToMatch": "Unmatched employments",
            "employmentsMoved": "Employment moved | Employments moved",
            "employmentsPreviewError": "We couldn't load the preview, so you can't create job profiles based on this selection. Please try again later or choose another option.",
            "emptyStateDescription": "At the current moment you can't manually create jobs and need help from our customer success. Creating jobs manually is under development and will be coming shortly.",
            "emptyStateTitle": "You don't have any jobs",
            "error": "Error",
            "errorFetchingJobs": "We encountered an error when fetching your jobs",
            "errors": {
                "emptyFile": "The file is empty. You need to add at least one row of data to import.",
                "headerDuplicateColumns": "The file contains duplicate column names. Please ensure each column name is unique (Columns should match the template file).",
                "headerNumberOfColumns": "The file has an incorrect number of columns. Please ensure the columns match the expected format (Reference the template file).",
                "invalidCsv": "The file could not be read. Please check if it is a valid CSV file.",
                "invalidHeader": "The file header is incorrect. Please ensure it matches the required format (Reference template file for correct names).",
                "rowCareer": "Row {rowNumber}: The career value is invalid. It should be one of the following: 1, 2.",
                "rowGrade": "Row {rowNumber}: The grade value is invalid. It should be a positive number greater than or equal to 0.",
                "rowJobCode": "Row {rowNumber}: The job code value is invalid. It should be between 1 and 255 characters.",
                "rowJobFamily": "Row {rowNumber}: The job family value is invalid",
                "rowTitle": "Row {rowNumber}: The title value is invalid. It should be between 1 and 255 characters.",
                "unknownError": "An unknown error occurred. Please check your file and try again. If the problem persists, don't hesitate to contact our Support."
            },
            "evaluateJob": "Evaluate the job",
            "evaluateJobInfo": "Select what best fits the job profile for each factor below. At the end you’ll see its calculated grade.",
            "evaluatedFactorLevels": "Evaluated factor levels",
            "evaluation": "Evaluation",
            "evaluationNotDone": "Finish evaluating the job profile to see the result.",
            "evaluationResult": "Evaluation result",
            "executive": "Executive",
            "executiveOptionInfo1": "Have overall responsibility for the individual organization, business unit or group/corporation.",
            "executiveOptionInfo2": "Accountable for business performance (P&L).",
            "executiveOptionInfo3": "Responsible for functional and/or cross-divisional strategy.",
            "executiveOptionInfo4": "Executive director positions that are involved in the day-to-day management.",
            "executiveShort": "EX",
            "exportCompilationReport": "Compilation report",
            "exportCompilationReportOnlyConnectedEmployments": "Compilation report (Only job profiles with employments)",
            "exportFactorPlan": "Factor plan",
            "exportJobFamilies": "Export job families",
            "factorDescription": "Factor level description",
            "factorLevel": "Factor level",
            "factorPlan": {
                "JobEvaluationDescription": "Here’s a compilation of all your job evaluations within the job architecture. Refer to the factor descriptions for clarification on what the requirements are for each factor grade.",
                "JobEvaluationTitle": "Your job evaluation",
                "coverInfo": "The structure behind the job architecture and job evaluations",
                "coverTitle": "Factor plan",
                "factorLevels": "Factor levels",
                "factorsTitle": "Factors",
                "fileName": "Factor plan",
                "grade": "Level",
                "lower": "Lower",
                "resultIntervalDescription": "This table shows what score is needed for each grade. Higher grades have higher complexity than lower grades and therefore requires a higher score.",
                "resultIntervalTitle": "Result interval",
                "score": "Score",
                "scoreDescription": "Each factor and its factor levels gives a score according to the table below. A job profile’s grade is based on the final score from the sum of the score from each factor. In a later section you can see what score is needed per grade.",
                "structureTitle": "Structure",
                "upper": "Upper"
            },
            "factors": "Factors",
            "failedToLoadProfile": "Misslyckades att ladda in job profilen. Försök igen eller välj en annan profil.",
            "failedToLoadSuggestions": "We couldn’t load the suggestions for your employees. Try refreshing the page. If the problem persists, contact our Technical Support.",
            "family": "Family",
            "featureBenefits1": "Benchmark your salaries against competitors.",
            "featureBenefits2": "Evaluate your jobs using a standard factor plan developed by our experts.",
            "featureBenefits3": "Manage pay bands.",
            "featureBenefits4": "Create and continuously update your structure directly in Sysarb.",
            "featureExplanation": "By using Sysarb’s standard structure for job architecture you’ll be able to:",
            "field": "Field",
            "fields": "Fields",
            "fillInBasicDetails": "Fill in the basic details",
            "filterHasNoMatch": "We couldn't find any matching job profiles. Try clearing or using different filters and search.",
            "filters": "Filters",
            "finalScore": "Final score",
            "finalScoreDesciption": "The total score from all factors is {totalScore} points which lands the job profile at grade {valuationLevel}. The selected career is {career}.",
            "general": "General",
            "generate": "Generate",
            "generatingJobDescription": "Generating job description...",
            "getStarted": "Get started",
            "globalJobFamily": "Job family | Job families",
            "goToDataImport": "Go to data import",
            "goToManageEmployments": "Connect employees",
            "goToValuation": "Go to evaluation",
            "gradeExists": "Grade already exists",
            "gradeInUse": "Grade is in use",
            "gradeNotFound": "Grade not found",
            "gradingCreatedTimeBy": "Created {time} by {name}",
            "gradingLastUpdateTimeBy": "Last updated {time} by {name}",
            "group": "Group",
            "hasConnectedJobProfile": "Have connected job profile",
            "hideAlreadyMatched": "Hide matched",
            "hideDone": "Hide done",
            "hideIncompleteJobProfiles": "Hide incomplete job profiles",
            "hideMissingFamily": "Hide job profiles without global job family",
            "hideMissingLevel": "Hide job profiles without grading",
            "home": "Home",
            "import": "Import",
            "importData": "Import data",
            "importDataInfo": "You need to import data to the “local” job architecture data fields per employment. This is best done via a file import or your integration. You can import the following fields:",
            "importError": "An error occured while importing.",
            "importFile": "From file",
            "importFromPayEquityAudit": "Equal jobs from pay equity audit",
            "importJobArchitectureVia": "Import your job architecture via file import or integrations.",
            "importJobProfilesByEmploymentData": {
                "header": "Create job profiles via employment data",
                "info": ""
            },
            "importJobProfilesWithFile": {
                "careerDescription": "The career column adds the career type in forms of a number.",
                "grade": "A grade reflects a job profile’s complexity. You determine how complex a job profile is with a job evaluation that consists of various criteria. In this column, you’ll import grades from your external job evaluation.",
                "header": "Import job architecture via file",
                "possibleValues": "You should only provide the numbers from the example below in the careers column.",
                "step1": "1. Download the template",
                "step1Info": "In order for us to successfully import and set-up your job architecture in our platform you need to follow our template. Download it and fill it with the data of your job architecture.",
                "step2": "2. Upload the template filled in with your data",
                "step2Info": "Once you are done filling in the template, upload it as a csv-file (UTF-8). And we’ll start the importing your job profiles.",
                "success": "File imported successfully.",
                "titleDescription": "A job profile is a group of employees with similar job assignments. The job profile typically consists of one or multiple position titles. In this column, you’ll be importing the job profiles’ titles."
            },
            "importSuccess": "Jobs imported",
            "importYourOwn": "Import your own (external job architecture)",
            "includePeopleFactor": "Include “People” factor in job evaluation",
            "includePeopleFactorDescription": "This factor is used when you have roles that have a professional responsibility over people’s lives and well-being. For example, firefighters, nurses among others. ",
            "individualContributor": "Individual Contributor",
            "individualContributorOptionInfo1": "Contributes mainly through application and development of skills.",
            "individualContributorOptionInfo2": "Professionals contributes individually or as a member of an organizational unit.",
            "individualContributorOptionInfo3": "Required skill level to perform work tasks varies from unskilled to expert.",
            "individualContributorOptionInfo4": "Disciplinary leadership does not belong to core tasks.",
            "individualContributorShort": "IC",
            "insert": "Insert",
            "insightHasDifferingCurrencies": "You have employees with a different currency than the primary currency for this country.",
            "insights": "Insights",
            "introductionInfo": "Maintaining clarity and coherence in organizational structure is paramount in the dynamic landscape of modern businesses.\n\nJob architecture encompasses the systematic arrangement of organisational roles, establishing clear hierarchies, career paths, and compensation structures. It involves categorising positions based on factors such as skills, responsibilities, and levels of authority. By defining these elements, job architecture ensures consistency, transparency, and equity across the organisation.",
            "introductionTitle": "Get started with your job architecture",
            "invalidFeedback": "Unable to save",
            "invalidIndex": "Invalid index",
            "invalidJobCodesButton": "View invalid codes",
            "invalidJobCodesExplanation": "A job code identifies a single job, so every employment that shares a code must have identical job information — the same grade, family, career type, and so on. The codes below appear with conflicting information and need to be corrected so that each code maps to exactly one job.",
            "invalidJobCodesListHeading": "Codes that need attention",
            "invalidJobCodesModalHeading": "Invalid job codes",
            "invalidJobCodesWarning": "{count} job code(s) are incorrectly configured and don't map to a single job profile.",
            "job": "Job profile",
            "jobArchitecture": "Welcome to our Job Architecture",
            "jobArchitectureDescription": "Designed to help you better understand the roles and responsibilities within your organization, and to ensure that everyone is paid fairly for the work they do. With this feature, you can group job titles into families and subfamilies based on their functions and responsibilities, making it easier to compare salaries across different levels and subgroups",
            "jobCluster": "Job cluster",
            "jobCode": "Job code",
            "jobDescription": "Job description",
            "jobEvaluation": "Job evaluation",
            "jobFamilyAndLevel": "Job family + grade",
            "jobProfile": "Job profile",
            "jobProfileAndLevel": "Job profile + grade",
            "jobProfileCreated": "Job profile created",
            "jobProfileEmployeesInfo": "These are the employees in this job profile whose employments have been updated and requires your attention. Review the suggested placements.",
            "jobProfilesWithUpdated": "Job profiles with updated employees",
            "jobProfilesWithUpdatedDescription": "Below you can find job profiles with employments that has one or more updated watched fields.",
            "jobs": "Job profiles",
            "jobsError": "We encountered an error while fetching the job list. If the error persists contact support.",
            "keepCurrent": "Keep current job profile { employeeCount }",
            "lastModifiedBy": "Published at",
            "level": "Grade | Grades",
            "levelDescription": "",
            "levelHelp": "Level help",
            "levelHelpText": "Here you can find information about the different levels",
            "levelInfo": {
                "autonomyAndProblemSolving": "Autonomy and problem solving",
                "autonomyAndProblemSolvingLevels": {
                    "1": "Receives clear work assignments and jobs with a low degree of autonomy. The work is carried out under close monitoring and supervision.",
                    "10": "Works independently and solves complex problems, often with a focus on development and innovative solutions.",
                    "11": "Works independently and develops new knowledge and moves the work forward within their own competence area.",
                    "12": "Works independently and develops new knowledge and moves the work forward within their own competence area.",
                    "13": "",
                    "14": "",
                    "15": "",
                    "2": "Works with clearly defined standard routines and clear work instructions and with some degree of work management and supervision.",
                    "3": "Carries out independently assigned tasks with a limited degree of supervision.",
                    "4": "Works independently according to established methods and routines, and is able to handle various types of tasks.",
                    "5": "Carries out own tasks independently. Can also coordinate work outside their own area.",
                    "6": "Works based on guidance and direction from management, but takes basic responsibility for evaluating work and methods to achieve goal fulfillment.",
                    "7": "Works independently with few instructions and minimal guidance. Current work experiences are used to look at things from new perspectives.",
                    "8": "Works independently with few instructions and minimal guidance. Current work experiences are used to look at things from new perspectives.",
                    "9": "Works independently and solves complex problems. Needs guidance only in very complex situations."
                },
                "educationAndExperience": "Education and experience",
                "educationAndExperienceLevels": {
                    "1": "Has limited education and/or work experience.",
                    "10": "Has specialist competence and a deep understanding through advanced academic education and/or long experience.",
                    "11": "Assessed as an expert in the field. Has expanded competence and a deep understanding based on research level degrees and/or long work experience in the competence area.",
                    "12": "Assessed as a senior expert in the field. Has expanded competence and a deep understanding based on research level degrees and/or long work experience in the competence area.",
                    "13": "",
                    "14": "",
                    "15": "",
                    "2": "Has basic skills through previous education and/or some work experience.",
                    "3": "Has knowledge through high school education in the current field and/or work experience.",
                    "4": "Has knowledge through post-secondary education in the field and/or significant work experience.",
                    "5": "Has knowledge through post-secondary education in the field and/or significant work experience.",
                    "6": "Has knowledge and basic understanding based on undergraduate academic degree and/or equivalent work experience.",
                    "7": "Has knowledge and understanding based on undergraduate degree and/or equivalent work experience.",
                    "8": "Has knowledge and understanding based on graduate academic degree from university and/or through work experience.",
                    "9": "Has knowledge and a deep understanding based on advanced academic education and/or long experience."
                },
                "responsibilityAndImpact": "Responsibility and impact",
                "responsibilityAndImpactLevels": {
                    "1": "Impact only on own work.",
                    "10": "Responsible for planning, development, implementation of processes, quality and guidelines as well as follow-up within their area. Impact on business level/management level.",
                    "11": "Responsible for planning, development, implementation of processes, quality and guidelines as well as follow-up within their area. Impact at an overall level.",
                    "12": "Overall and strategic responsibility for planning, development, quality and result follow-up. Great opportunities to influence and change services and processes that affect the entire organization.",
                    "13": "",
                    "14": "",
                    "15": "",
                    "2": "Impact primarily on own work.",
                    "3": "Impact primarily on own work but can also serve as support for colleagues within the same work area.",
                    "4": "Assists in developing appropriate methods for new tasks both for oneself and in the own work team.",
                    "5": "Suggests improvements and development both in own work, work team and work in other groups.",
                    "6": "Contributes to improving and developing work within the own area and ensures to share experiences for the group's development.",
                    "7": "Responsible for planning and independently driving own work and participates in planning and development work within the own group.",
                    "8": "Responsible for planning and independently driving own work and participates in planning and development work within the own group.",
                    "9": "Responsible for planning, coordination, driving and following up on processes and/or quality within their responsibility area. Impact on other employees' work."
                }
            },
            "levelMatchBulkTooltip": "Select all employments that you want to bulk update.",
            "levelProgressBar": "{ done } / { total } assigned levels",
            "levelsMatched": "Employees assigned a grade",
            "loadingInsights": "Loading insights",
            "loadingJobArchitecture": "Loading job architecture...",
            "loadingJobProfile": "Loading job profile...",
            "loadingJobProfiles": "Loading job profiles...",
            "manageEmployments": "Employments",
            "manageGradesButton": "Manage grades",
            "manageJobsTitle": "Your job profiles",
            "management": "Management",
            "managementShort": "M",
            "managerOptionInfo1": "Focuses primarily on management of employees and organizational units and budget responsibility.",
            "managerOptionInfo2": "Results are achieved indirectly through leadership, promotion, support and motivation as well as functional use of resources available.",
            "market": "Market",
            "marketData": "Market",
            "match": "Match",
            "matchAll": "Match all",
            "matchAllEmployments": "Match all to profile ({count})",
            "matchDescription": "Match your positions to our job profiles to map where your employees should be placed in the architecture",
            "matchFew": "Match few",
            "matchPosition": "Match Position | Match positions",
            "matchPositionHelpText": "Match your positions to profiles in our job catalogue",
            "matchPositions": "Match positions",
            "matchProfiles": "Match profiles",
            "matchRemaining": "Match remaining to profile ({ count })",
            "matchSpecificEmployments": "Match specific individuals",
            "matchTo": "Match employments to { name }",
            "matchedEmployments": "Matched employments",
            "matchedToLevel": "Matched to grade",
            "matchedToProfile": "Matched to profile",
            "matchedToSubFamily": "Matched to sub-family",
            "max": "Max",
            "min": "Min",
            "missingCountry": "Missing country",
            "missingFactorLevel": "Missing factor level",
            "missingFamily": "Missing Job family",
            "missingJob": "Missing job profile",
            "missingJobCode": "A job code is required to update the the job description",
            "missingLevel": "No grade",
            "modifiedCountrySalaryTypes": "Modified salary type for country's pay ranges",
            "modifiedEmployments": "Modified employments",
            "modifiedJobProfiles": "Modified job profiles",
            "modifiedPayBands": "Modified pay ranges",
            "more": "More",
            "moveToUnassigned": "Move to unassigned",
            "municipality": "Municipality",
            "municipalityEngDemo": "Municipality English Demo",
            "mustSelectEmployee": "Select an employee in the table",
            "name": "Name",
            "new": "New",
            "newEmployments": "New employments",
            "newPositionTitles": "new position titles",
            "newSalaries": "new salaries",
            "newStatisticalCodes": "new statistical codes",
            "newlyHired": "Newly hired employees",
            "newlyHiredInfo": "These are the employees with new employment numbers. Review the suggested placements. You can manually select job profiles via the unassigned tab if needed.",
            "newlyHiredPlacement": "You have {count} employees with new employments that needs to be assigned to a job profile.",
            "nextJobProfile": "Next job profile",
            "nextPosition": "Next Position",
            "noAccessTo": "No access to job architecture specific benchmark data.",
            "noAvailable": "No sub-families available",
            "noCoworkersConnectedToJobProfile": "This job profile has no employees connected to it.",
            "noEmploymentsConnectedToJobProfileInfo": "You have no associated employees to this job profile. Connect employees to the job profile here.",
            "noEmploymentsConnectedToJobProfileInfoPublished": "You have no associated employees to this job profile",
            "noFieldsFound": "No fields found...",
            "noGradesText": "Your employees have no data in local grade. Create a grade or do a new data import via integrations or file import.",
            "noGroupsLeft": "You have no employees with updated employments left to review",
            "noJobArchitectureData": "You have no job architecture data",
            "noJobArchitectureDataInformation": "We couldn't find any job profiles that you have access to. Check with your administrator if you think you are missing access to a job profile.",
            "noJobDescription": "This job profile has no job description.",
            "noJobEvaluationDone": "You haven't made a job evaluation for this job profile.",
            "noJobEvaluationDonePublished": "This job profile has no completed job evaluation.",
            "noJobProfiles": "No job profiles matching the search",
            "noJobProfilesAvailable": "You have no job profiles available.",
            "noJobProfilesFound": "No job profiles found...",
            "noOverviewData": "There is nothing to show at the moment.",
            "noPositionsRelatedToJobProfile": "This job profile doesn't have any associated positions",
            "noPreviewAvailableForGivenSelection": "No preview available",
            "noPublishedJobProfile": "The employees have no job profile currently published.",
            "noSelected": "No sub-family selected",
            "noStatisticalCodesRelatedToJobProfile": "This job profile doesn't have any associated statistical codes",
            "noSuggestionsForNewEmployments": "You have no new employments",
            "noSuggestionsForNewEmploymentsDescription": "We’ll give you suggestions if you import employments with new employment numbers.",
            "noSuggestionsFound": "We can't find any suggestion that matches the selected employees. Deselect employees or browse among all your job profiles.",
            "noTogglesActivated": "You haven't selected what changes in employment data we should notify you about",
            "noUpdatedEmployments": "You have no updated employments",
            "noUpdatedEmploymentsDescription": "There haven’t been any changes to an employment’s watched fields since you last uploaded new data.",
            "notEvaluatedNoEmployees": "You haven't evaluated nor added employees to the job profile. Click one of the buttons below to get started.",
            "notPublished": "Not published",
            "notifyMe": "Notify me about changes in...",
            "numberOfCoworkers": "No. of employees",
            "numberOfCreateJobProfiles": "Number of created job profiles",
            "onlyProfilesForRole": "Only your job profiles",
            "onlyProfilesWithEmployments": "Show only profiles with employments",
            "open": "Open",
            "optionalEvaluationFactor": "Optional evaluation factor",
            "optionalEvaluationFactorDescription": "This factor is specific to certain jobs and not all organisations are affected by this factor. Not including this factor won´t affect your ability to benchmark your job profiles against other organisations.",
            "organisation": "Organisation",
            "organisationLevel1": "Organisation Level 1",
            "organisationLevel2": "Organisation Level 2",
            "organisationLevel3": "Organisation Level 3",
            "organisationLevel4": "Organisation Level 4",
            "organisationLevel5": "Organisation Level 5",
            "organisationLevel6": "Organisation Level 6",
            "organisationNode": "Organisation Node",
            "organize": "Organize",
            "otherActions": "Other actions",
            "overview": "Overview",
            "overviewTitle": "Your job architecture",
            "payRange": "Pay range",
            "payRangeAggregated": "Aggregated",
            "payRangeInGrade": "Pay range in grade {level}",
            "payRangeInJobProfileTooltip": "These are the pay ranges your employees you want to match with would have if they were placed in this job profile. If you have multiple pay ranges, then we present an aggregated pay range.",
            "payRangeMissing": "There is no pay range set for the evaluation grade",
            "payRangeWithName": "Pay range ({name})",
            "payRanges": "Pay ranges",
            "points": "points",
            "position": "Position title",
            "positionMatchBulkTooltip": "Select all employments that you want to bulk update.",
            "positionProgressBar": "{ done } / { total } matched to position",
            "positionTitles": "Position titles",
            "positionTitlesInJobProfile": "Position titles in job profile",
            "positionTitlesInJobProfileTooltip": "The employees already assigned to this job profile have one of these position titles.",
            "positions": "Positions",
            "positionsLeftToMatch": "Positions to match",
            "positionsMatched": "Matched positions",
            "prevPosition": "Previous position",
            "preview": "Preview",
            "previewError": "\"Unfortunately, we couldn't load the preview of jobs from the selected audit. Please try again later or contact our Customer Success team for assistance. We apologize for any inconvenience this may have caused.\"",
            "previewOf5Profiles": "Preview of your first 5 job profiles",
            "previous": "Previous",
            "profile": "Sub family",
            "progressTitle": "Getting started with your job architecture",
            "publish": "Publish",
            "publishHeader": "Publish changes",
            "publishInfo": "When you publish the changes they will be visible to your employees and managers. ",
            "publishSucceeded": "All changes have been published",
            "publishUpdateDescription": "Description of update",
            "publishUpdateInfo": "This description is to help you catalogue versions of your job architecture",
            "published": "Published",
            "publishedNoJobProfileInformation": "You have either no employees assigned to a job profile or the job profiles contains too few employees.",
            "publishedNoJobs": "You have no employees assigned to a job profile",
            "publishing": "Publishing...",
            "quickFilters": "Quick filter",
            "regenerate": "Regenerate",
            "regeneratePasswordError": "Failed to regenerate the password. Please try again.",
            "region": "Region",
            "reviewedDoneMessage": "Everyone has been reviewed in this job profile! Feel free to continue reviewing employees in the next job profile.",
            "salary": "Salary",
            "salaryPerLevel": "Salary per level",
            "salaryRange": "Salary Range",
            "save": "Save",
            "savingDraft": "Saving changes...",
            "selecJobFamily": "No job family",
            "selectAnEmployee": "Select an employee in the table to get suggested job profiles that matches their employment data.",
            "selectAtLeastOneFieldToSeePreview": "Select at least one field to see a preview",
            "selectAuditToSeePreview": "Select an audit to see the preview",
            "selectCareer": "Select career",
            "selectCareerInfo": "The career determines which factors you grade the job with. Select the career that best describes the job.",
            "selectCustomField": "Select field",
            "selectEmployees": "Select employees",
            "selectEmployeesInfo": "This is where you define which employees will be imported into the pay equity audit.",
            "selectFamilyGroup": "Select entire family",
            "selectGlobalFamily": "Edit job family",
            "selectHowToCreateJobProfiles": {
                "header": "Import your current job architecture"
            },
            "selectJobCluster": "Select job cluster",
            "selectJobEvaluation": {
                "header": "What evaluation and structure do you want to use?",
                "info": "You can choose to use Sysarb’s job evaluation or an external job evaluation. This choice will affect which features you have available and how you’ll work with the job architecture in Sysarb."
            },
            "selectJobFamily": "Select job family",
            "selectJobProfile": "Select job profile",
            "selectLevel": "Select level",
            "selectNoGlobalFamily": "Deselect job family",
            "selectPayEquityAudit": "Select the pay equity audit you wish to create jobs from",
            "selectProfileToMatchTo": "Select a profile to match to",
            "selectSubFamily": "Select sub-family",
            "selectToBrowse": "Select an employee in the table to browse job profiles.",
            "selected": "Selected | Selected",
            "selectedUptoFields": "Add up to 3 fields",
            "setting": {
                "changeWarning": "Removing a watched field deletes its related suggestions.",
                "commonInfo": "To avoid getting frequent updates with often irrelevant changes we recommend you select between 1-3 fields to watch.",
                "commonTitle": "Commonly watched fields",
                "otherInfo": "You can also select other employment fields. Note that you’ll get drastically more employments to review if you select a lot of fields.",
                "otherTitle": "Other fields"
            },
            "settings": "Settings",
            "shortGradeExist": "Short grade exists",
            "shortGradeLength": "Short grade must be between 1-3 characters",
            "showDetailed": {
                "employeeNames": "Employees per grade",
                "genderDistribution": "Gender distribution",
                "genderDistributionPerLevel": "Gender distribution per level",
                "general": "General",
                "keyvaluesForGroup": "Keyvalues for sub-family",
                "keyvaluesPerLevel": "Key values per grade",
                "positions": "Positions per grade",
                "salary": "Salary",
                "salaryMaximum": "Max {'|'} Base Salary",
                "salaryMedian": "Median {'|'} Base Salary",
                "salaryMinimum": "Min {'|'} Base Salary",
                "salaryPerLevel": "Salary per level",
                "salaryPercentileHigh": "90th salary percentile  {'|'} Base Salary",
                "salaryPercentileLow": "10th salary percentile  {'|'} Base Salary",
                "statisticalCodes": "Statistical Codes per grade",
                "totalSalaryMaximum": "Max {'|'} Total Salary",
                "totalSalaryMedian": "Median {'|'} Total Salary",
                "totalSalaryMinimum": "Min {'|'} Total Salary",
                "totalSalaryPercentileHigh": "90th percentile {'|'} Total Salary",
                "totalSalaryPercentileLow": "10th percentile {'|'} Total Salary"
            },
            "showEntireOrganisation": "Give access to all job profiles",
            "showLevelDescriptions": "Show level descriptions",
            "sparbank": "Sparbank",
            "standard": "Standard",
            "startMatching": "Start matching",
            "statisticalCode": "Statistical code",
            "statisticalCodes": "Statistical codes",
            "statisticalCodesInJobProfile": "Statistical codes in job profile",
            "statisticalCodesInJobProfileTooltip": "The employees already assigned to this job profile have one of these statistical codes.",
            "status": "Status",
            "stepsCompleted": "{completed} of {total} steps completed",
            "sub-family": "Sub-family",
            "subFamilyAndLevel": "Subfamily + grade",
            "successFullyAssigned": "{count} employee was successfully assigned to {title}. | {count} employees were successfully assigned to {title}.",
            "successFullyKeptCurrent": "{count} employee kept current job profile. | {count} employees kept current job profile.",
            "successFullyUnassigned": "{count} employee was successfully unassigned. | {count} employees were successfully unassigned.",
            "suggestedJobProfile": "Suggested job profile",
            "suggestedJobProfiles": "Job profiles you might look for...",
            "suggestion": "Suggestion",
            "suggestions": "Suggestions",
            "suggestionsForNewEmployments": "Suggestions for new employments",
            "suggestionsForNewEmploymentsDescription": "Below you can find employments with a new employment number. These employments have no current job profile.",
            "sysarb": {
                "executive": {
                    "level14": "Leads and coordinates work primarily for senior executives to achieve agreed-upon goals and results.\n\nHas full responsibility for an entire operation, including budget and personnel management.\n\nThe work is typically carried out by developing long-term strategies together with the management team and by inspiring and enabling others to deliver.",
                    "level15": "Leads and coordinates the work for senior executives.\n\nHas full managerial responsibility for an entire operation, including budget and personnel management.\n\nThe work is typically carried out by developing long-term strategies and by inspiring and enabling others to deliver.",
                    "level16": "Leads and coordinates the work for senior executives.\n\nHas full managerial responsibility for an entire operation, including budget and personnel management.\n\nThe work is typically carried out by developing long-term strategies and by inspiring and enabling others to deliver.\n\nCarries the same requirements as the previous level but operates on a larger scale, such as the size of the operation, budget, geographical scope, number of employees, and so on."
                },
                "individualContributor": {
                    "level1": "Has limited education and/or work experience.\n\nReceives clear tasks assigned and works with a low degree of independence.\nThe work is carried out under close supervision and monitoring.\n\nInfluence only on own work.",
                    "level10": "Has specialist competence and a deep understanding through advanced academic education and/or extensive experience.\n\nWorks independently and solves complex problems, often focusing on development and innovative solutions.\n\nResponsible for planning, developing, and implementing processes, quality, and guidelines, as well as follow-up within their area.\n\nInfluence at the organizational/administrative level.",
                    "level11": "Considered an expert in their field. Has advanced competence and a deep understanding based on a doctoral degree and/or extensive work experience within the area of expertise.\n\nWorks independently and develops new knowledge, advancing the work within their area of expertise.\n\nResponsible for planning, developing, and implementing processes, quality, and guidelines, as well as follow-up within their area.\n\nInfluence at a strategic level.",
                    "level12": "Considered a senior expert in their field. Has advanced competence and a deep understanding based on a doctoral degree and/or extensive work experience within the area of expertise.\n\nWorks independently and develops new knowledge, advancing the work within their area of expertise.\n\nOverall and strategic responsibility for planning, development, quality, and performance follow-up. Significant ability to influence and change services and processes that impact the entire organization.",
                    "level13": "An employee recognized externally as a thought leader within their job family or area of expertise.\n\nInfluences business direction by developing innovative approaches that go beyond existing solutions for services and/or products.\n\nLeads highly visible multidisciplinary project teams or initiatives. Negotiates with senior executives and/or external parties to influence decisions.\n\nStrategic impact and/or recognition beyond the organization.",
                    "level2": "Has basic skills through previous education and/or some work experience.\n\nWorks with clearly defined standard routines and clear work instructions, with some degree of supervision and oversight.\n\nInfluence primarily on own work.",
                    "level3": "Has knowledge through secondary education in the relevant field of work and/or work experience.\n\nIndependently carries out assigned tasks with a limited degree of supervision.\n\nInfluence primarily on own work but can also serve as support for colleagues within the same area of work.",
                    "level4": "Has knowledge through post-secondary education in the field of work and/or significant work experience.\n\nWorks independently according to established methods and routines, and is capable of handling various types of work assignments.\n\nAssists in developing appropriate methods for new tasks, both for oneself and within the own work team.",
                    "level5": "Has knowledge through post-secondary education in the field of work and/or significant work experience.\n\nIndependently carries out own tasks. Can also coordinate work outside their own area.\n\nProposes improvements and development for their own work, the work team, and work in other groups.",
                    "level6": "Has knowledge and basic understanding based on an academic degree at the undergraduate level and/or equivalent work experience.\n\nWorks according to instructions, guidance, and direction from management, but takes basic responsibility for evaluating work and methods to achieve objectives.\n\nContributes to improving and developing work within their own area and ensures to share experiences for the group's development.",
                    "level7": "Has knowledge and basic understanding based on an academic degree at the undergraduate level and/or equivalent work experience.\n\nWorks according to instructions, guidance, and direction from management, but takes basic responsibility for evaluating work and methods to achieve objectives.\n\nContributes to improving and developing work within their own area and ensures to share experiences for the group's development.",
                    "level8": "Has knowledge and understanding based on an undergraduate degree and/or equivalent work experience.\n\nWorks independently with few instructions and minimal guidance. Current work experience is used to view things from new perspectives.\n\nResponsible for planning and independently driving own work, and participates in planning and development work within the own group.",
                    "level9": "Has knowledge and understanding based on an advanced academic degree from a university and/or through work experience.\n\nWorks independently with few instructions and minimal guidance. Current work experience is used to view things from new perspectives.\n\nResponsible for planning and independently driving own work, and participates in planning and development work within the own group."
                },
                "manager": {
                    "level10": "Leads employees (levels 1-6) and activities by setting and achieving agreed-upon goals and results.\n\nHas responsibility for a unit, including budget and personnel.\n\nSets goals at the operational level. Decisions are guided by policies, procedures, and the common business plan.",
                    "level11": "Leads employees (levels 7-11) and activities by setting and achieving agreed-upon goals and results.\n\nHas responsibility for a unit, including budget and personnel.\n\nSets goals at the operational level. Decisions are guided by policies, procedures, and the common business plan.",
                    "level12": "Leads and coordinates the work of employees and/or managers to achieve agreed-upon goals and results.\n\nHas responsibility for units and/or departments, including budget and personnel.\n\nThe work is typically led in an indirect manner by setting organizational goals and enabling others to deliver.",
                    "level13": "Leads and coordinates the work of managers to achieve agreed-upon goals and results.\n\nHas responsibility for an entire operation, including budget and personnel.\n\nThe work is typically carried out by developing long-term strategies together with colleagues and by enabling others to deliver.",
                    "level7": "Leads and coordinates the daily operations for employees (levels 1-5) who report directly.\n\nWorks based on set goals but usually has no personal or budgetary responsibility.\n\nReceives guidance and supervision from a manager.",
                    "level8": "Leads and coordinates the daily operations for employees who report directly.\n\nWorks based on set goals, has personnel responsibility, but does not have full responsibility for the budget.\n\nReceives guidance and supervision from a manager.",
                    "level9": "Leads and coordinates the daily operations for employees (levels 1-9) who report directly.\n\nWorks based on set goals, often has budget responsibility but does not have formal personnel responsibility.\n\nReceives guidance and supervision from a manager."
                }
            },
            "sysarbFactorValues": {
                "SY-F10V1": "Performs work that mainly consists of routine and recurring work tasks where conditions exist to plan and organize the work elements.",
                "SY-F10V2": "Performs work that regularly contains time pressure while at the same time unforeseen and unorganized work elements arise with demands for situation adaptation.",
                "SY-F10V3": "Performs work that daily contains mentally strenuous work tasks such as demands for availability, situation adaptation, deep concentration in complicated work tasks, time pressure, communication difficulties, stressful relationships and/or threats of violence.",
                "SY-F10V4": "Performs work that for most of the working time contains mentally strenuous work tasks such as demands for availability, situation adaptation, deep concentration in complicated work tasks, time pressure, communication difficulties, stressful relationships and/or threats of violence.",
                "SY-F1V1": "Requires professional skills obtained through brief instruction.",
                "SY-F1V2": "Requires professional skills obtained through short on-the-job training. (Elementary school)",
                "SY-F1V3": "Requires professional skills obtained through specific courses and structured training.",
                "SY-F1V4": "Requires professional skills normally acquired through a three-year upper secondary education or equivalent practice. (Upper secondary education)",
                "SY-F1V5": "Requires professional skills normally acquired through vocational college, apprenticeship programs or individual courses from university. (Vocational engineer/Vocational college)",
                "SY-F1V6": "Requires professional skills normally acquired through a degree at the basic level of university. (Bachelor's or university degree)",
                "SY-F1V7": "Requires professional skills corresponding to a degree at an advanced level of university. (Master's degree)",
                "SY-F1V8": "Requires professional skills corresponding to the highest scientific standard. (Doctoral or licentiate degree)",
                "SY-F2V1": "Requires no professional experience. After regular introduction, the assignment can be performed independently.",
                "SY-F2V2": "Requires up to one year of experience.",
                "SY-F2V3": "Requires 1-3 years of professional experience.",
                "SY-F2V4": "Requires 3-5 years of professional experience.",
                "SY-F2V5": "Requires 5-8 years of professional experience.",
                "SY-F2V6": "Requires 8-10 years of professional experience.",
                "SY-F2V7": "Requires more than 10 years of experience.",
                "SY-F2V8": "Requires more than 15 years of experience.",
                "SY-F3V1": "Requires pleasant treatment and cooperation, mainly within own unit or nearby units in the workplace.",
                "SY-F3V2": "Requires good communicative and empathetic ability in meeting with both contacts within the organization and customers.",
                "SY-F3V3": "Requires very good communicative ability and social skills to handle conflicts of interest.",
                "SY-F3V4": "Requires high communicative ability to communicate complex issues.",
                "SY-F3V5": "Requires persuasive and diplomatic skills in negotiations.",
                "SY-F4V1": "Works with repetitive and relatively routine work tasks that are mainly completed daily. The approaches are known and usually involve choosing between a number of pre-given alternatives.",
                "SY-F4V2": "Requires the ability to identify and solve problems. Known solutions and domain expertise are used to solve recurring problems.",
                "SY-F4V3": "Requires the ability to solve new problems, often based on known approaches and available information. More complicated issues are solved together with domain expertise.",
                "SY-F4V4": "Requires the ability to evaluate new problems and to analyze and modify known solutions. Working methods and solution alternatives are not given or defined and often require new thinking.",
                "SY-F4V5": "Requires analysis of new problems, compilation and evaluation of information and other sources, and development of new solutions. Has multifaceted problems with demands for several perspectives such as theories, methods, guidelines, legal interpretations and impact analyses.",
                "SY-F4V6": "Requires development of innovative concepts and strategies. Often involves research and/or development work in very complex contexts.",
                "SY-F5V1": "Has a scope of action that is strongly limited and is restricted only to one's own workstation or personal work area.",
                "SY-F5V2": "Has responsibility to perform own work tasks based on guidelines and instructions where the focus is on efficiency and reliability in execution.",
                "SY-F5V3": "Has responsibility to plan and organize own work tasks, and contributes to planning and development work in the own workplace.",
                "SY-F5V4": "Has either the scope of action to make operational/strategic decisions within own unit, or influence on the work within one's domain through decisions at a strategic level.",
                "SY-F5V5": "Has either the scope of action to make operational/strategic decisions within own and underlying units, or influence on the work within one's domain through decisions at a strategic level.",
                "SY-F5V6": "Has the scope of action to make strategic decisions that affect the entire division.",
                "SY-F5V7": "Has the scope of action to make strategic decisions and implement measures that affect the entire organization's strategy and results.",
                "SY-F6V1": "Has responsibility that is limited to one's own assignment and introduction of new colleagues.",
                "SY-F6V2": "Coordinates work tasks in teams, education and guidance of colleagues.",
                "SY-F6V3": "Supervises a group of employees, without formal management.",
                "SY-F6V4": "Leads employees in their operational execution (mostly employees without requirements for an academic degree). Responsible for operational decisions for the own team (first management level).",
                "SY-F6V5": "Leads employees in their specialist assignments (mostly employees with requirements for an academic degree). Responsible for operational decisions for the own team (first management level).",
                "SY-F6V6": "Leads managers. Has direct responsibility for employees in the own department (second management level).",
                "SY-F6V7": "Leads several levels of hierarchy (third management level).",
                "SY-F6V8": "Leads several levels of hierarchy (from the fourth management level).",
                "SY-F7V1": "Has a responsibility for other people that is limited to normal consideration and care.",
                "SY-F7V2": "Has a personal professional responsibility for other people's health, care, development or safety.",
                "SY-F7V3": "Has an independent responsibility to assess and meet the needs of others - to influence other people's health, care, development or safety by following rules, instructions or programs.",
                "SY-F7V4": "Has an independent responsibility to influence, change and make decisions about efforts or conditions that affect other people's health, care, development or safety.",
                "SY-F7V5": "Has an independent responsibility to evaluate, influence, change and make crucial decisions about efforts, instructions or programs that affect other people's health, care, development or safety.",
                "SY-F8V1": "Has a responsibility for resources that is limited to normal care.",
                "SY-F8V2": "Has a personal professional responsibility to use, store and maintain resources of relatively large economic values.",
                "SY-F8V3": "Has an independent responsibility to develop, maintain or manage resources of large economic values by following rules, instructions or programs. Consequences of negligence and violations become noticeable for the business.",
                "SY-F8V4": "Has an independent responsibility to develop or manage resources of extensive economic values where consequences of negligence and violations become serious for the business.",
                "SY-F8V5": "Has overall and strategic responsibility for resources within the business. Negligence, violations or abuse in decisions often lead to extensive economic and operational consequences.",
                "SY-F9V1": "Performs work that takes place outdoors or indoors where some exertion occurs, but for relatively short periods and where relief is available. The risk of own injury or illness is small.",
                "SY-F9V2": "Performs work that for shorter periods can contain physically strenuous work situations. There is, however, a limited risk of own injury or illness.",
                "SY-F9V3": "Performs work that at each work shift contains physically uncomfortable working positions and strenuous physical work situations. There is an increased risk of accidents, injury or illness.",
                "SY-F9V4": "Performs work where physically uncomfortable working positions and very strenuous work situations are a natural part of the work. There is a very high risk of accidents, injury or illness."
            },
            "sysarbFactors": {
                "SY-F1": {
                    "description": "The factor assesses the theoretical knowledge required to perform a job. Theoretical qualifications are measured by the extent of the education needed for a particular position. The levels are based on the European and Swedish Qualifications Framework (EQF/SeQF). Note that it is the level of knowledge that is assessed, not the individual's actual education.",
                    "title": "Education"
                },
                "SY-F10": {
                    "description": "The factor assesses the basic requirements of the work in tasks that affect the work-related psychological and emotional strain over time in the position. The factor also takes into account time pressure and stress levels.",
                    "title": "Psychological working conditions"
                },
                "SY-F2": {
                    "description": "The factor assesses the requirements for work-related, relevant experience needed to perform a task independently and with satisfactory quality. All new employees receive an introduction and some guidance. For positions at higher levels, it is usually required that the employee has acquired knowledge through experience from similar work in the past.",
                    "title": "Experience"
                },
                "SY-F3": {
                    "description": "The factor assesses the requirements for social skills in a position. This includes communication and collaboration, the ability to convey and receive information, build long-term relationships, manage conflicts of interest, and influence others.",
                    "title": "Social skills"
                },
                "SY-F4": {
                    "description": "The factor assesses the cognitive abilities required for the task. This refers to the ability to independently identify needs and propose solutions to arising problems. The scale gradually increases from performing tasks, identifying, evaluating, and analyzing problems, to developing new methods needed to solve problems.",
                    "title": "Cognitive skills"
                },
                "SY-F5": {
                    "description": "The factor assesses operational responsibility and influence within the organization. This refers to planning, development, results, and follow-up from both qualitative and quantitative perspectives. An important aspect is the authority to influence others in the organization. Is the responsibility limited to the position's tasks, within the team, within the division, or does the position's work impact the entire organization?",
                    "title": "Impact"
                },
                "SY-F6": {
                    "description": "The factor assesses the responsibility that a manager or leader has for directing and distributing work, as well as providing feedback on work performance, results, and salary to employees. The role also includes following up on set goals and guidelines, as well as hiring, developing, and dismissing employees.",
                    "title": "Leadership | Management"
                },
                "SY-F7": {
                    "description": "The factor assesses the responsibility for the health, development, care, supervision, and well-being of others. This factor evaluates the responsibility for third parties (patients, students, clients, users, etc.), i.e., those for whom the organization exists, and does not pertain to the organization's own employees.",
                    "title": "People"
                },
                "SY-F8": {
                    "description": "The factor assesses the direct responsibility for the management of the organization's tangible assets, such as equipment, machinery, properties, goods and inventory, environmental, and/or natural resources.\n\nThe factor also evaluates the responsibility for the organization's intangible assets, such as source code, trademarks, patents, and data management. Thus, the factor assesses the responsibility for assets that can be measured in economic terms and are often found on the organization's balance sheet, and does not pertain to the organization's ongoing operating costs (budget).\n\nResponsibility for technical regulatory decisions, such as building permits, planning, and traffic issues, is also evaluated within this factor.",
                    "title": "Resources"
                },
                "SY-F9": {
                    "description": "The factor assesses the basic requirements of the work regarding physical strain and effort over time. The factor also takes into account unpleasant physical environments, such as exposure to high noise levels, pollution, odors, and an increased risk of personal injury or infection—provided that occupational health and safety regulations are followed.\n\nThe likelihood of an injury or violent situation occurring in the workplace is also assessed here.",
                    "title": "Physical working conditions"
                }
            },
            "tabs": {
                "level": "Levels",
                "overview": "Overview",
                "position": "Profiles",
                "start": "Start"
            },
            "template": "Template",
            "templateName": "Import job architecture template",
            "title": "Title",
            "titleCharacterLimit": "Title can't exceed {count} characters",
            "titleRequired": "Title is required",
            "titleTooLong": "Title too long: maximum characters allowed is {count}.",
            "tooSmallDataSet": "There needs to be atleast 5 men and women to see insights for a country",
            "totalEmployments": "Employments",
            "totalPoints": "Total points",
            "translationIds": "Translation IDs",
            "typeInfo": "In Sysarb you can use your own \"external\" job architecture in our different modules or create a new job architecture with the Sysarb job evaluation factors.",
            "unassignCurrent": "Unassign job profile { employeeCount }",
            "unassigned": "Unassigned",
            "unassignedEmployees": "Unassigned employees",
            "unassignedPlacement": "You have {count} employees who haven't been assigned to a job profile. You should assign them to a job profile.",
            "undo": "Undo",
            "unknownJobProfile": "Unknown job profile",
            "updateSubfamily": "Update sub-family",
            "updatedFields": "{field} and +{count} other updated fields",
            "updating": "Updating...",
            "useAidAutoMatch": "Auto match using AID codes",
            "useAidAutoMatchHelp": "Allows for quick matching of employments with exact match on AID code to sub-family.",
            "useOurFactors": "Use our job evaluation factors.",
            "validFeedback": "Saved",
            "valuationResult": "Grading result",
            "visma": "Visma",
            "watchedFields": "Watched fields",
            "whatIsAJobProfile": "What is a job profile?",
            "women": "Women",
            "youAreAboutToMatch": "You are about to match:",
            "youCantEdit": "You can't edit your job architecture directly in Sysarb.",
            "youNeedToFinish": "You need to finish all three steps to create the audit.",
            "youNeedToPublishFirst": "You need to publish before you can select a job profile. If you have not created a job profile yet, please do so first.",
            "yourPositions": "Your positions",
            "yourSubFamilies": "Your sub-families"
        },
        "jobClusterList": {
            "active": "Active",
            "addJobCluster": "Add job cluster",
            "cantDeleteInUse": "You can't delete a job cluster that is in use.",
            "deleteJobCluster": "Do you want to delete job clusters?",
            "deleteJobClusterInfo": "Once you delete the equal job cluster, it will be deleted from all job profiles. This action is irreversible, meaning you will have to recreate the job cluster and add it to all job profiles again if you change your mind.",
            "deleting": "Deleting...",
            "enterName": "Enter name...",
            "jobCluster": "Job cluster",
            "name": "Name",
            "newName": "New name"
        },
        "jobFamilies": {
            "infoText": "Select the job families that are relevant to your organizational needs. You can toggle entire groups or individual job families to customize your selections.",
            "yourJobFamilies": "Your job families"
        },
        "legalEntityList": {
            "addLegalEntity": "Create legal entity",
            "code": "Code",
            "create": "Create",
            "enterCode": "Enter code",
            "enterName": "Enter name",
            "legalEntity": "Legal entity",
            "mustFillInAllFields": "You must fill in the required fields",
            "name": "Name",
            "newCode": "New code",
            "newName": "New name"
        },
        "liteAnalysisInfo": {
            "1": "Ease in to the pay equity audits with light version to get you started.",
            "2": "Includes the standard equal job analysis.",
            "3": "Doesn't include a comparative job analysis and job evaluation.",
            "4": "Is not compliant with EU Pay Transparency reporting."
        },
        "login": {
            "backToLogin": "Back to login",
            "bankId": "BankID",
            "bankIdOnThisUnit": "BankID on this device",
            "bankIdOtherDevice": "Use BankID on another device",
            "bankIdThisDevice": "Use BankID on this device",
            "capsLockWarning": "Your caps-lock is turned on",
            "changePassword": "Change password",
            "contactSupport": "Contact us",
            "continue": "Continue",
            "emailSent": "Email sent",
            "emailSentDescription": "Check your email and open the link to reset your password.",
            "errors": {
                "cannotUseSSO": "Cannot use single sign-on"
            },
            "followInstructions": "Follow the instructions in the BankID app.",
            "forgotPassword": {
                "description": "Enter your username or email and click on the button 'Send' below. You will then recieve an email with instructions of how to set a new password.",
                "fail": "Didn't find any user by that username.",
                "noToken": "Access token missing",
                "sendButton": "Send recovery mail",
                "success": "If you account exists we will send an email with instructions on how to reset your password.",
                "title": "Reset your password"
            },
            "forgotYourPassword": "Forgot your password?",
            "goToSystemPortal": "Go to system portal",
            "instanceAccountType": {
                "1": "Developer",
                "2": "User",
                "3": "Root",
                "4": "Support",
                "5": "Consultant"
            },
            "instanceInactive": "Your account is not active on this instance",
            "invalidLoginRequirements": {
                "password": "This user is not configured to use password as authentication method."
            },
            "loggingIn": "Logging in",
            "loggingInAs": "Logging in as",
            "loggingInWith": "Log in with",
            "login": "Login",
            "loginBankId": "Login with BankID",
            "loginNow": "Login now",
            "loginUserAccount": "Login with user account",
            "loginWithBankId": "Start BankID login",
            "missingCode": "You have to enter the code you received in the text message",
            "noRoleFound": "No role was found, please try reloading the page. If the problem persists, reach out to Technical Support for assistance.",
            "noUsersToSimulate": "There are no users to simulate.",
            "openBankIdAppDescription": "Open the BankID application on you mobile device and click on the button QR code in the application. Point the camera towards the QR code below.",
            "openBankIdAppDescriptionPhone": "Click the button below to start the BankID application on your device.",
            "openBankIdAppDescriptionVerify": "Confirm your identity in the BankID application.",
            "openBankIdStartDescription": "Click the button below to log in.",
            "orLoginWith": "or log in with",
            "passwordUpdated": "Password has been updated",
            "reload": "Reload",
            "scanAndFollow": "Scan the QR code and follow the instructions in the app.",
            "scanQrCode": "Scan the QR-code",
            "selectInstance": "Select instance",
            "selectInstanceAccountDescription": "Choose where you want to login.",
            "selectSsoProvider": "Select how you want to sign in",
            "sendLinkToEmail": "Send link to email",
            "showHidePassword": "Toggle password visibility",
            "smsCode": {
                "description": "We are sending you a code to your mobile phone. Please enter the code below.",
                "title": "Enter the code that was sent by SMS"
            },
            "sso": "Single sign-on (SSO)",
            "standard": "Username",
            "startBankId": "Use BankID on this device",
            "submitstop": {
                "password": "Enter your password to continue",
                "sms": "Enter your SMS code to continue",
                "username": "Enter your username to continue"
            },
            "subtitles": {
                "SSO": "Single sign-on (SSO)",
                "bankId": "BankID",
                "usernameAndPassword": "Username and password"
            },
            "supportWarning": "Support users must log in through the system portal.",
            "toggleShowButtonOnLarge": "Log in on this device",
            "toggleShowQrOnSmall": "Log in on another device",
            "tryAgain": "Try again",
            "useBankId": "Use BankID",
            "usePassword": "Use password",
            "usernameOrEmail": "Username or email",
            "usernameTooltip": "The identifier for your user, could be a user name, an email address or a social security number.",
            "welcomeBack": "Welcome back!",
            "working": "Please wait"
        },
        "mailPreview": {
            "preview": "Preview",
            "previewLanguage": "The preview is displayed in your selected application language:"
        },
        "manager": {
            "activities": "Activities",
            "addEmployee": "Add employees",
            "addQuestion": "Add question",
            "analysis": "Analysis",
            "assessments": "Assessments",
            "assessmentsOverview": "Assessments overview",
            "averageCompaRatio": "Avg. compa-ratio",
            "axisZoom": "Axis zoom for {chartTitle}",
            "axisZoomLabel": "Axis zoom for {chartTitle}",
            "baseSalary": "Base Salary",
            "chartFor": "Chart for {chartTitle}",
            "completed": "Completed",
            "contactAdministrator": "Contact administrator",
            "contactAdministratorModal": {
                "header": "Your administrators",
                "subheader": "Below you can see your administrators:"
            },
            "create1on1for": "Create 1-to-1 for",
            "createDiscussion": "Create discussion",
            "createGroup": "New group discussion",
            "createOneOnOne": "New 1 on 1",
            "created": "Created",
            "createdByAdmin": "Created by admin",
            "createdByManager": "Created by manager",
            "dashboard": "Dashboard",
            "deleteDiscussion": "Delete discussion",
            "discussion": {
                "deleteQuestionsRelatedToTemplate": "Delete template questions",
                "deleteTemplateConfirmation": "Yes delete all questions related to the template.",
                "deleteTemplateQuestions": "This question is part of {template}. Would you like to delete all questions related to the template?",
                "employeesInDiscussion": "Employees in the discussion",
                "employeesNotInDiscussion": "You haven't added any employees to the discussion",
                "employmeeInDiscussion": "Employee in discussion"
            },
            "discussionHasNoEmployees": "You haven’t added any employees to the discussion yet.",
            "discussionTitle": "Discussion title",
            "discussions": "Discussions",
            "due": "Due {date}",
            "dueDate": "due",
            "editDiscussion": "Edit discussion",
            "editTarget": "Edit target",
            "employeeCount": "{count} employees | {count} employee | {count} employees",
            "employeeHasNoAssessments": "You have no assessments.",
            "employeeHasNoDiscussions": "Employee haven't been added to any discussions.",
            "employeeHasNoTargets": "Employee has no targets",
            "employeeNoUserAccount": "Employee must have a user account to start a 1-to-1 discussion",
            "employeeNotAddedToAssessments": "Employee haven't been added to any assessments.",
            "employeeSalary": "{salary} {currency}/{salaryType}",
            "employees": "Employees",
            "employeesJobProfile": "Job profiles",
            "emptyList": "No discussion matches your filters",
            "emptyTargetList": "No targets matches your filters",
            "filters": "Filters",
            "grade": "Grade",
            "group": "Group",
            "groupInfo1": "Create questions for a group of employees.",
            "groupInfo2": "Keep track and manage all of the invited employees in one discussion.",
            "importFromTemplate": "Import from template",
            "inProgressNotice": "Performance review is still ongoing so the results can change.",
            "insights": "Insights",
            "jobArchitecture": "Job architecture",
            "jobArchitectureDisabled": "The job architecture isn’t currently available.",
            "jobLevelEmpty": "The job profile hasn't been given a grade.",
            "jobProfileDescription": "Here are all your employees' job profiles.",
            "jobProfileEmpty": "There are no job profiles found.",
            "jobProfileError": "Failed to fetch Job Profiles.",
            "lastResponseDate": "Last response date",
            "loadingDashboard": "Loading manager dashboard...",
            "manager": "Manager",
            "missed": "Missed",
            "myEmployees": "My employees",
            "name": "Name",
            "new": "New",
            "newDiscussion": "New discussion",
            "newTarget": "New target",
            "noAssessmentsSet": "No assessments have been set for this salary review yet.",
            "noDescription": "Missing Description",
            "noDiscussions": "No discussion has been created for your unit. Create a new one or wait until your administrator adds a discussion.",
            "noEmployees": "You have no employees added to your unit. Contact your administrator (HR manager) for help.",
            "noEmployeesInThisUnit": "No targets exist in this unit. Talk to your Administrator to get help investigate.",
            "noPayGapData": "There is currently no pay gap information to display",
            "noPayGapDataWithinOrg": "There is currently no pay gap information to display. Click \"Show all grades\" to see pay grades for your whole organisation.",
            "noPayRange": "No pay range has been added for the grade.",
            "noTargetsCreated": "No targets have been created for this employee.",
            "noTargetsExist": "No targets exist",
            "notAllowed": "Not Allowed",
            "notAllowedToDeleteAdminQuestion": "You cannot delete a discussion created by an administrator",
            "notStarted": "Not started",
            "oneOnOne": "1-to-1",
            "oneOnOneInfo1": "Discussion will only be added to 1 employee.",
            "oneOnOneInfo2": "Create questions specific for the selected employee.",
            "oneToOne": "1-to-1",
            "ongoing": "Ongoing",
            "ongoingActivities": "Ongoing activities",
            "open": "Open",
            "openActions": "Open actions for {title}",
            "openActivities": "Open activities",
            "openJobArchitecture": "Open job architecture",
            "overdue": "Overdue",
            "overview": "Overview",
            "payGapMean": "Pay gap {'|'} Mean",
            "payGapMedian": "Pay gap {'|'} Median",
            "payGapPerGrade": "Pay gap per grade",
            "payQuartile": {
                "info": "All employees are divided into four groups based on their salaries, from lowest to highest salary.",
                "lowerMiddleQuartile": "Lower middle",
                "lowerQuartile": "Lower",
                "unknownQuartile": "Unknown",
                "upperMiddleQuartile": "Upper middle",
                "upperQuartile": "Upper"
            },
            "payQuartiles": "Pay quartiles",
            "payRange": "Pay Range",
            "payRangesToggleSrHint": "pay ranges for this job profile",
            "quartile": "Quartile",
            "questionNoTitle": "Missing title",
            "receivingSalaryComponents": "Receiving salary components",
            "receivingSalaryComponentsInfo": "The proportion of men and women who receive variable pay. Excluding your base salary, the variable pay includes all compensation and benefits provided by your employer.",
            "receivingSalaryComponentsInfoIncludes": "In your organization it includes:",
            "reset": "Reset filter",
            "salaryComponentGapMean": " Salary component gap {'|'} Mean",
            "salaryComponentGapMedian": " Salary component gap {'|'} Median",
            "salaryComponents": "Salary Components",
            "salaryReviewAssessment": "Assessment",
            "salaryReviews": "Salary review",
            "salarySetting": "Salary review",
            "searchDiscussionOrEmployee": "Search for a discussion or an employee",
            "sectionManager": "Section manager",
            "selectEmployee": "Select employee",
            "showAllGrades": "Show all grades",
            "showLessPayRanges": "Show less",
            "showMorePayRanges": "Show more",
            "showOnlyInOrg": "Show fewer grades",
            "started": "Started",
            "status": "Status",
            "targetOrEmployee": "Search for a target or employee...",
            "targets": "Targets",
            "titleMissing": "Title missing",
            "type": "Type",
            "unadjustedEqualityTimerMean": "Unadjusted equality timer {'|'} Mean",
            "unadjustedPayGapMean": "Unadjusted pay gap {'|'} Mean",
            "unadjustedPayGapMedian": "Pay gap {'|'} Median",
            "variablePayGapMean": "Variable pay gap {'|'} Mean",
            "variablePayGapMedian": "Variable pay gap {'|'} Median",
            "verifyDeleteDiscussion": "Are you sure that you want to delete the discussion?",
            "waitingOnOk": "Waiting on OK",
            "yourActivities": "Your activities",
            "yourEmployees": "Your employees",
            "yourOrganization": "Your organization",
            "yourUnit": "Your unit"
        },
        "managerAssessmentStatusFilter": {
            "done": "Done",
            "notDone": "Not done",
            "status": "Status"
        },
        "managerSalaryReviewAssessmentCard": {
            "openAssessment": "Open assessment"
        },
        "managerSelector": {
            "addManager": "Add manager",
            "findManager": "Search",
            "loadingManagers": "Loading possible managers",
            "noManager": "No manager",
            "noMatchingManager": "Nothing matches you search query",
            "searchToSeeUsers": "Start searching to see available options",
            "selectManager": "Select manager"
        },
        "mappingChartHelper": {
            "age": "Age",
            "automatedAnalysis": "Automated analysis (ALPHA)",
            "compaRatio": "Compa-ratio",
            "completed": "Completed",
            "dateOfBirth": "Age",
            "disabledHidePerformance": "Presentation mode hides performance",
            "distanceFromMean": "Distance to mean (%)",
            "distanceFromMedian": "Distance to median (%)",
            "employmentDate": "Company tenure",
            "employments": "Employee",
            "employmentsToAnalyze": "Need to analyze",
            "ethnicity": "Ethnicity",
            "gender": {
                "value": [
                    "Women",
                    "Men",
                    "Not declared"
                ]
            },
            "genders": "Gender",
            "groupMean": "Group mean salary",
            "groupMedian": "Group median salary",
            "locality": "City",
            "noGroup": "No group",
            "organization": "Organization",
            "performance": "Performance",
            "position": "Position title",
            "positionLevel": "Position level",
            "predictedSalaryGroup": "Predicted salary (group)",
            "predictedSalaryOrganisation": "Predicted salary (organisation)",
            "rankOnYAxis": "Rank on employments",
            "salary": "Salary",
            "statisticalCode": "Statistical code",
            "timeInCurrentPosition": "Job tenure",
            "womanDominatedMean": "Female dominated mean",
            "womanDominatedMedian": "Female dominated median"
        },
        "mappingContainer": {
            "employeeChangedWorkNotification": "{name} has been moved to {work}",
            "massiveChangeNotification": "Significant changes have been made to the data for this pay equity audit. Please verify that this has not impacted your current work.",
            "severalEmplpoymentsHasChangedWorkNotification": "Several employees have changed group."
        },
        "mappingEmploymentInfo": {
            "action": "Action",
            "analysisCompleteHistoryMode": "You cannot change the status when you are in history mode",
            "analysisCompleteNeedsAnalysis": "You need to finish analysis before you can mark the employee as done",
            "analysisReason": "Reason for analysis",
            "analyze": "Analyze",
            "approveReason": "Use suggestion",
            "automatedAnalysis": "Suggested reasons for analysis...",
            "changeWork": "Change work",
            "changeWorkErrorMessage": "Something went wrong, please try again, if the problem persists contact customer success.",
            "changeWorkSuccessMessage": "{name} has been moved to {workName}",
            "chooseAnalysisReason": "Choose reason for analysis",
            "chooseReasonForAnalysis": "Choose reason for analysis",
            "comments": "Comments",
            "compaRatio": "Compa-ratio",
            "complete": "Completed",
            "costCenter": "Cost Center",
            "createAction": "Create action",
            "createAnalysis": "Create analysis",
            "currency": "Currency",
            "currentSalary": "Current salary: ",
            "employmentDate": "Company tenure start date",
            "employmentNumber": "Employment number",
            "employmentTime": "Company tenure",
            "equalityTimer": "Equality Timer",
            "exitHistoryMode": "Exit history mode",
            "female": "Female",
            "gender": "Gender",
            "hidden": "Hidden",
            "hide": "Hide ",
            "historicalDataFor": "Historical data for {employee}",
            "historyModeActive": "History mode for this employee is active",
            "hours": "h",
            "identifiedMoreThanOneReasonCode": "AI has identified following reasons for analysis",
            "increaseSalaryWith": "Increase salary with",
            "jobFamily": "Job family",
            "keyValues": "Key values",
            "legalEntity": "Legal entity",
            "locality": "Locality",
            "male": "Male",
            "managerCode": "Manager code",
            "medianMan": "average man",
            "medianWoman": "average woman",
            "minutes": "min",
            "moreComments": "More comments",
            "moveWorkConfirm": {
                "content": "This will move {employee} to {work}. \n\nAre you sure you want to continue?",
                "header": "Move {employee}"
            },
            "noActionHistory": "No action could be found on {mapping}",
            "noAnalysisReasonChoosen": "No reason for analysis has been choosen",
            "noCommentHistory": "No comment could be found on {mapping}",
            "notComplete": "Mark as complete",
            "notDeclared": "Not declared",
            "notPossibleToEdit": "Individual tags can only be edited in equal jobs!",
            "notPossibleToEditAnalysis": "Reason for analysis can only be edited in equal jobs!",
            "organization": "Organization",
            "otherReasonForAnalysis": "Other reason",
            "payBand": "Pay band",
            "payGrade": "Pay grade",
            "performance": "Performance",
            "position": "Position title",
            "positionLevel": "Position level",
            "proximity": "Nearby",
            "proximtyAutomatedAnalysis": "Automated analysis (proximity)",
            "rejectReason": "Reject suggestions",
            "reset": "Reset",
            "salary": "Salary",
            "salaryDate": "Salary date",
            "salaryIncrement": "Salary Increment",
            "salaryIncrementSecond": "Salary increment 2",
            "salaryIncrementThird": "Salary increment 3",
            "salaryYear": "Salary year",
            "seconds": "sec",
            "show": "Show ",
            "showHistory": "Show historical data.",
            "shown": "Shown",
            "tags": "Tags",
            "timeInCurrentPosition": "Job tenure",
            "toggleEmployee": "Show or hide {employee} on charts.",
            "totalSalary": "Total salary",
            "work": "Work",
            "workIsDoneWarning": {
                "content": "If you move {employee} to {work} you may need to recheck the analysis. \n\nDo you want to move { employee } to { work } anyway?",
                "header": "{work} is marked as done"
            }
        },
        "mappingWorkTags": {
            "addAutoText": "Add auto text?",
            "employeeHasBeenTagged": "\n\nEmployee has been marked with: ",
            "employmentTagState": "{count} {tagType}",
            "high": "higher",
            "less": "less",
            "low": "lower",
            "markedEmployees": "{count} {noun} have been marked",
            "more": "more",
            "negative": "negative",
            "negativeTooltip": "Salary ratio explained by {low} {tagName}",
            "neutral": "neutral",
            "neutralTooltip": "Salary ratio explained by {tagName}",
            "noTags": "No tags found",
            "notPossibleToUnmarkTag": "Its not possible to unmark a tag that has been marked on an individual. {tagStatesString}",
            "person": "person",
            "persons": "people",
            "positive": "positive",
            "positiveTooltip": "Salary ratio explained by {high} {tagName}",
            "tag": "tag | tags",
            "tagHeaderIndividual": "Individual",
            "tagHeaderMarket": "Market",
            "tagHeaderWork": "Work",
            "tagsReadonly": "Tags can't be changed on comparative analysis, please go to equal analysis to make changes."
        },
        "mappings": {
            "activate": "Activate",
            "activateMapping": "Activate pay equity audit",
            "active": "Active",
            "addName": "Add name",
            "addOperationalAdministrator": "Add Operational administrator",
            "addOperationalAdministratorHelptext": "Add users with the \"Operational administrator\" role to give them access to the current pay equity audit.",
            "adjustedSalary": "Adjusted salary",
            "analyze": "Analyze",
            "analyzeBasedOn": "Analyze based on",
            "analyzeEqualWorks": "Equal jobs",
            "analyzeEquivalentWorks": "Comparative jobs",
            "analyzeOnCompaRatio": "Analyze based on Compa ratio",
            "analyzePolicy": "Policy & practice",
            "archived": "Archived",
            "automatedAnalsisInfoText": "Automated analysis is a tool for identifying individuals within groups of equal jobs that should be analyzed.\nSo that you know – the tool is currently in alpha and should only be used as guidance in your analysis work.",
            "automatedAnalysis": "Automated analysis",
            "automatedAnalysisCustomOutlierOver": "Acceptable distance over median",
            "automatedAnalysisCustomOutlierUnder": "Acceptable distance under median",
            "averageSalaryType": "Mean salary / median salary",
            "baseSalary": "Base salary",
            "changeDate": "Change date",
            "chooseMapping": "Choose a survey from the list to the left.",
            "coffeeBreak": "This seems to take a while. \n Go get a coffee or close this message to continue working.",
            "compaRatio": "Compa-ratio",
            "copyEqualWorksActionPlan": "Action plan equal jobs",
            "copyEqualWorksAnalysis": "Analysis equal jobs",
            "copyEqualWorksWorkComplete": "Work completed",
            "copyEqualityActionPlan": "Action plan comparative jobs",
            "copyEqualityAnalysis": "Analysis comparative jobs",
            "copyMappingDescription": "You will now create a copy of your pay equity audit; in the list below, you can choose what data should be copied.",
            "copyMappingEmployments": "Pay equity audit employments",
            "copyWorkValuation": "Job evaluations",
            "copying": "Copying {name}",
            "correlationAnalsisInfoText": "Activate correlation analysis",
            "correlationAnalysis": "Correlation analysis",
            "createSalarySurvey": "New pay equity audit",
            "created": "Created",
            "currencies": "The following currencies are used in the current pay equity audit:",
            "dashboard": "Dashboard",
            "deleteConfirmationInfo": "Are you sure you want to delete the audit?",
            "deleteConfirmationTitle": "Delete audit",
            "deleteMapping": "Delete pay equity audit",
            "deleteMappingWarning": "Are you really sure that you want to delete the pay equity audit?",
            "deleting": "Deleting {name}",
            "document": "Report",
            "documentActiveMeasures": "Active measures",
            "documentExport": "Export",
            "documentFinalReport": "Final report",
            "duplicateMapping": "Copy pay equity audit",
            "equalWork": "Equal job:",
            "excludesNonDeclaredGenders": "Employees with a non declared gender has been found. These will be exluded from the pay equity audit.",
            "factorPlan": "Factor plan",
            "filterBelow": "Filter below ",
            "finalize": "Finalize",
            "finalizeMapping": "Finalize pay equity audit",
            "finalizeMappingNotification": "Are you sure, you want to finalize the pay equity audit?",
            "finished": "Finished",
            "general": "General:",
            "goToAudit": "Open",
            "greeting": "Hi ",
            "hideEquivalentWorkAnalysis": "Hide comparative jobs analysis features",
            "import": "Import",
            "loadingAudit": "Fetching audit...",
            "loadingAudits": "Loading audits...",
            "mappingDate": "Equal pay audit start date",
            "mappingName": "Audit",
            "mappingSalarySettings": "Total salary",
            "mappingSettings": "Settings",
            "mappingSettingsSalaryAnalysis": "Salary reviews",
            "mappingSettingsSecurity": "Security",
            "mappingSettingsWorkFilters": "Filter for jobs",
            "markFinished": "Mark pay equity audit as done",
            "markFinishedDescription": "Great job on completing your pay equity audit! Could you confirm that the audit is finished by marking your analysis as done? We’ll update the analysis status on the global overview.",
            "markedAsDone": "Marked as done",
            "meanSalary": "Mean salary",
            "medianSalary": "Median salary",
            "noArchived": "You have no archived audits",
            "noUsersWithRole": "There are no users in the organisation with this role.",
            "oneGender": "Hide single gendered groups",
            "oneGenderOneEthnicity": "Hide single gendered groups with only one ethnicity",
            "operationalAdministrator": "Operational administrator",
            "organize": "Organize",
            "organizeGroup": "Group",
            "organizeWorkValuation": "Job evaluation",
            "overview": "Overview",
            "payPhilosophy": "Pay philosophy",
            "people": " people",
            "percentile": "10th 90th / 20th 80th",
            "prepare": "Prepare",
            "salary": "Salary",
            "salaryConsistsOf": "Salary consists of",
            "salaryDifference": "Salary ratio",
            "salaryDifferenceText": "Groups with a salary ratio lower than the given percentage will be hidden in the analysis of Equal jobs. Salary difference in Equal jobs is calculated between genders within the group. Salary difference in Comparative jobs is calculated between female-dominated and non-female-dominated jobs.",
            "salaryDifferenceTextEthnicity": "Groups with a salary ratio lower than the given percentage will be hidden in the analysis of Equal jobs. Salary difference in Equal jobs is calculated between genders and ethnicities within the group. Salary difference in Comparative jobs is calculated between female-dominated jobs and non-female-dominated jobs.",
            "salarySurvey": "Pay equity audit",
            "selectCentralTendency": "Compare groups with",
            "selectPercentiles": "Select percentiles",
            "showOptions": "Show",
            "singleGenderAndEthnicityText": "Groups that include only employees of a single gender and the same ethnicity will be hidden in the analysis of Equal jobs.",
            "singleGenderText": "Groups that include only employees of a single gender will be hidden in the analysis of Equal jobs.",
            "smallGroupText": "Groups that include fewer than the given number of employees will be hidden in the Equal and Equal value jobs analysis.",
            "status": "Status",
            "tenthNineteenth": "10th 90th",
            "totalSalary": "Total salary",
            "twentiethEighteenth": "20th 80th",
            "typeOfSalary": "Salary / Salary increment",
            "undoMarkFinished": "Mark pay equity audit as not done",
            "undoMarkFinishedDescription": "Are you thinking about revisiting your pay equity audit? We’ll update the analysis status to ongoing or past due on the global overview."
        },
        "mappingsAnalyzeActionCostSlider": {
            "year": "Year"
        },
        "mappingsAnalyzeActionPlan": {
            "actionPlan": "Action plan",
            "actionPlanEqualWorks": "Action plan from equal jobs:",
            "comments": "Comments",
            "costYear1": "Year 1",
            "costYear2": "Year 2",
            "costYear3": "Year 3",
            "costs": "Monthly cost",
            "group": "Group",
            "individualActions": "Individual actions",
            "individuals": "Individual",
            "simulatingSalaries": "Simulate salary changes",
            "simulatingSalariesDescription": "Move a point in the chart to create an individual action.",
            "year": "Year"
        },
        "mappingsAnalyzeCategoryList": {
            "analysisBadgeTooltip": "{manual} manual analysis {'|'} {automated} suggested by AI",
            "done": "Done",
            "noDoneCategories": "No analysis done",
            "notDone": "Not done",
            "nothingToAnalyze": "Nothing to analyze",
            "toBeAnalyzed": "To analyze"
        },
        "mappingsAnalyzeCheckboxFilter": {
            "noValue": "No value"
        },
        "mappingsAnalyzeEqualWorks": {
            "actionPlan": "Action plan",
            "activate": "Activate",
            "activateForThisAudit": "You have activated the new equal job in labs. Do you want to activate it for this audit?",
            "analysis": "Analysis",
            "analyze": "Analyze",
            "automatedAnalysis": "Automated analysis (ALPHA)",
            "automatedAnalysisWarning": "Automated analysis",
            "average": "Average",
            "averageAge": "Average age",
            "averageYearsOfEmployment": "Average company tenure",
            "comments": "Comments",
            "compaRatio": "Compa-ratio",
            "completeWork": "Mark as complete",
            "count": "Count",
            "eighteenthPercentile": "80th salary percentile",
            "employments": "Employments",
            "equalWorks": "Equal jobs",
            "ethnicity": "Ethnicity",
            "female": "Female",
            "fetchInsights": "Fetch insights!",
            "filterEmployees": "Filter employees",
            "generativeInsights": "Generative insights",
            "insightsInformation": "Use the power of AI to generate insights for your job. Note that no personal information is shared during the process. Generative insights is not always 100% accurate so accept them on your own discretion. Your group needs to have over 20 employees in order to work.",
            "loadingInsights": "Analyzing...",
            "male": "Male",
            "max": "Max",
            "median": "Median",
            "min": "Min",
            "newActionPlan": "Add to action plan",
            "newEmployeesInGroup": "This job has new employees who need to be reviewed.",
            "ninetiethPercentile": "90th salary percentile",
            "notDeclared": "Not declared",
            "notEnoughMenOrWomenToCompare": "There needs to be more men or women for automated analysis. (The group must contain at least two men and two women)",
            "otherAnalysis": "Other analysis",
            "position": "Position title",
            "positionLevel": "Position Level",
            "ratio": "Ratio",
            "salary": "Salary",
            "salaryDifference": "Salary ratio (F/M)",
            "salaryOverview": "Salaries, overview",
            "showEmployees": "Show",
            "showEmploymentList": "Show employment list",
            "statisticalCode": "Statistical code",
            "tags": "Tags",
            "tenthPercentile": "10th salary percentile",
            "timeInCurrentPosition": "Job tenure",
            "total": "Total",
            "twentiethPercentile": "20th salary percentile",
            "unadjustedSalaryDifferenceMean": "Unadjusted pay gap {'|'} Mean",
            "unadjustedSalaryDifferenceMedian": "Unadjusted pay gap {'|'} Median",
            "userGuideContent": "Here you analyze within the work. In your analysis, you can use history from previous surveys or use one of the filters in the view. Then you can analyze and document in a simple way directly in the system.",
            "workComplete": "Work complete",
            "workEmployments": "Employments in group {work}",
            "year": "Years"
        },
        "mappingsAnalyzeEquivalentWorks": {
            "actionPlan": "Action plan",
            "analysis": "Analysis",
            "analyze": "Analyze",
            "analyzeEqualWorks": "Analyze from equal jobs",
            "analyzeIsMissing": "Analysis is missing",
            "analyzeOf": "Analyze of",
            "cannotCompleteWorkTooltip": "Only \"{title}\" can be marked as complete in this job group",
            "cannotUndoCompleteWorkTooltip": "Only \"{title}\" can be marked as not complete in this job group",
            "comments": "Notes",
            "compaRatio": "Compa-ratio",
            "completeWork": "Mark as complete",
            "costsEqualWorks": "Costs from equal jobs:",
            "details": "Details",
            "equivalentWorks": "Comparative jobs",
            "femaleDominatedWorks": "Female dominated jobs",
            "fetchedFrom": "Fetched from:",
            "filterEmployees": "Filter employees",
            "filterWork": "Filter work",
            "importTags": "Copy tags",
            "isSimulatingSalaries": "Simulating salary changes",
            "otherAnalysis": "Other analysis",
            "rankOnYAxis": "Number of employees",
            "salary": "Salary",
            "showEmploymentList": "Show employment list",
            "tags": "Tags",
            "timeInCurrentPosition": "Job tenure",
            "useSuggestionOfAnalyse": "Use suggestion of analyse text?",
            "useTagSuggestions": "Use suggestions of tags?",
            "userGuideContent": "Here, you can analyze the difference between female-dominated jobs and comparative jobs. You get previous analyses from similar jobs, and tags are also included.",
            "workComplete": "Work complete",
            "workEmployments": "Employments in group {work}",
            "year": "Years"
        },
        "mappingsAnalyzeFilter": {
            "clearFilters": "Clear",
            "shouldDisable": "All employments have the same value, so you cannot use this filter for this work."
        },
        "mappingsAnalyzeGeneralFilters": {
            "age": "Age",
            "clearFilters": "Clear filters",
            "contract": "Contract",
            "costCenter": "Cost Center",
            "employmentTime": "Company tenure",
            "ethnicity": "Ethnicity",
            "filterOnAge": "years",
            "filterOnSalary": "Salary {currency}",
            "filterOnTimeInWork": "years",
            "filters": "Filters",
            "formOfEmployment": "Form of employment",
            "individualTags": "Individual tags",
            "jobFamily": "Job family",
            "legalEntity": "Legal entity",
            "locality": "Locality",
            "organisationNode": "Organisation node",
            "payGrade": "Pay grade",
            "performance": "Performance",
            "position": "Position title",
            "positionLevel": "Position level",
            "rankOnYAxis": "Rank on employments",
            "salary": "Salary",
            "salaryDate": "Salary date",
            "salaryTypes": "Salary types",
            "salaryYear": "Salary year",
            "statisticalCode": "Statistical code",
            "timeInCurrentPosition": "Job tenure"
        },
        "mappingsAnalyzeWorkList": {
            "all": "All",
            "done": "Done",
            "mappingWorksEmpty": "You don't seem to have any workgroups. Go to the organize tab, to add groups.",
            "noAnalysis": "No jobs to analyze.",
            "noMatches": "No matches",
            "noWorkValuation": "There is no job evaluation! Please check job valuations on the organize tab.",
            "noWorks": "There are no works to show.",
            "notDone": "Not done",
            "people": " people",
            "salaryDifference": "Salary ratio",
            "searchWork": "Search work...",
            "selectWork": "Select work",
            "workHasEmployeesMarkedForAnalysis": "{work} has {count} employments marked for analysis.",
            "works": "Jobs",
            "worksComplete": "Great work! The task list is now complete."
        },
        "mappingsConnectedWorks": {
            "box": "Grade",
            "count": "Count",
            "excludesNonDeclaredGenders": "Employees with non declared genders are excluded from the calculation. \n\nClick on the icon to open a list with excluded employees.",
            "grade": "Grade",
            "meanSalary": "Mean salary",
            "meanSalaryDifferenceCurrency": "Mean salary, difference {currency}",
            "meanSalaryDifferencePercent": "Mean salary, difference %",
            "medianSalary": "Median salary",
            "medianSalaryDifferenceCurrency": "Median salary, difference {currency}",
            "medianSalaryDifferencePercent": "Median salary, difference %",
            "salaryDifference": "Salary ratio",
            "salaryEffectedBy": "Salary affected by",
            "womenRatio": "Women ratio",
            "work": "Work"
        },
        "mappingsDocumentExport": {
            "activeMeasures": "Active measures",
            "analyseEqualWorks": "Analyze equal jobs",
            "analyseEquivalentWorks": "Analyze comparative jobs",
            "chooseWork": "Select at least one work",
            "compilation": "Compilation",
            "document": "Document",
            "download": "Download",
            "employmentInformationReport": "Compilation - Employees",
            "executiveSummary": "Executive summary",
            "executiveSummaryExported": "Executive summary exported!",
            "executiveSummaryInfo": "Executive summary summarises the process and presents key findings to give the reader a brief understanding of the current situation and your work. ",
            "executiveSummaryTitle": "Export executive summary",
            "export": "Create executive summary",
            "exportFromAnalyse": "Export from analyse",
            "exportFromOrganize": "Export from organize",
            "exportTemplates": "Report templates",
            "factorPlan": "Factor plan",
            "fileTypeExcel": "(.xlsx)",
            "fileTypePdf": "(.pdf)",
            "fileTypeWord": "(.docx)",
            "finalReport": "Final report template",
            "finishedReport": "Final report template",
            "mappingWorks": "Equal pay audit jobs",
            "new": "New",
            "premadeReports": "Premade reports",
            "preview": "Preview",
            "storeDocument": "Store document",
            "summaryReport": "Summary report",
            "uploadCompanyLogo": "Add your company logo to the report",
            "uploadedCompanyLogo": "Your uploaded company logo that will be visible in the report",
            "userGuideContent": "Here you will find all the reports that you can generate from the system. Choose which layout you want and what the reports should contain.",
            "workValuation": "Job evaluation & evaluation result"
        },
        "mappingsEqualWorksKeyValues": {
            "age": "Age",
            "compaRatio": "compa-ratio",
            "correlation": "Correlation",
            "employments": "Employments",
            "ethnicity": "Ethnicity",
            "ethnicitySalaryDifference": "Ratio | Ethnicity",
            "ethnicitySalaryDifferenceInfo": "The ratio is the difference between the lowest paid ethnicity group average salary divided by the highest.",
            "excludeNonDeclaredGender": "\n\n(Employees with non declared genders are excluded from this calculation)",
            "explainedDifference": "Explained difference",
            "explainedDifferenceTooltip": "The part of the mean difference that is explained by the data in out system.",
            "female": "Female",
            "gender": "Gender",
            "invalidCorrelation": "Unavailable",
            "male": "Male",
            "max": "Max salary",
            "maxCompaRatio": "Max compa-ratio",
            "mean": "Mean salary",
            "meanCompaRatio": "Mean compa-ratio",
            "meanDifference": "Mean difference",
            "meanDifferenceTooltip": "The difference in the mean salaries between the genders",
            "median": "Median salary",
            "medianCompaRatio": "Median compa-ratio",
            "min": "Min salary",
            "minCompaRatio": "Min compa-ratio",
            "salary": "salary",
            "salaryDifference": "Ratio | Gender",
            "salaryDifferenceInfo": "The ratio is the difference between the female {averageSalary} divided by the male {averageSalary}. {nonDeclaredString}",
            "timeInCurrentPosition": "Job tenure",
            "unadjustedSalaryDifference": "Unadjusted pay gap",
            "unadjustedSalaryDifferenceInfo": "The Unadjusted pay gap is the difference between men's and women's {averageSalary} expressed as percentage of men's salary. When a pay gap is negative, women earn more than men. \n{nonDeclaredString}",
            "unadjustedSalaryDifferenceMean": "Unadjusted pay gap {'|'} Mean",
            "unadjustedSalaryDifferenceMedian": "Unadjusted pay gap {'|'} Median",
            "unexplainedDifference": "Unexplained difference",
            "unexplainedDifferenceTooltip": "The part of the mean difference that isn't explainable by data in the system. Can be due to missing data for example education level or due to discrimination."
        },
        "mappingsOrganizeGroup": {
            "addMatchingEmployments": "There are {amount} employees with matching statistical code and position.",
            "addToSelection": "Add matching employments to selection",
            "birthDate": "Birth date",
            "changeWork": "Change work",
            "chooseLegalEntity": "Choose legal entity...",
            "chooseOrganisationNode": "Choose organisation node...",
            "chooseStatisticalCode": "Choose statistical code...",
            "chooseWork": "Choose work...",
            "compaRatio": "Compa-ratio",
            "confirmDeleteEmptyWorks": "Do you want to delete all empty jobs?",
            "confirmDeleteWork": "Are you sure that you want to delete the work",
            "confirmMoveWorkWithActions": "You are about to move one or multiple employments that already have actions connected to their current work. If you move these, the actions will be deleted. Are you sure that you want to continue?",
            "contract": "Contract",
            "currency": "Currency",
            "deleteEmptyWorks": "Delete empty jobs",
            "duplicates": "Duplicates",
            "employeeChangedWorkNotification": "{name} has been moved to {work}",
            "employment": "Employment",
            "employmentDate": "Company tenure start date",
            "employmentNumber": "Employment number",
            "employmentRate": "Employment rate",
            "equity": "Long-term incentive",
            "ethnicity": "Ethnicity",
            "exactMatchingEmploymentsDescription": "The following employments match the chosen employment's statistical code and position. ",
            "female": "Female",
            "fileCouldNotBeImported": "File could not be imported, please try again! If the problem persists contact customer success.",
            "fileImported": "Import finished successfully",
            "fileIsEmpty": "File does not conatin any data",
            "formOfEmployment": "Form of employment",
            "gender": "Gender",
            "group": "Group",
            "groupEmployments": "Group employments",
            "groupEmploymentsDescription": "Select the employees you would like to move, then select a work from suggestions, all, or create a new work in the grouping options.",
            "importEmploymentComments": "Import comments",
            "importEmploymentPerformance": "Import performance",
            "importEmploymentTags": "Import tags",
            "individualWorkValuation": "Individual job evaluation",
            "jobFamily": "Job family",
            "lastPayIncrease": "Last pay increase",
            "legalEntity": "Legal entity",
            "locality": "City",
            "male": "Male",
            "managerCode": "Manager code",
            "mappingEmploymentGrouping": {
                "allEmployments": "All employments",
                "employmentsToGroup": "Employments to group",
                "employmentsToReview": "Employments to review"
            },
            "moveEmployments": "Move employments",
            "moveOriginal": "Move original selection",
            "moveSelected": "Move selected:",
            "moveWithSelected": "Move with additionally selected rows",
            "name": "Name",
            "newWorkName": "New work name",
            "newWorkNo": "New job number",
            "no": "No",
            "noEmptyWorksToRemove": "There are no empty jobs to remove.\nAll jobs contains one or more employments.",
            "organisationNode": "Organisation node",
            "organization": "Organization",
            "organizationalLevel1": "Organization level 1",
            "organizationalLevel2": "Organization level 2",
            "organizationalLevel3": "Organization level 3",
            "organizationalLevel4": "Organization level 4",
            "organizationalLevel5": "Organization level 5",
            "organizationalLevel6": "Organization level 6",
            "overview": "Overview",
            "payBand": "Pay band",
            "payGrade": "Pay grade",
            "performance": "Performance",
            "personalIdentityNumber": "Unique-ID",
            "position": "Position title",
            "positionLevel": "Position Level",
            "rankOnYAxis": "Rank on employments",
            "removeEmployee": "Remove employee from the pay equity audit",
            "removeEmployeeConfirmation": "Are you sure you want to remove {name} from the pay equity audit?",
            "removeEmployees": "Remove employees from the pay equity audit",
            "removeEmployeesConfirmation": "Are you sure you want to remove {number} employees from the pay equity audit?",
            "salary": "Salary",
            "salaryDate": "Salary date",
            "salaryExchange": "Salary exchange",
            "salaryIncrement": "Salary increment",
            "salaryIncrementSecond": "Salary increment second",
            "salaryIncrementThird": "Salary increment third",
            "salaryYear": "Salary year",
            "socialSecurityNumber": "Unique-ID",
            "sortGroup": "Sort",
            "sortGroupsByGroupAsc": "Groups, A-Z",
            "sortGroupsByGroupDesc": "Groups, Z-A",
            "sortGroupsBySizeLargeToSmall": "Large to small groups",
            "sortGroupsBySizeSmallToLarge": "Small to large groups",
            "statisticalCode": "Statistical code",
            "suggestedWork": "Suggested work",
            "timeInCurrentPosition": "Job tenure",
            "totalSalary": "Total salary",
            "userGuideContent": "Here you group the employments in each job. The system helps with suggestions to facilitate the work.",
            "userGuideLinkText": "Click here to learn more.",
            "wantToAddToSelection": "Do you want to add them to the selection?",
            "wantToMove": "Do you want to move them as well?",
            "work": "Job",
            "workIsDoneWarning": {
                "content": "If you move {employee} to {work} you may need to recheck the analysis. \n Do you want to move { employee } to { work } anyway?",
                "header": "{work} is marked as done"
            },
            "worksToRemove": "The following jobs will be removed:",
            "yes": "Yes",
            "zeroSalaryWarning": "Some employees have a base salary of 0, which affects the accuracy of pay gap calculations. Update their salaries to ensure accurate results."
        },
        "mappingsOrganizeWorkValuation": {
            "description": "Description",
            "factor": "Factor",
            "fileCouldNotBeImported": "File could not be imported",
            "fileIsEmpty": "File does not conatin any data",
            "helptext": "Valuation help",
            "hideSearchBar": "Hide search bar",
            "importWorkValuation": "Import job evaluation",
            "interval": "Interval",
            "level": "Level",
            "mappingFactor": "Factor value",
            "note": "Note",
            "points": "Points",
            "searchWork": "Search job",
            "showSearchBar": "Show search bar",
            "userGuideContent": "Here you can review the job valuation and the results in the valuation boxes. Search functions and filters are in the view to facilitate your work.",
            "valuationBox": "Grade",
            "valuationBoxes": "Grades",
            "valuationHelp": "Valuation help",
            "work": "Job",
            "workValuation": "Job evaluation"
        },
        "mappingsOverview": {
            "adjustedPayGap": "Adjusted pay gap",
            "age": "Age",
            "allWorks": "All jobs",
            "betaCoeff": "Salary factors",
            "blinderOaxaca": {
                "beta": {
                    "female": "Female",
                    "male": "Males",
                    "total": "Total"
                },
                "errors": {
                    "aliasedTerms": "Aliased terms detected in the model, indicating either multicollinearity or insufficient data diversity to produce a meaningful model. Please try deselecting some pay factors.",
                    "aliasedTermsWithFactors": "{factors} are too closely correlated. Select only one of them to get better results.",
                    "alreadyInRange": "The adjusted pay gap is already within range of the required pay gap.",
                    "constantPredictors": "Employees all have the same value in {Factors}. The factors doesn’t offer any meaningful insights. Remove them from the model.",
                    "modelFailed": "Quantile regression model fitting failed — unable to compute the adjusted pay gap.  Please try deselecting some pay factors.",
                    "modelToWeak": "The model is too weak to offer any meaningful insights.",
                    "noIdBody": "No ID column found in body request",
                    "noIdEmps": "No ID column found in employee data",
                    "noStrategy": "No cost to close strategy provided",
                    "notSignificant": "The model isn't statistically significant — unable to calculate an adjusted pay gap.  Please try deselecting some pay factors.",
                    "oneGroup": "Gender pay gaps couldn’t be calculated due to only one gender being represented in the audit.",
                    "perfectFit": "Sample size is too small for the amount of factors selected. We can’t calculate your adjusted pay gap.",
                    "relativeDifferenceInGeometricMeans": "We were unable to calculate the individual impact of each pay factor on the adjusted pay gap. Rest assured, it doesn’t affect the adjusted pay gap."
                },
                "explained": "Explained salary difference",
                "factors": {
                    "additionalDataOne": "Additional data 1",
                    "additionalDataOneInfo": "Select when you want to use a first custom data point to impact the salary. This factor introduces flexibility by allowing the use of a specific organization-defined variable in your pay analysis.",
                    "additionalDataThree": "Additional data 3",
                    "additionalDataThreeInfo": "Select when you want to use a third custom data point to impact the salary. This factor enables even more customization by incorporating a third organization-specific variable into the pay analysis.",
                    "additionalDataTwo": "Additional data 2",
                    "additionalDataTwoInfo": "Select when you want to use a second custom data point to impact the salary. This factor provides further flexibility by allowing the use of additional organization-specific information in your pay analysis.",
                    "age": "Age | Ages",
                    "ageInfo": "Select when you think increased age reflects their experience and when experience or age should impact the salary.",
                    "contract": "Contract",
                    "contractInfo": "Select when you think the type of contract should impact the salary. This factor considers variations in contract types that may influence responsibilities, job security, or expectations, and therefore justify differences in pay.",
                    "employmenttime": "Company tenure | Company tenures",
                    "employmenttimeInfo": "Select when you think prolonged loyalty within the organisation should increase the salary.",
                    "explained": "All pay factors",
                    "femaleLogical": "Female",
                    "fulltime": "Full-time ",
                    "fulltimeInfo": "Select when you think full-time status should impact the salary. This factor accounts for differences in working time arrangements that may influence pay, such as full-time versus other forms of employment.",
                    "gender": "Gender | Genders",
                    "intercept": "(Intercept)",
                    "jobCareerBand": "Career band",
                    "jobCareerBandInfo": "Select when you think the career band of a job should increase the salary. The career band reflects the overall scope and impact level of a job within the organization and is assigned in the job architecture module at the time of creating the pay equity audit.",
                    "jobFamily": "Job family | Job families",
                    "jobFamilyInfo": "Select when you think the job family of a job should increase the salary. The job family is based on job family assigned to the invididual in the job architecture module at the time of creating the pay equity audit..",
                    "jobSubfamily": "Sub family",
                    "jobSubfamilyInfo": "Select when you think the job sub family of a job should increase the salary. The job sub family is a more specific categorization within the broader job family and is assigned to the individual in the job architecture module at the time of creating the pay equity audit.",
                    "locality": "Locality",
                    "localityInfo": "Select when you think the geographical location of the job should impact the salary. Locality reflects regional differences in labor markets, cost of living, and pay norms, which may justify salary adjustments based on where the work is performed.",
                    "managerCodeInfo": "Select when manager code reflects responsibility and when you think increased responsibility should increase the salary.",
                    "managercode": "Manager code | Manager codes",
                    "payBand": "Pay band",
                    "payGrade": "Pay grade",
                    "performance": "Performance | Performances",
                    "performanceInfo": "Select when you think good performance throughout the year should increase the salary.",
                    "positionLevelInfo": "Select when job evaluations are done outside Sysarb and when you think increased complexity should increase the salary.",
                    "positionlevel": "Position level | Position levels",
                    "statutorygrade": "Statutory grade | Statutory grades",
                    "statutorygradeInfo": "Select when you think the statutory grade of a job should impact the salary. This factor considers grade differences from an applicable collective agreement or statutory pay framework that may justify differences in pay.",
                    "timeInCurrentPositionInfo": "Select when you think prolonged durations in a specific job reflects their competence and when you think increased competence should increase the salary.",
                    "timeincurrentposition": "Job tenure | Job tenures",
                    "unknown": "Unknown | Unknowns",
                    "valuation": "Grade | Grades",
                    "valuationPointsInfo": "Select when you think the increased complexity of a job should increase the salary. The level is based on the score from your job valuation in the pay equity audit."
                },
                "meanDifference": "Mean salary difference",
                "readMore": "Read more about how we calculate the adjust pay gap here",
                "relativeMeanInfoText": "Because the geometrical means were too similar, a direct calculation was used instead of breaking down the result into separate factors. This means it's not possible to show how each factor contributed, but the final result is still correct.",
                "report": {
                    "KeyValues": "Key Values",
                    "ReportHeader": "FPI Report",
                    "adjRSquaredDecompAdvGroup": "Adjusted R-squared (Decomposition: Advantaged Group)",
                    "adjRSquaredDecompDisadvGroup": "Adjusted R-squared (Decomposition: Disadvantaged Group)",
                    "adjRSquaredDirect": "Adjusted R-squared (Direct)",
                    "adjustedPayGap": "Adjusted Pay Gap (absolute)",
                    "adjustedPayGapAbsolute": "Adjusted Pay Gap (absolute)",
                    "adjustedPayGapDecompPercentage": "Adjusted Pay Gap (decomposition; percentage)",
                    "adjustedPayGapDirectPercentage": "Adjusted Pay Gap (direct; percentage)",
                    "adjustedPayGapPercentageOfAdvantaged": "Adjusted Pay Gap (decomposition; percentage)",
                    "adjustedPayGapPercentageOfAdvantagedDirect": "Adjusted Pay Gap (direct; percentage)",
                    "adjustedRSquaredAdvantagedGroup": "Adjusted R-squared (Advantaged Group)",
                    "adjustedRSquaredDisadvantagedGroup": "Adjusted R-squared (Disadvantaged Group)",
                    "advantagedComparePay": "Unadjusted Mean Salary (Advantaged Group)",
                    "coeffTableDecompAdvGroup": "Coefficient Table (Decomposition: Advantaged Group)",
                    "coeffTableDecompDisadvGroup": "Coefficient Table (Decomposition: Disadvantaged Group)",
                    "coeffTableDirect": "Coefficient Table (direct)",
                    "coefficient": "Coefficient",
                    "dataPointsUsedAdvGroup": "Data points used (Advantaged Group)",
                    "dataPointsUsedDirectMethod": "Data points used (Direct)",
                    "dataPointsUsedDisadvGroup": "Data points used (Disadvantaged Group)",
                    "decompMethodModelEval": "Decomposition Method Model Evaluation",
                    "directMethodModelEval": "Direct Method Model Evaluation",
                    "disadvantagedComparePay": "Unadjusted Mean Salary (Disadvantaged Group)",
                    "estimateHeader": "Estimate",
                    "factorName": "Name",
                    "factors": "Factors",
                    "fileName": "Adjusted Pay Gap Data Report",
                    "nAdvantagedGroup": "n (Advantaged Group)",
                    "nDisadvantagedGroup": "n (Disadvantaged Group)",
                    "pValueHeader": "p.value",
                    "payGapDirectMethod": "Adjusted R-squared (Direct)",
                    "percentageOfAdvantaged": "Percentage of advantaged",
                    "percentageOfExplained": "Percentage of explained",
                    "percentageOfUnadjusted": "Percentage of unadjusted",
                    "rSquaredDecompAdvGroup": "R-squared (Decomposition: Advantaged Group)",
                    "rSquaredDecompDisadvGroup": "R-squared (Decomposition: Disadvantaged Group)",
                    "rSquaredDirect": "R-squared (Direct)",
                    "standardErrorOfTheAdvantagedGroupModel": "Standard Error of the Advantaged Group's Model",
                    "statisticHeader": "Statistic",
                    "stdErrorHeader": "std.error",
                    "term": "Name",
                    "termHeader": "Term",
                    "unadjustedMeanSalaryAdv": "Unadjusted Mean Salary (Advantaged Group)",
                    "unadjustedMeanSalaryDisadv": "Unadjusted Mean Salary (Disadvantaged Group)",
                    "unadjustedPayGap": "Unadjusted Pay gap (absolute)",
                    "unadjustedPayGapAbsolute": "Unadjusted Pay gap (absolute)",
                    "value": "Value"
                },
                "salaryDifference": "Salary difference",
                "unexplained": "Unexplained salary difference"
            },
            "chartAgeGroupGender": "Age distribution",
            "chartGenderDistribution": "Gender distribution",
            "chartGenderSalaryDistribution": "Works and salary ratio",
            "chartOrganisationWorkStructure": "Organisations work structure",
            "chartSalaryDevelopment": "Count of employments and salary costs",
            "chartSalaryDifference": "Salary development",
            "chartSalaryGroupGender": "Distribution of gender in salary groups",
            "comparedWith": "Compared with:",
            "count": "Count",
            "countEmployments": "Number of employments",
            "currencyTenThousands": "Shown in tens of thousands",
            "currencyThousands": "Shown in thousands ({currency})",
            "date": "Date",
            "description": "Description",
            "document": "Document",
            "employments": "Employments",
            "equalityTimer": "Equality Timer",
            "excludeNonDeclaredGender": "\n\n(Employees with non declared genders are excluded from this calculation)",
            "female": "Women",
            "femaleDominated": "Female dominated",
            "femaleHighestPaid": "Women earn more than men",
            "generalActionPlanMeasures": "General actionplan",
            "male": "Men",
            "maleDominated": "Non female dominated",
            "maleHighestPaid": "Men earn more than women",
            "mappingAdjustedSalaryFactors": {
                "changesWillBeShownAfterCreation": "You’ll receive more details on each factor’s effect after creating the audit. You can see the selected factors above.",
                "coefficient": "Coefficient",
                "constantFactor": "{ factor } has the same value for all employees and won't affect the adjusted pay gap.",
                "createFactorPlan": "Create factor plan",
                "evaluate": "Evaluate jobs",
                "explaination": "Select which pay factors you want to affect a employee's salary. What can't be explained by your pay factors will be your adjusted pay gap.",
                "factorHasNoData": "It either doesn't exist any data for this factor or the data doesn't contain numbers, deselect it or import new data for this factor.",
                "factorsWithErrors": "Unable to calculate adjusted pay gap",
                "factorsWithErrorsDescription": "The following factors have validation errors. Please import correct data or disable these factors to view the adjusted pay gap:",
                "importError": {
                    "date": "Failed to import data. { factor } is expected to be a date in the format YYYY-MM-DD.",
                    "number": "Failed to import { factor }, make sure all values are numbers."
                },
                "importFormat": {
                    "date": "The import expect { factor } to be a date in the format YYYY-MM-DD.",
                    "number": "In order to calculate the impact of { factor } on the adjusted pay gap all values for { factor } need to be numbers."
                },
                "importText": "Download the template and update the values in the { factor } column. After that, upload and import the file.",
                "insufficientCategories": "{ factor } doesn't have enough distinct categories. Please ensure it has at least 2 unique values or import new data for this factor.",
                "missingFactorPlan": "No factor plan exists so Level won't affect the adjusted pay gap.",
                "missingValuations": "Grade has the same value for all employees and won't affect the adjusted pay gap.",
                "noneNumberData": "In order for us to calculate the impact of { factor } on the adjusted pay gap we’ll need you to convert your { factors } to numbers.",
                "payFactors": "Pay factors",
                "payPhilosophy": "Pay Philosophy",
                "r2": "r²",
                "recommended": "Recommended",
                "template": {
                    "employmentNumber": "Employment number",
                    "name": "Name",
                    "uniqueId": "Unique ID"
                }
            },
            "maxSalary": "Max salary",
            "meanSalary": "Mean salary",
            "medianSalary": "Median salary",
            "minSalary": "Min salary",
            "name": "Name",
            "otherGroups": "Other",
            "overviewNotAvailable": "It seems that the salary mapping contains employees with different currencies and information about compa-ratio is missing. We advise you to add compa-ratio to the salary mapping or alternatively divide the material.",
            "percentageFemale": "Percentage women",
            "percentageMale": "Percentage men",
            "percentageNotDeclared": "Percentage not declared",
            "ratio": "Ratio",
            "salaryDifference": "Salary ratio",
            "salaryDifferenceInfo": "The ratio is the difference between the female {averageSalary} divided by the male {averageSalary}. {nonDeclaredString}",
            "showFor": "Show diagrams for: ",
            "shownInYears": "Shown in years",
            "singleGender": "Single gender",
            "totalSalaryCost": "Total salary cost",
            "unadjustedPayGap": "Unadjusted pay gap",
            "userGuideContent": "On this tab, you can review your data and its key figures.",
            "withCurrency": "Currency:",
            "years": "yr"
        },
        "mappingsPrepare": {
            "clickToContinue": "Continue to start the import process",
            "creatingEmployments": "Creating employments",
            "creatingFactorPlan": "Creating factor plan",
            "creatingWorks": "Creating jobs",
            "deleteFactorPlanWarning": "Warning: your current job evaluation and factor plan will be deleted if you choose to import a new job evaluation",
            "import": "Import",
            "importCompleted": "Your import is complete. Click here to continue to import employements.",
            "importDisabledTooltip": "Fix errors before continuing.",
            "importHasErrors": "The import is completed but problems occurred. Verify that all data has been imported.",
            "importSuccess": "Import completed",
            "jobArchitecture": "Jobarchitecture",
            "prepare": "Prepare",
            "userGuideContent": "In this view, you start the mapping by importing the data and the factor plan you want to use. Take a look at how you proceed and what is good to think about, especially regarding grouping and data from previous mappings."
        },
        "mappingsPrepareAdjustedPayGap": {
            "userGuideContent": "In this view, you can choose which pay factors you want to use to influence a employee's salary."
        },
        "mappingsPrepareMappingFactor": {
            "comment": "Level description",
            "createNewFactor": "New factor",
            "createNewFactorValue": "Create a new value",
            "deleteFactor": "Remove factor",
            "deleteFactorPlanWarning": "Warning: your current job evaluations will be deleted if you choose to import a new factor plan",
            "deleteFactorValue": "Remove factor level",
            "description": "Description",
            "factorDescription": "Factor description",
            "factorLevels": "Factor levels",
            "factorPlanLanguageInfo": "When importing a factor plan, the system language will be used.\nThis language can be changed in system settings.",
            "importNewFactorPlan": "Import new factor plan",
            "importingFactorPlan": "Importing factor plan...",
            "level": "Level",
            "name": "Name",
            "newFactor": "Ny Faktor",
            "noFactorPlan": "You haven't created a factor plan yet.",
            "points": "Points",
            "prepareMappingFactor": "Factors",
            "preview": "Preview",
            "valuationHelpText": "Evaluation help-text",
            "verifyDeleteFactor": "Are you sure you want to remove the factor?",
            "verifyDeleteFactorValue": "Are you sure you want to remove the factor level?"
        },
        "meanSalaryDifferencesInfo": {
            "1": "Jobs with equal or lower complexity but higher mean salary will be highlighted for analysis.",
            "2": "Compliant with EU Pay Transparency reporting"
        },
        "medianSalaryDifferencesInfo": {
            "1": "Jobs with equal or lower complexity but higher median salary will be highlighted for analysis.",
            "2": "Outliers have less impact on the salary differences.",
            "3": "Is not compliant with EU Pay Transparency reporting"
        },
        "multiStepComponent": {
            "back": "Back",
            "cancel": "Cancel",
            "finished": "Done",
            "next": "Continue",
            "skip": "Skip"
        },
        "navigationbar": "Mobile navigation menu",
        "notification": {
            "dismiss": "Dismiss"
        },
        "notificationButton": {
            "unreadNotifications": "unread notifications"
        },
        "notificationModal": {
            "dismiss": "Dismiss",
            "dismissAll": "Dismiss all",
            "noNotifications": "No notifications to display.",
            "title": "Notifications"
        },
        "orgNodeSelector": {
            "selectNode": "Select organisation"
        },
        "overviewBanner": {
            "dataLastUpdated": "Data last updated {date}",
            "loggedInAs": "Logged in as {role} into {customer}",
            "loggedInAsRole": "Logged in as {role}",
            "loggedInCustomer": "Working in {customer}",
            "welcome": "👋 Welcome to Sysarb",
            "welcomeWithName": "👋 Welcome to Sysarb, {firstName}"
        },
        "partnerPlatform": {
            "3rStrategyDesc": "3R Strategy is a UK-based reward consultancy that helps organizations attract and retain talent through pay transparency and fair, equitable reward strategies with over 25 years of experience.",
            "activeMeasures": "Active Measures",
            "aonDesc": "Radford Data & Analytics, from Aon, offers compensation insights to innovative companies across various industries, enhancing decision-making with comprehensive data. Learn more at radford.aon.com.",
            "bookMeeting": "Book a meeting",
            "citrisDesc": "Citris offers reward consulting services, from strategy development to implementation, focusing on fresh perspectives and hands-on experience. Visit citris.ie for more details and insights.",
            "clearAllFilters": "Clear filters",
            "compteamDesc": "CompTeam helps improve business performance by implementing programs designed to attract, retain, and engage top talent, boosting overall productivity and success.",
            "country": "Country",
            "culpepperDesc": "Culpepper provides trusted compensation data and consulting services, assisting organizations in making thoughtful and informed compensation decisions with reliable solutions.",
            "dei": "DEI (Diversity, Equity & Inclusion)",
            "eUPayTransparencyDirective": "EU Pay Transparency Directive",
            "equalPayAudit": "Pay equity analysis",
            "equidiDesc": "Equidi provides real-time visibility on gender pay gaps and workforce representation, offering bespoke recommendations for setting goals, tracking progress, and improving performance for a more equitable future.",
            "equityPeopleDesc": "EquityPeople helps clients manage employee equity pools, advising on grant benchmarks, pool planning, and equity education to ensure effective utilisation and maximise motivational power.",
            "equityPrograms": "Equity Programs",
            "espertaDesc": "Barcelona-based Esperta supports SMEs with job grading, job architecture, and pay equity analysis, focusing on Spanish law to ensure compliance and fairness.",
            "europe": "Europe",
            "executiveRemuneration": "Executive Remuneration",
            "expertise": "Expertise",
            "explainationText": "Sometimes everything isn't crystal clear, which we fully understand! That's why we have gathered our team of experts, who are more than happy to help! Each one in our team has different skills and are experts in their fields. Feel free to book a meeting with the one you think suits you best. If it turns out that it's better that you meet another person, we will be happy to help you solve it!",
            "explore": "Explore our partner network",
            "fairPayCertificate": "Fair Pay Certificate",
            "figuresDesc": "Figures is Europe's leading compensation management platform, helping mid-market companies make fair and efficient salary decisions with reliable data and tools.",
            "fpiDesc": "Fair Pay Innovation Lab supports companies in implementing fair pay practices, offering certification, sharing best practices, and guiding organizations through comprehensive fair pay analysis.",
            "genderPayGapReporting": "Gender Pay Gap Reporting",
            "getHelp": "Get help from one of our partners",
            "getHelpDescription": "We have proactively worked to find like-minded partners who are experts in salaries, compensation, and gender equality. You can search or browse to find the best partner for your needs.",
            "global": "Global",
            "gradarDesc": "Gradar offers a comprehensive job architecture solution that supports consistent job grading, salary alignment, and pay equity analysis with a user-friendly software system.",
            "interim": "Interim",
            "internationalPension": "International Pension",
            "jobArchitecture": "Job Architecture",
            "kornFerryDesc": "Korn Ferry is a global consulting firm that designs optimal organization structures, helping hire, reward, and develop professionals to enhance business success.",
            "mandatumDesc": "Mandatum is a leading Finnish financial service provider offering comprehensive compensation and benefits services, including one of Finland's largest salary surveys.",
            "meetingBooking": "Book a meeting",
            "mercerDesc": "Mercer, with 25,000 employees in over 130 countries, provides trusted advice and solutions to build healthier, more sustainable futures, enhancing performance and well-being globally.",
            "meritiesDesc": "Merities Consulting guides companies in applying pay equity and transparency, improving staff engagement, reducing turnover, and attracting new talent with tailored solutions.",
            "mobility": "Mobility",
            "mostRelevantSkills": "Most relevant skills",
            "newPayCollectiveDesc": "New Pay Collective brings visibility to reward practices, offering tailored solutions that balance objectives, structures, and rewards, driving change through practical and effective strategies.",
            "noPartnersFound": "No partners found",
            "noProfileMatches": "Sorry, we couldn't find a profile match for your selected values.",
            "nordicRewardPartnersDesc": "Nordic Reward Partners offers strategic advice and practical solutions in reward management, leveraging decades of experience to help organizations work smarter and more effectively.",
            "ourConsultants": "Our consultants & partners",
            "partnerPlatform": "Partner platform",
            "payEquityAnalysis": "Pay Equity Audits",
            "payTransparency": "Pay Transparency",
            "performAndPayDesc": "Perform & Pay develops performance management and reward strategies, tools, and practices with over 30 years of experience, providing clear and flexible solutions for businesses.",
            "performanceManagement": "Performance Management",
            "popularServices": "Popular services",
            "qbiddDesc": "Since 2004, QBiDD has helped over 250 organizations address HR and reward management issues effectively, focusing on medium to large international companies.",
            "ravioDesc": "Ravio provides real-time market data and tools to manage and communicate compensation, trusted by high-growth tech companies like Deliveroo and WeTransfer.",
            "rewardHeadsDesc": "Reward Heads enables organizations to use Total Reward strategies to attract, retain, and motivate the best people with customized and innovative solutions.",
            "rewardPhilosophy": "Reward Philosophy",
            "rewardSmarterDesc": "RewardSmarter helps HR work strategically with Compensation & Benefits, combining consulting support with HR tools and training to streamline processes and enhance efficiency.",
            "salaryComDesc": "Salary.com provides employee compensation data, software, and services, helping companies manage compensation expenditures with real-time data and analytical tools, optimizing their pay strategies.",
            "salaryReview": "Salary Review",
            "salarySurveys": "Salary Surveys",
            "sectorTags": {
                "international": "International",
                "private": "Private",
                "public": "Public"
            },
            "sectors": "Sectors",
            "sharpmaniaDesc": "Sharpmania provides HR and Facility Management expertise, offering innovative and comprehensive solutions during strategic changes and organizational transformations.",
            "skillTags": {
                "activeMeasures": "Active measures",
                "compBen": "Comp & ben",
                "payEquityAnalysis": "Pay equity audit",
                "practicalSalarySetting": "Practical salary review",
                "processLeading": "Process leading",
                "strategicSalarySetting": "Strategic salary review",
                "trainer": "Trainer",
                "workArchitecture": "Work architecture",
                "workEvaluation": "Job evaluation",
                "workShopFacilitator": "Work shop - Facilitator"
            },
            "stilti": "STI/LTI",
            "sysarbDesc": "Trusted consulting partner known for tailored expert services across diverse industries.",
            "totalRewardsConsulting": "Total Rewards Consulting",
            "tryAdjusting": "Try adjusting your search or filter settings to find partners.",
            "whatDoYouWantHelpWith": "What do you want help with?",
            "whichSector": "In which sector do you want help with?",
            "wtwDesc": "WTW provides data-driven, insight-led solutions in people, risk, and capital, helping enhance organizational resilience, motivate the workforce, and maximize performance globally."
        },
        "payEquityAudit": {
            "analyze": {
                "actualSalary": "Actual total salary",
                "actualSalaryDistanceFrom": "Actual total salary (distance from mean (%))",
                "explanationsAndAdjustments": {
                    "noExplanationsAdded": "No explanations have been added"
                },
                "predictedSalary": "Predicted total salary",
                "predictedSalaryDistanceFrom": "Predicted total salary (distance from mean (%))"
            },
            "baseSalary": "Base salary",
            "benefitsInKind": "Benefits in kind",
            "companyCarAllowance": "Car allowance",
            "explanations": "Explanations",
            "increase": "Increase",
            "insights": "Quick insights",
            "localJobProfileLevel": "Local job profile grade",
            "salaryComponents": "Salary components",
            "selectedEmploymentsAmount": "1 selected employee out of {total} | {n} selected employees out of {total}",
            "tags": {
                "analysed": "Analyzed",
                "beenOnParentalLeave": "Been on parental leave",
                "competingLabourMarket": "Competing labour market",
                "differentSalaryYear": "Different salary year",
                "frozen": "Frozen",
                "highPerformer": "High performer",
                "lessCompetence": "Less competence",
                "lessExperience": "Less experience",
                "lessPerformance": "Less performance",
                "lessResponsibility": "Less responsibility",
                "lowPerformer": "Low performer",
                "manager": "Manager",
                "market": "Market",
                "moreCompetence": "More competence",
                "moreExperience": "More experience",
                "morePerformance": "More performance",
                "moreResponsibility": "More responsibility",
                "newToJob": "New to job",
                "noExplanation": "No explanation",
                "noSalaryIncrease": "No salary increase",
                "notAnalysed": "Not analyzed",
                "notFrozen": "Not frozen",
                "older": "Older",
                "other": "Other",
                "outlierAbove": "Outliers above predicted salary",
                "outlierBelow": "Outliers below predicted salary",
                "prevEmployment": "Previous employment",
                "receivedBonus": "Received bonus",
                "salaryIncrease": "Salary increase",
                "younger": "Younger"
            },
            "thanPeers": "than peers"
        },
        "performanceFilter": {
            "excellent": "Excellent",
            "filterAfterResultInterval": "Filter after result interval",
            "good": "Good",
            "needsWork": "Needs work",
            "performance": "Performance",
            "valueMissing": "Value missing",
            "veryGood": "Very good"
        },
        "positionFilter": {
            "position": "Position title"
        },
        "presentationButton": {
            "description": "The presentation mode hides sensitive data"
        },
        "presentationModeActive": {
            "leavePresentationMode": "Click to leave presentation mode",
            "salaryHidden": "Salaries are hidden"
        },
        "presentationModeBar": {
            "exit": "Exit",
            "name": "Name",
            "performance": "Performance",
            "presentationModeTitle": "You are in presentation mode",
            "salary": "Salary"
        },
        "previewQuestions": {
            "answerEmployee": "Answer from employee",
            "cancelPreview": "Cancel preview",
            "comments": "Comments",
            "lastResponseDate": "Last response date",
            "manager": "Manager",
            "noAnswerEmployee": "The employee has chosen not to show the answer yet",
            "question": "Question"
        },
        "processBarStep": {
            "sendReminderEmail": "Send reminder"
        },
        "progressMeterComponent": {
            "of": "of",
            "step": "step"
        },
        "prompts": {
            "customerInformationPrompt": {
                "customerPackage": "Customer package",
                "description": "We need to know if these settings are still up to date.",
                "newSettings": "Semiannual settings check up!",
                "updateCustomerSettings": "Update customer settings!"
            },
            "later": "Fill in later",
            "save": "Accept"
        },
        "questionTemplateList": {
            "addQuestion": "Add question",
            "addQuestionTemplate": "Create question template",
            "create": "Create",
            "deleteQuestion": "Are you sure that you want to delete the question?",
            "deleteQuestionTemplate": "Delete question template",
            "description": "Description",
            "enterDescription": "Enter description",
            "enterName": "Enter name",
            "enterQuestion": "Enter question",
            "enterTitle": "Enter title",
            "name": "Name",
            "newName": "New name",
            "noData": "There are no question templates created",
            "numberOfQuestions": "Questions",
            "overview": "Overview",
            "question": "Question",
            "questionTemplate": "Question template",
            "questions": "Questions",
            "title": "Title"
        },
        "roleAccessSettings": {
            "description": "Here you can manage which roles that have access to Sysarb and a summary of what each role has access to.",
            "employeeDesc1": "Access to their own employee portal.",
            "employeeDesc2": "Can view and update their own personal data.",
            "managerDeputyDesc1": "Only access to data based on assigned organization unit.",
            "managerDeputyDesc2": "Access to manager dashboard and their employees' employee portals.",
            "managerDesc1": "Only access to data based on assigned organization unit.",
            "managerDesc2": "Access to manager dashboard and their employees' employee portals.",
            "mutationError": "Something went wrong while updating this role. Please try again.",
            "operationalAdministratorDesc1": "Only access to data based on assigned organization unit and all underlying units.",
            "operationalAdministratorDesc2": "Access to shared pay equity audits.",
            "queryError": "Something went wrong while loading role access settings. Please try again later.",
            "readOnlyDesc1": "Read-only access to data based on assigned organization unit.",
            "readOnlyDesc2": "Cannot make any changes to data.",
            "salarySurveyAnalystDesc1": "Access to pay equity audits based on assigned organization unit.",
            "salarySurveyAnalystDesc2": "Only access to data based on assigned organization unit and all underlying units.",
            "sectionManagerDesc1": "Only access to data based on assigned organization unit and all underlying units.",
            "sectionManagerDesc2": "Access to managers' dashboards and their employees' employee portals based on the organization unit.",
            "title": "Which roles should have access to Sysarb?",
            "unionDesc1": "Access to pay equity audit data relevant to the union.",
            "unionDesc2": "Can review pay equity audits and related reports."
        },
        "salary": {
            "approveSalary": "Approve salary",
            "attestationWarning": "The salary has been changed since you last attestation, please make a new attest.",
            "createSalaryReviewToSeeNewSalary": "The new salary will be shown once the employee is included in a salary review.",
            "current": "Current",
            "new": "New",
            "salary": "Salary",
            "salaryApproved": "Salary approved",
            "salaryExchange": "Salary exchange",
            "salaryIncrement": "Salary Increment",
            "salaryNotShown": "Your manager has chosen not to show your salary at this time.",
            "salaryReviewMissing": "Salary review missing.",
            "total": "Total"
        },
        "salaryBreakdown": {
            "benifitsInKind": "Benefits in kind",
            "carAllowance": "Car allowance",
            "hourlySalary": "Hourly salary",
            "longTermIncentive": "Long-term incentive",
            "occupationalPension": "Occupational pension",
            "oneTimeBonus": "One time bonus",
            "overtime": "Overtime",
            "paidHoliday": "Paid holidays",
            "salary": "Base salary",
            "salaryIncrement": {
                "1": "Salary Increment 1",
                "2": "Salary Increment 2",
                "3": "Salary Increment 3"
            },
            "shortTermIncentive": "Short-term incentive",
            "unknown": "Unknown"
        },
        "salaryCriteria": {
            "assessmentHelp": "Assessment help",
            "choose": "- Choose -",
            "description": "Description",
            "finished": "Finished",
            "markAsDone": "Mark as done",
            "noActiveSalaryReview": "There is no salary review activated for the current year.",
            "noSalaryCriteria": "There are no assessment criteria for the current year",
            "salaryCriteria": "Salary Criteria",
            "salaryCritieraLevels": "Criteria",
            "todo": "(Todo)"
        },
        "salaryCriteriaLevel": {
            "verifyDelete": "Are you sure that you want to delete the salary criteria level?"
        },
        "salaryCriteriaList": {
            "addLevel": "Create level",
            "chooseOrganisationNode": "Choose organisation node...",
            "chooseWork": "Choose work...",
            "createError": "Failed to create \"{item}\"!",
            "creatingLevel": "(creating level...)",
            "criteria": "Salary criteria",
            "deleteCriteria": "Delete salary criteria",
            "deleteError": "Failed to remove \"{item}\"!",
            "description": "Description",
            "helptext": "Helptext",
            "level": "Level",
            "levels": "Levels",
            "levelsWillAlsoBeRemoved": "This will also remove all levels that are connected to the salary criteria.",
            "name": "Name",
            "noHelptext": "Level help texts are missing",
            "organisation": "Organisation",
            "organisationNode": "Organisation node",
            "overview": "Overview",
            "removingLevel": "(removing level...)",
            "specificCriterias": "Specific criteria",
            "updateError": "Failed to update \"{item}\"!",
            "useSpecificCriteria": "Use specific criteria",
            "value": "Value",
            "verifyDelete": "Are you sure that you want to delete the salary criteria?",
            "work": "Work"
        },
        "salaryCriteriaTemplateList": {
            "addCriteria": "Create salary criteria",
            "addSalaryCriteriaTemplate": "Create salary criteria template",
            "create": "Create",
            "createError": "Failed to create \"{item}\"!",
            "criteria": "Lönekriterie",
            "criterias": "Salary criteria",
            "description": "Description",
            "enterName": "Enter name",
            "excellent": "Excellent",
            "good": "Good",
            "name": "Name",
            "needsWork": "Needs work",
            "newName": "New name",
            "noData": "There are no salary critera tempaltes created",
            "overview": "Overview",
            "salaryCriteriaTemplate": "Salary criteria template",
            "specific": "Specific",
            "useSpecificCriteria": "Use specific criteria",
            "useSysarbStandardLevels": "Create Sysarbs standard levels",
            "veryGood": "Very good"
        },
        "salaryOverviewBox": {
            "female": "Female",
            "fullTimeEmployments": "full time employments",
            "male": "Male",
            "max": "Max",
            "mean": "Mean",
            "median": "Median",
            "min": "Min",
            "ninetiethPercentile": "90th salary percentile",
            "notDeclared": "Not declared",
            "partTimeEmployments": "part time employments",
            "salaryOverview": "Salaries, overview",
            "tenthPercentile": "10th salary percentile",
            "total": "Total"
        },
        "salaryRaiseWidgets": {
            "allocated": "Allocated",
            "individualBudgets": "Budgets",
            "leftToAllocate": "Left to allocate",
            "salaryRaiseOneBudget": "Salary lift 1",
            "salaryRaiseTwoBudget": "Salary lift 2",
            "totalBudget": "Total budget",
            "unnamedBudget": "Budget"
        },
        "salaryReview": {
            "budgetData": "Budget data",
            "errorDescription": "The salary review you are looking for is not available. Please try again later.",
            "errorHeading": "Something went wrong",
            "goToSalarySetting": "Go to salary review",
            "managerName": "Manager",
            "noArchived": "You haven't archived any salary reviews.",
            "noAuditsFoundMessage": "No salary review was found! Start by creating one.",
            "organisationName": "Organisation",
            "salaryData": "Salary data",
            "salaryReview": "Salary review",
            "totalBudget": "Total budget",
            "totalSpendFinished": "Distrubuted - Finished",
            "totalSpendNotFinished": "Distributed - Not finished",
            "unArchive": "Unarchive"
        },
        "salaryReviewAssessment": {
            "assessment": "Assessment",
            "assessmentHelp": "Assessment help",
            "description": "Description",
            "excludedFromSalaryReview": "Employee is excluded from assessments",
            "finished": "Done",
            "grouping": "Grouped by",
            "manager": "Manager",
            "name": "Name",
            "person": "Person",
            "salaryCriteria": "Salary criteria",
            "salaryCritieraLevels": "Criteria level",
            "salaryReviewAssessment": "Assessment",
            "valueMissing": "Value missing"
        },
        "salaryReviewAssessmentBox": {
            "assessmentBoxes": "Assessment boxes:",
            "noAssessmentData": "No assessment data found for this salary review",
            "salaryCriteriasOverview": "Salary criteria, overview"
        },
        "salaryReviewAssessmentCardHeader": {
            "completed": "Completed",
            "ongoing": "Ongoing"
        },
        "salaryReviewAssessmentCardTable": {
            "criteria": "Criteria",
            "manager": "Manager",
            "noCriteriaAdded": "No criteria have been added for this assessment.",
            "you": " (you)"
        },
        "salaryReviewBudget": {
            "addBudget": "Add budget",
            "amountOfCoworkers": "Amount of employees",
            "amountOfManagers": "Amount of managers",
            "amountOfOrgNodes": "{withEmploymentsCount} units with employees of {totalCount} total units",
            "appliesTo": "Applies to",
            "averageHoursWorked": "Average hours worked",
            "budget": "Budget",
            "budgetAverage": "Average working hours",
            "budgetDescription": "Comment",
            "budgetIndividualGuarantee": "Individual guarantee",
            "budgetName": "Budget name",
            "budgetPercentage": "Percent",
            "budgetPublishSuccess": "Budgets published successfully!",
            "budgetSalaryFieldInfo": "Which part of the salary do you want to use for budget calculation? (only applies for monthly salaries)",
            "budgetSalaryFieldInfoHeader": "Salaries contribution to budget",
            "budgetSalaryFieldInfoText": "Employees' contribution to the budget is based on their base or total salary.\nThis setting only affects employees with monthly or yearly salaries.",
            "budgetScopeInfo": "What do you want to base your calculations for your budget on?",
            "budgetScopeInfoHeader": "Contribution to budget",
            "budgetScopeInfoText": "Budgets are calculated by the contributions of each employees (percentage or fixed amount) or each unit (fixed amount regardless of the number of employees).",
            "budgetSettings": "Budget settings",
            "budgetStatusInfo": "How would you like to work with salary review?",
            "budgetStatusInfoHeader": "Work with budgets",
            "budgetStatusInfoText": "Decide whether you want to work with budgets in your salary set or allow managers to set salaries for their employees freely.",
            "budgetStyleInfo": "Do you want to divide your budget into multiple pots?",
            "budgetStyleInfoHeader": "Multiple pots",
            "budgetStyleInfoText": "You can divide your budget into two separate pots. \nIt's most commonly used for initiatives or the application of minimum salaries.",
            "budgetType": "Type of salary raise",
            "budgetUnpublishSuccess": "Budgets unpublished successfully!",
            "budgetValue": "Currency",
            "budgetsArePublished": "Your budgets are published",
            "calculatedBudget": "Calculated budget for each unit",
            "calculatedHourlyBudget": "Calculated hourly budget",
            "calculatedMonthlyBudget": "Calculated monthly budget",
            "calculatedYearlyBudget": "Calculated yearly budget",
            "calculation": "Calculation",
            "comment": "My comment",
            "companyPlaceholder": "Your organization",
            "contractedHours": "Contracted hours",
            "coworkers": "Employees",
            "createBudgets": "Create budgets",
            "createdBudgets": "Your created budgets",
            "cumulativeWorkHours": "Cumulative working hours",
            "deleteConfirmationInfo": "You cannot restore the budget once you have deleted it. \nAre you sure you want to remove the budget?",
            "deleteConfirmationTitle": "Delete budget",
            "employees": "Employees",
            "employeesTooltip": "How many of your employees have been included in a budget",
            "enterTitle": "Enter title",
            "everyManager": "Each manager",
            "inactiveBudgetHeader": "You have choosen to not create budgets",
            "inactiveBudgetMessage": "Click on \"Publish\" when it's time for managers to start setting salaries. If you want to create budgets, update your budget settings",
            "increaseValue": "Salary increase for each employee { budgetType }",
            "increaseValueOrg": "Salary increase for each unit ({ budgetType })",
            "legacyCalculate": "Calculation",
            "legacySelection": "Selection",
            "mailButtonLinkPublished": "Start setting salaries",
            "mailDefaultContentPublished": "Hi {name}!<br /><br />{company} have started this year's salary setting, and it is now time for you to log into Sysarb and set your employee's salaries. You can log into Sysarb by clicking the button below.<br /><br />Good luck!",
            "mailDefaultContentUnpublished": "Hi {name}!<br /><br />Salary reviews have been temporarily hidden due to the need to modify the budget. Do not worry, though! The salaries you have set will be saved, and you can view and edit them once the salary setting has been republished.<br /><br />You will get another email when it is time to log in again and continue with the salary setting.<br /><br />Hope you have an amazing day!",
            "mailInviteTitlePublished": "The salary review has been published",
            "mailInviteTitleUnpublished": "The salary review has been unpublished",
            "mailSendout": "Email sendout",
            "manager": "Manager",
            "managerComment": "Manager comment",
            "managers": "Managers",
            "managersTooltip": "How many of your managers have been included in a budget",
            "markAsDone": "Mark as done",
            "markAsUndone": "Unlock for editing",
            "maxSalary": "Max salary (valuta)",
            "minSalary": "Min salary (currency)",
            "no": "No",
            "noBudgets": "Manager sets budget",
            "noOfEmployments": "Number of employments",
            "organisation": "Organisation",
            "organisationNodes": "Team",
            "organisationNodesTooltip": "Number of teams that have been included in a budget",
            "ourSPData": "Our SP data",
            "percent": "Salary raise (%)",
            "publish": "Publish salary review",
            "publishBudget": "Publish budget",
            "publishError": "Publish attempt failed. Please try again! \n If the problem persists please contact customer success",
            "publishMessage": "Include your own message in the email",
            "publishOption": "To whom do you want to publish the performance review?",
            "publishTo": "You will publish to:",
            "publishing": "Publishing...",
            "salary": "Base salary",
            "salaryRaiseColumn": "Locked to salary lift",
            "salaryRaiseOne": "Raise 1",
            "salaryRaiseTwo": "Raise 2",
            "salaryRange": "Salary range (currency) ",
            "saveBudgetSettings": "Save budget settings",
            "sectionManagerComment": "Section manager comment",
            "settingsError": "Something went wrong while trying to save budget settings. Please try again.",
            "settingsSaved": "Budget settings have been saved!",
            "singlePot": "Single salary pot",
            "startPreparingBudget": "Start preparing your budget",
            "status": "Status",
            "stepCalculate": "3. Calculate your budget ( {budgetValue} {currency} )",
            "stepGeneral": "1. General",
            "stepSelection": "2. Selection ( {employmentCount} )",
            "totalBudget": "Total budget (currency)",
            "totalCalculatedBudget": "Total calculated budget",
            "totalCalculatedBudgetTooltip": "The total sum for the budget",
            "totalGroupSalary": "Total salary for the group",
            "totalRaiseOne": "Total budget raise 1",
            "totalRaiseTwo": "Total budget raise 2",
            "totalSalary": "Total salary",
            "twoPots": "Two salary pots",
            "type": "Type",
            "unPublish": "Unpublish salary review",
            "unPublishMessage": "Unpublishing budgets will temporarily hide the salary review for managers. Managers’ work will be saved but cannot view or edit it. We recommend you edit the budgets without unpublishing if you want to make minor adjustments",
            "unPublishTo": "You will unpublish to:",
            "unionComment": "Union comment",
            "units": "Units",
            "unpublishWarning": "When you edit the budget, it will automatically update the available pots for the managers. Are you sure you want to unlock the budget for editing?",
            "value": "Salary raise (currency)"
        },
        "salaryReviewCriterias": {
            "assessmentHelpText": "Assessment help",
            "budgetPublishSuccess": "Performance assessment has been published!",
            "budgetUnpublishSuccess": "Performance assessment has been published!",
            "compareCoworkers": "Compare employees' performances with different salary criteria.",
            "coworkers": "Managers and employees",
            "deleteCriteriaConfirmationInfo": "Are you sure you want to delete the salary criteria?",
            "deleteCriteriaConfirmationTitle": "Delete salary criteria",
            "deleteCriteriaValueConfirmationInfo": "Are you sure you want to delete the assessment level?",
            "deleteCriteriaValueConfirmationTitle": "Delete asssessment level",
            "deleteGrade": "Delete grade",
            "description": "Description",
            "emptyMessage": "You haven't created any result intervals",
            "end": "End %",
            "errorUpdatingOrganisationNodes": "Unable to update selection because an assessment has already been completed on one of your nodes. Please clear the existing assessments and try again.",
            "general": "General",
            "grades": "Assessment levels",
            "import": "Import",
            "importCriterias": "Import salary criterias",
            "importing": "Importing salary criterias",
            "loadingCriterias": "Loading salary criterias",
            "mailButtonLinkPublished": "Start the performance review",
            "mailDefaultContentManagerAndEmployeePublished": "Hi {name}!<br /><br />{company} have started a performance review in Sysarb and it is now time for you to log into Sysarb and start with your performance review. You can log into Sysarb by clicking the button below.<br /><br />Good luck!",
            "mailDefaultContentManagerPublished": "Hi {name}!<br /><br />{company} have started a performance review in Sysarb and it is now time for you to log into Sysarb and start with your performance review. If you want your employees to do a selfassesment for comparison you can invite them inside Sysarb. You can log into Sysarb by clicking the button below.<br /><br />Good luck!",
            "mailDefaultContentPublished": "Hi {name}!<br />{company} has started a performance review and it is now time for you to log into Sysarb and get started with your performance review. If you want your employees to do a selfassesment for comparison you can invite them inside Sysarb. You can log into Sysarb by clicking the button below.<br /><br />Good luck!",
            "mailDefaultContentUnpublished": "Hi {name}!<br /><br />The performance review have been temporarily hidden due to the need for modifications on the salary criterias. Do not worry though! Your answers are saved and you will be able to view and edit them once the performance review have been republished.<br /><br />You will get another mail when it is time to log in again and continiue with the performance review.<br /><br />Hope you have an amazing day!",
            "mailInviteTitlePublished": "You have been invited to a performance review",
            "mailInviteTitleUnpublished": "The performance review has been unpublished",
            "mailSendout": "Email sendout",
            "managers": "Managers",
            "name": "Name",
            "newCriteria": "New salary criteria",
            "newGrade": "New assessment level",
            "newResultInterval": "New result interval",
            "noCriterias": "Salary criteria are used to evaluate a employee’s performance. Each criteria is divided into multiple assessment levels which rate how well they performed on a criteria. Get started by importing a template or create new criteria!",
            "noResultInterval": "Your employees' result from the performance review is recalculated to a percentage of their maximum score and placed within a result interval. With result intervals, you can:",
            "noTemplateSelected": "No template selected",
            "organisationNode": "Apply on a select few organisation nodes",
            "publish": "Publish performance review",
            "publishError": "Something went wrong while publishing the performance assessment. Please try again.",
            "publishMessage": "Include your own message in the email",
            "publishTo": "You will publish to:",
            "publishing": "Publishing...",
            "recalculatePerformanceAssessment": "Recalculate assessments",
            "resultIntervals": "Result intervals",
            "salaryCriterias": "Your salary criterias",
            "salaryCriteriasArePublishedWarning": "The salary criterias are published. Any changes will affect all published performance reviews",
            "score": "Score",
            "seePerformance": "See performance in salary review for an affected manager.",
            "selectWork": "Apply on a select few jobs",
            "selection": "Selection",
            "specificOrganisationNodesUpdated": "Specific units selected successfully",
            "specificSelection": "Apply criteria only to specific units and jobs",
            "specificWorkUpdated": "Specific work selected successfully!",
            "start": "Start %",
            "unPublish": "Unpublish performance review",
            "unPublishMessage": "Unpublishing salary criterias will temporarily hide the performance review for managers and employees. Managers’ and employees’ work will be saved but they will not be able to view or edit their work. If you want to make minor adjustments we instead recommend you to edit the criterias without unpublishing",
            "unPublishTo": "You will unpublish to:",
            "updateOrganisationNodes": "Select specific units",
            "updateWorks": "Select specific jobs"
        },
        "salaryReviewFilterRow": {
            "chosen": "Chosen",
            "filter": "Filter",
            "performance": "Performance",
            "position": "Position title",
            "salaryPriority": "Salary priority",
            "union": "Union",
            "valueMissing": "Value missing"
        },
        "salaryReviewHeader": {
            "IO": "IO",
            "IOoptions": {
                "employments": "Employments",
                "export": "Export",
                "import": "Import"
            },
            "activate": "Archived",
            "archive": "Archive",
            "archiveInfo": "Would you like to archive your salary review?",
            "budget": "Budget",
            "budgetCalculation": "Budget settings",
            "criterias": "Salary criteria",
            "delete": "Delete salary review",
            "deleteInfo": "If you delete the salary review, you will lose all your work in this salary set, as well as manager performance reviews and new salaries.",
            "deleting": "Deleting...",
            "general": "General",
            "hasBudgets": "You have budgets that are created. You must delete all budgets before you can change budget settings.",
            "identityNumber": "Identity number",
            "overview": "Overview",
            "publish": "Publish",
            "publishBudget": "Salary review",
            "publishPerformanceReview": "Performance review",
            "published": "Published",
            "result": "Result",
            "salarySetting": "Salary",
            "salarySettingsStarted": "You can't change the budget settings if the managers have already started setting reviews. You'll need to talk with managers who have set salaries to reset them.",
            "settings": "Settings",
            "syncjobActiveOnDeleteInfo": "You have an ongoing process related to this salary review. The process needs to be completed before you can delete the salary review.",
            "unArchive": "Unarchive",
            "unArchiveInfo": "Would you like to unarchive the salary review?",
            "union": "Union",
            "unionTemplate": "Union template",
            "unionsDeleted": "All union data on employees has been deleted.",
            "unionsDeletedError": "Something went wrong while trying to delete union data. Please try again or contact Customer Success.",
            "unionsImported": "Unions from file {filename} imported.",
            "unionsImportedError": "Something went wrong while importing the union file. Please check the file and try again.",
            "unpublish": "Unpublish",
            "unpublished": "Unpublished"
        },
        "salaryReviewMatchingCoworkers": {
            "add": "Add",
            "coworkerAdded": "Your modified selection has been saved. {importCount} employees has been added!",
            "coworkerReAdded": "You have re added {reAddedCount} employees",
            "errorOccured": "An error occurred when trying to add a employee, please close this window and try again. If the problem persists, contact Customer Success.",
            "ignoreCoworkers": "{count} employees has been added to the ignore list.",
            "infoText": "Here you can add employees that recently matched your salary criterias, most commonly due to an update in their employment.",
            "newlyMatched": "Newly matched employees",
            "removedCoworkersMessage": "You have removed {removedCount} employees. They have been moved to ignored employees.",
            "selectedCoworkersAmount": "{selected} selected out of {total} matched employees"
        },
        "salaryReviewOverview": {
            "add": "Add",
            "addError": "{count} employees were unable to be added to the salary set.",
            "addMatchingCoworkers": "now matches your selection criteria. Do you want to add them?",
            "addedCoworkers": "Imported employees",
            "addingEmployments": "Adding employees to salary review",
            "addingEmploymentsSuccess": "{count} employee added to the salary review. | {count} employees added to the salary review.",
            "additionalComments": "Additional comments",
            "amountOfPeople": "1 employee | {count} employees",
            "attestEmployees": "Attest {'|'} employee",
            "attestEmployeesTooltip": "How many employees have attested to their new salary",
            "attestManager": "Attest {'|'} Manager",
            "attestManagerTooltip": "How many employees have been attested by a manager",
            "attestSectionManager": "Attest {'|'} Department manager",
            "attestSectionManagerTooltip": "How many employees have been attested by a department manager",
            "attestUnion": "Attest {'|'} Union",
            "attestUnionTooltip": "How many employees have been attested by a member of the union",
            "attestation": "Attestation",
            "attestationTooltip": "The sum of all attestations done by each role",
            "betaInfo": "This module is still under development, click the button if you want to go back to the old pay review module.",
            "cannotExlude": "The salary review status is completed. It would be best if you revoked the finished salary review for this employee to exclude it from the salary review",
            "comment": "Add a comment",
            "commentInfo": "Use this field to add notes on why the employee has been excluded or any other special considerations. This field will be available to the employee's manager, department manager and union representative.",
            "completed": "Completed",
            "deleteError": "{count} employees were unable to be deleted from the salary review.",
            "deleteSuccess": "{count} employees deleted.",
            "employeeCompleted": "Employee completed",
            "employmentsCurrencyNotMatchingConversionInformation": "There are employees that do not match the currently selected currency conversion, sync all employees that have currencies that differ from the chosen main currency or select another currency conversion",
            "employmentsHasCurrencyNotIncludedInCurrencyConverterInformation": "Some employees have currencies not covered by the current conversion — add the missing conversions to include them in synchronization.",
            "errorFetchingEmployee": "An error occurred while getting the employee. Try refreshing the page. If the problem persists please reach out to customer success",
            "exclude": "Exclude",
            "excludeAssessment": "Exclude from performance review",
            "excludeInfo": "Excluding a employee will disable the option for the manager to set a new salary or review the performance of the coworker. However, the coworker will still contribute to the pot in budget calculations",
            "excludeSalarySettings": "Exclude from salary review",
            "excluded": "Excluded",
            "excludedFromSalarySetting": "This employee is excluded from salary review",
            "finishedManagers": "Finished managers",
            "finishedManagersTooltip": "How many employees your managers have reviewed",
            "finishedPerformanceReviews": "Finished performance reviews",
            "general": "General",
            "goToOldModule": "Go to old module",
            "ignore": "Ignore",
            "ignoredCoworkers": "Ignored employees",
            "inProgress": "In progress",
            "increaseOneSpent": "Increase 1 spent",
            "increaseTwoSpent": "Increase 2 spent",
            "manageSelectionCriteria": "Manage your selection criterias",
            "manageSelectionInfo ": "Here, you can change the filters for your selection, which we will use to check for newly matched employees and notify you about them.",
            "managerAndEmployeeCompleted": "Manager and employee completed",
            "managerCompleted": "Manager completed",
            "markAsDone": "Finished",
            "matchingCoworkers": "{currentCount} employees match out of {totalCount}",
            "matchingCoworkersAmount": "{coworkers} employees",
            "minimumIncrease": "Minimum new base salary",
            "modifySelection": "Modify selection",
            "newMatches": "New matches",
            "newSalary": "New salary",
            "newSalaryIncrement": "New salary increment",
            "newSalaryIncrementSecond": "New salary increment 2",
            "newSalaryIncrementThird": "New salary increment 3",
            "newTotalSalary": "New total salary",
            "notStarted": "Not started",
            "other": "Other",
            "overview": "Overview",
            "percentageRaise": "Salary increase (%)",
            "processTimedOut": "The process couldn't be completed. Please try again.",
            "reAddIgnored": "Manage ignored",
            "reAddInfoText": "Here, you can add employees who match your salary criteria that have been either ignored or removed from the salary review",
            "remainingBudget": "Remaining budget",
            "remainingBudgetTooltip": "What remains of the calculated budget",
            "removalSuccess": "Employees removed",
            "remove": "Remove",
            "removeDisabledTooltip": "Select employees in the list to remove",
            "removeEmployments": "Remove employees",
            "removeWarning": "Are you sure you want to remove {employments} from the current salary review?\n\nCompleted assessments or new salaries removed can't be restored.",
            "removingEmployments": "Removing employees",
            "review": "Review",
            "reviewedWorkers": "Reviewed employees",
            "salariesSet": "Salaries set",
            "salariesSetTooltip": "How many salaries the manager have set and marked as done",
            "salary": "Salary",
            "salaryHasAttestations": "This salary has been attested, if you choose to change the salary the attestations will be removed",
            "salaryLift": "Salary increase",
            "salaryRaiseOne": "Increase 1",
            "salaryRaiseTwo": "Increase 2",
            "search": "Search...",
            "selfAssessments": "Self assessments",
            "selfAssessmentsTooltip": "How many employees have reviewed their performance",
            "showLess": "Show less",
            "showMore": "Show more",
            "startAddingEmployments": "Starting import process",
            "startRemovingEmployments": "Starting removal process",
            "startingProcess": "Starting process",
            "startingSync": "Starting sync process",
            "sync": "Sync",
            "syncDisabled": "Sync disabled when salary setting has started",
            "syncEmployments": "Synchronizing employees",
            "syncError": "Syncing finished with {count} sync errors. Please check the employments synced fields.",
            "syncFailedToStart": "The sync process encountered an error. Refresh the page and try again.",
            "syncInfo": "Synchronize {syncCount} with data from the baseregistry.\nData before being synchronized cannot be restored.\n\nDo you want to synchronize?",
            "syncSucceeded": "{count} employees synchronized with the base registry.",
            "syncWithRegistry": "Sync with base registry",
            "syncing": "Syncing",
            "synk": "Synk",
            "synkDisabledTooltip": "Select employees in the list to sync",
            "tableTitle": "Employees",
            "undoMarkAsDone": "Revoke finished",
            "union": "Union",
            "unionAndMinSalaries": "Conditions for salary review",
            "unionMinSalariesDescription": "Here you set values in regards to your collective agreement and the union that represents the employee and their work",
            "userInformation": "User information",
            "work": "Work"
        },
        "salaryReviewResult": {
            "attest": "Attest",
            "attestation": "Attestation",
            "attested": "Attested",
            "averageHoursWorked": "Average hours worked",
            "averageSalary": "Average salary",
            "averageSalaryHourly": "Average salary (hourly)",
            "averageSalaryIncreasePercent": "Average salary increase",
            "contractedHours": "Contracted hours",
            "date": "Date",
            "download": "Download",
            "exportNewSalaryToExcel": "Export salary review",
            "exportNonChangedSalaries": "Exclude employees with no salary increase",
            "exportToExcel": "Export salary result",
            "finished": "Finished",
            "group": "Group",
            "highestSalary": "Highest salary",
            "highestSalaryHourly": "Highest salary (hourly)",
            "hourlySalaries": "Hourly salaries",
            "hourlySalary": "Hourly salary",
            "increaseVsPerformance": "Salary increase",
            "lowestSalary": "Lowest salary",
            "lowestSalaryHourly": "Lowest salary (hourly)",
            "medianSalary": "Median salary",
            "medianSalaryHourly": "Median salary (hourly)",
            "monthlySalaries": "Monthly salaries",
            "monthlySalary": "Monthly salary calculated on total salary",
            "negotiationRound": "Negotiation round",
            "newIncrement": "New salary increment 1",
            "newIncrementThird": "New salary increment 3",
            "newIncrementTwo": "New salary increment 2",
            "newSalaryExchange": "New salary exchange",
            "newTotalSalary": "New total salary",
            "newTotalSalaryOriginalCurrency": "New total salary (local)",
            "noGrade": "No grade",
            "noGroup": "No group",
            "notAttested": "Not attested",
            "notFinished": "Not finished",
            "overallResult": "Overall performance",
            "performance": "Performance",
            "performanceReview": "Performance review",
            "position": "Position title",
            "potContribution": "Pot contribution",
            "result": "Results",
            "results": "Results",
            "role": "Role",
            "salaries": "Salaries",
            "salary": "Salary",
            "salaryIncrease": "Salary increase",
            "salaryIncreaseAndPerformance": "Salary increase vs performance",
            "salaryIncreaseHourly": "Salary increase (hourly)",
            "salaryIncreaseMonthly": "Salary increase (monthly)",
            "salaryProgression": "Salary progression",
            "salaryRaise": "Salary raise",
            "salarySetting": "Salary review",
            "salaryType": "Salary type",
            "score": "Score",
            "sendNewSalariesError": "Something went wrong. Please refresh the page and try again.",
            "sendNewSalariesSuccess": "Your managers are now allowed to send salaries!",
            "sendSalaries": "Activate send salaries",
            "year": "Year"
        },
        "salarySet": {
            "actualSalary": "Actual salary",
            "addEmployments": "Add employees...",
            "adminComment": "HR comment",
            "attestSalaries": "Attest salaries",
            "attestation": "Attestation",
            "attestationNewSalaryBody": "After you attest the new salaries only administrators can change them, are you sure that you want to attest {numberOfSelectedEmployments} salaries?",
            "attestationNewSalaryHeader": "Attestation",
            "attestationWarning": "The salary has been changed since you last attestation, please make a new attest.",
            "autoDistributeSalaries": "Distribute salaries",
            "autoDistributeSalariesError": "Something went wrong, please try again, if the problem persists contact customer success.",
            "averageHoursWorked": "Average hours worked",
            "averageSalaryIncrease": "Average salary increase",
            "baseSalary": "Base salary",
            "basedOnPerformance": "Based on performance",
            "birthDate": "Date of birth",
            "budget": "Budget",
            "cannotAttestSalaries": "Cannot attest salaries because not all employees have recieved a salary that fulfills thier individual salary guarantee",
            "cannotMarkSalariesAsFinished": "Cannot mark salaries as finished because not all employees have recieved a salary that fulfills thier individual salary guarantee",
            "cannotMarkSalaryAsFinished": "Cannot mark salary as finished because the emploee has not recieved a salary that fulfills thier individual salary guarantee",
            "comment": "My comment",
            "contract": "Contract",
            "contractType": "Contract type",
            "contractedHours": "Contracted hours",
            "convertedSalariesText": "Salaries in this salary review have been converted to a standard currency. Click here to see the values used for the conversion.",
            "costCenter": "Cost center",
            "country": "Country",
            "currency": "Currency",
            "currencyWarning": "This employee's currency differs from the currency used in the salary review.",
            "current": "Current",
            "distribute": "Distribute",
            "distributeInvidualValue": "Individual amount",
            "distributePercentage": "Percent(%)",
            "distributeTotalValue": "Total amount",
            "distributionGroupContainsFinishedRows": "Your selection contains employments that are already marked as 'finished' for salary review",
            "distributionWarningText": "Are you sure that you want to replace {translation} on {numberOfSelectedEmployments} employees? The new salary increase value on the chosen employments will be set to {value}.",
            "employment": "Employment",
            "employmentRate": "Employment rate",
            "employments": "Employments",
            "employmentsWithNoRule": "Employments without rules",
            "ethnicity": "Ethnicity",
            "exportSummaryReport": "Export summary report",
            "female": "Female",
            "filter": "Filter",
            "finished": "Finished",
            "fullTimeSalary": "Fulltime salary",
            "gender": "Gender",
            "grouping": "Grouped by",
            "historicalSalary": "Historical salary",
            "hourlySalary": "Hourly salary",
            "hourlyShortCode": "/ph",
            "individualGaranteeBudget": "Individual guarantee",
            "individualGuaranteeSalaryRaise": "Individual guarantee",
            "individualGuaranteeSalaryRaiseOne": "Individual guarantee {'|'} Raise 1",
            "individualGuaranteeSalaryRaiseTwo": "Individual guarantee {'|'} Raise 2",
            "is": "is",
            "localNewMonthlySalary": "Local {'|'} New monthly salary",
            "localNewYearlySalary": "Local {'|'} New yearly salary",
            "mainLevel": "Main level",
            "male": "Male",
            "managerComment": "Manager comment",
            "markAllSalariesAsFinished": "Mark all salaries as finished",
            "markAllSalariesAsFinishedConfirm": "Are you sure that you want to mark all salaries as finished?",
            "markSalaryAsFinished": "Mark as finished",
            "message": "Message",
            "messagePlaceholder": "Add message",
            "minimumNewSalary": "Min new salary",
            "minimumNewSalaryCost": "Min new salary cost",
            "minimumPoints": "Minimum number of points",
            "mixedCurrencyWarning": "This salary review includes employees who have salaries in a currency that differs from the standard currency.",
            "mixedSalaries": "The diagram contains employees with both monthly and hourly salaries. In order to compare both salary types we have recalculated your employees' hourly salaries to monthly salaries.",
            "monthlySalary": "Montly salary",
            "name": "Name",
            "needToSetSalary": "You need to set a salary before you can see the groups salary increase",
            "new": "New",
            "newHourlySalary": "New hourly salary",
            "newSalary": "New base salary",
            "newSalaryExchange": "New salary exchange",
            "newSalaryIncrement": "New salary increment",
            "newSalaryIncrementSecond": "New salary increment 2",
            "newSalaryIncrementThird": "New salary increment 3",
            "newTotalSalary": "New total salary",
            "newTotalYearlySalary": "New total yearly salary",
            "noEmploymentInSalaryReview": "There are no employments in the selected salary review for your manager role",
            "noHistoricalSalary": "No historical salary data available for this employee",
            "noSalaryReview": "There are no salary reviews for your manager role",
            "noSalarySetting": "Not required",
            "none": "None",
            "notDeclared": "Not declared",
            "numberOfEmployeesSelected": "no employees selected | 1 employee selected | {count} employees selected",
            "organisation": "Organisation",
            "organisationLevels": "organisation levels",
            "overview": "Overview",
            "percentOfTotalSalary": "% of their total salary",
            "percentageRaise": "Salary increase (%)",
            "performance": "Performance",
            "position": "Position title",
            "resultPercentage": "Result",
            "salary": "Salary",
            "salaryExchange": "Salary exchange",
            "salaryIncrease": "Salary increase",
            "salaryIncrement": "Salary increment",
            "salaryIncrementLocal": "Current salary increment",
            "salaryIncrementSecond": "Salary increment 2",
            "salaryIncrementThird": "Salary increment 3",
            "salaryInfo": "Salary info",
            "salaryLift": "Salary increase",
            "salaryLocal": "Current salary",
            "salaryPriority": "Salary priority",
            "salaryRaiseOne": "Salary raise 1",
            "salaryRaiseTwo": "Salary raise 2",
            "salarySetting": "Salary review",
            "salaryWord": "Fulltime/monthly salary",
            "salaryYear": "Salary year",
            "sectionManageComment": "Section Manager Comment",
            "sectionManagerComment": "Section Manager Comment",
            "selectAll": "- All -",
            "send": "Send",
            "sendNewSalaries": "Send out new salaries",
            "sendNewSalariesBody": "Choose the employees you want to send out the information to. Then press send.",
            "sendNewSalariesHeader": "Send information to employees about the new salary",
            "sender": "Sender",
            "senderPlaceholder": "Add sender",
            "showAverageIncrease": "Show average",
            "socialSecurityNumber": "Unique-ID",
            "status": "Status",
            "statuses": {
                "finished": "Finished",
                "notStarted": "Not started",
                "started": "Started"
            },
            "subLevel": "Sublevel",
            "title": "Title",
            "titlePlaceholder": "Add title",
            "total": "Total",
            "totalSalary": "Total salary",
            "totalSalaryIncrease": "Total",
            "totalSalaryIncrement": "Salary increments (sum)",
            "undoMarkAllSalariesAsFinished": "Undo marking salaries as finished",
            "undoMarkSalaryAsFinished": "Undo marking as finished",
            "union": "Union",
            "unionComment": "Union Comment",
            "unionSuggestedSalary": "Union suggested salary increase",
            "valueMissing": "Value missing",
            "warnings": "Warnings",
            "work": "Work",
            "yearlyPayouts": "Yearly payouts"
        },
        "salarySettingsComponent": {
            "activateGlobalOverview": "Use the global overview dashboard",
            "additional": "Additional",
            "additionalData": "Additional data",
            "additionalDataInfo": "Various customizable data fields that can capture unique or supplementary information relevant to your organization.",
            "allowAnalysisOfEthnicity": "Allow analysis of ethnicity",
            "benefitsInKind": "Benefits in kind",
            "benefitsInKindInfo": "A financial reward given to employees in addition to their regular salary.",
            "bonus": "Bonus",
            "bonusInfo": "A financial reward given to employees in addition to their regular salary.",
            "calculateFactorWeightFromMin": "Calculate factor weight from min value",
            "carAllowance": "Car allowance",
            "carAllowanceInfo": "When you use part of the employee's salary to pay for a car lease.",
            "customerLogotype": "Customer logo",
            "defaultCountry": "Default country",
            "defaultCurrency": "Default currency",
            "defaultSalaryType": "Default salary type",
            "defaultYearlyPayouts": "Number of yearly payouts",
            "factorPlan": "Factor plan",
            "internationalSettings": "International settings",
            "jobArchitecture": "Job architecture",
            "localJobArchitecture": "Local job architecture",
            "localJobArchitectureInfo": "Helps to align compensation with job structures within specific areas or job categories.",
            "longTermIncentive": "Long-term incentive",
            "longTermIncentiveInfo": "A bonus or reward granted based on performance over a longer period.",
            "none": "None",
            "oneTimeBonus": "One time bonus",
            "oneTimeBonusInfo": "A single, non-recurring payment.",
            "overtime": "Overtime",
            "overtimeInfo": "Overtime covers additional hours worked beyond the standard workweek, often compensated at a higher rate.",
            "paidHolidays": "Paid holidays",
            "paidHolidaysInfo": "Paid time off for employees used for vacation or similar. Calculated from base salary x no. of paid holidays.",
            "paidSickLeave": "Paid sick leave",
            "paidSickLeaveInfo": "Paid time off provided to employees when they are ill or need medical treatment. Relevant when the number of paid sick days differs between employees.",
            "parentalLeave": "Parental leave",
            "parentalLeaveInfo": "Paid time off provided to employees following the birth or adoption of a child.",
            "pension": "Pension",
            "pensionInfo": "The sum dedicated to the employee's retirement fund. It's typically calculated as a percentage from the base salary.",
            "salaryExchange": "Salary exchange",
            "salaryExchangeInfo": "An arrangement where employees can exchange a portion of their salary for other benefits.",
            "salaryIncrement": "Salary increment",
            "salaryIncrementInfo": "A non-defined additional salary component that can be freely used. Only numerical values are accepted.",
            "salaryIncrementSecond": "Salary increment 2",
            "salaryIncrementThird": "Salary increment 3",
            "salarySet": "Salary set",
            "salarySettings": "Salary",
            "salarySystem": "Salary system",
            "shortTermIncentive": "Short-term incentive",
            "shortTermIncentiveInfo": "A bonus or reward granted based on performance over a brief period.",
            "showRemainingAndTotalBudget": "Only show remaining sum in diagram",
            "svgLogotype": "SVG-logotype for reports and mail",
            "totalCompensation": "Total compensation",
            "totalCompensationInfo": "What values should be included in your employees' total compensations. The total compensation will be used for analysis and calculating metrics.",
            "totalSalary": "Total salary",
            "workHoursPerMonth": "Work hours per month"
        },
        "salaryStructureCharts": {
            "Employees": "Employees",
            "employmentYear": "Employment year",
            "newMonthlySalary": "New monthly salary",
            "newSalaryExchange": "New salary exchange",
            "newSalaryIncrease": "New salary increase",
            "newSalaryIncreaseSecond": "New salary increase 2",
            "newSalaryIncreaseThird": "New salary increase 3",
            "newSalaryPerformanceChart": "New salary/Performance",
            "position": "Position title",
            "salaryAgeChart": "Salary/Age",
            "salaryEmploymentLengthChart": "Salary/Employment length",
            "salaryPerformanceChart": "Salary/Performance",
            "work": "Work"
        },
        "salarySurveySummaryActionPlan": {
            "actionPlan": "Action plan",
            "actionPlanInfo": "Here, the costs of the measures identified in the analysis are reported. The figures show costs for individuals, jobs, and the total sum. Smaller measures should be implemented immediately, and more extensive measures should be implemented within three years. Gender equality work is essential because it positively affects productivity, job satisfaction, and the willingness to stay in the organization.",
            "amountOfMeasures": "No. of measures",
            "measuresIndividuals": "Measures for individuals",
            "measuresWorks": "Measures for jobs",
            "month": "mon",
            "total": "Total",
            "yearOne": "Year 1",
            "yearThree": "Year 3",
            "yearTwo": "Year 2"
        },
        "salarySurveySummaryInsights": {
            "age": "Age",
            "employmentTime": "Company tenure",
            "equalPayAudit": "Pay equity audit",
            "genderDistribution": "Gender distribution in the organization",
            "genderDistributionSalary": "Gender distribution based on salary level",
            "insights": "Insights on salary ratios",
            "insightsShort": "Insights",
            "men": "Men",
            "ourPayPhilosophy": "Our pay philosophy",
            "payGap": "Pay gap",
            "payGapDescription": "By June 2026, new legislation across Europe will mandate how organizations must work with and report on pay gaps. Any pay gap of 5% or more within equal or comparable roles will require explanation or corrective action. {Company}’s goal is to achieve pay equity by eliminating these gaps, striving for an adjusted pay gap of 0%.",
            "payGapInsights": "Insights about your pay gap",
            "payGapInsightsDescription": "A pay gap happens when men and women are paid differently. There are two different types of pay gaps, unadjusted- and adjusted pay gaps. The unadjusted pay gap is the difference between men's and women's salaries. Adjusted pay gap considers the pay factors to explain parts of the unadjusted pay gap. What can't be explained by the pay factors is the adjusted pay gap.",
            "payGapMean": "Pay gap {'|'} Mean",
            "payGapMedian": "Pay gap {'|'} Median",
            "payPhilosophyDescription": "{company} aims to set fair salaries that reflect our core values as an organization. A salary should never be affected by one's gender, ethnicity, religion or sexual orientation. However, what should affect one's salary is our pay factors. Factors that we can proudly communicate internally as well as externally to explain why one has a specific salary. Below you can see our pay factors:",
            "salaryLevels": "Salary levels in the organization",
            "salaryRatioDescription": "The gender pay gap is the difference between men's and women's salaries. Our goal is to eliminate the gender pay gap, that is, achieve a 0% pay gap. Under the upcoming Pay Transparency Directive from EU, pay gaps over 5% must be explained or addressed. \nThe numbers show how much more men earn than women based on mean and median salaries at {company}.",
            "salaryRatioInsights": "Insights on salary ratios",
            "timeInCurrentPosition": "Job tenure",
            "valuation": "Valuation",
            "women": "Women"
        },
        "securitySettingsComponent": {
            "acceptedFailedLoginAttempts": "Number of accepted failed login attempts",
            "acceptedFailedLoginAttemptsInfo": "How many times a user can fail to login before account is blocked.",
            "activate": "Activate",
            "activateBetaFeatures": "Activate beta features",
            "allowLoginViaBankID": "If you have employees in Sweden, you can allow them to login via their BankIDs. For it to work properly, all your employees needs to have their BankID fields filled with their social security numbers.",
            "allowUseOfAi": "Enable Ai features",
            "alphaFlagCustomerVisible": "This flag affects all users, not just support",
            "alphaFlags": "Alpha features",
            "approve": "Do you want to proceed?",
            "authenticationSecurity": "Authentication security",
            "betaFeatures": "Labs",
            "betaFlags": "Beta features",
            "blockReUse": "When the user makes a new password, we'll block the user from re-using their previous password.",
            "contactSupportToChange": "Contact support to change these values.",
            "copy": "Copy",
            "copySocialSecurityNo": "Copy social security number from employee to user",
            "copySocialSecurityNoHelptext": "This will copy the social security number from all your employees that have a connected user. This is done to be able to login with BankID. Before you do this make sure that all social security numbers are correct. To be able to proceed with this action please enter your username and then press proceed button.",
            "enterCorrectUsername": "You must enter the correct username",
            "enterUsername": "Enter username",
            "error": "Something went wrong!",
            "forcePasswordUpdate": "Force your users to update their password after a number of days.",
            "forgotPasswordLifespan": "Forgot passwork link lifespan (minutes)",
            "forgotPasswordLifespanInfo": "How many minutes a user can use the link to reset their password in “Forgot password” emails.",
            "invitationPasswordLifespan": "Welcome email link lifespan (days)",
            "invitationPasswordLifespanInfo": "How many days a user can use the link to create an account in Sysarb via the “Welcome email”.",
            "login": "BankID login",
            "lowerCaseLetter": "Lowercase letter",
            "numbers": "Numbers",
            "passwordComplexity": "Password complexity",
            "passwordDisableReuse": "Disable re-use of old password",
            "passwordHistoryLength": "Number of old passwords to remember",
            "passwordLifeSpan": "Password life span",
            "passwordLifeSpanDays": "Password life span (days)",
            "passwordLongevity": "Password longevity",
            "passwordMinLength": "Min password length",
            "passwordMustInclude": "Passwords must include:",
            "passwordMustIncludeLowerCase": "Contains a lowercase letter",
            "passwordMustIncludeNumbers": "Contains a number",
            "passwordMustIncludeSpecialCharacters": "Contains a special character (!{'@'}#...)",
            "passwordMustIncludeUpperCase": "Contains an uppercase letter",
            "passwordMustNotBeGuessable": "Not easy to be guessable",
            "securitySettings": "Security",
            "showPersonalData": "Show personal data",
            "showPersonalDataForUnion": "If this is activated the system will show name on all the employees for the union representative.",
            "specialCharacters": "Special characters (!{'@'}#...)",
            "ssoEnabled": "Single sign-on is enabled.",
            "ssoEnabledDescription": "When single sign-on is activated all login is handled by your IT department. Any changes to login requirements should be handled by them.",
            "systemSettings": "System and security",
            "unableToCopySocialSecurityNo": "Unknown error while copying social security number",
            "unionSettings": "Union",
            "upperCaseLetter": "Uppercase letter",
            "useBankIDAsDefaultLogin": "Use BankID as default login method for Swedish employees",
            "useBankIDAsDefaultLoginAllUsers": "Use BankID as default login (all users)",
            "username": "Username"
        },
        "selection": "Selection",
        "setPassword": {
            "confirmNewPassword": "Confirm new password",
            "goToLogin": "Go to login",
            "linkInvalid": "Link has expired. Please fill in the form below to request a new link via email.",
            "newPassword": "New password",
            "noMatch": "The passwords doesn't match.",
            "parametersNotValid": "The parameters are not valid.",
            "passwordNotSet": "You need to enter a password.",
            "setPassword": "Set password",
            "success": "Password updated successfully. Click the link below to go to the login page"
        },
        "settings": {
            "Appinfo": "App information",
            "acceptGradeInfo": "From your latest update you have {count} new grades. You need to confirm and determine their correct order before approving the changes. You can also delete old unused grades if needed.",
            "access": "Access to job architecture",
            "activateBeta": "Activate labs",
            "activateBetaInformation": "With labs activated, you’ll have access to our up-and-coming features that are currently under development 🚀🧪 Lab features apply across all your users and will be updated continuously, so expect updates from time to time. Be the first to share your feedback! ",
            "addGrade": "Add grade",
            "apiKeys": "API keys",
            "baseRegistry": "Base registry",
            "betaFeatures": "Labs",
            "betaInformation": "Try out our latest features while they are being tested 🧪 Lab features apply across all your users and you might experience bugs. Not all features stay, but most features will be officially released after a while. Be the first to share your feedback!",
            "betaNotActivated": "You haven’t activated labs yet",
            "cannotEditGradeInUse": "Grade is in use by a job profile and can't be edited.",
            "cantEditGradeTitle": "Can't edit title when the grade is used.",
            "copilot": "Copilot",
            "costCenter": "Cost center",
            "countrySettings": "Country settings",
            "currencyGroup": "Currency conversion",
            "customerInformation": "Customer information\t",
            "deActivateBetaFeatures": "Deactivate labs",
            "deleteCountrySettings": "Delete settings",
            "deleteCountrySettingsContent": "This can't be undone. If you add employees to this country or legal entity later, it will start with Sysarb's default settings, not necessarily the ones you have now.",
            "deleteCountrySettingsInUse": "You can't delete settings that are currently in use",
            "deleteGrade": "Delete grade",
            "deleteGradeConsequences": "The following will happen when you delete the grade:",
            "deleteGradeReasonGrade": "The grade will be deleted",
            "deleteGradeReasonPayRanges": "Any pay ranges created on the grade will be deleted",
            "developer": "Developer",
            "discussion": "Discussions",
            "employeePortal": "Employee portal",
            "empty": "We have no labs features currently but stay tuned for our new labs features coming soon 🔥.",
            "errorSavingGrades": "An error occurred while attempting to save changes",
            "exportAllJobFamilies": "All job families",
            "exportSelectedJobFamilies": "Selected job families",
            "featuresInDevelopment": "Features in development",
            "file": "Files",
            "flipOrder": "Reverse order",
            "friends": "Friends",
            "general": "General",
            "globalPEAsettings": "Pay equity audit settings",
            "gradeAbbrev": "Abbreviations",
            "gradeDescription": "Description",
            "gradeIsUsed": "Grade is in use by a job profile and can't be deleted.",
            "gradeNew": "New",
            "gradeNotAcceptedTooltip": "This new grade was recently imported from your file import or integration.",
            "gradeShortLabelTooltip": "Abbreviations are used to display career and grade together in a condensed format.",
            "gradeShortTitle": "Short grade",
            "gradeSortOrder": "Sort from easiest at the top to most complex at the bottom",
            "gradeTitle": "Grade",
            "gradeUsed": "Grade is in use by a job profile and cannot be deleted.",
            "grades": "Manage grades",
            "involveSettings": "Involve settings",
            "jobArchitecture": "Job architecture",
            "jobArchitectureAccessFullAccessInfo": "Access to data on all job profiles",
            "jobArchitectureAccessInfo": "Determine which roles should have access to the job architecture and the data each role is permitted to access.",
            "jobArchitectureAccessNoAccessInfo": "No access to the job architecture.",
            "jobArchitectureAccessNodeOnlyAccessInfo": "Users with this role now has access to all published data related to their own organization in the job architecture.",
            "jobArchitectureAccessToOrganisationData": "Access to job profiles related to the role's organisation/unit",
            "jobArchitecturehasAccessInfo": "Access to job architecture",
            "jobCluster": "Job cluster",
            "jobFamilies": "Job families",
            "jobFamilyHasJob": "Family connected to job profile",
            "jobFamilyHasJobInfo": "This family has job profiles associated to it. Change all job profiles with this family in the job architecture to unlock it.",
            "learnMore": "Learn more",
            "legalEntity": "Legal entity",
            "manageGradesInfo": "Configure how levels work in your job architecture. The order they are placed in determines how complex they are and will affect how your job architecture is visualised and what jobs are selected for the comparative job analysis.",
            "maxCharacters": "Max 3 characters",
            "newGrade": "Grade",
            "newShortGrade": "G",
            "noGradesHeading": "You have no grades",
            "payEquityAudit": "Pay equity audit",
            "recommended": "Recommended",
            "roleAccess": "Role access",
            "salary": "Salary",
            "salaryCriteria": "Salary criteria",
            "security": "Security",
            "shortGradeEmpty": "The auto-generated abbreviation wasn’t unique so we failed to add it.",
            "shortGradeErrorTooltip": "The short grade is invalid",
            "shortGradeUnableToAutogenerate": "We couldn’t auto-generate an unique abbreviation",
            "ssoSettings": "Single sign-on\t",
            "statisticalCode": "Statistical code\t",
            "successSavingGrades": "Changes have been saved",
            "system": "System",
            "templates": "Templates",
            "union": "Union",
            "unknownLegalEntity": "Unknown legal entity",
            "useExternalJobArchitecture": "Use external job architecture",
            "useSysarbJobArchitecture": "Use Sysarbs job architecture",
            "userProvisioning": "User provisioning (SCIM)",
            "whatJobArchitecture": "What type of job architecture do you use?",
            "work": "Work"
        },
        "singleSignOnSettings": {
            "acsUrl": "Assertion Consumer Service (ACS) URL",
            "activate": "Enable single sign-on",
            "certificate": "Certificate",
            "copyToClipboard": "Copy to clipboard",
            "directLink": "You can use the following link to log in directly",
            "downloadMetaData": "Download SP metadata",
            "enable": "Activate",
            "enableInfo": "Enable or disable SSO",
            "entityId": "Entity ID",
            "entryPoint": "Entry point",
            "multipleSettings": "Your system uses multiple SSO configurations.",
            "multipleSettingsWarning": "Contact Technical Support for help with the configuration",
            "option1": "Option 1. Upload your metadata into Sysarb.",
            "option1Our": "Option 1. Upload our SP metadata to your system.",
            "option2": "Option 2. Enter your metadata into Sysarb.",
            "option2Our": "Option 2. Enter our SP metadata to your system.",
            "title": "Single Sign-on",
            "unableToLoadSettings": "Unable to load SSO settings",
            "uploadError": "Error uploading file",
            "uploadMetaData": "Upload IdP metadata",
            "warning": "Enabling SSO with incomplete or wrong settings will block all users from logging in. Including you.",
            "warning2": "Make these settings in collaboration with your IT department.",
            "yourIdPData": "Your IdP data"
        },
        "standardAnalysisInfo": {
            "1": "Includes the comparative job analysis that allows you to analyse pay discrepancies between jobs of similar complexity",
            "2": "Includes the standard equal job analysis.",
            "3": "Compliant with EU Pay Transparency reporting."
        },
        "statisticalCodeList": {
            "addStatisticalCode": "Create statistical code",
            "alreadyInUse": "{value} is already in use, please select an other value.",
            "code": "Code",
            "create": "Create",
            "description": "Description",
            "enterCode": "Enter code",
            "enterDescription": "Enter description",
            "enterExample": "Enter example",
            "enterName": "Enter name",
            "example": "Example",
            "fileCouldNotBeImported": "File could not be imported",
            "fileIsEmpty": "File does not conatin any data",
            "fillOutFields": "You must enter values to the fields name and code",
            "importColumnOrder": "Column 1: Name, Column 2: Code, Column 3: Description, Column 4: Example",
            "importErrorSummary": "{count} row(s) could not be imported:",
            "importErrorsAndMore": "...and {count} more",
            "importFormatInfo": "Upload a CSV file with statistical codes. The file should use semicolon (;) as delimiter and include a header row.",
            "importPartialSuccess": "Imported {success} of {total} statistical codes",
            "importRowError": "Row {row}: {name} ({code})",
            "importSkipped": "{count} code(s) already exist and were skipped",
            "importStatisticalCodes": "Import statistical codes",
            "importSuccess": "Successfully imported {count} statistical codes",
            "importingProgress": "Importing {current} of {total}...",
            "name": "Name",
            "newCode": "New code",
            "newDescription": "New description",
            "newExample": "New example",
            "newName": "New name",
            "removeStatisticalCodeConfirmation": "There may be people connected to the selected statistical codes. If this is the case the connection will be lost. Are you sure that you wish to remove the selected statistical codes?",
            "removeStatisticalCodes": "Remove statistical codes",
            "rowMissingRequiredFields": "Row {row} is missing name and code",
            "statisticalCode": "Statistical code"
        },
        "suggestionMatch": {
            "inWork": "in work",
            "matches": "Matches",
            "matchingPosition": "Position title",
            "matchingStatisticalCode": "Statistical code",
            "positionMatchesWorkName": "Position title matches job title",
            "statisticalCodeMatchesWorkNo": "Statistical code matches job code"
        },
        "support": {
            "accountType": "Account type",
            "app": "Web application",
            "browser": "Browser",
            "browserVersion": "Browser version",
            "core": "Core",
            "data": "Data",
            "downlink": "Speed",
            "effectiveType": "Connection type",
            "fps": "Framerate",
            "isOnline": "Is online",
            "isSupported": "Is supported",
            "jsHeapSizeLimit": "Memory limit",
            "loginId": "Login ID",
            "network": "Network",
            "onlineAt": "Online since",
            "os": "Operating system",
            "role": "Role",
            "rtt": "Effective round-trip time",
            "saveData": "Data saver",
            "serverAddress": "Server address",
            "title": "Support information",
            "tokenValidUntil": "Token valid until",
            "totalJSHeapSize": "Allocated memory",
            "usedJSHeapSize": "Used memory",
            "userId": "User ID",
            "version": "Version"
        },
        "targetItem": {
            "deleteTarget": "Delete target",
            "notAllowedToDeleteLockedTargets": "You cannot delete a target locked by a manager",
            "notAllowedToDeleteManagerTargets": "You cannot delete a target created by a manager"
        },
        "tiptap": {
            "headingLevel1": "Heading 1",
            "headingLevel2": "Heading 2",
            "headingLevel3": "Heading 3",
            "linkText": "Link Text",
            "save": "save",
            "standard": "Standard"
        },
        "totalSalarySettings": {
            "includedFields": "Included fields:",
            "whatIsIncluded": "What's included in total salary",
            "whatIsIncludedInfo": "These salary settings were activated when the pay equity audit was created. They show which fields are included in your total salary."
        },
        "treeNodeFilter": {
            "noMatches": "No results for \"{query}\"",
            "noNodes": "No filters found",
            "search": "Search"
        },
        "treeNodeFilterNode": {
            "only": "Only"
        },
        "treeNodeSelect": {
            "noMatches": "No matches",
            "noNameOnNode": "Selected item has no name",
            "noSelection": "None selected",
            "onlyParent": "Only",
            "selectOption": "Select option"
        },
        "union": {
            "salarySetting": "Salary review"
        },
        "unionDashboard": {
            "noActiveSalaryReviews": "There are no active salary reviews available for the moment.",
            "oneOrMoreSalaryReviews": "To attest salaries for employees, please click on the menu to the left and select the salary review you want to review.",
            "welcome": "Welcome"
        },
        "unionList": {
            "addUnion": "Create union",
            "create": "Create",
            "enterName": "Enter name",
            "name": "Name",
            "newName": "New name",
            "noData": "There are no unions created",
            "showEmployeesNames": "Show employees' names to union representatives",
            "union": "Union",
            "yourUnions": "Your unions"
        },
        "unionSalarySet": {
            "adminComment": "HR comment",
            "attestSalaries": "Attest salaries",
            "attestation": "Attestation",
            "attestationNewSalaryBody": "After you attest the new salaries its not possible to remove the attestation. Are you sure that you want to attest all salaries?",
            "attestationWarning": "The salary has been changed since you last attestation, please make a new attest.",
            "attestations": "Attestations",
            "averageHoursWorked": "Average hours worked",
            "contractedHours": "Contracted hours",
            "costCenter": "Cost center",
            "country": "Country",
            "currency": "Currency",
            "employedHourly": "Employed hourly",
            "employedMonthly": "Employed monthly",
            "employees": "Employees",
            "employmentRate": "Employment rate",
            "employmentType": "Employment type",
            "excludedEmployees": "Excluded",
            "exportSummaryReport": "Export summary report",
            "female": "Female",
            "fileName": "Summary",
            "gender": "Gender",
            "hideFilters": "Hide filters",
            "hideSearch": "Hide search field",
            "hourlyShortCode": "/ph",
            "male": "Male",
            "managerComment": "Manager comment",
            "minimumNewSalary": "Min new salary",
            "minimumNewSalaryCost": "Min new salary cost",
            "name": "Name",
            "newSalary": "New base salary",
            "newSalaryExchange": "New salary exchange",
            "newSalaryIncrement": "New salary increment",
            "newSalaryIncrementSecond": "New salary increment 2",
            "newSalaryIncrementThird": "New salary increment 3",
            "newSalaryOriginalCurrency": "New salary (local)",
            "newTotalSalary": "New total salary",
            "noComment": "No comment",
            "noSalarySetting": "Not required",
            "notDeclared": "Not declared",
            "organisation": "Organisation",
            "percentageRaise": "Salary increase (%)",
            "performance": "Performance",
            "position": "Position title",
            "resultPercentage": "Result",
            "salary": "Salary",
            "salaryExchange": "Salary exchange",
            "salaryIncrement": "Salary increment",
            "salaryIncrementSecond": "Salary increment 2",
            "salaryIncrementThird": "Salary increment 3",
            "salaryLift": "Salary increase",
            "salaryLiftBudget": "Salary increase",
            "salaryLiftPercent": "Salary increase %",
            "salaryRaiseOne": "Salary raise 1",
            "salaryRaiseOneBudget": "Salary raise 1",
            "salaryRaiseTwo": "Salary raise 2",
            "salaryRaiseTwoBudget": "Salary raise 2",
            "salaryYear": "Salary year",
            "sectionManagerComment": "Section manager comment",
            "shouldSetSalary": "Should have new salary",
            "showFilter": "Show filters",
            "showSearch": "Show search field",
            "totalSalary": "Total salary",
            "totalSalaryIncrease": "Total salary increase",
            "totalSalaryIncreasePercent": "Total salary increase (%)",
            "unionSuggestedSalary": "Suggested salary increase",
            "work": "Work"
        },
        "unsavedChangesModal": {
            "content": "You have unsaved changes. If you leave this page, your changes will be lost.",
            "heading": "Unsaved Changes",
            "leavePage": "Leave page",
            "stayOnPage": "Stay on page"
        },
        "userForm": {
            "account": "Account",
            "changeRoleJunctionForUser": "Change role junction for user",
            "common": "Common",
            "createDefaultRoleJunctions": "Create default role junctions",
            "deleteUser": "Delete user",
            "forceNewPassword": "Force new password",
            "forgotPassword": "Send forgot password email",
            "importUsers": "Import users",
            "inviteNewUsers": "Invite new users",
            "notifications": "Notifications",
            "password": "Password",
            "rights": "Rights",
            "setPasswordFromUserInterface": "Set password",
            "updateEmailFromEmployment": "Update email from employment",
            "user": "User",
            "userLog": "User log"
        },
        "userGuide": {
            "chat": "Chat",
            "readFaq": "Read FAQ",
            "watchVideo": "Watch video"
        },
        "verifyEmail": {
            "continue": "Continue",
            "emailError": "Couldn't update the email address. Refresh the page and try again.",
            "noEmailSent": "Haven't got an email?",
            "noEmailSet": "You don't have an email saved. Enter and verify it to continue.",
            "parametersNotValid": "The parameters are not valid.",
            "resend": "Send new verification",
            "resent": "Resend...",
            "sendVerificationEmail": "Send verification email",
            "sendVerifyEmailDescription": "Please verify your email by clicking on the link sent to your inbox. This will confirm that you have access to the email address provided.",
            "sendVerifySuccess": "Verification email sent.",
            "success": "Your email has been verified!",
            "verifyEmail": "Verify email"
        },
        "welcomeToSysarb": {
            "descriptionOne": "We're happy that you're as passionate as we are about contributing to fairer workplaces. In Sysarb, you'll be able to analyze salary differences, set up your job architecture, and share these insights with your employees.",
            "descriptionTwo": "Before you can access all of our features, you need to import your data into Sysarb. You can import data easily via our file importer or through one of our many integration partners.",
            "importData": "Import data",
            "noAccessToActiveEmployments": "You don't have access to any active employment. Contact your system owner to help you set up your role if you need access to any active employments",
            "noDataImported": "Your administrator haven't imported any data into Sysarb. Until then, there's unfortunately not a lot you can do in Sysarb. Either contact your administrator for more information or come back another time.",
            "visitHelpCenter": "Visit our help center",
            "welcomeToSysarb": "Welcome to Sysarb"
        },
        "workButton": {
            "check": "Are you sure?",
            "missingName": "Missing name...",
            "move": "Move",
            "moveEmployees": "Move employees",
            "moveEmployeesToWork": "Do you want to move ({employeeCount}) employees to {workName}?"
        },
        "workList": {
            "addWork": "Create work",
            "create": "Create",
            "description": "Description",
            "enterDescription": "Enter a description of the work",
            "enterWorkName": "Enter work name",
            "enterWorkNo": "Enter work number",
            "name": "Name",
            "newWorkName": "New work name",
            "newWorkNo": "New work number",
            "removeWorks": "Remove jobs",
            "removeWorksConfirmation": "There can be employments connected to the selected jobs. If this is the case the connection will be lost. Are you sure that you wish to remove the selected jobs?",
            "removingWorks": "Removing jobs",
            "selectMapping": "You must choose a pay equity audit",
            "updateWorkFromMappingWork": "Update from pay equity audit",
            "updatingWorks": "Updating jobs",
            "work": "Work",
            "workNo": "Work number",
            "workNoAlreadyInUse": "{workNo} in use, please choose another"
        },
        "workTagsHelper": {
            "higher": "Higher",
            "lower": "Lower",
            "negative": "negative",
            "neutral": "neutral",
            "positive": "positive"
        }
    },
    "country": {
        "AFG": "Afghanistan",
        "AGO": "Angola",
        "AIA": "Anguilla",
        "ALA": "Åland Islands",
        "ALB": "Albania",
        "AND": "Andorra",
        "ARE": "United Arab Emirates",
        "ARG": "Argentina",
        "ARM": "Armenia",
        "ASM": "American Samoa",
        "ATA": "Antarctica",
        "ATF": "French Southern Territories",
        "ATG": "Antigua and Barbuda",
        "AUS": "Australia",
        "AUT": "Austria",
        "AZE": "Azerbaijan",
        "BDI": "Burundi",
        "BEL": "Belgium",
        "BEN": "Benin",
        "BES": "Bonaire, Sint Eustatius and Saba",
        "BFA": "Burkina Faso",
        "BGD": "Bangladesh",
        "BGR": "Bulgaria",
        "BHR": "Bahrain",
        "BHS": "Bahamas",
        "BIH": "Bosnia and Herzegovina",
        "BLM": "Saint Barthélemy",
        "BLR": "Belarus",
        "BLZ": "Belize",
        "BMU": "Bermuda",
        "BOL": "Bolivia (Plurinational State of)",
        "BRA": "Brazil",
        "BRB": "Barbados",
        "BRN": "Brunei Darussalam",
        "BTN": "Bhutan",
        "BVT": "Bouvet Island",
        "BWA": "Botswana",
        "CAF": "Central African Republic",
        "CAN": "Canada",
        "CCK": "Cocos (Keeling) Islands",
        "CHE": "Switzerland",
        "CHL": "Chile",
        "CHN": "China",
        "CIV": "Côte d'Ivoire",
        "CMR": "Cameroon",
        "COD": "Congo, Democratic Republic of the",
        "COG": "Congo",
        "COK": "Cook Islands",
        "COL": "Colombia",
        "COM": "Comoros",
        "CPV": "Cabo Verde",
        "CRI": "Costa Rica",
        "CUB": "Cuba",
        "CUW": "Curaçao",
        "CXR": "Christmas Island",
        "CYM": "Cayman Islands",
        "CYP": "Cyprus",
        "CZE": "Czechia",
        "DEU": "Germany",
        "DJI": "Djibouti",
        "DMA": "Dominica",
        "DNK": "Denmark",
        "DOM": "Dominican Republic",
        "DZA": "Algeria",
        "ECU": "Ecuador",
        "EGY": "Egypt",
        "ERI": "Eritrea",
        "ESH": "Western Sahara",
        "ESP": "Spain",
        "EST": "Estonia",
        "ETH": "Ethiopia",
        "FIN": "Finland",
        "FJI": "Fiji",
        "FLK": "Falkland Islands (Malvinas)",
        "FRA": "France",
        "FRO": "Faroe Islands",
        "FSM": "Micronesia (Federated States of)",
        "GAB": "Gabon",
        "GBR": "United Kingdom of Great Britain and Northern Ireland",
        "GEO": "Georgia",
        "GGY": "Guernsey",
        "GHA": "Ghana",
        "GIB": "Gibraltar",
        "GIN": "Guinea",
        "GLP": "Guadeloupe",
        "GMB": "Gambia",
        "GNB": "Guinea-Bissau",
        "GNQ": "Equatorial Guinea",
        "GRC": "Greece",
        "GRD": "Grenada",
        "GRL": "Greenland",
        "GTM": "Guatemala",
        "GUF": "French Guiana",
        "GUM": "Guam",
        "GUY": "Guyana",
        "HKG": "Hong Kong",
        "HMD": "Heard Island and McDonald Islands",
        "HND": "Honduras",
        "HRV": "Croatia",
        "HTI": "Haiti",
        "HUN": "Hungary",
        "IDN": "Indonesia",
        "IMN": "Isle of Man",
        "IND": "India",
        "IOT": "British Indian Ocean Territory",
        "IRL": "Ireland",
        "IRN": "Iran (Islamic Republic of)",
        "IRQ": "Iraq",
        "ISL": "Iceland",
        "ISR": "Israel",
        "ITA": "Italy",
        "JAM": "Jamaica",
        "JEY": "Jersey",
        "JOR": "Jordan",
        "JPN": "Japan",
        "KAZ": "Kazakhstan",
        "KEN": "Kenya",
        "KGZ": "Kyrgyzstan",
        "KHM": "Cambodia",
        "KIR": "Kiribati",
        "KNA": "Saint Kitts and Nevis",
        "KOR": "Korea, Republic of",
        "KWT": "Kuwait",
        "LAO": "Lao People's Democratic Republic",
        "LBN": "Lebanon",
        "LBR": "Liberia",
        "LBY": "Libya",
        "LCA": "Saint Lucia",
        "LIE": "Liechtenstein",
        "LKA": "Sri Lanka",
        "LSO": "Lesotho",
        "LTU": "Lithuania",
        "LUX": "Luxembourg",
        "LVA": "Latvia",
        "MAC": "Macao",
        "MAF": "Saint Martin (French part)",
        "MAR": "Morocco",
        "MCO": "Monaco",
        "MDA": "Moldova, Republic of",
        "MDG": "Madagascar",
        "MDV": "Maldives",
        "MEX": "Mexico",
        "MHL": "Marshall Islands",
        "MKD": "North Macedonia",
        "MLI": "Mali",
        "MLT": "Malta",
        "MMR": "Myanmar",
        "MNE": "Montenegro",
        "MNG": "Mongolia",
        "MNP": "Northern Mariana Islands",
        "MOZ": "Mozambique",
        "MRT": "Mauritania",
        "MSR": "Montserrat",
        "MTQ": "Martinique",
        "MUS": "Mauritius",
        "MWI": "Malawi",
        "MYS": "Malaysia",
        "MYT": "Mayotte",
        "NAM": "Namibia",
        "NCL": "New Caledonia",
        "NER": "Niger",
        "NFK": "Norfolk Island",
        "NGA": "Nigeria",
        "NIC": "Nicaragua",
        "NIU": "Niue",
        "NLD": "Netherlands, Kingdom of the",
        "NOR": "Norway",
        "NPL": "Nepal",
        "NRU": "Nauru",
        "NZL": "New Zealand",
        "OMN": "Oman",
        "PAK": "Pakistan",
        "PAN": "Panama",
        "PCN": "Pitcairn",
        "PER": "Peru",
        "PHL": "Philippines",
        "PLW": "Palau",
        "PNG": "Papua New Guinea",
        "POL": "Poland",
        "PRI": "Puerto Rico",
        "PRK": "Korea (Democratic People's Republic of)",
        "PRT": "Portugal",
        "PRY": "Paraguay",
        "PSE": "Palestine, State of",
        "PYF": "French Polynesia",
        "QAT": "Qatar",
        "REU": "Réunion",
        "ROU": "Romania",
        "RUS": "Russian Federation",
        "RWA": "Rwanda",
        "SAU": "Saudi Arabia",
        "SDN": "Sudan",
        "SEN": "Senegal",
        "SGP": "Singapore",
        "SGS": "South Georgia and the South Sandwich Islands",
        "SHN": "Saint Helena, Ascension and Tristan da Cunha",
        "SJM": "Svalbard and Jan Mayen",
        "SLB": "Solomon Islands",
        "SLE": "Sierra Leone",
        "SLV": "El Salvador",
        "SMR": "San Marino",
        "SOM": "Somalia",
        "SPM": "Saint Pierre and Miquelon",
        "SRB": "Serbia",
        "SSD": "South Sudan",
        "STP": "Sao Tome and Principe",
        "SUR": "Suriname",
        "SVK": "Slovakia",
        "SVN": "Slovenia",
        "SWE": "Sweden",
        "SWZ": "Eswatini",
        "SXM": "Sint Maarten (Dutch part)",
        "SYC": "Seychelles",
        "SYR": "Syrian Arab Republic",
        "TCA": "Turks and Caicos Islands",
        "TCD": "Chad",
        "TGO": "Togo",
        "THA": "Thailand",
        "TJK": "Tajikistan",
        "TKL": "Tokelau",
        "TKM": "Turkmenistan",
        "TLS": "Timor-Leste",
        "TON": "Tonga",
        "TTO": "Trinidad and Tobago",
        "TUN": "Tunisia",
        "TUR": "Türkiye",
        "TUV": "Tuvalu",
        "TWN": "Taiwan, Province of China",
        "TZA": "Tanzania, United Republic of",
        "UGA": "Uganda",
        "UKR": "Ukraine",
        "UMI": "United States Minor Outlying Islands",
        "URY": "Uruguay",
        "USA": "United States of America",
        "UZB": "Uzbekistan",
        "VAT": "Holy See",
        "VCT": "Saint Vincent and the Grenadines",
        "VEN": "Venezuela (Bolivarian Republic of)",
        "VGB": "Virgin Islands (British)",
        "VIR": "Virgin Islands (U.S.)",
        "VNM": "Viet Nam",
        "VUT": "Vanuatu",
        "WLF": "Wallis and Futuna",
        "WSM": "Samoa",
        "YEM": "Yemen",
        "ZAF": "South Africa",
        "ZMB": "Zambia",
        "ZWE": "Zimbabwe"
    },
    "dataSources": {
        "Employments": "Employee management",
        "Friends": "Friends",
        "MappingEmployments": "Pay equity audit",
        "MarketEmployments": "Market",
        "SalaryReviewEmployments": "Salary review"
    },
    "employmentStatus": {
        "active": "Active",
        "inActive": "Inactive"
    },
    "entities": {
        "employment": {
            "assessmentPercentage": "Performance",
            "employmentDate": "Employment date",
            "employmentTime": "Employment time",
            "employmentYear": "Employment year",
            "formOfEmployment": "Employment form",
            "newSalaryExchange": "New salary exchange",
            "newSalaryIncrement": "New salary increment",
            "newSalaryIncrementSecond": "New salary increment 2",
            "newTotalSalary": "New total salary",
            "position": "Position title",
            "salary": "Salary",
            "salaryExchange": "Salary exchange",
            "salaryIncrement": "Salary Increment",
            "salaryIncrementSecond": "Salary increment 2",
            "salaryYear": "Salary year",
            "totalSalary": "Total salary",
            "work": "Work"
        }
    },
    "entityErrorCodes": {
        "DOB-fd": "Birthdate can't be set in the future.",
        "EMAIL-ae": "Email address is already in use. Contact Customer Success if you need help.",
        "EMAIL-wf": "Please provide a correct email address.",
        "PIN-ae": "Identification number already in use",
        "SSN-ae": "Something went wrong, contact Customer Success if you need help.",
        "SSN-if": "Please provide a correct social security number between 10 and 12 digits.",
        "UN-ae": "Username is already in use. Please try another one."
    },
    "enums": {
        "gender": {
            "value": {
                "0": "Women",
                "1": "Men",
                "2": "Not declared",
                "null": "Unknown"
            }
        },
        "genderIdentity": {
            "value": {
                "0": "Female",
                "1": "Male",
                "2": "Not declared"
            }
        },
        "organizationalLevel": {
            "value": {
                "1": "Organization level 1",
                "2": "Organization level 2",
                "3": "Organization level 3",
                "4": "Organization level 4",
                "5": "Organization level 5",
                "6": "Organization level 6"
            }
        },
        "salaryIncrement": {
            "value": {
                "1": "Salary increment",
                "2": "Salary increment 2",
                "3": "Salary increment 3"
            }
        },
        "workTagState": {
            "value": {
                "1": "negative",
                "2": "neutral",
                "3": "positive"
            }
        }
    },
    "errors": {
        "errorCode": {
            "0": "An unknown error occurred while setting the password.",
            "1000": "You cannot login with single sign-on.",
            "1001": "You cannot login with username and password.",
            "1002": "It looks like we're having trouble with the connection. Please try again in a bit.",
            "18": "You don't have sufficient rights.",
            "19": "Wrong SMS code",
            "50": "Your password has expired.",
            "6": "Wrong username or password.",
            "70": "The password is too short.",
            "73": "The password must contain at least one lowercase letter.",
            "74": "The password must contain at least one uppercase letter.",
            "75": "The password must contain at least one digit.",
            "76": "The password must contain at least one special character.",
            "77": "The password can't contain your name or username.",
            "78": "The password is too easy to guess.",
            "79": "You can't reuse an old password.",
            "87": "A user is already set.",
            "99": "The user is not connected to the login service.",
            "unknown": "Unknown error"
        },
        "rights": {
            "noRightsToViewField": "Insufficient rights",
            "noSufficientRightsToEditField": "You do not have rights to edit this field."
        }
    },
    "field": {
        "grade": "Grade",
        "short_grade": "Short grade"
    },
    "fileExtensions": {
        "csv": ".csv",
        "json": ".json"
    },
    "gender": {
        "female": "Female | Females",
        "male": "Male | Males",
        "man": "Man | Men",
        "notDeclared": "Not declared",
        "woman": "Woman | Women"
    },
    "genders": {
        "enums": {
            "0": "Female | Women",
            "1": "Male | Men",
            "2": "Not declared",
            "null": "Unknown"
        },
        "female": "Female | Women | Women",
        "male": "Male | Men | Men",
        "notDeclared": "Not declared"
    },
    "glossary": {
        "active": "Active",
        "apply": "Apply",
        "categorial": "Categorial",
        "copied": "Copied!",
        "copy": "Copy",
        "current": "Current",
        "employee": "Employee",
        "employer": "Employer",
        "end": "End",
        "error": "Error",
        "female": "Female",
        "fields": {
            "additionalData": "Additional data",
            "averageHoursWorked": "Average hours worked",
            "baseSalary": "Base salary",
            "benefitsInKind": "Benefits in kind",
            "compaRatio": "Compa ratio",
            "companyCarAllowance": "Car allowance",
            "contract": "Contract",
            "contractType": "Contract type",
            "contractedHours": "Contracted hours",
            "costCenter": "Cost center",
            "country": "Country",
            "currency": "Currency",
            "dateOfBirth": "Date of birth",
            "email": "Email",
            "employmentEndDate": "Employment end date",
            "employmentNumber": "Employment number",
            "employmentRate": "Employment rate",
            "employmentTimeStartDate": "Company tenure start date",
            "ethnicity": "Ethnicity",
            "externalCareerBand": "External career band",
            "externalJobCode": "External job code",
            "externalJobFamily": "External job family",
            "externalJobProfile": "External job profile",
            "externalJobProfileLevel": "External job profile grade",
            "externalSubFamily": "External subfamily",
            "firstName": "First name",
            "formOfEmployment": "Form of employment",
            "fteWorkHoursPerMonth": "Full-time working hours per month",
            "gender": "Gender",
            "isManager": "Is manager",
            "jobTenure": "Job tenure",
            "jobTenureStartDate": "Job tenure start date",
            "jobTitle": "Job",
            "lastName": "Last name",
            "lastPayIncrease": "Last pay increase",
            "legalEntityCode": "Legal entity code",
            "legalEntityName": "Legal entity name",
            "locality": "Locality",
            "longTermIncentive": "Long-term incentive",
            "managerCode": "Manager code",
            "occupationalPension": "Occupational pension",
            "oneTimeBonus": "One time bonus",
            "organizationLevel": "Organization level",
            "overtime": "Overtime",
            "paidHolidayAllowance": "Paid holiday allowance",
            "paidSickDays": "Paid sick days",
            "parentalLeaveEndDate": "Parental leave end date",
            "parentalLeaveStartDate": "Parental leave start date",
            "performance": "Performance",
            "positionLevel": "Position level",
            "positionTitle": "Position title",
            "salaryDate": "Salary date",
            "salaryExchange": "Salary exchange",
            "salaryIncrement": "Salary increment",
            "salaryType": "Salary type",
            "salaryYear": "Salary year",
            "shortTermIncentive": "Short-term incentive",
            "statisticalCode": "Statistical code",
            "statutoryGrade": "Statutory grade",
            "targetBonus": "Target bonus",
            "totalSalary": "Total salary",
            "uniqueID": "Unique-ID",
            "unitNumber": "Unit number",
            "workNumber": "Work number",
            "workTitle": "Work",
            "yearlyPayouts": "Yearly payouts"
        },
        "grade": "Grade",
        "inactive": "Inactive",
        "index": {
            "1": "1.",
            "10": "10.",
            "2": "2.",
            "3": "3.",
            "4": "4.",
            "5": "5.",
            "6": "6.",
            "7": "7.",
            "8": "8.",
            "9": "9."
        },
        "male": "Male",
        "men": "Men",
        "midpoint": "Midpoint",
        "name": "Name",
        "new": "New",
        "no": "No",
        "notDeclared": "Not declared",
        "numerical": "Numerical",
        "payFactor": "Pay factor",
        "recommended": "Recommended",
        "required": "Required",
        "salary": "Salary",
        "standard": "Standard",
        "start": "Start",
        "uniqe": "Unique",
        "unsaved": "Unsaved",
        "women": "Women",
        "yes": "Yes"
    },
    "integrations": {
        "contactSupport": "Contact support",
        "noMapping": "No field",
        "sftp": {
            "errorId": {
                "1": {
                    "description": "Authentication failed. Please check that your login details are entered correctly.",
                    "footer": "",
                    "header": "Authentication failed"
                },
                "2": {
                    "description": "The integration cannot be reached at the moment. Try again or contact customer success.",
                    "footer": "",
                    "header": "No connection"
                },
                "3": {
                    "description": "There is no file on the server. Check that there is a file with the correct file name uploaded.",
                    "footer": "",
                    "header": "File is missing"
                },
                "4": {
                    "description": "We could not find a matching header in the sync. If you changed the name of a column, you need to restore the column to its original name.",
                    "footer": "Columns you need to correct:",
                    "header": "Could not load some headings"
                },
                "5": {
                    "description": "The salary file has an incorrect coding. We require UTF-8 format.",
                    "footer": "",
                    "header": "Corrupt payroll file"
                },
                "6": {
                    "description": "The salary file contains no data.",
                    "footer": "",
                    "header": "No data"
                },
                "7": {
                    "description": "Unknown error. Please contact customer success.",
                    "footer": "The following error has occurred:",
                    "header": "An unknown error has occurred"
                }
            }
        }
    },
    "jobFamilies": {
        "SY-1000": "Business Administration",
        "SY-1001": "Consulting (external)",
        "SY-1002": "Corporate Affairs",
        "SY-1003": "Customer Service",
        "SY-1004": "Culture",
        "SY-1005": "Education",
        "SY-1006": "Engineering",
        "SY-1007": "Finance",
        "SY-1009": "Health Care",
        "SY-1010": "Hospitality",
        "SY-1011": "Human Resources",
        "SY-1012": "Information Technology",
        "SY-1013": "Legal Services",
        "SY-1014": "Marketing",
        "SY-1015": "Media and Entertainment",
        "SY-1016": "Social care and services",
        "SY-1017": "Public Administration",
        "SY-1018": "Public Health / Safety",
        "SY-1019": "Public Transportation",
        "SY-1020": "Public Infrastructure and services",
        "SY-1021": "Production",
        "SY-1022": "Project Management",
        "SY-1023": "Quality Management",
        "SY-1024": "Real Estate / Facility Management",
        "SY-1025": "Research and Development",
        "SY-1026": "Retail",
        "SY-1027": "Retail Banking",
        "SY-1028": "Risk Management",
        "SY-1029": "Sales",
        "SY-1030": "Software Development",
        "SY-1031": "Supply Chain Management",
        "SY-1032": "Technicians / Skilled Trade",
        "SY-1034": "Tax",
        "SY-1035": "Risk",
        "SY-1036": "Fire",
        "SY-1037": "HVAC",
        "SY-1038": "Legal",
        "SY-1039": "Police",
        "SY-1040": "DevOps",
        "SY-1041": "Library",
        "SY-1042": "Medtech",
        "SY-1043": "Kitchen",
        "SY-1044": "Service",
        "SY-1045": "Payroll",
        "SY-1047": "Prisons",
        "SY-1048": "Rigging",
        "SY-1049": "Treasury",
        "SY-1050": "Catering",
        "SY-1051": "Operator",
        "SY-1052": "Carpentry",
        "SY-1053": "Plumbing",
        "SY-1054": "Physician",
        "SY-1056": "Storeroom",
        "SY-1057": "Logistics",
        "SY-1058": "Cementing",
        "SY-1060": "Accounting",
        "SY-1061": "Psychiatry",
        "SY-1063": "Compliance",
        "SY-1065": "Journalism",
        "SY-1066": "Publishing",
        "SY-1067": "Counseling",
        "SY-1068": "Gas / Heat",
        "SY-1069": "Geoscience",
        "SY-1070": "Metallurgy",
        "SY-1071": "Seismology",
        "SY-1072": "Electrical",
        "SY-1073": "Call Center",
        "SY-1075": "Dental care",
        "SY-1076": "IT Helpdesk",
        "SY-1077": "IT Security",
        "SY-1078": "Advertising",
        "SY-1079": "Video Games",
        "SY-1080": "Integration",
        "SY-1082": "Electricity",
        "SY-1083": "Maintenance",
        "SY-1084": "Store Sales",
        "SY-1086": "Warehousing",
        "SY-1089": "Architecture",
        "SY-1090": "Nursing care",
        "SY-1093": "Life Science",
        "SY-1094": "Locksmithing",
        "SY-1095": "Field Service",
        "SY-1096": "Web Analytics",
        "SY-1097": "Product-Owner",
        "SY-1099": "Museum Workers",
        "SY-1100": "Social Affairs",
        "SY-1101": "Animal Control",
        "SY-1102": "Sales Training",
        "SY-1103": "Data Scientist",
        "SY-1105": "IT Architecture",
        "SY-1107": "Market Research",
        "SY-1109": "Quality Control",
        "SY-1112": "Public Relations",
        "SY-1113": "Cultural Workers",
        "SY-1114": "Media Production",
        "SY-1115": "Railway Services",
        "SY-1116": "Waste Management",
        "SY-1117": "Quality Planning",
        "SY-1118": "Physical Science",
        "SY-1121": "Software Testing",
        "SY-1122": "Primary Education",
        "SY-1123": "IT Administration",
        "SY-1124": "Quality Assurance",
        "SY-1125": "Sales Engineering",
        "SY-1126": "UI/UX Development",
        "SY-1127": "Plating & Welding",
        "SY-1128": "Investor Relations",
        "SY-1129": "Regulatory Affairs",
        "SY-1130": "Product Management",
        "SY-1131": "Ambulance / Rescue",
        "SY-1132": "Airport Operations",
        "SY-1133": "Telecommunications",
        "SY-1136": "Telecommunications",
        "SY-1137": "Business Assistance",
        "SY-1138": "Business Consulting",
        "SY-1139": "Secondary Education",
        "SY-1140": "Health Care Support",
        "SY-1141": "HR Business Partner",
        "SY-1143": "Laboratory Services",
        "SY-1145": "Brickwork & Masonry",
        "SY-1147": "Software Customizing",
        "SY-1148": "Software Development",
        "SY-1149": "Government Relations",
        "SY-1150": "Culture / Art School",
        "SY-1151": "Education",
        "SY-1152": "Chemical Engineering",
        "SY-1153": "Biotech | Laboratory",
        "SY-1154": "Human Resources",
        "SY-1157": "Economic Development",
        "SY-1158": "Database Development",
        "SY-1159": "Software Development",
        "SY-1160": "Materials Management",
        "SY-1161": "Industrial Machinery",
        "SY-1162": "Technology Consulting",
        "SY-1163": "Software Architecture",
        "SY-1164": "Complaints Management",
        "SY-1165": "Aerospace Engineering",
        "SY-1168": "Agile- / Scrum-Master",
        "SY-1169": "IT Project Management",
        "SY-1170": "Safety and Compliance",
        "SY-1171": "Software Architecture",
        "SY-1172": "Automotive Engineering",
        "SY-1173": "Electrical Engineering",
        "SY-1174": "Industrial Engineering",
        "SY-1175": "Mechanical Engineering",
        "SY-1176": "Rehab and habilitation",
        "SY-1177": "Web Content Management",
        "SY-1181": "Key Account Management",
        "SY-1183": "Internal Communications",
        "SY-1184": "Electronics Engineering",
        "SY-1185": "Regulation & Inspection",
        "SY-1188": "Sales",
        "SY-1191": "Environmental Protection",
        "SY-1194": "Retail",
        "SY-1195": "Requirements Engineering",
        "SY-1196": "Purchasing / Procurement",
        "SY-1197": "Technical Product Support",
        "SY-1198": "Culture",
        "SY-1199": "Early Childhood Education",
        "SY-1200": "Environmental Engineering",
        "SY-1201": "Finance",
        "SY-1204": "Quality / Product Testing",
        "SY-1205": "Technical Customer Service",
        "SY-1206": "Event and Venue Management",
        "SY-1208": "Web design / Graphic-Design",
        "SY-1209": "Education",
        "SY-1211": "Marketing",
        "SY-1212": "Local Public Transportation",
        "SY-1215": "Production",
        "SY-1216": "Site Selection / Acquisition",
        "SY-1217": "Project Management (external)",
        "SY-1218": "Childcare | Education Support",
        "SY-1219": "Engineering | General",
        "SY-1220": "Health Care",
        "SY-1222": "Hospitality",
        "SY-1224": "Crisis Management and Planning",
        "SY-1225": "Materials Science and Research",
        "SY-1226": "Sales Support / Administration",
        "SY-1227": "Recruitment | Employer Branding",
        "SY-1228": "Civil / Construction Engineering",
        "SY-1229": "Controlling / Financial Analysis",
        "SY-1230": "Legal Services",
        "SY-1231": "Boilermaking / Fitting & Turning",
        "SY-1232": "Equality, Diversity and Inclusion",
        "SY-1233": "Production & Maintenance Planning",
        "SY-1234": "Risk Management",
        "SY-1235": "ERP Configuration / Customisation",
        "SY-1236": "Customer Service",
        "SY-1237": "Compensation | Benefits | Mobility",
        "SY-1241": "Corporate Affairs",
        "SY-1245": "Electro-Mechanical and Mechatronics",
        "SY-1248": "Project Management",
        "SY-1249": "Quality Management",
        "SY-1251": "Consulting (external)",
        "SY-1253": "Port Authorities and Maritime Services",
        "SY-1254": "Software Development | General",
        "SY-1256": "Information Technology",
        "SY-1257": "Business Administration",
        "SY-1258": "Media and Entertainment",
        "SY-1259": "Supply Chain Management",
        "SY-1260": "Research and Development",
        "SY-1263": "Real Estate / Facility Management",
        "SY-1542": "Health and Fitness",
        "SY-1543": "Administration",
        "SY-1544": "Folk High School",
        "SY-1545": "Special Education",
        "SY-1564": "Administration",
        "SY-1567": "Public Administration",
        "SY-1568": "Local Government Administration",
        "SY-1569": "Public Health / Safety",
        "SY-1570": "Public Transportation",
        "SY-1573": "Maintenance",
        "SY-1575": "Retail Banking",
        "SY-1576": "Social care and services",
        "SY-1577": "Administration",
        "SY-1579": "Transportation",
        "SY-1580": "Technicians / Skilled Trade",
        "SY-1581": "Heavy Equipment",
        "SY-1582": "Landscaping",
        "SY-1583": "Gardening",
        "SY-1584": "Agriculture",
        "SY-1586": "Branch Banking",
        "SY-1588": "Financial Planning & Investment Advisory Service",
        "SY-1589": "Lending & Leasing Operations",
        "SY-1600": "Public Infrastructure and services",
        "SY-1601": "Societal Development",
        "SY-1602": "Statistics | Analytics",
        "SY-1603": "Labour Market",
        "SY-1604": "Eldercare",
        "SY-1605": "Disability Care",
        "SY-1608": "Urban Planning",
        "SY-1609": "Inside Sales Representative",
        "SY-1610": "Field Sales Representative",
        "SY-1611": "Business Development",
        "SY-1612": "Housekeeping",
        "SY-1613": "Higher Education",
        "SY-1614": "Leisure",
        "SY-1615": "Quality",
        "SY-1616": "Risk and Security",
        "SY-1617": "Environment",
        "SY-1618": "Sustainability",
        "SY-1619": "Fraud",
        "SY-1620": "Private Banking",
        "SY-1621": "Investment Banking",
        "SY-1622": "Liquidity and Asset Management",
        "SY-1623": "Investment Banking",
        "SY-1624": "Capital Markets Services",
        "SY-1625": "Merges and Acquisitions",
        "SY-1626": "Securities Trading",
        "SY-1627": "Insurance",
        "SY-1628": "Underwriting",
        "SY-1629": "Insurance",
        "SY-1630": "Claim Services",
        "SY-1631": "Insurance Operations",
        "SY-1632": "Mechanic",
        "SY-1633": "Music Production",
        "SY-1634": "Artist & Repertoire (A&R)",
        "SY-1635": "Film & Television",
        "SY-1636": "Creativity | Art",
        "SY-1637": "Financial Services",
        "SY-1638": "Financial Services",
        "SY-1639": "Lending & Leasing Operations (B2C)",
        "SY-1640": "Financial Planning & Investment Advisory (B2B)",
        "SY-1641": "Business to Consumer Representatives",
        "SY-1642": "Business to Business Representatives",
        "SY-1643": "Lending & Leasing Operations (B2B)",
        "SY-1644": "Financial Planning & Investment Advisory (B2C)",
        "SY-1645": "Private Banking",
        "SY-1646": "Liquidity and Asset Management",
        "SY-1647": "Capital Markets Services",
        "SY-1648": "Merges and Aquisitions",
        "SY-1649": "Securities Trading",
        "SY-1650": "General Management",
        "SY-1651": "General Management",
        "SY-1652": "Corporate Development",
        "SY-1653": "Executive Management",
        "SY-1654": "General Project Management",
        "SY-1655": "Digital Marketing",
        "SY-1656": "DevOps and Cloud",
        "SY-1657": "IT Project Management",
        "SY-1658": "Network Engineering",
        "SY-1659": "Server Operations",
        "SY-1660": "Hardware Development",
        "SY-1661": "Talent Management",
        "SY-1662": "Religious and Civil Society",
        "SY-1663": "Religious and Civil Society",
        "SY-1664": "Pastoral Work",
        "SY-1665": "Diaconal Work",
        "SY-1666": "Church Music",
        "SY-1667": "Aid Work",
        "SY-1668": "Funeral Services",
        "SY-1669": "Energy",
        "SY-1670": "Logistics/Production",
        "SY-1671": "Research"
    },
    "keyValues": {
        "additionalDataOne": "Additional data 1",
        "additionalDataSecond": "Additional data 2",
        "additionalDataThird": "Additional data 3",
        "adjustedPayGap": "Adjusted pay gap",
        "age": "Age",
        "ageProblem": "Points | Age",
        "amount": "Amount",
        "analysisStatus": "Status",
        "averageAge": "Age {'|'} Average",
        "averageCompaRatio": "Average {'|'} Compa-ratio",
        "averageHoursWorked": "Average hours worked",
        "averageSalary": "Average {'|'} Base salary",
        "averageTotalSalary": "Average {'|'} Total Salary",
        "bonusActualBonus": "Short-term incentive",
        "bonusBenefitsInKind": "Benefits in kind",
        "bonusOneTimeBonus": "One time bonus",
        "bonusTargetBonus": "Target bonus",
        "cityLocality": "City/Locality",
        "comment": "Comment",
        "compaRatio": "Compa-ratio",
        "companyCarAllowance": "Car allowance",
        "companyTenure": "Company tenure",
        "companyTenureStartDate": "Company tenure start date",
        "contract": "Contract",
        "contractType": "Contract type",
        "contractedHours": "Contracted hours",
        "costCenter": "Cost center",
        "costYear1": "Cost year 1",
        "costYear2": "Cost year 2",
        "costYear3": "Cost year 3",
        "count": "Count",
        "countMen": "Count {'|'} Men",
        "countWomen": "Count {'|'} Women",
        "country": "Country",
        "currency": "Currency",
        "dateOfBirth": "Date of birth",
        "distanceFromPredictedSalary": "Distance from predicted salary",
        "distanceFromPredictedSalaryPercent": "Distance from predicted salary %",
        "distanceToMean": "Distance to mean",
        "email": "Email",
        "employmentDate": "Employment date",
        "employmentEndDate": "Company tenure end date",
        "employmentNumber": "Employment number",
        "employmentRate": "Employment rate",
        "employmentTime": "Company tenure",
        "employmentTimeProblem": "Points | Company tenure",
        "equalityTimer": "Equality Timer",
        "equity": "Long-term incentive",
        "ethnicity": "Ethnicity",
        "explanations": "Explanations",
        "femaleDominatedWork": "Female dominated work",
        "formOfEmployment": "Form of employment",
        "gender": "Gender",
        "genderRatio": "Women / Men",
        "groupSalaryIncrease": "Salary increase, group",
        "holidaysPaidHoliday": "Paid holiday",
        "holidaysPaidSickDays": "Paid sick days",
        "hourlySalary": "Hourly salary",
        "hourlySalaryOriginalCurrency": "Hourly salary (local)",
        "individualSalaryIncrease": "Salary increase, individual",
        "individualWorkValuation": "Individual work valuation",
        "isOutlier": "Is outlier",
        "jobFamily": "Job family",
        "jobProfile": "Job Profile",
        "jobTitle": "Job title",
        "lastPayIncrease": "Last pay increase",
        "legalEntity": "Legal entity",
        "legalEntityName": "Legal entity name",
        "localCurrency": "Local currency",
        "locality": "City",
        "longTermIncentive": "Long-term incentive",
        "managerCode": "Manager code",
        "managerName": "Manager",
        "maxCompaRatio": "Max {'|'} Compa-ratio",
        "maxSalary": "Max {'|'} Base salary",
        "maxTotalSalary": "Max {'|'} Total salary",
        "mean": "Mean",
        "meanCompaRatio": "Average {'|'} Compa-ratio",
        "meanCompaRatioMen": "Average {'|'} Compa-ratio men",
        "meanCompaRatioWomen": "Average {'|'} Compa-ratio women",
        "meanSalary": "Average {'|'} Base salary",
        "meanSalaryMen": "Average {'|'} Base salary men",
        "meanSalaryQouta": "Salary ratio (Average) {'|'} Base salary",
        "meanSalaryWomen": "Average {'|'} Base salary women",
        "meanTotalSalaryMen": "Average {'|'} Total salary men",
        "meanTotalSalaryQouta": "Salary ratio (Average) {'|'} Total salary",
        "meanTotalSalaryWomen": "Average {'|'} Total salary women",
        "meanYearsOfEmployment": "Average {'|'} Company tenure",
        "median": "Median",
        "medianCompaRatio": "Median {'|'} Compa-ratio",
        "medianSalary": "Median {'|'} Base salary",
        "medianSalaryQouta": "Salary ratio (Median) {'|'} Base salary",
        "medianTotalSalary": "Median {'|'} Total Salary",
        "medianTotalSalaryQouta": "Salary ratio (Median) {'|'} Total salary",
        "medianYearsOfEmployment": "Median {'|'} Company tenure",
        "minCompaRatio": "Min {'|'} Compa-ratio",
        "minSalary": "Min {'|'} Base salary",
        "minTotalSalary": "Min {'|'} Total salary",
        "minimumNewSalary": "New minimum salary",
        "name": "Name",
        "newHourlySalary": "New hourly salary",
        "newHourlySalaryOriginalCurrency": "New hourly salary (local)",
        "newSalary": "New salary",
        "newSalaryIncrement": "New Salary Increment",
        "newSalaryIncrementSecond": "New Salary Increment 2",
        "newSalaryIncrementThird": "New Salary Increment 3",
        "newSalaryOriginalCurrency": "New salary (local)",
        "newTotalSalary": "New total salary",
        "newTotalSalaryOriginalCurrency": "New total salary (local)",
        "occupationalClassification": "Occupational classification",
        "organisationNodeID": "Organisation node ID",
        "organisationNodeName": "Organization",
        "organization": "Organization",
        "organizationalLevel1": "Organization level 1",
        "organizationalLevel2": "Organization level 2",
        "organizationalLevel3": "Organization level 3",
        "organizationalLevel4": "Organization level 4",
        "organizationalLevel5": "Organization level 5",
        "organizationalLevel6": "Organization level 6",
        "originalCurrency": "Local currency",
        "outsidePayRange": "Outside payrange",
        "overtime": "Overtime",
        "parentalLeaveEndDate": "Parental leave end date",
        "parentalLeaveStartDate": "Parental leave start date",
        "payBand": "Pay band",
        "payGrade": "Pay grade",
        "pensionOccupationalPension": "Occupational pension",
        "percentMen": "Percent men",
        "percentWomen": "Percent women",
        "percentileCompaRatio10": "10th percentile {'|'} Compa-ratio",
        "percentileCompaRatio20": "20th percentile {'|'} Compa-ratio",
        "percentileCompaRatio80": "80th percentile {'|'} Compa-ratio",
        "percentileCompaRatio90": "90th percentile {'|'} Compa-ratio",
        "percentileSalary10": "10th salary percentile {'|'} Base salary",
        "percentileSalary20": "20th salary percentile {'|'} Base salary",
        "percentileSalary80": "80th salary percentile {'|'} Base salary",
        "percentileSalary90": "90th salary percentile {'|'} Base salary",
        "percentileTotalSalary10": "10th salary percentile {'|'} Total salary",
        "percentileTotalSalary20": "20th salary percentile {'|'} Total salary",
        "percentileTotalSalary80": "80th salary percentile {'|'} Total salary",
        "percentileTotalSalary90": "90th salary percentile {'|'} Total salary",
        "performance": "Performance",
        "performanceStatus": "Performance status",
        "personalIdentityNumber": "Unique-ID",
        "position": "Position title",
        "positionLevel": "Position level",
        "predictedSalary": "Predicted salary",
        "problemFactor": "Points | All",
        "salary": "Base salary",
        "salaryComponents": "Salary components",
        "salaryDate": "Salary date",
        "salaryExchange": "Salary exchange",
        "salaryFrozen": "Frozen salary",
        "salaryIncrement": "Salary Increment",
        "salaryIncrementSecond": "Salary increment 2",
        "salaryIncrementThird": "Salary increment 3",
        "salaryOriginalCurrency": "Salary (local)",
        "salaryProblem": "Points | Salary",
        "salaryQouta": "Salary ratio {'|'} Base salary",
        "salaryRelativeMean": "Average base salary (%)",
        "salaryRelativeMedian": "Median base salary (%)",
        "salarySettingStatus": "Salary review status",
        "salaryType": "Salary type",
        "salaryYear": "Salary year",
        "salaryreviewWorkName": "Salary review",
        "shortTermIncentive": "Short-term incentive",
        "socialSecurityNumber": "Unique-ID",
        "standardDeviation": "Standard deviation",
        "statisticalCode": "Statistical code",
        "statisticalCodeID": "Statistical code ID",
        "statisticalCodeName": "Statistical code name",
        "statutoryGrade": "Statutory grade",
        "timeInCurrentPosition": "Job tenure",
        "total": "Total",
        "totalCost": "Total cost",
        "totalSalary": "Total salary",
        "totalSalaryOriginalCurrency": "Total salary (local)",
        "totalSalaryQouta": "Salary ratio {'|'} Total salary",
        "totalSalaryRelativeMean": "Average total salary (%)",
        "totalSalaryRelativeMedian": "Median total salary (%)",
        "unAdjustedPayGap": "Unadjusted pay gap",
        "unadjustedPayGapSalary": "Unadjusted pay gap {'|'} Base salary",
        "unadjustedPayGapTotalSalary": "Unadjusted pay gap {'|'} Total salary",
        "union": "Union",
        "unionSuggestedSalary": "Union suggested salary increase",
        "work": "Work",
        "workName": "Job title",
        "workNo": "Work number",
        "yearlyPayouts": "Yearly payouts"
    },
    "legacyBudgetStatus": [
        "Not active",
        "Active",
        "Visible to the managers"
    ],
    "login": {
        "logout": "Logout",
        "switchInstance": "Switch instance",
        "welcomeMessage": "👋 Welcome {name}!",
        "welcomeMessageDescription": "Your HR department is actively working on setting everything up for you. Until then there isn’t much you can do in Sysarb."
    },
    "modelInsights": {
        "categoricalTerm": {
            "changesAdjustedPayGapBy": "Changes the adjusted pay gap by",
            "decreasesAdjustedPayGapBy": "Decreases adjusted pay gap by",
            "excluded": {
                "aliased": "This category is too closely correlated with another factor and its individual effect cannot be calculated.",
                "referenceCategory": "This is the reference category used as the baseline for comparing other categories in the analysis.",
                "singleGender": "This category only has employees of one gender and we can't calculate the effect on the adjusted pay gap nor its impact on employees' predicted salary."
            },
            "fulltime": {
                "false": "Part-time",
                "true": "Full-time"
            },
            "increasesAdjustedPayGapBy": "Increases adjusted pay gap by",
            "increasesGap": "{termName} increases the adjusted pay gap by {percentage}.",
            "missingData": "Missing data",
            "notSignificant": "{termName} does not have a statistically significant effect on the pay gap.",
            "reducesGap": "{termName} reduces the adjusted pay gap by {percentage}.",
            "representationShare": "Representation share",
            "representationShareTooltip": "The percentage of each gender that belongs to this category. For example, 33% means that 33% of all women in the audit work in this category.",
            "salaryEffect": "Men's salary increases by {menPct} while women's increase by {womenPct} from working in this category.",
            "significantEffect": "Salary is highly likely to be affected by working in {termName} for both men and women.",
            "whatTermTellsYou": "What {termName} tells you:"
        },
        "detailedPanel": {
            "adjustedPayGap": "Adjusted pay gap",
            "advantagedGroup": "Men (advantaged group)",
            "analysedEmployeesNote": "These numbers represent the employees that were analysed using the predictors. Some employees may be missing data and so may be dropped. The unadjusted pay gap may therefore differ from the dashboard, which represents all employees.",
            "breakdownDescription": "Without accounting for any pay factors your unadjusted pay gap shows how salaries differ between groups. Your selected pay factors can explain some of this difference. The remaining unexplained gap is your adjusted pay gap.",
            "contribution": "Contribution",
            "disadvantagedGroup": "Women (disadvantaged group)",
            "estimate": "Estimate",
            "explainedByFactors": "Explained by factors",
            "hasBiggestImpact": "has the biggest impact on the pay gap",
            "haveSmallestImpact": "have the smallest impact on the pay gap",
            "howMuchExplains": "How much each factor explains of your pay gap",
            "introText": "In this section you'll find everything you need to know about the results from the regression analysis. We're doing a Blinder-Oaxaca decomposition which means you'll see results from two regression lines, one for women and one for men.",
            "introTextSecondary": "We summarize the insights you can conclude based on the details but you also have the option to show all the statistical data from the model.",
            "nerdModeInfo": "These tables show the full regression output for each group. The estimate represents the coefficient, and p-values below 0.05 indicate statistical significance.",
            "pValue": "p-value",
            "payFactors": "Pay factors",
            "payGapDecomposition": "Pay gap decomposition",
            "regressionDetails": "Regression model details",
            "share": "Share",
            "stdError": "Std. Error",
            "summary": {
                "adjustedMenHigher": "This leaves an adjusted pay gap of {gap} in favour of men, meaning men earn more than women even after accounting for factors.",
                "adjustedMenHigherWomenExpected": "This pushes the adjusted pay gap to {gap} in favour of men, meaning women should have even higher salaries than men according to your pay factors.",
                "adjustedNoGap": "This leaves no unexplained gap between groups.",
                "adjustedWomenHigher": "This leaves an adjusted pay gap of {gap} in favour of women, meaning women earn more than men even after accounting for factors.",
                "adjustedWomenHigherMenExpected": "This pushes the adjusted pay gap to {gap} in favour of women, meaning men should have even higher salaries than women according to your pay factors.",
                "biggestImpact": "{factors} have the biggest impact.",
                "factorsExplain": "Your pay factors explain {explained} of this difference.",
                "smallestImpact": "{factors} have the smallest impact.",
                "unadjustedMenHigher": "Without accounting for any pay factors, your unadjusted pay gap shows men earn {gap} more than women.",
                "unadjustedNoGap": "Without accounting for any pay factors, there is no pay gap between men and women.",
                "unadjustedWomenHigher": "Without accounting for any pay factors, your unadjusted pay gap shows women earn {gap} more than men."
            },
            "tStatistic": "t-statistic",
            "tabDetails": "Show details",
            "tabInsights": "Show insights",
            "term": "Term",
            "title": "Detailed information on your regression model",
            "toggleNerd": "Show detailed statistics",
            "toggleRegular": "Show regular",
            "unadjustedPayGap": "Unadjusted pay gap",
            "unexplained": "Unexplained (adjusted gap)"
        },
        "factorBreakdown": {
            "categorical": {
                "aggregateEffect": "When adding up the effects on the adjusted pay gap from each {factorName} the final result is that {factorName} reduces the adjusted pay gap by {percentage}.",
                "excludedTerms": "{count} {factorName}s are single gendered and have been excluded. These {factorName}s can't be used to determine the effect on adjusted pay gap nor predicted salaries.",
                "referenceCategory": "{factorName}: {termName} has been removed as the reference category to avoid multicollinearity and provide a stable baseline for comparison. {menPercentage} of men and {womenPercentage} of women belong to this category."
            },
            "decreasesAdjustedPayGapBy": "Decreases adjusted pay gap by",
            "detailed": {
                "bothSignificant": "Salary is highly likely to be affected by {factorName} for both men and women (both p-values are below 0.05).",
                "coefficient": "Coefficient (logspace)",
                "field": "Field",
                "impactDecrease": "Higher {factorName} is associated with higher pay. Since women generally have higher {factorName} they are more positively affected by it. This decreases the adjusted pay gap by {percentage}.",
                "impactIncrease": "Higher {factorName} is associated with higher pay. Since men generally have higher {factorName} they are more positively affected by it. This increases the adjusted pay gap by {percentage}.",
                "meanFactor": "Mean {factorName}",
                "men": "Men",
                "menHigherMean": "Men has higher mean {factorName} than women (observed from their coefficients).",
                "pValue": "p-value",
                "salaryIncrease": "Men's salary increases by {menPct} per {factorName} while women's increase by {womenPct}",
                "women": "Women",
                "womenHigherMean": "Women has higher mean {factorName} than men (observed from their coefficients)."
            },
            "excluded": {
                "correlationReason": "{factor} has been excluded from the model due to high correlation with another factor. Try removing other factors if you want to include {factor}."
            },
            "increasesGap": "{factorName} increases the adjusted pay gap by {percentage}.",
            "menHigherBullet1": "Men have generally higher {factorName} than women in your organisation",
            "menHigherBullet2": "Men's salary increases by a higher rate per {factorName} than women's",
            "notSignificantBullet1": "{factorName} does not have a significant effect on the adjusted pay gap.",
            "notSignificantBullet2": "Consider whether this factor should be included in your analysis.",
            "reducesGap": "{factorName} reduces the adjusted pay gap by {percentage}.",
            "significantBullet3": "Salary is highly likely to be affected by {factorName} for both men and women",
            "whatDoesFactorTellYou": "What does {factorName} tell you?",
            "whatFactorTellsYou": "What {factorName} tells you:",
            "womenHigherBullet1": "Women have generally higher {factorName} than men in your organisation",
            "womenHigherBullet2": "Women's salary increases by a higher rate per {factorName} than men's"
        },
        "factorTable": {
            "aliasedFactor": "{factor} was excluded due to high correlation with another factor.",
            "aliasedFactorInfo": "This variable was too closely correlated with another factor and has been excluded from the model.",
            "categorical": "Categorical",
            "categoricalImpact": "The sum of the total impact of the factor on the adjusted pay gap is {percentage}.",
            "columns": {
                "contribution": "Contribution",
                "deviation": "Deviation",
                "factor": "Factor",
                "previousAdjustedPayGap": "Previous adjusted pay gap to:",
                "reducesAdjustedPayGapBy": "Changes the adjusted pay gap by",
                "significance": "Significance",
                "statisticalSignificance": "Statistical significance"
            },
            "deviation": {
                "excluded": "This factor was excluded from the analysis.",
                "menHigher": "{factorName} is on average higher for men than women which accounts for {percentage} of the pay gap.",
                "noImpact": "This factor has no significant impact on the pay gap.",
                "womenHigher": "{factorName} is on average higher for women than men which accounts for {percentage} of the pay gap."
            },
            "excluded": "Excluded",
            "noFactors": "No pay factors configured for this audit.",
            "noType": "Unknown factor type",
            "notSignificant": "Not significant",
            "numerical": "Numerical",
            "significant": "Significant",
            "title": "Pay factors",
            "toggleFactor": "Toggle {factor} factor",
            "tooltip": "These are the factors you've selected to explain legitimate salary differences. Significant factors have a measurable impact on pay."
        },
        "featureDisabled": "This feature is not enabled. Please enable the 'Model Insights' alpha flag in Labs.",
        "needToUpdateDataWarning": "We could not add {factor} because all employees have missing or identical values. Please update the data.",
        "significance": {
            "levels": {
                "not_significant": "Not significant",
                "significant": "Significant"
            },
            "tooltip": "Statistical significance indicates whether a factor's effect on salary is likely real (not due to random chance). P-value < 0.05 is considered significant."
        },
        "yourPayPhilosophy": {
            "description": "The pay philosophy should reflect what factors are considered when setting your employees' salaries. We'll use your pay philosophy to calculate an adjusted pay gap with regression analysis. The same pay factors are used to determine and predict employees' salaries to identify which salaries that might be problematic.",
            "noFactorsImageAlt": "No pay factors toggled.",
            "title": "Your pay philosophy"
        }
    },
    "module": {
        "baseRegistry": {
            "rolesHandledByScim": "Roles are managed by your user provisioning (SCIM) and all management of roles is either done in the identity provider or the SCIM related settings.",
            "userHandledByScim": "Account is managed by your identity provider (IdP) that also manages your user provisioning. All changes are done in your identity provider."
        },
        "integrations": {
            "4Human": "4Human",
            "AdditionalDataOne": {
                "description": "We don't expect any particular format or type of data.",
                "expectedValue": "",
                "title": "Additional data 1",
                "tooltip": "An open field where you can import any data you need."
            },
            "AdditionalDataSecond": {
                "description": "We don't expect any particular format or type of data.",
                "expectedValue": "",
                "title": "Additional data 2",
                "tooltip": "An open field where you can import any data you need."
            },
            "AdditionalDataThird": {
                "description": "We don't expect any particular format or type of data.",
                "expectedValue": "",
                "title": "Additional data 3",
                "tooltip": "An open field where you can import any data you need."
            },
            "Agda": "Agda PS",
            "AlexisHR": "AlexisHR",
            "AverageHoursWorked": {
                "description": "We expect a value in numbers, for example 18.5",
                "expectedValue": "18.5",
                "title": "Average hours worked",
                "tooltip": "The employee's average amount of work hours per month. Can used to calculate budgets in salary set for hourly salaries."
            },
            "BonusActualBonus": {
                "description": "We expect a value in numbers, for example 1000",
                "expectedValue": "1000",
                "title": "Short-term incentive",
                "tooltip": "The final bonus amount credited to the employee."
            },
            "BonusBenefitsInKind": {
                "description": "We expect a value in numbers, for example 1000",
                "expectedValue": "1000",
                "title": "Benefits in kind",
                "tooltip": "The monetary value, or sum, of non-monetary job benefits offered to the employee."
            },
            "BonusOneTimeBonus": {
                "description": "We expect a value in numbers, for example 1000",
                "expectedValue": "1000",
                "title": "One time bonus",
                "tooltip": "A monetary bonus you receive once."
            },
            "BonusTargetBonus": {
                "description": "We expect a value in numbers, for example 30000",
                "expectedValue": "30000",
                "title": "Target bonus",
                "tooltip": "The bonus an employee will receive if they meet their targets."
            },
            "CompaRatio": {
                "description": "We expect a value in numbers above 0, for example 1.1",
                "expectedValue": "1.1",
                "title": "Compa ratio",
                "tooltip": "A employee's salary relative to market rates. Used to give insights when analysing pay discrepancies."
            },
            "CompanyCarAllowance": {
                "description": "We expect a value in numbers, for example 1000",
                "expectedValue": "1000",
                "title": "Car allowance",
                "tooltip": "The monetary allowance given to employees who drive their vehicles to work."
            },
            "Contract": {
                "description": "We expect one or more agreement areas, for example Teknikarbetsgivaravtalet",
                "expectedValue": "Teknikarbetsgivaravtalet",
                "title": "Contract",
                "tooltip": "Which labour union that you have a collective agreement with, which impact the employee."
            },
            "ContractType": {
                "description": "We expect a description of the employment contract, for example hourly wage or monthly wage",
                "expectedValue": "Monthly wage",
                "title": "Contract type",
                "tooltip": "Used to describe the employment contract with the employee. Could be fee, retainer, paid monthly or similar."
            },
            "ContractedHours": {
                "description": "We expect a value in numbers, for example 195",
                "expectedValue": "195",
                "title": "Contracted hours",
                "tooltip": "How many hours the employee is contracted to work per month."
            },
            "CostCenter": {
                "description": "We expect a code, can be in both numbers and letters, for example 42",
                "expectedValue": "42",
                "title": "Cost center",
                "tooltip": "Measures costs or income from a department, unit or similar. Can be used to filter out specific groups of employees."
            },
            "Country": {
                "description": "We expect the name of a country, for example Sweden",
                "expectedValue": "Sweden",
                "title": "Country",
                "tooltip": "Which country the employee's employment is contracted for. Used to divide employees into different audits."
            },
            "Currency": {
                "description": "We expect a currency code with three letters, for example SEK",
                "expectedValue": "SEK",
                "missingFunctions": {
                    "currency": "Ability to handle different currencies by splitting analyses and salary reviews"
                },
                "title": "Currency",
                "tooltip": "What currency the employee is paid in. Used in combination with a currency converter to compare salaries from different currencies."
            },
            "DateOfBirth": {
                "description": "We expect a date formatted according to {date}",
                "expectedValue": [
                    "1995-03-15",
                    "03-15-1995",
                    "15-03-1995"
                ],
                "title": "Date of birth",
                "tooltip": "When the employee was born. Used to determine age which is used for sorting, filtering and analysis."
            },
            "Email": {
                "description": "We expect an email, for example hello{'@'}sysarb.se",
                "expectedValue": "hello{'@'}sysarb.se",
                "title": "Email",
                "tooltip": "The email address to contact the employee for invites, discussions and performance reviews."
            },
            "EmploymentDate": {
                "description": "We expect a date formatted according to {date}",
                "expectedValue": [
                    "1995-03-15",
                    "03-15-1995",
                    "15-03-1995"
                ],
                "title": "Company tenure start date",
                "tooltip": "When the employee started their employment."
            },
            "EmploymentEndDate": {
                "description": "We expect a date formatted according to {date}",
                "expectedValue": [
                    "1995-03-15",
                    "03-15-1995",
                    "15-03-1995"
                ],
                "title": "Company tenure end date",
                "tooltip": "When the employee's employment will be terminated. The employment will be inactivated on the specified date."
            },
            "EmploymentNumber": {
                "description": "We expect a code, can be in both numbers and letters, for example 201213312",
                "expectedValue": "201213312",
                "missingFunctions": {
                    "discussion": "Complementary information during discussion process",
                    "payEquityAnalysis": "Updating of historical employment data",
                    "payManagement": "Complementary information during pay management process"
                },
                "title": "Employment number",
                "tooltip": "A unique number for their employment. Used to differentiate between a employee's employments."
            },
            "EmploymentRate": {
                "description": "We expect a value in numbers between 0 and 100, for example 100",
                "expectedValue": "100",
                "missingFunctions": {
                    "analysisModule": "Ability to filter by this field in analysis module",
                    "payEquityAnalysis": "Complementary information during pay equity audit"
                },
                "title": "Employment rate",
                "tooltip": "The percentage of a full-time employment the employee works."
            },
            "Equity": {
                "description": "We expect an integer, for example 2050",
                "expectedValue": "2050",
                "title": "Long-term incentive",
                "tooltip": "Total sum for an employee's benefit value"
            },
            "Ethnicity": {
                "description": "We expect an ethnicity, such as African American",
                "expectedValue": "African American",
                "title": "Ethnicity",
                "tooltip": "The employee's ethnicity. Can be used for sorting, filtering and analysis. Must be activated in system settings first. Note that it isn't allowed to collect and save data on ethnicity for Swedish employees."
            },
            "Forename": {
                "description": "We expect a name, for example Anders",
                "expectedValue": "Anders",
                "missingFunctions": {
                    "payEquityAnalysis": "Complementary information during pay equity audit"
                },
                "title": "First name",
                "tooltip": "The employee's first name."
            },
            "FormOfEmployment": {
                "description": "We expect a form of employment, for example Permanent employment",
                "expectedValue": "Permanent employment",
                "missingFunctions": {
                    "analysisModule": "Ability to filter by this field in analysis module",
                    "payEquityAnalysis": "Complementary information during pay equity audit"
                },
                "title": "Form of employment",
                "tooltip": "The arrangement of a employee's work model."
            },
            "Fortnox": "Fortnox",
            "FteWorkHoursPerMonth": {
                "description": "We expect a value in numbers, for example 160",
                "expectedValue": "160",
                "title": "Full-time equivalent work hours per month",
                "tooltip": "The number of work hours per month for a full-time equivalent employee."
            },
            "Gender": {
                "description": "We expect either \"Male\", \"Female\", \"Not declared\", \"Man\", \"Kvinna\" or \"Ej definierat\"",
                "expectedValue": "Female",
                "title": "Gender",
                "tooltip": "The employee's gender. Used to calculate gender pay gaps and identify pay discrepancies."
            },
            "Hogia": "Hogia",
            "HolidaysPaidHoliday": {
                "description": "We expect the number of days, for example 20",
                "expectedValue": "20",
                "title": "Paid holiday",
                "tooltip": "The number of days you have paid leave from work."
            },
            "HolidaysPaidSickDays": {
                "description": "We expect the number of days, for example 20",
                "expectedValue": "20",
                "title": "Paid sick days",
                "tooltip": "The number of days you have paid sick leave. Leave this empty if you have an infinite number of days of paid sick leave."
            },
            "HourlySalary": {
                "description": "We expect an hourly wage in numbers, for example 130",
                "expectedValue": "130",
                "title": "Hourly salary",
                "tooltip": "How much the employee earns per hour if the employee is paid by the hour"
            },
            "IdentificationNo": {
                "description": "We expect a unique number or letter combination, for example 15234",
                "expectedValue": "15234",
                "title": "Unique-ID",
                "tooltip": "The unique number and letter combination used to identify employees in your company"
            },
            "IndividualWorkValuation": {
                "description": "We expect a value in numbers, for example 120",
                "expectedValue": "120",
                "title": "Individual work valuation",
                "tooltip": "What points did the employee's work receive based on your valuation criteria"
            },
            "IsEmployee": {
                "description": "We expect either \"Yes\", \"No\", \"Ja\" or \"Nej\"",
                "expectedValue": "Yes",
                "title": "Is employee",
                "tooltip": "Whether the person is an employee or not"
            },
            "IsManager": {
                "description": "We expect either \"Yes\", \"No\", \"Ja\" or \"Nej\"",
                "expectedValue": "Yes",
                "title": "Move manager",
                "tooltip": "Whether the employee is a manager or not. Used during the import if the manager needs to be moved within organization tree."
            },
            "JobFamily": {
                "description": "We expect the name of the employee's job family, for example Developer",
                "expectedValue": "Developer",
                "title": "External job family",
                "tooltip": "Which family in your job architecture the employee's job is categorised in."
            },
            "LastPayIncrease": {
                "description": "We expect a value in numbers, for example 1630",
                "expectedValue": "1630",
                "title": "Last pay increase",
                "tooltip": "The employee's last salary increase."
            },
            "LegalEntityCode": {
                "description": "We expect a code in either numbers or letters, for example A0001",
                "expectedValue": "A0001",
                "title": "Legal entity code",
                "tooltip": "The code for your organisation, subsidiary or similar that's treated as its own entity in terms of legislation and income."
            },
            "LegalEntityName": {
                "description": "We expect a name, for example Sysarb Sweden AB",
                "expectedValue": "Sysarb Sweden AB",
                "title": "Legal entity name",
                "tooltip": "The name for your organisation, subsidiary or similar that's treated as its own entity in terms of legislation and income."
            },
            "LocalCareerBand": {
                "description": "We expect one of the following: 1 (individual contributor) or 2 (manager)",
                "expectedValue": "1",
                "title": "Local career band",
                "tooltip": "Which responsibilities define the job profile. Whether it’s to your performance or facilitating the performance of others."
            },
            "LocalJobCode": {
                "description": "We expect a code, that can be in numbers and letters, for example 123CBA",
                "expectedValue": "123CBA",
                "title": "Local job code",
                "tooltip": "A code that’s preferably unique to the job profile. Used for identifying a job profile."
            },
            "LocalJobFamily": {
                "description": "We expect a job family name, for example Software development",
                "expectedValue": "Software development",
                "title": "Local job family",
                "tooltip": "A group of job profiles that are in the same industry or have large similarities."
            },
            "LocalJobProfile": {
                "description": "We expect a title for a job profile, for example Developer",
                "expectedValue": "Developer",
                "title": "Local job profile",
                "tooltip": "A group of employees that have the same or similar job tasks."
            },
            "LocalJobProfileLevel": {
                "description": "We expect a grade, for example 7",
                "expectedValue": "7",
                "title": "Local job profile grade",
                "tooltip": "The level, or grade a job profile has. The level reflects how complex a job is."
            },
            "LocalSubFamily": {
                "description": "We expect a subfamily name, for example, Geoscience",
                "expectedValue": "Geoscience",
                "title": "Local subfamily",
                "tooltip": "A sub-group of job family that further narrows down to a more specific group of job profiles."
            },
            "Locality": {
                "description": "We expect the name of the employee's location, for example Stockholm",
                "expectedValue": "Stockholm",
                "title": "Locality",
                "tooltip": "Which regional area, city or county which the employee work in."
            },
            "ManagerCode": {
                "description": "We expect a code in either numbers or letters, for example 1230642",
                "expectedValue": "1230642",
                "title": "Manger code",
                "tooltip": "Used to differentiate hierarchy or amount of responsibility between managers."
            },
            "OccupationalClassification": {
                "description": "We expect a classification, for example White collar",
                "expectedValue": "White collar",
                "title": "Occupational classification",
                "tooltip": "The employee's legal or contractual staff category under the applicable agreement."
            },
            "OrganizationalLevel1": {
                "description": "We expect your company name, for example Sysarb",
                "expectedValue": "Sysarb",
                "title": "Organization level 1",
                "tooltip": "The highest node, or unit in your organization tree. Should typically be your company name."
            },
            "OrganizationalLevel2": {
                "description": "We expect a name for a part of your organization",
                "expectedValue": "Deparment A",
                "title": "Organization level 2",
                "tooltip": "The second level of nodes, or units in your organization tree. Used for managing roles and access to data."
            },
            "OrganizationalLevel3": {
                "description": "We expect a name for a part of your organization",
                "expectedValue": "Deparment A",
                "title": "Organization level 3",
                "tooltip": "The third level of nodes, or units in your organization tree. Used for managing roles and access to data."
            },
            "OrganizationalLevel4": {
                "description": "We expect a name for a part of your organization",
                "expectedValue": "Deparment A",
                "title": "Organization level 4",
                "tooltip": "The fourth level of nodes, or units in your organization tree. Used for managing roles and access to data."
            },
            "OrganizationalLevel5": {
                "description": "We expect a name for a part of your organization",
                "expectedValue": "Deparment A",
                "title": "Organization level 5",
                "tooltip": "The fifth level of nodes, or units in your organization tree. Used for managing roles and access to data."
            },
            "OrganizationalLevel6": {
                "description": "We expect a name for a part of your organization",
                "expectedValue": "Deparment A",
                "title": "Organization level 6",
                "tooltip": "The sixth level of nodes, or units in your organization tree. Used for managing roles and access to data."
            },
            "Overtime": {
                "description": "We expect the number of hours overtime, for example 40",
                "expectedValue": "40",
                "title": "Overtime",
                "tooltip": "Hours spent beyond standard work schedule that qualify for overtime pay."
            },
            "ParentalLeaveEndDate": {
                "description": "We expect a date formatted according to {date}",
                "expectedValue": "{date}",
                "title": "Parental leave end date",
                "tooltip": "The date the employee’s parental leave ends."
            },
            "ParentalLeaveStartDate": {
                "description": "We expect a date formatted according to {date}",
                "expectedValue": "{date}",
                "title": "Parental leave start date",
                "tooltip": "The date the employee’s parental leave starts."
            },
            "PensionOccupationalPension": {
                "description": "We expect a percentage value, for example 15",
                "expectedValue": "15",
                "title": "Occupational pension",
                "tooltip": "How much (%) the employee earn in pension."
            },
            "Performance": {
                "description": "We expect an assessment in either numbers or letters, for example 4",
                "expectedValue": "4",
                "missingFunctions": {
                    "payEquityAnalysis": "Ability to use performance when analyzing pay gaps"
                },
                "title": "Performance",
                "tooltip": "A score for the employee's latest performance."
            },
            "Personio": "Personio",
            "PositionLevel": {
                "description": "We expect a position level, can be in both numbers and letters, for example Junior",
                "expectedValue": "Junior",
                "title": "Position level",
                "tooltip": "The grade, level or seniority of your employee within their position."
            },
            "Salary": {
                "description": "We expect a value in numbers, for example 30205",
                "expectedValue": "30205",
                "title": "Salary",
                "tooltip": "A employee's base salary without salary increments. Used for comparing pay discrepancies."
            },
            "SalaryDate": {
                "description": "We expect a date formatted according to {date}",
                "expectedValue": [
                    "1995-03-15",
                    "03-15-1995",
                    "15-03-1995"
                ],
                "missingFunctions": {
                    "analysisModule": "Ability to filter by this field in analysis module",
                    "payManagement": "Complementary information during pay management process"
                },
                "title": "Salary date",
                "tooltip": "The last date the employee's salary was adjusted."
            },
            "SalaryExchange": {
                "description": "We expect a value in numbers, for example 1020",
                "expectedValue": "1020",
                "title": "Salary exchange",
                "tooltip": "Replacing part of a employee's salary with a benefit. Could be a company car, increased payment to pension or similar."
            },
            "SalaryIncrement": {
                "description": "We expect a value in numbers, for example 201",
                "expectedValue": "201",
                "title": "Salary increment 1",
                "tooltip": "An additional increase to a employee's base salary. Could be due to niche competence, increased responsibility or similar."
            },
            "SalaryIncrementSecond": {
                "description": "We expect a value in numbers, for example 201",
                "expectedValue": "201",
                "title": "Salary increment 2",
                "tooltip": "An additional increase to a employee's base salary. Could be due to niche competence, increased responsibility or similar."
            },
            "SalaryIncrementThird": {
                "description": "We expect a value in numbers, for example 201",
                "expectedValue": "201",
                "title": "Salary increment 3",
                "tooltip": "An additional increase to a employee's base salary. Could be due to niche competence, increased responsibility or similar."
            },
            "SalaryType": {
                "description": "We expect either: \"Årslön\", \"Månadslön\", \"Timlön\", \"TotalÅrslön\", \"TotalMånadslön\", \"TotalTimlön\", \"Yearly\", \"Monthly\", \"Hourly\", \"YearlyTotalComp\", \"MonthlyTotalComp\" or \"HourlyTotalComp\"",
                "expectedValue": "Monthly",
                "title": "Salary type",
                "tooltip": "How the employee's salary is paid over a specific time period. Could be hourly, monthly or yearly."
            },
            "SalaryYear": {
                "description": "We expect a year in numbers, for example 2021",
                "expectedValue": "2021",
                "title": "Salary year",
                "tooltip": "Specifies the year which year the salary was set."
            },
            "Sftp": "File server integration",
            "SocialSecurityNumber": {
                "description": "We expect the Swedish identity number to be formatted according to YYYYMMDD-XXXX, YYMMDD-XXXX, YYYYMMDDXXXX or YYMMDDXXXX",
                "expectedValue": "YYYYMMDD-XXXX",
                "title": "Swedish personal identity number",
                "tooltip": "A unique identifier. Could be used as a login method depending on your country."
            },
            "StatisticalCode": {
                "description": "We expect code, can be in numbers and letters, suggested according to AID or SSYK standard, for example 2171",
                "expectedValue": "2171",
                "missingFunctions": {
                    "analysisModule": "Ability to filter by this field in analysis module",
                    "payEquityAnalysis": "Complementary information during pay equity audit\n- Ability to create job groups from statistical code"
                },
                "title": "Statistical code",
                "tooltip": "A code that represents a position or job assignments, for example AID-codes, BESTA-codes. Used for grouping employees for analysis and to check benchmark data."
            },
            "StatutoryGrade": {
                "description": "We expect the employee's statutory grade, for example C3",
                "expectedValue": "C3",
                "title": "Statutory grade",
                "tooltip": "The employee's grade or level under an applicable collective agreement or statutory pay framework."
            },
            "Surname": {
                "description": "We expect a family name, for example Andersson",
                "expectedValue": "Andersson",
                "missingFunctions": {
                    "payEquityAnalysis": "Complementary information during pay equity audit"
                },
                "title": "Surname",
                "tooltip": "The employee's last name."
            },
            "Sympa": "Sympa",
            "TimeInCurrentPosition": {
                "description": "We expect a date formatted according to {date}",
                "expectedValue": [
                    "1995-03-15",
                    "03-15-1995",
                    "15-03-1995"
                ],
                "title": "Job tenure start date",
                "tooltip": "How long the employee's current employment have been ongoing."
            },
            "Union": {
                "description": "We expect the name of the employee's trade union, for example Kommunal",
                "expectedValue": "Kommunal",
                "title": "Union",
                "tooltip": "Which trade union organization is responsible for reviewing the employee's interest in working life"
            },
            "UnitNumber": {
                "description": "We expect a code, can be in both numbers and letters, for example 4200",
                "expectedValue": "4200",
                "title": "Unit number",
                "tooltip": "A unique code for a node, or unit, in your organization tree. Can be used to create your organizational structure."
            },
            "VismaP": "Visma P",
            "WorkName": {
                "description": "We expect the name of the employee's work, for example Developer",
                "expectedValue": "Developer",
                "title": "Work",
                "tooltip": "Name of the job the employee has."
            },
            "WorkNo": {
                "description": "We expect a value in numbers, for example 234",
                "expectedValue": "234",
                "title": "Work number",
                "tooltip": "Number or code of the job the employee has. Used to group employees for analysis."
            },
            "WorkPosition": {
                "description": "We expect the name of the employee's job title, for example UI-Designer",
                "expectedValue": "UI-Designer",
                "missingFunctions": {
                    "payManagement": "Complementary information during pay management process"
                },
                "title": "Position title",
                "tooltip": "The professional title that the employee has"
            },
            "YearlyPayouts": {
                "description": "We expect an integer, for example 12",
                "expectedValue": "12",
                "title": "Yearly payouts",
                "tooltip": "How many payments the employee receives per year."
            },
            "accept": "Accept",
            "accessTokenPlaceholder": "The access token you created in AlexisHR",
            "accessTokenTitle": "Access token",
            "activateIntegration": "Activate integration with fortnox",
            "addAnother": "Add another integration",
            "addCoworkers": "Add employees",
            "addField": "Add field",
            "addIntegration": "Add integration",
            "all": "All",
            "allFields": "All fields",
            "allMatchedFields": "All matched fields",
            "allowedFileFormats": "Allowed file formats: CSV (UTF-8)",
            "alreadyAuthenticated": "You are already authenticated. If you want to change your connection settings, click the button below.",
            "analyseModule": "Analyze module",
            "approveAllPreviousMatches": "Approve your latest matches",
            "approveMatches": "Approve matches",
            "approvedMatches": "Approved matches",
            "areYouSure": "Are you sure you want to delete this field?",
            "auth": "Authentication",
            "authFailed": "Authentication failed! Make sure you enter the correct information and try again.",
            "authFailedBanner": "1 integration failed authentication, most likely because the authentication keys have expired. Scroll down to update the authentication details on the affected integration and try to sync again. | {count} integrations failed authentication, most likely because the authentication keys have expired. Scroll down to update the authentication details on the affected integrations and try to sync again.",
            "authFailedTooltip": "The integration failed authentication, most likely because the authentication keys have expired. Update the authentication details and try to sync again.",
            "authHasFailed": "Authentication failed",
            "authHeader": "Sync with your integration",
            "authHelptext": "To make your integration work, you must ensure that your data with one of our integration partners is sent to us. You'll need to log in to the selected integration partner by filling in the information below and clicking on test connection.",
            "authHelptextSftp": "Configure how the SFTP integration is set up. The choices below determine where the SFTP server is hosted and how the file is delivered.",
            "authSuccess": "Authentication succeeded! Click continue to go to the next step.",
            "authToken": "Authentication key",
            "authTokenPlaceholder": "Enter your authentication key...",
            "authenticate": "Authenticate",
            "authenticating": "Authenticating...",
            "autoCloseModal": "The modal closes automatically in {countdown} seconds",
            "autoMatchedInfo": "This field is automatically matched for this integration and can't be changed.",
            "autoSync": "Auto sync",
            "autoSyncHelpText": "We'll do a sync each night to keep your data up to date",
            "autoSyncInfoOne": "Sync automatically each night to keep your data up-to-date.",
            "autoSyncInfoTwo": "Get notifications when auto sync fails.",
            "automaticMatch": "Automatic matches",
            "automaticMatchDescription": "Here are all {count} employees presented who will automatically be matched because their unique ID shares a personal number with a unique ID in Sysarb. We will match to the unique ID in Sysarb, if you want to update the unique ID, you can do it in the base register.",
            "baseNode": "First organization level",
            "baseNodeDisabled": "You can not select first organization level because there is either no base node in the system or there is more than one node",
            "cantRemove": "You can not delete your own headers, if you do not want to match your headers with one of Sysarb's headers, you can just ignore it",
            "cantUseWithBasenode": "This module does not work with base node structure",
            "cellData": "You wrote in \"{column}\" on row {row}:",
            "changeAuth": "Change connection settings",
            "checklist": "Checklist",
            "chooseDBColumn": "Choose from Sysarbs headers",
            "chooseField": "Choose Field",
            "choosePreferences": "Choose preferences",
            "chooseSalaryFile": "Choose salary file",
            "chooseSalaryFileHelptext": "Start by downloading the custom payroll file template found on the right of this view. In this template you will find three tabs where we recommend that you fill in the tab called \"Recommended\". This tab contains the fields that will create the most value for your work in Sysarb. On the \"All fields\" tab you will find all the fields to which you can upload information.\n\nFill in your information under the columns and save the file in CSV format, then drag the file here. You need to change your excel to a CSV file (UTF-8), you do this by saving as and changing file format, CSV (UTF-8) is usually the first CSV format that appears.",
            "cleanCellData": "Value after we have correction:",
            "clearCache": "Clear cache",
            "clientIdPlaceholder": "Enter your client id...",
            "clientIdTitle": "Client Id",
            "clientSecretPlaceholder": "Enter your client secret...",
            "clientSecretTitle": "Client Secret",
            "close": "Close",
            "code": "Code",
            "columnName": "Column name",
            "columnPreviewTimeout": "The preview could not be loaded at the moment.",
            "companyColumns": "Your headers",
            "companyName": "Company name",
            "companyNameHelptext": "Your company name is used to create the base structure for your organisational tree. You can edit this later in your system settings.",
            "companyNameNotSet": "No company name is set",
            "completeCsv": "Complement CSV",
            "confirmChangeMapping": "The chosen header is already in use, this will replace the current match",
            "conflict": "Unique ID that shares person number with unique ID in Sysarb ",
            "conflictBody": "{count} of your employees unique ID do not exist in Sysarb. However, we have found several other unique IDs that share the same social security number as the employees and therefore we cannot automatically match these. You will need to go into the base registry and remove at least one of them.",
            "conflictTitle": "{count} unique IDs in your salary file share social security numbers with two or more unique IDs in Sysarb",
            "conflictingDescription": "Here are the {count} employee's unique ID presented, which lack an exact match but share a social security number with multiple unique ID in Sysarb. You need to remove at least one of the unique IDs in the base register.",
            "continue": "Continue",
            "conversation": "Discussion",
            "country": "Country",
            "coworkers": "Employees",
            "createHistoricalData": "Save historical data",
            "createIntegration": "Create integration",
            "createIntegrationError": "We encountered an error while trying to create your integration. Please try again.",
            "currency": "Currency",
            "customerColumns": {
                "active": "Active",
                "address1": "Address 1",
                "address2": "Address 2",
                "age": "Age",
                "annual_salary": "Annual salary",
                "annual_salaryType": "Annual salary type",
                "anstdat": "Employment date",
                "anstform": "Form of employment",
                "anstnr": "Employment number",
                "anstnrextern": "External employment number",
                "anställningsdatum": "Employment date",
                "anställningsform": "Form of employment",
                "anställningsnummer": "Employment number",
                "arbetsplatsens_adress": "Workplace address",
                "arbetsplatsens_ort": "Workplace city",
                "arbhel": "Employer",
                "autoNonRecurringTax": "Automatic non recurring tax",
                "avatar": "Avatar",
                "averageHourlyWage": "Average hourly wage",
                "averageWeeklyHours": "Average weekly hours",
                "bankAccountNo": "Bank account number",
                "befattning": "Position title",
                "birthDate": "Birthdate",
                "birthdate": "Birthdate",
                "bsk1": "Besta code 1",
                "bsk2": "Besta code 2",
                "bsk3": "Besta code 3",
                "bsk_123": "Besta code merged",
                "changed_at": "Changed at",
                "city": "City",
                "clearingNo": "Clearing number",
                "companyId": "Company ID",
                "companyName": "Company name",
                "compensationId": "Compensation ID",
                "compensation_amount": "Compensation - Amount",
                "compensation_currency": "Compensation - Currency",
                "compensation_effectiveDate": "Compensation - Effective date",
                "compensation_exchangeRate": "Compensation - Exchange rate",
                "compensation_id": "Compensation - ID",
                "compensation_paidOvertime": "Compensation - Paid overtime",
                "compensation_payoutFrequency": "Compensation - Payout frequency",
                "compensation_payoutPeriod": "Compensation - Payout period",
                "compensation_updated": "Compensation - Updated",
                "computed_DateOfBirthFromPersonalIdentityNumber": "Calculated date of birth from personal identity number",
                "computed_GenderFromPersonalIdentityNumber": "Calculated gender from personal identity number",
                "counted_salary": "Counted salary",
                "country": "Country",
                "created": "Created",
                "custom_fields_country": "Own field - Country (Kombo)",
                "custom_fields_custom_band": "Own field - Band (Kombo)",
                "custom_fields_custom_contract": "Own field - Contract (Kombo)",
                "custom_fields_custom_employment_type": "Own field - Employment type (Kombo)",
                "custom_fields_custom_legal_entity": "Own field - Legal entity (Kombo)",
                "custom_fields_custom_market": "Own field - Market (Kombo)",
                "custom_fields_custom_position": "Own field - Position (Kombo)",
                "custom_fields_custom_position_level": "Own field - Position level (Kombo)",
                "custom_fields_custom_region": "Own field - Region (Kombo)",
                "custom_fields_custom_startdate": "Own field - Start date (Kombo)",
                "custom_fields_custom_work": "Own field - Job (Kombo)",
                "custom_fields_job_family": "Own field - Job family (Kombo)",
                "custom_fields_sf_employments_compInfoNav_results_currencyCode": "Own field - Currency code (SF)",
                "custom_fields_sf_employments_compInfoNav_results_endDate": "Own field - Employment end date (SF)",
                "custom_fields_sf_employments_compInfoNav_results_frequency": "Own field - Frequency (SF)",
                "custom_fields_sf_employments_compInfoNav_results_notes": "Own field - Notes (SF)",
                "custom_fields_sf_employments_compInfoNav_results_payComponent": "Own field - Pay component (SF)",
                "custom_fields_sf_employments_compInfoNav_results_paycompvalue": "Own field - Pay component value (SF)",
                "custom_fields_sf_employments_compInfoNav_results_seqNumber": "Own field - Sequence number (SF)",
                "custom_fields_sf_employments_compInfoNav_results_startDate": "Own field - Employment start date (SF)",
                "custom_fields_sf_employments_end_date": "Own field - End date (SF)",
                "custom_fields_sf_employments_jobInfoNav_businessUnit": "Own field - Business unit (SF)",
                "custom_fields_sf_employments_jobInfoNav_company": "Own field - Company (SF)",
                "custom_fields_sf_employments_jobInfoNav_costCenter": "Own field - Cost center (SF)",
                "custom_fields_sf_employments_jobInfoNav_customDouble12": "Own field - 'customDouble12' (SF)",
                "custom_fields_sf_employments_jobInfoNav_customString105": "Own field - 'customString105' (SF)",
                "custom_fields_sf_employments_jobInfoNav_customString18": "Own field - 'customString18' (SF)",
                "custom_fields_sf_employments_jobInfoNav_customString7": "Own field - 'customString7' (SF)",
                "custom_fields_sf_employments_jobInfoNav_department": "Own field - Department (SF)",
                "custom_fields_sf_employments_jobInfoNav_division": "Own field - Division (SF)",
                "custom_fields_sf_employments_jobInfoNav_emplStatusNav_externalCode": "Own field - Employment status external code (SF)",
                "custom_fields_sf_employments_jobInfoNav_jobTitle": "Own field - Job title (SF)",
                "custom_fields_sf_employments_jobInfoNav_localJobTitle": "Own field - Local job title (SF)",
                "custom_fields_sf_employments_jobInfoNav_managerEmploymentNav_personIdExternal": "Own field - Person ID External (SF)",
                "custom_fields_sf_employments_jobInfoNav_payGrade": "Own field - Pay grade (SF)",
                "custom_fields_sf_employments_jobInfoNav_startDate": "Own field - Start date (SF)",
                "custom_fields_sf_employments_jobInfoNav_timeTypeProfileCodeNav_availableTimeTypes_results_timeType": "Own field - Time type (SF)",
                "custom_fields_sf_employments_start_date": "Own field - Employment date (SF)",
                "custom_fields_statistical_code": "Own field - Statistical code (Kombo)",
                "date_of_birth": "Date of birth",
                "datedSchedules_EmployeeId": "Dated schedules - Employee ID",
                "datedSchedules_FirstDay": "Dated schedules - First day",
                "datedSchedules_ScheduleId": "Dated schedules - Schema ID",
                "datedWages_EmployeeId": "Dated wages - Employee ID",
                "datedWages_FirstDay": "Dated wages - First day",
                "datedWages_HourlyPay": "Dated wages - Hourly salary",
                "datedWages_MonthlySalary": "Dated wages - Monthly salary",
                "deltidslön": "Part-time salary",
                "departmentId": "Department ID",
                "display_full_name": "Full name",
                "distributionAddress": "Distribution address",
                "efternamn": "Last name",
                "eget_fält_1": "Custom field 1",
                "eget_fält_2": "Custom field 2",
                "eget_fält_3": "Custom field 3",
                "eget_fält_4": "Custom field 4",
                "eget_fält_5": "Custom field 5",
                "eget_fält_6": "Custom field 6",
                "eget_fält_7": "Custom field 7",
                "eget_fält_8": "Custom field 8",
                "email": "Email",
                "employedTo": "Employed to",
                "employeeId": "Employee ID",
                "employeeNumber": "Employee number",
                "employee_companyEmployeeCalculatedStatus": "Employee - Company calculated status",
                "employee_companyEmployeeOffboardingDate": "Employee - Company employee offboarding date",
                "employee_companyId": "Employee - Company ID",
                "employee_countriesOfEmployments": "Employee - Countries of employments",
                "employee_employeeId": "Employee - ID",
                "employee_employmentCount": "Employee - Employment count",
                "employee_endDate": "Employee - End date",
                "employee_freeEmployer_from": "Employee - Free employer from",
                "employee_freeEmployer_to": "Employee - Free employmer to",
                "employee_hasMainEmployer": "Employee - Has main employmer",
                "employee_id": "Employee - ID",
                "employee_mainEmployer": "Employee - Main employer",
                "employee_number": "Employee number",
                "employee_primaryEmployment_fteFactor": "Employee - Primary employment FTE factor",
                "employee_primaryEmployment_id": "Employee - Primary employment ID",
                "employee_primaryEmployment_idExt": "Employee - Primary employment ID external",
                "employee_primaryEmployment_orgUnitId": "Employee - Primary employment organisation unit ID",
                "employee_primaryLocation_companyNumber": "Employee - Primary location company number",
                "employee_primaryLocation_externalId": "Employee - Primary location external ID",
                "employee_primaryLocation_name": "Employee - Primary location name",
                "employee_primaryLocation_visitAddress_address": "Employee - Primary location visit address",
                "employee_primaryLocation_visitAddress_city": "Employee - Primary location visit adress city",
                "employee_primaryLocation_visitAddress_municipality": "Employee - Primary location visit municipality",
                "employee_primaryLocation_visitAddress_zipCode": "Employee - Primary location visit adress zip code",
                "employee_residencePermit_from": "Employee - Residence permit from",
                "employee_residencePermit_to": "Employee - Residence permit to",
                "employee_resourceType": "Employee - Resource type",
                "employee_salaryNumber": "Employee - Salary number",
                "employee_salarySystemCompanyId": "Employee - Salary system company ID",
                "employee_selfSickness": "Employee - Self sickness",
                "employee_seniorityDate": "Employee - Seniority date",
                "employee_startDate": "Employee - Start date",
                "employee_statusDate": "Employee - Status date",
                "employee_totalFteFactor": "Employee - Total FTE factor",
                "employee_userCalculatedStatus": "Employee - User calculated status",
                "employee_userId": "Employee - User ID",
                "employee_userStatus": "Employee - User status",
                "employee_workPermit_from": "Employee - Work permit from",
                "employee_workPermit_to": "Employee - Work permit to",
                "employee_workStatus": "Employee - Work status",
                "employmentCountry": "Employment country",
                "employmentDate": "Employment date",
                "employmentForm": "Employment form",
                "employmentId": "Employment ID",
                "employmentNumber": "Employment number",
                "employmentRate": "Employment rate",
                "employmentTypeId": "Employment type ID",
                "employment_changed_at": "Employment - Changed at",
                "employment_companyLocation_companyNumber": "Employment - Company location number",
                "employment_companyLocation_externalId": "Employment - Company location external ID",
                "employment_companyLocation_id": "Employment - Company location ID",
                "employment_companyLocation_name": "Employment - Company location name",
                "employment_companyLocation_postAddress_address": "Employment - Company location post address address",
                "employment_companyLocation_postAddress_city": "Employment - Company location post address city",
                "employment_companyLocation_postAddress_municipality": "Employment - Company location post address municipality",
                "employment_companyLocation_postAddress_zipCode": "Employment - Company location post address zip code",
                "employment_companyLocation_visitAddress_address": "Employment - Company location visit address",
                "employment_companyLocation_visitAddress_city": "Employment - Company location visit address city",
                "employment_companyLocation_visitAddress_municipality": "Employment - Company location visit address municipality",
                "employment_companyLocation_visitAddress_zipCode": "Employment - Company location visit address zip code",
                "employment_company_id": "Employment - Company ID",
                "employment_company_name": "Employment - Company name",
                "employment_costPlace": "Employment - Cost place",
                "employment_country": "Employment - Country",
                "employment_createdAt": "Employment - Created at",
                "employment_documentStatus": "Employment - Document status",
                "employment_effectiveStatus": "Employment - Effective status",
                "employment_effectiveStatusDate": "Employment - Effective status date",
                "employment_effective_date": "Employment - Effective date",
                "employment_emailWork": "Employment - Email work",
                "employment_employeeId": "Employment - Employee ID",
                "employment_employeeType_employeeType": "Employment - Employee type employee type",
                "employment_employeeType_employmentType": "Employment - Employee type employment type",
                "employment_employeeType_employmentTypeId": "Employment - Employee type employment type ID",
                "employment_employeeType_id": "Employment - Employee type ID",
                "employment_employeeType_status": "Employment - Employee type status",
                "employment_employeeType_typeId": "Employment -  Employee type type ID",
                "employment_employee_id": "Employment - Employee ID",
                "employment_employmentCalculatedStatus": "Employment - Employment calculated status",
                "employment_employmentComment": "Employment - Employment comment",
                "employment_employmentManagerId": "Employment - Employment manager ID",
                "employment_employmentStatus": "Employment - Employment status",
                "employment_endDate": "Employment - End date",
                "employment_externalId": "Employment - External ID",
                "employment_firstWorkingDay": "Employment - First working day",
                "employment_fteFactor": "Employment - FTE factor",
                "employment_hasEmploymentLocation": "Employment - Has employment location",
                "employment_hrRoleId": "Employment - HR role ID",
                "employment_id": "Employment - ID",
                "employment_invitationDateTimestamp": "Employment - Invitation date timestamp",
                "employment_isLastEmployment": "Employment - Is last employment",
                "employment_jobDescription": "Employment - Job description",
                "employment_jobId": "Employment - Job ID",
                "employment_jobTitle": "Employment - Job title",
                "employment_job_title": "Employment - Job title",
                "employment_lastWorkingDay": "Employment - Last working day",
                "employment_mainWorkplace": "Employment - Main workplace",
                "employment_managerId": "Employment - Manager ID",
                "employment_noticePeriod": "Employment - Notice period",
                "employment_number": "Employment - Number",
                "employment_occupationalCode": "Employment - Occupational code",
                "employment_orgUnitId": "Employment - Organisation unit ID",
                "employment_orgUnitManagerId": "Employment - Organisation unit manager ID",
                "employment_orgUnitName": "Employment - Organisation unit name",
                "employment_pay_currency": "Employment - Pay currency",
                "employment_pay_frequency": "Employment - Pay frequency",
                "employment_pay_period": "Employment - Pay period",
                "employment_pay_rate": "Employment - Pay rate",
                "employment_personalJobDescription": "Employment - Personal job description",
                "employment_phoneNumberWork": "Employment - Phone number work",
                "employment_positionTitle": "Employment - Position title",
                "employment_presentFteFactor": "Employment - Present FTE factor",
                "employment_probationPeriod": "Employment - Probation period",
                "employment_referenceId": "Employment - Reference ID",
                "employment_remainingDays": "Employment - Remaining days",
                "employment_remote_deleted_at": "Employment - Deleted at",
                "employment_remote_id": "Employment - External ID",
                "employment_salaryCurrency": "Employment - Salary currency",
                "employment_salaryDefinition": "Employment - Salary definition",
                "employment_salarySystemCompanyId": "Employment - Salary system company ID",
                "employment_salaryType": "Employment - Salary type",
                "employment_salaryValue": "Employment - Salary value",
                "employment_startDate": "Employment - Start date",
                "employment_status": "Employment status",
                "employment_statusDate": "Employment - Status date",
                "employment_terminateReason": "Employment - Terminate reason",
                "employment_terminationDate": "Employment - Termination date",
                "employment_type": "Employment type",
                "employment_userCalculatedStatus": "Employment - User calculated status",
                "employment_userId": "Employment - User ID",
                "employment_userName": "Employment - User name",
                "employment_userPhoto": "Employment - User photo",
                "employment_userStatus": "Employment - User status",
                "employment_uuid": "Employment - Unique ID",
                "employment_validFrom": "Employment - Valid from",
                "employment_validTo": "Employment - Valid to",
                "employment_workRelationType": "Employment - Work relation type",
                "employment_workingHoursArrangement": "Employment - Working hours arrangement",
                "employment_workingHoursPerWeek": "Employment - Working hours per week",
                "endDate": "End date",
                "epost": "Email",
                "ethnicity": "Ethnicity",
                "fasttill": "Fixed addition",
                "fasttill2": "Fixed addition 2",
                "fasttill3": "Fixed addition 3",
                "firstName": "First name",
                "first_name": "First name",
                "foernamn": "First name",
                "foraType": "Insurance type",
                "fullName": "Full name",
                "fullTimeSalary": "Full-time salary",
                "födelsedatum": "Birthdate",
                "förnamn": "Forename",
                "gender": "Gender",
                "genderFromPNUMID": "Gender from social security number",
                "gfom": "Valid from",
                "gtom": "Valid to",
                "hasOccupationalPension": "Has occupational pension",
                "heltidslön": "Full-time salary",
                "hireDate": "Hire date",
                "homeAddress_city": "Home address - City",
                "homeAddress_country": "Home address - Country",
                "homeAddress_location_coordinates": "Home address - Location coordinates",
                "homeAddress_location_type": "Home address - Location type",
                "homeAddress_postalCode": "Home address - Postal code",
                "homeAddress_street": "Home address - Street",
                "home_address": "Home address",
                "hourlyPay": "Hourly salary",
                "hourlySalary": "Hourly salary",
                "id": "ID",
                "identificationNumber": "Identification number",
                "identifikationsnummer": "identification number",
                "inactive": "Inactive",
                "isManager": "Move manager",
                "jobTitle": "Job title",
                "job_title": "Job title",
                "katkod": "Kat code",
                "kön": "Gender",
                "lastName": "Last name",
                "last_name": "Last name",
                "lontyp": "Salary type",
                "lönetillägg_1": "Salary increment 1",
                "lönetillägg_2": "Salary increment 2",
                "lönetillägg_3": "Salary increment 3",
                "löneväxling": "Salary exchange",
                "maanbel": "Monthly salary",
                "managerEmployeeId": "Manager employee ID",
                "manager_first_name": "Manager - First name",
                "manager_id": "Manager ID",
                "manager_last_name": "Manager - Last name",
                "manager_remote_id": "Manager - External ID",
                "marital_status": "Marital status",
                "mobile_phone_number": "Phone number",
                "monthlySalary": "Monthly salary",
                "nationality": "Nationality",
                "nonRecurringTax": "Non recurring tax",
                "officeId": "Office ID",
                "oid": "Oid",
                "orgLevel2": "Organisation level 2",
                "organisationLevel1": "Organisation level 1",
                "organisationLevel2": "Employment - Organisation level 2",
                "organisationLevel3": "Employment - Organisation level 3",
                "organisationLevel4": "Employment - Organisation level 4",
                "organisationLevel5": "Employment - Organisation level 5",
                "organisationLevel6": "Employment - Organisation level 6",
                "organisationsnivå_1": "Organisation level 1",
                "organisationsnivå_2": "Organisation level 2",
                "ownField1": "Own field 1",
                "ownField2": "Own field 2",
                "ownField3": "Own field 3",
                "ownField4": "Own field 4",
                "ownField5": "Own field 5",
                "ownField6": "Own field 6",
                "ownField7": "Own field 7",
                "ownField8": "Own field 8",
                "partTimeSalary": "Part-time salary",
                "payment_type_other": "Payment type",
                "payment_type_success_factors": "Payment type (SF)",
                "personalIdentityNumber": "Personal identity number",
                "personal_email": "Personal email",
                "personelType": "Personnel type",
                "phone1": "Phone 1",
                "phone2": "Phone 2",
                "placdat": "Placdat",
                "placeOfWork": "Place of work",
                "pnumid": "Social security number",
                "position": "Position",
                "postCode": "Post code",
                "postalAddress": "Postal address",
                "postort": "Post town",
                "privateEmail": "Private email",
                "privatePhone": "Private phone",
                "profile_addressLine1": "Profile - Address line 1",
                "profile_addressLine2": "Profile - Address line 2",
                "profile_alias": "Profile - Alias",
                "profile_city": "Profile - City",
                "profile_connectedEmployeeData_employeeId": "Profile - Linked employee ID",
                "profile_connectedEmployeeData_organizationNumber": "Profile - Linked organisation number",
                "profile_country": "Profile - Country",
                "profile_dateOfBirth": "Profile - Date of birth",
                "profile_emailPrivate": "Profile - Private email",
                "profile_firstName": "Profile - First name",
                "profile_gender": "Profile - Gender",
                "profile_id": "Profile - ID",
                "profile_instanceEmployeeId": "Profile - Instance employee ID",
                "profile_maritalStatus": "Profile - Marital status",
                "profile_nationality": "Profile - Nationality",
                "profile_paymentDetails_accountNumber": "Profile - Account number",
                "profile_paymentDetails_countryOfBank": "Profile - Country of bank",
                "profile_personalIdentification_idCountry": "Profile - Country ID",
                "profile_personalIdentification_idNumber": "Profile - ID number",
                "profile_personalIdentification_idType": "Profile - ID type",
                "profile_personalIdentification_passportCountry": "Profile - Passport country",
                "profile_personalIdentification_passportNumber": "Profile - Passport number",
                "profile_phoneNumberPrivate": "Profile - Private phone number",
                "profile_surname": "Profile - Surname",
                "profile_userCalculatedStatus_remainingDays": "Profile - User calculated remaining days",
                "profile_userCalculatedStatus_status": "Profile - User calculated status",
                "profile_userPhoto": "Profile - User photo",
                "profile_zipCode": "Profile - Zip code",
                "remote_created_at": "External created at",
                "remote_deleted_at": "External deleted at",
                "remote_id": "Employee-ID (Salary system)",
                "salary": "Salary",
                "salaryExchange": "Salary exchange",
                "salaryForm": "Salary form",
                "salarySupplement1": "Salary supplement 1",
                "salarySupplement2": "Salary supplement 2",
                "salarySupplement3": "Salary supplement 3",
                "scheduleId": "Schedule ID",
                "ssn": "Social security number",
                "start_date": "Start date",
                "statisticalCode": "Statistical code",
                "statistikkod": "Statistical code",
                "sysarb_Generated_SalaryType": "Sysarb generated salary type",
                "sysarb_mapped_contract": "Sysarb - Mapped contract",
                "sysarb_mapped_cost_center": "Sysarb - Mapped cost center",
                "sysarb_mapped_legal_entity": "Sysarb - Mapped legal entity",
                "sysarb_mapped_market": "Sysarb - Mapped market",
                "sysarb_mapped_region": "Sysarb - Mapped region",
                "sysarb_mapped_work": "Sysarb - Mapped work",
                "sysselsättningsgrad": "Employment level",
                "taxAllowance": "Tax allowance",
                "taxColumn": "Tax column",
                "taxTable": "Tax table",
                "tax_id": "Tax code",
                "termination_date": "Termination date",
                "timloen": "Hourly salary",
                "timlön": "Hourly salary",
                "title": "Title",
                "updated": "Updated",
                "userId": "User ID",
                "utdelningsadress": "Post address",
                "veckoarbetstid_deltid": "Weekly work hours, part-time",
                "veckoarbetstid_helttid": "Weekly work hours, full-time",
                "weeklyWorkingHoursFullTime": "Weekly working hours full time",
                "weeklyWorkingHoursPartTime": "Weekly working hours part-time",
                "workEmail": "Work email",
                "work_email": "Work email",
                "work_location_address_city": "Work location - City",
                "work_location_address_country": "Work location - Country",
                "work_location_address_raw": "Work location - Raw address",
                "work_location_address_state": "Work location - State",
                "work_location_address_street_1": "Work location - Street 1",
                "work_location_address_street_2": "Work location - Street 2",
                "work_location_address_zip_code": "Work location - Zip code",
                "work_location_id": "Workplace ID",
                "work_location_name": "Work location - Name",
                "work_location_remote_id": "Work location - External ID",
                "workplaceAddress": "Workplace address",
                "yrkeserf": "Experience"
            },
            "dataForSelected": "Data for selected fields will have higher priority.",
            "dateFormat": [
                "YYYY-MM-DD",
                "MM-DD-YYYY",
                "DD-MM-YYYY"
            ],
            "dateFormatHelptext": "It is important that all dates in the excel file follow the selected formatting below (including hyphens).",
            "dateFormatting": "How do you want to format your dates in the file?",
            "dbColumnNames": {
                "AverageHoursWorked": "Average hours worked",
                "CompaRatio": "Compa ratio",
                "Contract": "Contract",
                "ContractType": "Contract type",
                "ContractedHours": "Contracted hours",
                "CostCenter": "Cost center",
                "Country": "Country",
                "Currency": "Currency",
                "DateOfBirth": "Date of birth",
                "Email": "Email",
                "EmploymentDate": "Employment date",
                "EmploymentEndDate": "Company tenure end date",
                "EmploymentNumber": "Employment number",
                "EmploymentRate": "Employment rate",
                "Equity": "Long-term incentive",
                "Ethnicity": "Ethnicity",
                "Forename": "Forename",
                "FormOfEmployment": "Form of employment",
                "FteWorkHoursPerMonth": "Full-time equivalent work hours per month",
                "Gender": "Gender",
                "IndividualWorkValuation": "Individual job evaluation",
                "IsManager": "Move manager",
                "JobFamily": "External job family",
                "LastPayIncrease": "Last pay increase",
                "LegalEntityCode": "Legal entity code",
                "LegalEntityName": "Legal entity name",
                "Locality": "Locality",
                "ManagerCode": "Manager code",
                "OrganizationalLevel1": "Organizational level 1",
                "OrganizationalLevel2": "Organizational level 2",
                "OrganizationalLevel3": "Organizational level 3",
                "OrganizationalLevel4": "Organizational level 4",
                "OrganizationalLevel5": "Organizational level 5",
                "OrganizationalLevel6": "Organizational level 6",
                "Performance": "Performance",
                "PositionLevel": "Position level",
                "Salary": "Salary",
                "SalaryDate": "Salary date",
                "SalaryExchange": "Salary exchange",
                "SalaryIncrement": "Salary increment",
                "SalaryIncrementSecond": "Salary increment second",
                "SalaryIncrementThird": "Salary increment third",
                "SalaryType": "Salary type",
                "SalaryYear": "Salary year",
                "SocialSecurityNumber": "Unique-ID",
                "StatisticalCode": "Statistical code",
                "Surname": "Surname",
                "TimeInCurrentPosition": "Time in current position",
                "Union": "Union",
                "UnitNumber": "Unit number",
                "WorkName": "Work",
                "WorkNo": "Job code",
                "WorkPosition": "Job position title",
                "YearlyPayouts": "Yearly payouts"
            },
            "dd-mm-yyyy": "DD-MM-YYYY",
            "decryptFiles": "Decrypt uploaded files",
            "decryptFilesInfo": "Disabling this setting will erase the current keys. This will block access to any existing files!",
            "defaultValues": "Your chosen standards",
            "defaultValuesHelptext": "If you have empty values for the data fields below, we will autofill them with your selected default value for each. You can change your selected defaults in Settings > Salary",
            "delete": "Delete file",
            "deleteField": "Delete field",
            "deleteFileError": "Failed to delete the file. Please try again.",
            "deleteIntegration": "Delete integration",
            "deleteIntegrationError": "We encountered an error while trying to delete your integration. Please try again.",
            "deleting": "Deleting...",
            "description": "Description",
            "details": "Details",
            "directory": "Folder to read files from",
            "directoryHint": "Files are imported from the selected folder on the SFTP server.",
            "directoryNoFolders": "No folders were found on the server yet. Folders appear here once files have been delivered.",
            "directoryRoot": "/ (root folder)",
            "directorySelectPlaceholder": "Select folder",
            "directoryUpdateError": "We could not update the folder. Please try again.",
            "directoryUpdated": "Folder updated. Data will be reloaded.",
            "directoryValidation": "Directory is required.",
            "doNotCreateHistoricalData": "Don't save historical data",
            "dontCreateHistoricalData": "Do you want to save historical salary data?",
            "dontCreateHistroicalDataHelpText": "Saving historical salary data allows you to view an employee's salary development over time. This is valuable for understanding salary trends, career progress, and evaluating fair pay settings.",
            "dontMatchBaseNode": "The value does not match the base node in the system",
            "downloadFailed": "You have 1 integration for which downloading of data failed | You have {count} integrations for which downloading of data failed",
            "downloadFailedBanner": "1 integration couldn't be reached, likely because the credentials have expired or changed. Scroll down to update the credentials on the affected integration, and if the issue continues, forward the error log shown on its card to your contact at the integration provider. | {count} integrations couldn't be reached, likely because the credentials have expired or changed. Scroll down to update the credentials on the affected integrations, and if the issue continues, forward the error log shown on its card to your contact at the integration provider.",
            "downloadFailedInfo": "We're having trouble downloading data from the integration server. This could be an issue with the integration server itself. Try creating a new integration. If the problem persists, contact Customer Success.",
            "downloadFailedStatus": "Download failed",
            "downloadFailedTooltip": "The integration couldn't be reached, likely because the credentials have expired or changed. Update the credentials. If the issue continues, forward the error log shown on its card to your contact at the integration provider.",
            "downloadTemplate": "Download template",
            "downloading": "Downloading data",
            "editAuthentication": "Authentication",
            "employee": "Employee",
            "employment": "Employment",
            "employmentNumber": "Employment number",
            "enterFilename": "Enter filename",
            "enterTitle": "Enter title...",
            "errorMessage": "Error message",
            "errorOnRows": "Row that you need to correct: | Rows that you need to correct:",
            "errors": {
                "updateMapping": "Unable to update field matching."
            },
            "errorsToCorrect": "{count} error that need to be corrected | {count} errors that need to be corrected",
            "exactBody": "{count} of your employees unique ID do not exist in Sysarb. But we have found a unique ID for each employee that shares the same social security number as their unique ID in the payroll file. The employees will be automatically matched to the unique ID found in Sysarb.",
            "exactButMultipleBody": "There are {count} unique IDs in Sysarb that share social security numbers with employees who have been successfully matched. It will not affect your import but there may be employment data on the other unique ID",
            "exactButMultipleTitle": "{count} unique ID shares social security number with successfully matched employees | {count} unique ID share social security numbers with successfully matched employees",
            "exactTitle": " {count} unique ID in your payroll file will be automatically matched",
            "exactValue": "We expected the value below:",
            "exampleOfValue": "Example of value",
            "expectedValue": "We expected something like this:",
            "expectedValueHeader": "Expected value",
            "exportErrorLog": "Export error log",
            "exportErrorLogError": "Could not export the error log. Please try again.",
            "exportLog": "Export log",
            "externalJobArchitecture": "External job archtitecture",
            "failedIntegration": "Sync stopped. One or more errors have occurred. Click remedy to see the errors.",
            "failedSalaryFileImport": "Unfortuantely the import failed, you can continue the import to view the errors that occurred.",
            "failedToSync": "Failed to sync",
            "faultyFormat": "You have chosen a file with a faulty file format",
            "field": "Field",
            "fieldIntegration": "Field (integration)",
            "fieldsNeeded": "Data fields that you will need",
            "fileError": "The file could not be uploaded. The following error occurred:",
            "fileExtension": "File extension",
            "fileExtensionValidation": "File extension is required.",
            "fileImport": "File import",
            "fileImportErrors": {
                "FH-1000": {
                    "explanation": "Internal error, will be replaced at runtime",
                    "shortDescription": "Internal error"
                },
                "FH-2000": {
                    "explanation": "No matches found",
                    "shortDescription": "Matches not found"
                },
                "FH-3000": {
                    "explanation": "No file could be found",
                    "shortDescription": "File not found"
                },
                "FH-6000": {
                    "explanation": "Matches do not match the headers",
                    "shortDescription": "Matches do not match"
                },
                "FH-6100": {
                    "explanation": "Following rows contain the wrong amount of columns",
                    "shortDescription": "Incorrect amount of columns"
                },
                "FH-6200": {
                    "explanation": "There are no rows in the file",
                    "shortDescription": "File is empty"
                },
                "FH-6300": {
                    "explanation": "The file contains duplicates of the following column names: ",
                    "shortDescription": "The file contains duplicates of the following column names: "
                },
                "FH-6400": {
                    "explanation": "More than 100 rows in the file contain the wrong amount of columns",
                    "shortDescription": "Too many incorrect rows"
                },
                "FH-7000": {
                    "explanation": "The file encoding is not supported, it must be UTF-8",
                    "shortDescription": "The file encoding is not supported"
                },
                "FH-8000": {
                    "explanation": "Failed to remove verification errors",
                    "shortDescription": "Failed to delete error"
                },
                "FH-8100": {
                    "explanation": "The verification could not be removed",
                    "shortDescription": "Failed to delete verification"
                },
                "FH-9000": {
                    "explanation": "Internal error, will be replaced at runtime",
                    "shortDescription": "Internal error"
                }
            },
            "fileName": "SalaryFileTemplate",
            "fileUploaded": "You have uploaded a salary file",
            "fillInAccessToken": "You must fill in the access token",
            "fillInAllFields": "Fill all the fields to continue",
            "fillInAuthValues": "You must fill in the url and authentication key",
            "fillInAuthValuesAgda": "You must fill in the URL, username and password.",
            "fillInUsername": "Fill in all fields",
            "fillInValues": "You must fill in all values",
            "filters": {
                "addFilter": "Add filter",
                "addValue": "Add value",
                "column": "Column",
                "description": "Filters for integrations",
                "enterValue": "Enter value",
                "errors": {
                    "createFilter": "Unable to create filter",
                    "deleteFilter": "Error deleting filter",
                    "deleteValue": "Error deleting value",
                    "loadFilters": "Unable to load filters",
                    "updateFilter": "Error updating filter",
                    "updateValue": "Error updating value"
                },
                "filterType": "Filter type",
                "filterValues": "Filter values",
                "is": "Is",
                "isNot": "Is Not",
                "newFilter": "New filter",
                "noFilters": "No filters",
                "noFiltersDescription": "No filters created yet",
                "selectColumn": "Select column to filter on",
                "success": {
                    "filterCreated": "Filter created",
                    "filterDeleted": "Filter deleted",
                    "filterUpdated": "Filter updated"
                },
                "title": "Integration filters",
                "values": "Value to filter on",
                "valuesInfo": "Values to filter on"
            },
            "finish": "Finish",
            "finished": "Your work with the salary file import is complete",
            "firstValueInFile": " is the first value in your file.",
            "forename": "Firstname",
            "functionalityYouMiss": "Functionality you miss out on:",
            "generalErrors": "General errors",
            "goodJob": "Good job! Now that you have created your integration, you can decide whether you want to go back to your data center or add more integrations.",
            "groupBy": "Group by",
            "hasMatching": "Has matching",
            "hasPriority": "Has priority if matched to the same field as an integration that adds employees.",
            "haveMatchingCoworkers": "Supplement data for employees already added via integrations that adds employees.",
            "haveNewCoworkers": "Add new employees to Sysarb.",
            "headersToMapp": "Headers to map",
            "hideDone": "Hide matched",
            "hostTitle": "Who should host the server?",
            "hostTypeUpdateError": "Failed to update host type. Please try again.",
            "howToFixVerification": "How do I fix verification errors?",
            "howToFixVerificationIntro": "The errors in 'Verification' mean your integration contains values that aren't supported by the Sysarb field they're mapped to. This happens for one of two reasons:",
            "howToFixVerificationReasonFormat": "Update the affected employees directly in your HRIS or wherever the source data lives.",
            "howToFixVerificationReasonFormatTitle": "The value is in an unsupported format.",
            "howToFixVerificationReasonMapping": "To change the mapping, go back to the Data center page, click the ':' button for the integration, and select 'Matched fields'.",
            "howToFixVerificationReasonMappingTitle": "The field is mapped to the wrong Sysarb field.",
            "idMethod": "Unique ID",
            "idMethodHelptext": "If your unique IDs are formatted as swedish person-numbers, you don't need to specify gender or date of birth for each employee.",
            "idMethodToolTipText": "A unique ID is required for each employee so that we know who is who. The unique ID can consist of numbers, letters, and special characters, but it must be unique within your organization and be exactly the same in every import.",
            "idModelToggleText": "Fetch gender and date of birth from unique ID",
            "idType": {
                "ID": "Unique-ID",
                "SWE": "Unique-ID"
            },
            "identityNumber": "Unique-ID",
            "import": "Import",
            "importData": "Import data",
            "importFailed": "The import of your salary data failed.",
            "importSalaryFile": "Import salary file",
            "importTypeIntegration": "This employment was imported by a integration.",
            "importTypeSalaryFile": "This employment was imported by a salary file.",
            "importing": "Importing...",
            "importsDataFor": "Imports data for",
            "inactivateEmployeeStatus": "Disable their employment",
            "inactivateEmploymentsThatsExists": "Disable employees",
            "inactivateMissing": "Inactivate missing employees",
            "inactivateMissingInfoOne": "Employees previously imported via an integration will be set to inactive if they aren't in any of the integrations that adds employees",
            "inactivateMissingInfoTwo": "Data will not be automatically deleted but you won't be able to select inactive employees for pay equity audits, salary reviews or similar.",
            "individualErrors": "Values ​of individuals that need to be corrected",
            "integration": "Integration",
            "integrationErrors": "Validation problems",
            "integrationErrorsHelptext": "Investigate the errors below and correct them in your payroll system in order to synchronize the integration.",
            "integrationSettings": "Integration settings",
            "integrationType": "Select integration type",
            "isExactMatch": "Is exact match",
            "isMaster": "Adds employees",
            "isRequired": "Required",
            "isSupplementary": "Supplements data",
            "keepEmployeeStatus": "Maintain their employment status",
            "keepEmployments": "Maintain employee statuses",
            "keepManagers": "Maintain their position",
            "lastFileUpdate": "Last file update",
            "lastImport": "Last import",
            "lastImported": "Last imported:",
            "lastSync": "Last sync",
            "loadingIntegration": "Loading integration...",
            "loadingIntegrations": "Loading integrations...",
            "mactchingSocialSecurityNumbers": "Unique-ID {count} (Sysarb)",
            "managers": "Management of managers",
            "managersHelp": "Do you want help moving managers?",
            "managersHelptext": "We strongly recommend that managers be placed one level above their employees in the organization tree. Otherwise, it will mean that they set a salary and create conversations for themselves inside Sysarb. So if your managers are already placed one level above, you should choose \"Keep their position\" otherwise we recommend that you choose to move them up and we will take care of the rest.",
            "managersLocated": "Where are your managers located?",
            "mandatoryFields": "Mandatory",
            "manualSync": "Manual sync",
            "manualUpload": "Manual upload in Sysarb",
            "manualUploadInfo1": "Upload the file directly in Sysarb when an update is needed",
            "manualUploadInfo2": "Suitable for ad hoc or low-frequency supplementary updates where automation is not required",
            "mappedHeaders": "Already mapped headers",
            "mapping": "Processing data",
            "mappingFailed": "Field matching failed",
            "mappingFailedBanner": "1 integration has fields matched to the wrong counterpart between the integration and ours. Scroll down to the affected integration to review and correct the mappings. If the mappings are correct then forward the error log shown on its card to your contact at the integration provider. | {count} integrations have fields matched to the wrong counterpart between the integration and ours. Scroll down to each affected integration to review and correct the mappings. If the mappings are correct then forward the error log shown on its card to your contact at the integration provider.",
            "mappingFailedInfo": "Scroll down to each affected integration to review and correct the mappings. If the mappings are correct then forward the error log shown on its card to your contact at the integration provider.",
            "mappingFailedText": "You have 1 integration with incorrectly matched fields | You have {count} integrations with incorrectly matched fields",
            "mappingFailedTooltip": "The integration has fields matched to the wrong counterpart between the integration and ours. Review and correct the mappings. If the mappings are correct, then forward the error log to your contact at the integration provider.",
            "mappingsLoadingWarning": "Some data could not be loaded. Please reload the page and try again.",
            "masterInfo": "Integrations that adds employees decides which employees are imported into Sysarb. Data for all required fields need to be within the integration but can be replaced by a supplementary integration.",
            "masterIntegration": "Master integration",
            "masterOrSupplementary": "This integration can be either an integration that adds employees or a supplementary integration. You'll decide later on exactly which type you want {name} to act as.",
            "matchColumns": "Match columns",
            "matchColumnsHelptext": "In this step, you will match headings (columns) from your payroll file with Sysarb's headings so that your data ends up in the right place in the platform. You can choose to match all fields, or just some fields. Fields that do not match will be ignored. However, you must match all required fields in order for your payroll file import to be approved.",
            "matchFields": "Match fields",
            "matchFieldsInfo": "You can select which field in your integration to match to a field in Sysarb.",
            "matchMandatoryFields": "Match all required fields to advance to next step",
            "matchedFieldSysarb": "Matched field (Sysarb)",
            "matchedFields": "Matched fields",
            "missingDateFormat": "Date format is missing",
            "missingEmployees": "How do you want to handle employees who are missing?",
            "missingEmployeesHelptext": "How do you want to handle employees who are not part of the integration partner's platform but exist in our system?",
            "missingFunctions": "Including this field will give you:",
            "missingMatching": "Missing matching",
            "missingRowsInFile": "There are no rows in the file",
            "missingSettings": "You still haven't filled in all the integration details. Please press edit to complete.",
            "missingValuesInColumn": "The column has no value in the file, so you should not match it.",
            "mm-dd-yyyy": "MM-DD-YYYY",
            "modules": "What are you interested in working with?",
            "modulesHelptext": "Depending on what you choose, some fields will be required and others will not. You can of course load data in all the fields we have available and also tick several choices below.",
            "moveManagers": "Move up managers one level",
            "moveManagersToParentNode": "Move managers to parent node",
            "moveManagersToParentNodeInfoOne": "Select this if your managers are assigned to the same units as their employees within your organisation structure.",
            "moveManagersToParentNodeInfoTwo": "If managers remain placed on the same unit as their employees, they will be able to set their own salary.",
            "mustHaveMatching": "Must have matching employees from an integration that adds employees.",
            "mustProvideData": "Integration must provide data for all required fields.",
            "name": "Name",
            "newEmail": "New email",
            "newEmployments": "new employments | new employment | new employments",
            "newSalaryFile": "New salary file",
            "newUnitNumber": "New unit number",
            "noApprovedMatches": "There are no approved matches",
            "noColumn": "(column missing)",
            "noColumnData": "The selected field does not contain any data.",
            "noData": "Select a field from Sysarb to see more information about it and expected format.",
            "noErrors": "Nice work, the file has passed verification!",
            "noFileUploaded": "No file uploaded yet",
            "noHeadersExists": "No headers exists",
            "noInformation": "There is nothing to review. Press on import to start the salary import.",
            "noIntegrationColumn": "Select a field to see a preview of your data",
            "noOverlap": "Provide data for at least all required fields.",
            "noPreviousMatches": "There are no more saved matches",
            "noSelection": "Select field",
            "noSuggestionMatches": "There are no more suggestions for matches",
            "noSyncData": "No data synchronization has yet taken place.",
            "noUnusedMatches": "There are no unused headings",
            "noValue": "No value",
            "notCompletedIntegrations": "Incomplete integrations",
            "oldEmail": "Old email",
            "oldUnitNumber": "Current unit number",
            "ongoingIntegration": "Current integration",
            "ongoingSalaryFileImport": "You have an ongoing salary file import",
            "onlyComplements": "Adds no new employees, only complements data.",
            "open": "Open",
            "openAuthentication": "Open authentication",
            "openMatchedFields": "Open matched fields",
            "openVerification": "Open verification",
            "optional": "Optional",
            "orgNodes": "Organization levels",
            "orgTreeType": "What does your organizational structure look like?",
            "orgTreeTypeHelptext": "There are two ways to import an organizational structure, through organizational levels that describe the branch up to the top level for each employee, or through unit numbers that point to a specific organizational node. The third option (first organization level) is that everyone ends up on the same node.",
            "organization": "Organization",
            "organizationNode": "Organization node",
            "other": "Other",
            "overlapWithMaster": "Overlap with integrations that adds employees",
            "password": "Password",
            "passwordPlaceholder": "Enter password...",
            "passwordTitle": "Password",
            "passwordValidation": "Password is required.",
            "path": "Organizational structure",
            "payEquityAudit": "Pay equity audit",
            "payManagement": "Pay management",
            "port": "Port",
            "portPlaceholder": "Enter ftp server port...",
            "portValidation": "Invalid format for port, expected: 0-65535",
            "preferences": "Preferences",
            "prepareForImport": "Preparing to start import, this may take some time if you have chosen to disable many employees",
            "preparingData": "Preparing data",
            "preparingSync": "Preparing synchronization",
            "pressToContinue": "Please click continue to proceed",
            "preview": {
                "approve": "I approve",
                "contactCustomerSuccess": "Contact customer success",
                "currentData": "Current data",
                "field": "Field",
                "fieldsWithChanges": "Affected fields",
                "fieldsWithoutChanges": "Unaffected fields",
                "filterChangedCoworkers": "Hide employees without changes",
                "filterChangedFields": "Hide fields without changes",
                "generalInformation": "{count} new employments will be created. | {count} new employment will be created. | {count} new employments will be created.",
                "generalInformationTitle": "General information",
                "hasNoUpdates": "Everything is already synced!",
                "loadMore": "Load more",
                "loadingData": "Loading data...",
                "name": "Name",
                "new": "New",
                "newData": "New data",
                "newEmployments": "New employments",
                "newEmploymentsList": "List of new employments",
                "noChanges": "No new employments have been added.",
                "update": "Update",
                "warning": "{count} ({percent}%) new employments will be created. We just want to double check that this is correct. If not the probable cause is the employees unique-ids are not matching between us and the integration partner. To solve this you will have to change the employees unique-id in either system.",
                "warningTitle": "{count} new employments"
            },
            "previewAndSyncIntegration": "Preview",
            "previewIntegration": "Preview",
            "previewTitle": "Data preview",
            "previousMatches": "Your last matches",
            "proceedWithoutRecommended": "Continue without recommended fields",
            "profile": "Profile",
            "profileSettingsInfo": "Settings that only relate to this specific integration. You can edit these afterwards.",
            "recommended": "Recommended",
            "recommendedFields": "Recommended",
            "refresh": "Refresh",
            "regeneratePasswordError": "Failed to regenerate the password. Please try again.",
            "relax": "The import of the salary file has now started. Sit back, have a coffee and do something fun until the file has been uploaded.",
            "remedy": "Show problems",
            "removeMatching": "Remove matching",
            "replace": "Replace",
            "replaceData": "Don't save historical data",
            "required": "Required",
            "requiredFieldsNotMatched": "Required field are not matched",
            "requirementsNotMet": "You need to match at least 2 fields to proceed, including all required fields.",
            "reviewInformation": {
                "EC-INF-1000": {
                    "explanation": "We see that {count} employee has a different email in our system, if this is correct you can continue. Otherwise double check what email you are importing. | We see that {count} employees has a different email in our system, if this is correct you can continue. Otherwise double check what emails you are importing.",
                    "list": "View list of affected employees",
                    "shortDescription": "{count} employee with salary information in your salary file that has a different email | {count} employees with salary information in your salary file that has a different emails"
                },
                "EE-INF-1000": {
                    "explanation": "Of course, it is not strange that you already have salary information in the system, but we will replace existing salary information with data from this salary file import. However, you have the option of saving existing salary information as historical data. Historical salary information is used to see an employee's salary development and career in your company. So if you make a payroll file import to supplement or correct a previous payroll file import, we recommend that you do not save historical data. But if it is instead a payroll file import to update their payroll data after a new payroll year, we recommend that you save their payroll data as historical data.",
                    "list": "View list of affected employees",
                    "shortDescription": "{count} employee with salary information in your salary file is already in the system | {count} employees with salary information in your salary file are already in the system"
                },
                "LE-INF-1000": {
                    "explanation": "{count} new legal entity will be created. \nWe just want to double check with you so that it's true. \nIf this is not the case or you are unsure, you can get a list on which line we have found the new legal entity. | {count} new legal entities will be created. \nWe just want to double check with you so that it's true. \nIf this is not the case or you are unsure, you can get a list of which lines we have found new legal entities.",
                    "list": "View list of new legal entities",
                    "shortDescription": "{count} new legal entity | {count} new legal entities"
                },
                "ME-INF-1000": {
                    "explanation": "We see that you have {count} employee in the system who have active status but are not included in the file. If the person has left the company, we recommend that you deactivate the employee. Otherwise, we recommend maintaining the employment status. If you are unsure of who it is, you can get a list of which employee is missing. | We see that you have {count} employees in the system who have active status but are not included in the file. If the people have left the company, we recommend that you deactivate the employees. Otherwise, we recommend that you keep the employment status. If you are unsure of who it concerns, you can get a list of which employees are missing.",
                    "list": "View list of affected employees",
                    "shortDescription": "{count} active employee in the system is missing in the file | {count} active employees in the system are missing in the file"
                },
                "NE-INF-1000": {
                    "explanation": "{count} new employee will be created. We just want to double check with you so that it's true. If this is not the case or you are unsure, you can get a list of the line we have found the new employee. | {count} new employees will be created. We just want to double check with you so that it's true. If this is not the case or you are unsure, you can get a list of which lines we have found new employees.",
                    "list": "View list of new employees",
                    "shortDescription": "{count} new employee | {count} new employees"
                },
                "NS-INF-1000": {
                    "explanation": "{count} new statistical code will be created. We just want to double check with you so that it's true. If this is not the case or you are unsure, you can get a list on which line we have found the new statistical code. | {count} new statistical codes will be created. We just want to double check with you so that it's true. If this is not the case or you are unsure, you can get a list of which lines we have found new statistical codes.",
                    "list": "View list of new statistical codes",
                    "shortDescription": "{count} new statistical code | {count} new statistical codes"
                },
                "OR-INF-1000": {
                    "explanation": "{count} new organization node will be created. We just want to double check with you so that it's true. If this is not the case or you are unsure, you can get a list on which line we have found the new organizational node. | {count} new organizational nodes will be created. We just want to double check with you so that it's true. If this is not the case or you are unsure, you can get a list of which lines we have found new organizational nodes.",
                    "list": "View list of new organization nodes",
                    "shortDescription": "{count} new organization node | {count} new organization nodes"
                },
                "OS-INF-1000": {
                    "explanation": "You have chosen to place all employments on the base node but have matched columns that make it possible to save unit numbers. Are you sure you want to import on the base node? Otherwise, go back to preferences and change organizational structure.",
                    "shortDescription": "Is the organizational structure correct?"
                },
                "OS-INF-2000": {
                    "explanation": "You have chosen to place all employments on the base node but have matched columns that make it possible to save organization levels. Are you sure you want to import on the base node? Otherwise, go back to preferences and change organizational structure.",
                    "shortDescription": "Is the organizational structure correct?"
                },
                "OS-INF-3000": {
                    "explanation": "You have not entered enough data to import as a unit number. Are you sure you want to continue? Otherwise, you can either change the import setting to base node or add missing data.",
                    "shortDescription": "Are you missing data?"
                },
                "OS-INF-4000": {
                    "explanation": "You have chosen to place all employees on unit numbers but have matched columns that make it possible to save organization levels. Are you sure you do not want to import organizational nodes? Otherwise, go back to preferences and change organizational structure.",
                    "shortDescription": "Is the organizational structure correct?"
                },
                "OS-INF-5000": {
                    "explanation": "You have changed unit numbers on {count} different organization nodes. We just want to double check with you so that it's true. If this is not the case or you are unsure, you can get a list of which organization nodes we have found changed unit numbers.",
                    "list": "Show list of unit numbers",
                    "shortDescription": "{count} changed unit number | {count} changed unit numbers"
                },
                "RC-INF-1000": {
                    "explanation": "You have {count} recommended matching that lacks data. It does not stop you from working in the platform but some functionality will be limited or unavailable. If you want to access all functionality, you can complete your import either now or at a later time. | You have {count} recommended matches that lack data. It does not stop you from working in the platform but some functionality will be limited or unavailable. If you want to access all functionality, you can complete your import either now or at a later time.",
                    "list": "Show missing recommended fields",
                    "shortDescription": "{count} recommended match missing | {count} recommended matches are missing"
                },
                "SW-INF-1000": {
                    "explanation": "Need a translation.",
                    "list": "View list of affected employees",
                    "shortDescription": "{count} employee with salary information in your salary file is already in the system but with a different social security number | {count} employees with salary information in your salary file are already in the system with different social security numbers"
                }
            },
            "reviewValues": "Review",
            "reviewValuesHelptext": "In this step, you will choose how to handle employee data and review so that there are no unexpected changes in the number of employees, organizational nodes and statistical codes",
            "row": "Row | Rows",
            "rowId": "Row ID",
            "salary": "Salary",
            "salaryComponents": "Salary components",
            "salaryProperties": "Salary properties",
            "salarySurvey": "Pay equity audit",
            "salaryType": "Salary type",
            "save": "Save integration",
            "saveHistorical": "Save historical data",
            "saveHistoricalInfo": "Saving historical data will allow you to follow career and salary progression on employees.",
            "searchHeader": "Search after header...",
            "selectFile": "Drag and drop file or click to browse file on your computer",
            "selectIntegration": "Select integration",
            "selectMappingInfo": "The field you selected has already been paired with another field. Are you sure you want to use it here aswell?",
            "selectMappingTitle": "Field already selected",
            "selectedIntegration": "Selected integration",
            "selfHosted": "Self-hosted",
            "selfHostedFirewallWarning": "Setup requires IT involvement on your side",
            "selfHostedInfo1": "The SFTP server runs in your environment, managed by your IT team",
            "selfHostedInfo2": "Suitable if internal IT or security policies require self-hosting",
            "settings": "Settings",
            "settingsError": "An error occurred when updating the integration settings. If the problem persists, contact Customer Success.",
            "settingsInfo": "Set-up how you want your integrations to work in Sysarb. You can edit these afterwards.",
            "settingsNotCompleted": "Settings not completed",
            "sftpConfigurations": "SFTP configurations",
            "sftpDelivery": "SFTP delivery",
            "sftpDeliveryInfo1": "The file is pushed to the SFTP server daily",
            "sftpDeliveryInfo2": "Suitable for recurring, automated transfers",
            "sftpPasswordHint": "Copy password before moving on. The password will be hidden after leaving the page.",
            "sftpPasswordLeaveContent": "Make sure to save the password before you leave the page. For security reasons, the password will be hidden after leaving this page.",
            "sftpPasswordLeaveHeading": "Before you leave...",
            "sftpRegeneratePassword": "Regenerate",
            "showMoreValues": "Show more values",
            "skippedEmploymentsBanner": "{count} employment was skipped because it couldn't be imported due to missing or invalid data. Review the integration or check the error logs for more details. | {count} employments were skipped because they couldn't be imported due to missing or invalid data. Review the integrations or check the error logs for more details.",
            "smallScreen": "We recommend that you use a larger screen. A device with at least 640 px resolution is recommended.",
            "socialSecurityNumber": "Unique-Id (Salary file)",
            "startImport": "Start import",
            "startNewSalaryImport": "Start new salary import",
            "statisticalCode": "Statistical code",
            "suggestionMatches": "Suggestions on matches",
            "superflous": "Unique ID that shaers person number",
            "supplementData": "Supplement data for specific fields to already added employees",
            "supplementForSpecific": "Supplement data for one or a few specific fields.",
            "supplementary": "Supplementary integration",
            "supplementaryDisabled": "To create supplementary integrations, you need to have atleast one integration that adds employees",
            "supplementaryInfo": "Supplementary integrations are used to add niche data for specific fields. If a matched field from a supplementary integration overlaps with an integration that adds employees, the supplementary integration have priority.",
            "supplementaryIntegrations": "Supplementary integrations...",
            "supplementaryWithoutBetaEnabled": "Warning! This is a supplementary integration, but you have disabled them in Labs. Please remove it to avoid data corruption.",
            "supportFileUploaded": "File uploaded to support",
            "surname": "Lastname",
            "sympaKey": "Key",
            "sympaKeyPlaceholder": "Your key from Sympa",
            "sympaSecret": "Secret",
            "sympaSecretPlaceholder": "Your secret from Sympa",
            "sympafillInAuthValues": "Your must fill in Key and Secret",
            "sync": "Sync",
            "syncAll": "Sync all",
            "syncError": "We encountered an error while trying to synchronize your data. Please try again.",
            "syncFailed": "You have 1 integration for which synchronization failed | You have {count} integrations for which synchronization failed",
            "syncFailedBanner": "1 integration failed to sync. Refresh the page to try again, and if the problem persists, send the error log from the affected integration to our technical support. | {count} integrations failed to sync. Refresh the page to try again, and if the problem persists, send the error log from each affected integration to our technical support.",
            "syncFailedInfo": "Refresh the page to try again, and if the problem persists, send the error log from each affected integration to our technical support.",
            "syncFailedStatus": "Synchronization failed",
            "syncFailedTooltip": "The integration failed to sync. Refresh the page and try again, and if the problem persists, send the error log to our technical support.",
            "syncInProgress": "Syncing",
            "syncedCoworkers": "Synced employees",
            "syncing": "Your data is synchronizing into Sysarb",
            "sysarbColumns": "Sysarbs headers",
            "sysarbHosted": "Sysarb hosted",
            "sysarbHostedFirewallWarning": "Your firewall must allow outbound SFTP connections. Confirm with your IT team",
            "sysarbHostedInfo1": "Sysarb provides and manages the SFTP server",
            "sysarbHostedInfo2": "The standard option for most setups",
            "title": "Title",
            "totalImported": "Synced employees",
            "totalToImport": "Employees to sync",
            "triggerDownload": "Refresh data",
            "triggerMap": "Match fields",
            "triggerSync": "Sync",
            "triggerVerify": "Verify",
            "typeInfo": "When you have multiple integrations, we need to know if it's an integration meant for supplementing existing data or adding new employees to Sysarb.",
            "undo": "Undo",
            "uniqueId": "Unique ID",
            "uniqueIdThatSharesSSNDescription": "We have successfully matched your employees with their respective unique ID in the column Unique-ID. But we have found multiple unique ID that shares this person number. These unique ID will will not affect your import but it can exist employment data on them.",
            "unitNumber": "Unit number",
            "unitNumnberDisabled": "You can not select unit number as there are no entries in the system",
            "unknown": "Unknown",
            "unknownColumnDescription": "Missing description",
            "unknownColumnInformation": "Unknown column information",
            "unkownColumnTitle": "Unknown column",
            "unusedMatches": "Your unused headers",
            "uploadFailed": {
                "explanation": "A network error occurred."
            },
            "uploadFile": "Upload file to support",
            "uploadFileError": "Failed to upload the file. Please try again.",
            "uploadNewFile": "Upload new file",
            "uploadNewFileWarning": "If the new file is missing employees or data fields from the currently uploaded file, then the data will be removed from Sysarb.",
            "uploadTypeTitle": "How do you want to upload data to SFTP server?",
            "uploadingFile": "Uploading salary file...",
            "url": "URL",
            "urlPlaceholder": "Enter your Visma API subdomain",
            "urlPlaceholderAgda": "Enter your Agda PS API subdomain",
            "urlPlaceholderSftp": "Enter your SFTP url",
            "urlValidation": "Invalid format for URL, expected: sysarb.app",
            "useBasenode": "Import on basnode",
            "usedToTell": "Used to differentiate integrations from the same partner or to structure your integrations.",
            "usedToTellApart": "Used to tell integrations apart...",
            "user": "User",
            "username": "Username",
            "usernamePlaceholder": "Enter username...",
            "usernameTitle": "Username",
            "usernameValidation": "Username is required.",
            "validateValues": "Validate values",
            "validateValuesHelptext": "In this step, you must correct values in your payroll file that do not match our formats. Here are some tips to help you get started:",
            "validateValuesStep1": "Look at which column and which rows it is and what needs to be corrected",
            "validateValuesStep2": "It is enough to go back and change your choices on preferences do so and then go to step 5. If not take steps 3 and 4.",
            "validateValuesStep3": "Open your payroll file in Excel and make the corrections that need to be made. You can also make changes to your payroll system if it's easier for you ",
            "validateValuesStep4": "Repeat steps 1 and 3 for each error code",
            "validateValuesStep5": "When you have gone through all the error codes, export a new CSV file and click on \"Complete CSV\" and select your new CSV file",
            "validatingFile": "Validating file...",
            "validationErrors": {
                "BO-1000": {
                    "expectedValue": "ja",
                    "explanation": "Enter either \"ja\", \"nej\", \"yes\" or \"no\"",
                    "shortDescription": "Unexpected value"
                },
                "CC-1000": {
                    "explanation": " Because you have chosen to include {requiredColumn}, the following columns are required: {connectedColumns}",
                    "shortDescription": "The column is missing"
                },
                "CO-1000": {
                    "expectedValue": "Sweden",
                    "explanation": "We use English names for countries.",
                    "moreInfo": {
                        "button": "Show list of which countries we use"
                    },
                    "shortDescription": "We could not recognize the country you specified."
                },
                "CU-1000": {
                    "expectedValue": "SEK",
                    "explanation": "We use three-character abbreviations for currencies",
                    "moreInfo": {
                        "button": "Show list of which abbreviations we use"
                    },
                    "shortDescription": "We could not find what currency it is"
                },
                "DA-1000": {
                    "expectedValue": [
                        "1995-03-15",
                        "03-15-1995",
                        "15-03-1995"
                    ],
                    "explanation": "Enter the date with the formatting {dateFormat}",
                    "shortDescription": "We need a date to be entered with 8 digits"
                },
                "DA-2000": {
                    "expectedValue": [
                        "1995-03-15",
                        "03-15-1995",
                        "15-03-1995"
                    ],
                    "explanation": "Multiple seperators in date seperator must be one and only one of ' ./-'",
                    "shortDescription": "Incorrect date formatting"
                },
                "DA-3000": {
                    "expectedValue": [
                        "1995-03-15",
                        "03-15-1995",
                        "15-03-1995"
                    ],
                    "explanation": "Date formatting does not match your other date formatting | The date formatting in the payroll file does not match the date formatting you selected in preferences",
                    "shortDescription": "Incorrect date formatting"
                },
                "DA-4000": {
                    "expectedValue": [
                        "1995-03-15",
                        "03-15-1995",
                        "15-03-1995"
                    ],
                    "explanation": "Missing seperators in date. Month, year and day must be seperated. The seperator must be one and only one of ' ./-'",
                    "shortDescription": "Incorrect date formatting"
                },
                "DB-1000": {
                    "explanation": "Something went wrong while connecting to the database, test again or contact customer success",
                    "shortDescription": "Error connecting database"
                },
                "DN-1000": {
                    "expectedValue": "30000",
                    "explanation": "We need to enter an integer or decimal number",
                    "shortDescription": "Unexpected value"
                },
                "DN-2000": {
                    "expectedValue": "Enter a number that's equal to or greater than {min}",
                    "explanation": "The value is below the minimum allowed for this column",
                    "shortDescription": "Value below minimum allowed"
                },
                "DN-3000": {
                    "expectedValue": "Enter a number that's equal to or less than {max}",
                    "explanation": "The value is above the maximum allowed for this column",
                    "shortDescription": "Value above maximum allowed"
                },
                "EM-1000": {
                    "expectedValue": "hello{'@'}sysarb.se",
                    "explanation": "Make sure you do not miss an \"{'@'}\" or \".\" in the email address",
                    "shortDescription": "Not a valid email address"
                },
                "EM-2000": {
                    "expectedValue": "hello{'@'}sysarb.se",
                    "explanation": "An email address must be at least 6 characters long",
                    "shortDescription": "Not a valid email address"
                },
                "FH-1000": {
                    "explanation": "An internal server error occurred, contact customer succes",
                    "shortDescription": "Internal server error"
                },
                "FH-9000": {
                    "explanation": "An internal server error occurred, contact customer succes",
                    "shortDescription": "Internal server error"
                },
                "GE-1000": {
                    "expectedValue": "Female",
                    "explanation": "Enter either \"man\", \"kvinna\", \"ej definierat\", \"male\", \"female\" or \"not declared\"",
                    "shortDescription": "Unexpected value"
                },
                "IM-4000": {
                    "explanation": "An unexpected error occurred while importing the file, try again, or contact customer success",
                    "shortDescription": "Error on import"
                },
                "IM-4001": {
                    "explanation": "An unexpected error occurred while importing the file, try again, or contact customer success",
                    "shortDescription": "Error on import"
                },
                "IN-1000": {
                    "expectedValue": "12",
                    "explanation": "We need the values in the column to be entered as an integer",
                    "shortDescription": "Unexpected value"
                },
                "LE-1000": {
                    "expectedValue": "Sysarb",
                    "explanation": "One or more legal entities has the same code but different names.",
                    "shortDescription": "Multiple of same code with different names."
                },
                "LE-3000": {
                    "expectedValue": "Sys",
                    "explanation": "One or more legal entities is missing legal entity code.",
                    "shortDescription": "Missing legal entity code."
                },
                "LJ-1000": {
                    "explanation": "This row's {columnName} is \"{value}\", but other rows with job code {localJobCode} use \"{expectedValue}\". All rows sharing a job code must use the same job architecture values.",
                    "shortDescription": "Job architecture doesn't match other rows"
                },
                "LJ-2000": {
                    "explanation": "Job code {localJobCode} already exists in the system with {columnName} \"{expectedValue}\", but this row uses \"{value}\". Change this row to match the system, or update the existing data in the system to match.",
                    "shortDescription": "Conflicts with existing job architecture data"
                },
                "NO-1000": {
                    "expectedValue": "2171",
                    "explanation": "We need a value in the column for you to be able to work with all parts of the system",
                    "shortDescription": "Mandatory to fill in field"
                },
                "NU-1000": {
                    "expectedValue": "20",
                    "explanation": "The field can only contain numbers",
                    "shortDescription": "Unexpected value"
                },
                "OL-1000": {
                    "expectedValue": "A name without \"/\"",
                    "explanation": "\"/\" separates the levels in the organizational path, so a level name containing it is split into two levels and the import fails. Remove the \"/\" or replace it with another character.",
                    "shortDescription": "Organizational level names cannot contain \"/\""
                },
                "OS-1000": {
                    "expectedValue": "20",
                    "explanation": "The unit number is missing in the system, change to an existing unit number or add those that are missing in the system.",
                    "shortDescription": "The unit number is missing in the system"
                },
                "OS-10000": {
                    "explanation": "Every node's children must have unique names.\nFor example, a department can't have two children in the office.\nThe duplicated node is '{ duplicated }'",
                    "shortDescription": "Multiple child nodes with same name"
                },
                "OS-11000": {
                    "explanation": "Each child node in the payroll file must have a unique name. \nFor example, a department cannot have two child nodes named \"office\". The duplicated node is '{ duplicated }'.",
                    "shortDescription": "Multiple child nodes in the payroll file with the same name"
                },
                "OS-2000": {
                    "expectedValue": "20",
                    "explanation": "You have several unit numbers on one or more organization nodes, which makes it difficult for us to know which unit number we should use.",
                    "shortDescription": "Organization node may only have one unit number"
                },
                "OS-3000": {
                    "expectedValue": "20",
                    "explanation": "The row has no unit number or organization node",
                    "shortDescription": "The row has no unit number or organization node"
                },
                "OS-4000": {
                    "expectedValue": "20",
                    "explanation": "The row has no unit number. Each row must have a valid unit number.",
                    "shortDescription": "The row has no unit number"
                },
                "OS-5000": {
                    "expectedValue": "20",
                    "explanation": "You can not change the organization node connection on an existing unit number.",
                    "shortDescription": "You may not change the existing unit number"
                },
                "OS-6000": {
                    "expectedValue": "20",
                    "explanation": "In order for you to be able to import with a unit number in the future, each organization node must have a unique unit number.",
                    "shortDescription": "Unit number must be unique"
                },
                "OS-7000": {
                    "expectedValue": "The base node in the system",
                    "explanation": "Organization level 1 does not match the base node present in the system",
                    "shortDescription": "The organizational structure is not correct"
                },
                "OS-8000": {
                    "explanation": "There is no base node in the system. It is required that there is a base node set up in the system for you to be able to make an import.",
                    "shortDescription": "There is no base node in the system"
                },
                "OS-9000": {
                    "explanation": "There are multiple base nodes in the system. There may only be one base node stored in the system for you to be able to make an import.",
                    "shortDescription": "Multiple base nodes in the system"
                },
                "SA-1000": {
                    "expectedValue": "30000",
                    "explanation": "A salary may only contain numbers if the salary type is not set to hourly wage. Then it may also contain \",.\"",
                    "shortDescription": "Unexpected value"
                },
                "SA-2000": {
                    "expectedValue": "82.3",
                    "explanation": "A salary may only contain numbers and \",.\"",
                    "shortDescription": "Unexpected value"
                },
                "SA-3000": {
                    "expectedValue": "30000",
                    "explanation": "Salary can only contain decimal point if salary type is set to a hourly option",
                    "shortDescription": "Unexpected value"
                },
                "SS-1000": {
                    "expectedValue": "YYYYMMDD-XXXX",
                    "explanation": "A Swedish social security number is 10 or 12 digits long in the format YYMMDDXXXX or YYYYMMDD-XXX. Dashes are also allowed before the last 4 digits, YYMMDD-XXXX or YYYYMMDD-XXXX.",
                    "shortDescription": "Not a valid Swedish social security number"
                },
                "SS-2000": {
                    "expectedValue": "YYYYMMDD-XXXX",
                    "explanation": "A Swedish social security number can only contain numbers",
                    "shortDescription": "Not a valid Swedish social security number"
                },
                "SS-3000": {
                    "expectedValue": "YYYYMMDD-XXXX",
                    "explanation": "The employee must have been born between 1900-2022",
                    "shortDescription": "Unexpected social security number"
                },
                "SS-3001": {
                    "expectedValue": "YYYYMMDD-XXXX",
                    "explanation": "Month must be entered with a number between 01-12",
                    "shortDescription": "Incorrect date"
                },
                "SS-3002": {
                    "expectedValue": "YYYYMMDD-XXXX",
                    "explanation": "Day must be indicated with a number between 01-31 for social security numbers and 61-91 for coordination numbers",
                    "shortDescription": "Incorrect date"
                },
                "SS-4000": {
                    "expectedValue": "YYYYMMDD-XXXX",
                    "explanation": "The last digit in a Swedish social security number is a check digit and is determined by the remaining digits in the social security number based on a specific formula. We relay on the fact that the check digit is correct to make sure that the gener and birth date is calculated correctly.",
                    "shortDescription": "Invalid check digit in social security number"
                },
                "ST-1000": {
                    "expectedValue": "Monthly",
                    "explanation": "Enter the salary type with one of the following: \"Årslön\", \"Månadslön\", \"Timlön\", \"TotalÅrslön\", \"TotalMånadslön\", \"TotalTimlön\", \"Yearly\", \"Monthly\", \"Hourly\", \"YearlyTotalComp\", \"MonthlyTotalComp\" or \"HourlyTotalComp\". If there is no value to an employee, we will auto-fill it with your chosen standard",
                    "shortDescription": "Unexpected value"
                },
                "TE-1000": {
                    "explanation": "We use only Latin characters, which means A-Ö and several different special characters. The following characters are accepted: ! # $ % & ' ( ) * + , - . /  0 1 2 3 4 5 6 7 8 9 : ; = > < ? {'@'} A B C D E F G H I J K L M N O P Q R S T U V W X Y Z [ ] ^ _ ` a b c d e f g h i j k l m n o p q r s t u v w x y z  { | } ~ ¡ ¢ £ ¤ ¥ ¦ § ¨ © ª « ¬  ® ¯  ° ± ² ³ ´ µ ¶ · ¸ ¹ º » ¼ ½ ¾ ¿ À Á Â Ã Ä Å Æ Ç È É Ê Ë Ì Í Î Ï Ð Ñ Ò Ó Ô Õ Ö × Ø Ù Ú Û Ü Ý Þ ß à á â ã ä å æ ç è é ê ë ì í î ï ð ñ ò ó ô õ ö ÷ ø ù ú û ü ý þ ÿ",
                    "shortDescription": "Contains invalid characters"
                },
                "TE-2000": {
                    "expectedValue": "A maximum of 100 characters",
                    "explanation": "A value can contain a maximum of 100 characters",
                    "shortDescription": "Contains too many characters"
                },
                "TE-3000": {
                    "explanation": "A value must not contain \"#SAKNAS!\" or \"#MISSING!\".",
                    "shortDescription": "Incorrect value."
                },
                "US-1000": {
                    "explanation": "In order to be able to import employees with several jobs, the combination of {idType} and employment number needs to be unique",
                    "shortDescription": "The value must be unique"
                },
                "YE-1000": {
                    "expectedValue": "2018",
                    "explanation": "Wrong amount of characters for a year it should be in the format YYYY",
                    "shortDescription": "Incorrectly formatted year"
                },
                "YE-2000": {
                    "expectedValue": "2018",
                    "explanation": "Year can not be lower than 1900 and not higher than current year",
                    "shortDescription": "Wrong year"
                }
            },
            "value": "Value",
            "valueIntegration": "Value (integration)",
            "valuesFromFile": "Values from file (shows only the first 10 values in the file)",
            "verification": "Verification",
            "verificationAborted": "Sync was aborted",
            "verificationFailed": "You have 1 integration for which verification failed | You have {count} integrations for which verification failed",
            "verificationFailedBanner": "1 integration has employment fields that didn't pass our verification. Scroll down to the affected integration to see which fields need correcting. | {count} integrations have employment fields that didn't pass our verification. Scroll down to the affected integrations to see which fields need correcting.",
            "verificationFailedInfo": "Scroll down to the affected integrations to see which fields need correcting.",
            "verificationFailedStatus": "Verification failed",
            "verificationFailedTooltip": "The integration has employment fields that didn't pass our verification.",
            "verifyDelete": "Are you sure that you want to delete the import?",
            "verifyDeleteIntegration": "Deleting this integration will remove it permanently. Employees' status will be set to inactive, but will be reverted if they’re imported from another integration. Are you sure you want to delete this integration?",
            "verifyDeleteVerification": "Are you sure you want to delete the import?",
            "verifying": "Validating values",
            "yearlyPayouts": "Number of yearly payouts",
            "youHaveCreated": "You have created an integration!",
            "yourDataCenter": "Your data center",
            "yourIntegrations": "Your integrations",
            "yyyy-mm-dd": "YYYY-MM-DD"
        },
        "myuser": {
            "changePassword": "Change password",
            "checklist": "Checklist:",
            "confirmPassword": "Confirm password",
            "currentPassword": "Current password",
            "email": "Email",
            "guessable": "Guessable",
            "handledBySSO": "Your account is handled by your IT department.",
            "hrDepartmentManaging": "Your HR department is managing your personal details for your account. Contact them if you need to make changes.",
            "invalidOldPassword": "Current password is wrong.",
            "language": "Preferred language",
            "minimumPasswordLength": "At least {required} characters ({current} of {required})",
            "name": "Name",
            "newPassword": "New password",
            "password": "Password",
            "passwordChangeFailed": "There was a problem changing your password.",
            "passwordChangeSuccess": "Your password was changed.",
            "passwordRequirements": "Password requirements",
            "passwordRequirementsNotMet": "Password requirements was not met.",
            "passwordStrength": "Password strength:",
            "passwordsDoNotMatch": "Passwords do not match.",
            "passwordsMatch": "Passwords match",
            "risky": "Risky",
            "safe": "Safe",
            "secure": "Secure",
            "userName": "Username",
            "usesSSO": "Your company uses single sign-on. If you need to change password, do it in your internal systems.",
            "weak": "Weak",
            "yourAccount": "Your account"
        }
    },
    "modules": {
        "analytics": {
            "filterFields": {
                "fteWorkHoursPerMonth": "@:glossary.fields.fteWorkHoursPerMonth",
                "yearlyPayouts": "@:glossary.fields.yearlyPayouts"
            }
        },
        "baseRegistry": {
            "fields": {
                "fteWorkHoursPerMonth": "@:glossary.fields.fteWorkHoursPerMonth"
            },
            "pages": {
                "details": {
                    "newSalary": "@:glossary.new @.lower:glossary.fields.baseSalary",
                    "newSalaryDescription": "When you create a new base salary, the employee's current salary will be saved as a historical salary. After you have created a new base salary, you will be able to update other employment data for the new base salary."
                },
                "employments": {
                    "inputIntMinAndMaxLengthError": "Value should be at least {min} and have the max-length of {maxLength}",
                    "inputIntMinError": "Value should be at least {min} ",
                    "inputMaxLengthError": "Value can be at most {maxLength} characters"
                }
            }
        },
        "customEmployeeBaseSalary": {
            "genderEquality": {
                "meanBaseSalary": "Mean base salary",
                "medianBaseSalary": "Median base salary",
                "payGapsBaseSalaryTextWithSentences": "Base salary is the fixed portion of your salary before variable pay. The mean base salary is {meanWomen} {currency}/{salaryType} for women and {meanMen} {currency}/{salaryType} for men. {meanPayGapSentence} For median base salaries {medianPayGapSentence}",
                "payGapsBaseSalaryTextWithSentencesSingleGender": "Base salary is the fixed portion of your salary before variable pay. Only {onlyGender} are included here, and their mean base salary is {onlyGenderMean} {currency}/{salaryType}. {meanPayGapSentence} For median base salaries {medianPayGapSentence}"
            }
        },
        "employee": {
            "pages": {
                "averagePayLevelsGradeSingleGender": "For jobs that are equally complex as your job (jobs in grade {grade}), {gender} earn {salary} on average. A pay gap cannot be calculated when the job profile has only one gender.",
                "averagePayLevelsGradeSingleGenderBaseSalary": "For jobs that are equally complex as your job (jobs in grade {grade}), {gender}'s base salary is {salary} on average. A pay gap cannot be calculated when the job profile has only one gender.",
                "averagePayLevelsGradeSingleGenderTotalSalary": "For jobs that are equally complex as your job (jobs in grade {grade}), {gender}'s total salary is {salary} on average. A pay gap cannot be calculated when the job profile has only one gender.",
                "averagePayLevelsJobProfileSingleGender": "In your job profile, {gender} earn {salary} on average. A pay gap cannot be calculated when the job profile has only one gender.",
                "averagePayLevelsJobProfileSingleGenderBaseSalary": "In your job profile, {gender}'s base salary is {salary} on average. A pay gap cannot be calculated when the job profile has only one gender.",
                "averagePayLevelsJobProfileSingleGenderTotalSalary": "In your job profile, {gender}'s total salary is {salary} on average. A pay gap cannot be calculated when the job profile has only one gender.",
                "noGenderInGroup": "There are no {gender} in this group"
            }
        },
        "employeeDashboard": {
            "cannotConvertSalaryType": "There is insufficient data to convert to a different salary type"
        },
        "importData": {
            "pages": {
                "salaryFileTemplate": {
                    "canBeUsedInFiltersHeading": "Can be used in filters",
                    "canBeUsedInPayGapHeading": "Can be used in pay philosophy / adjusted pay gap",
                    "dateFieldFallback": "YYYY-MM-DD, DD-MM-YYYY, or MM-DD-YYYY.",
                    "description": {
                        "additionalData": "Free text field for company-specific information.",
                        "averageHoursWorked": "Average number of hours worked per month.",
                        "baseSalary": "Base salary without additions. Indicated in full-time equivalent for the chosen salary type.",
                        "bonusBenefitsInKind": "Any in-kind benefit you can attach a value.",
                        "bonusOneTime": "One-off bonus payment that is not part of regular recurring pay.",
                        "bonusShortTerm": "Short-term performance based cash bonus or similar.",
                        "bonusTarget": "Monetary value of the employee's target bonus. It's for reference only. It isn't included in total salary or any calcuations.",
                        "compaRatio": "The employee's salary in relation to a benchmark, most often market salary.",
                        "companyCar": "Monetary value of any car allowance or company car benefit. Use leasing value of the car as equivalent to an allowance.",
                        "contract": "Collective agreements or similar that directly affects employee's salary.",
                        "contractType": "The legal form under which the employee is engaged by the organization.",
                        "contractedHours": "Number of contracted working hours per month",
                        "costCenter": "Financial cost center that the employee’s costs are charged to.",
                        "country": "The employment's country specified in the employment contract.",
                        "currency": "Currency of all monetary values for the employee.",
                        "email": "The employee's email.",
                        "employmentDate": "Date the employee started working in the company (first employment date).",
                        "employmentEndDate": "End date of employment for leavers. Keep it blank for active employments.",
                        "employmentForm": "Broad employment form describing how the employee is engaged by the company.",
                        "employmentNumber": "Internal \"number\" used in your HRIS systems or similar to identify specific employments. If employment number changes it will be seen as the employee getting a new employment.",
                        "employmentRate": "Percentage of full-time the employee is contracted to work.",
                        "equityLongTerm": "Value of long-term incentives such as stock options or long-term bonus plans.",
                        "ethnicity": "An employee's ethnicity. This is commonly a very sensitive data to store so it's your responsibility to ensure you have the rights to store the data in Sysarb",
                        "fteWorkHoursPerMonth": "Number of working hours per month for a full-time employee. Used together with existing employment data to convert between salary types.",
                        "identification": "Unique identifier for the employee.",
                        "isManager": "Whether the employee is a manager in the company.",
                        "lastPayIncrease": "How large the latest pay increase was for the employee.",
                        "legalEntity": "@:glossary.name of the legal entity (@.lower:glossary.employer) that the employee belongs to.",
                        "legalEntityCode": "A unique code for the legal entity (@.lower:glossary.employer). Suggestively, the organization number.",
                        "localCareerBand": "Career band or track used in your external job architecture framework.",
                        "localJobCode": "A job profile's unique ID. @:glossary.required if you want to save job descriptions.",
                        "localJobFamily": "Broad functional family the job profile belongs to",
                        "localJobProfile": "A group of jobs or position titles that has the same or very similar work assignments",
                        "localJobProfileGrade": "Grade or level assigned to the job profile in your job architecture",
                        "localSubFamily": "More detailed grouping inside a job family",
                        "locality": "Primary work area, such as city, region or site.",
                        "managerCode": "Used to describe seniority level of managers.",
                        "occupationalClassification": "The employee's legal or contractual staff category under the applicable agreement.",
                        "occupationalPension": "Employer’s cost or contribution to the occupational pension.",
                        "organizationalLevelFive": "Unit (see above).",
                        "organizationalLevelFour": "Division / Business Area (see above).",
                        "organizationalLevelOne": "Parent Company - this will be the headnode of your organization tree.",
                        "organizationalLevelSix": "Team",
                        "organizationalLevelThree": "Third highest layer in the organization of your company like Unit. With multiple legal entities under the company that sit in different countries, you may use legal entity here and put division / business area, and Unit further down.",
                        "organizationalLevelTwo": "Second highest layer in the organization of your company like Division or Business Area. With presence in multiple countries, you may use country here and put division further down.",
                        "overtime": "Actual amount paid for overtime.",
                        "paidHoliday": "Extra amount paid to employees during their leave on top of their normal salary. If applicable, can use the same field to calculate the monetary value of additional leave in lieu of overtime.",
                        "paidSickDays": "Number of paid sick days for the employee per year.",
                        "parentalLeaveDate": "{startOrEnd} date of the current or most recent parental leave period.",
                        "performance": "Overall performance rating for the employee for the relevant period.",
                        "positionLevel": "Seniority or level of the position in your internal structure.",
                        "positionTitle": "Employee’s current job title.",
                        "salaryDate": "Date from which the reported salary is valid.",
                        "salaryExchange": "The monetary value the employee salary exchanges. Base salary should not be reduced by the salary exchange when importing.",
                        "salaryIncrement": "Can use for variable pay like allowances.",
                        "salaryType": "Refers to the value indicated on the Salary field. If this is calculated on monthly, indicate Monthly. If annual value, put Yearly.",
                        "salaryYear": "When indicated salary applies.",
                        "statisticalCode": "Code used for external or internal statistical reporting (for example national classification such as DISCO or AID).",
                        "statutoryGrade": "The employee's grade or level under an applicable collective agreement or statutory pay framework.",
                        "swedishSocialSecurityNumber": "Unique identifier for the employee in a swedish personal identity number format.",
                        "timeInCurrentPosition": "Date the employee started in their current role or position.",
                        "unitNumber": "A specific organization unit's ID.",
                        "workName": "A group of employees with same or similar assignments that should be analyzed against each other.",
                        "workNumber": "The unique identifier for the work or job the employee is performing.",
                        "yearlyPayouts": "Number of regular salary payments per year."
                    },
                    "exampleOfValue": {
                        "averageHoursWorked": "18,5",
                        "baseSalary": "30000",
                        "benefitsInKind": "1000",
                        "carAllowance": "1000",
                        "compaRatio": "1,10",
                        "contract": "Trade union agreement",
                        "contractType": "Consultant",
                        "contractedHours": "165,5",
                        "costCenter": "42",
                        "country": "Sweden",
                        "currency": "SEK",
                        "email": "hello{'@'}sysarb.se",
                        "employmentNumber": "E-104587",
                        "employmentRate": "100",
                        "ethnicity": "African American",
                        "externalCareerBand": "IND",
                        "externalJobCode": "J05",
                        "externalJobFamily": "Human Resources",
                        "externalJobProfile": "HR Business Partner",
                        "externalJobProfileGrade": "7",
                        "externalSubfamily": "Generalist",
                        "firstName": "Anna",
                        "formOfEmployment": "Permanent employment",
                        "gender": "@:glossary.female",
                        "isManager": "@:glossary.yes",
                        "lastName": "Andersson",
                        "lastPayIncrease": "1000",
                        "legalEntityCode": "A-001",
                        "legalEntityName": "Sysarb Sweden AB",
                        "locality": "Stockholm",
                        "longTermIncentive": "1000",
                        "managerCode": "C",
                        "occupationalClassification": "White collar",
                        "occupationalPension": "1000",
                        "oneTimeBonus": "1000",
                        "organizationLevel1": "Sysarb",
                        "organizationLevel2": "Department A",
                        "organizationLevel3": "Department A",
                        "organizationLevel4": "Department A",
                        "organizationLevel5": "Department A",
                        "organizationLevel6": "Department A",
                        "overtime": "1000",
                        "paidHolidayAllowance": "1000",
                        "paidSickDays": "8",
                        "parentalLeaveEndDateDD_MM_YYYY": "2025-12-16",
                        "parentalLeaveEndDateMM_DD_YYYY": "12-16-2025",
                        "parentalLeaveEndDateYYYY_MM_DD": "2025-12-16",
                        "parentalLeaveStartDateDD_MM_YYYY": "2025-03-15",
                        "parentalLeaveStartDateMM_DD_YYYY": "03-15-2025",
                        "parentalLeaveStartDateYYYY_MM_DD": "2025-03-15",
                        "performance": "4",
                        "positionLevel": "Junior",
                        "positionTitle": "HR Business Partner",
                        "salaryExchange": "1000",
                        "salaryIncrement1": "1000",
                        "salaryIncrement2": "1000",
                        "salaryIncrement3": "1000",
                        "salaryType": "Monthly",
                        "salaryYear": "2025",
                        "shortTermIncentive": "1000",
                        "statisticalCode": "151012",
                        "statutoryGrade": "C3",
                        "swedishSocialSecurityNumber": "19950315-1234",
                        "targetBonus": "1000",
                        "uniqueId": "E-135",
                        "unitNumber": "U42",
                        "workName": "Case manager",
                        "workNumber": "154",
                        "yearlyPayouts": "12"
                    },
                    "fieldRequirements": {
                        "country": "Either the 3 letter abbreviation or full name according to ISO 3166-1 (alpha-3).",
                        "currency": "Three letter code according to ISO 4217 currency code.",
                        "dateField": "All dates should use the same format. {dateFormat}.",
                        "employmentNumber": "Must be consistent between imports to count as same employment. Can be left blank",
                        "gender": "We expect either \"{male}\", \"{female}\" or \"{notDeclared}\".",
                        "identification": "Must be unique and consistent between imports.",
                        "isManager": "We expect either \"@:glossary.yes \" or \"@:glossary.no \".",
                        "legalEntityCode": "Required if legal entity name is provided.",
                        "localCareerBand": "IND, MGT or EXE (Individual contributor, Manager, Executive).",
                        "managerCode": "Keep manager code empty if employee is not a manager. Can be alphanumerical codes.",
                        "organizationalLevel1": "All employees must have the same value as what’s currently set as the name for organization level 1 in Sysarb.",
                        "performance": "Leave blank if not applicable or employee has not been part of the appraisal cycle. Must be numerical if used as @.lower:glossary.payFactor.",
                        "salary": "Should be the full-time equivalent monterary value in the employee's salary type. Without comma or decimal points.",
                        "swedishSocialSecurityNumber": "Must be a valid swedish personal identity number or coordination number. Must be consistent between imports."
                    },
                    "fieldRequirementsColumnHeading": "Field requirements",
                    "usedFor": {
                        "averageHoursWorked": "Used to convert between actual and full-time equivalent salaries for hourly salaries.",
                        "email": "@:glossary.required to be able to log into Sysarb and receive emails.",
                        "employmentNumber": "Identifying specific employments for employees. Required if employee has multiple active employments.",
                        "ethnicity": "Used for doing an ethnicity analysis in pay equity audit.",
                        "externalJobArchitecture": "Used to import external job architecture.",
                        "externalJobArchitectureRequired": "Used to import external job architecture (@.lower:glossary.required).",
                        "fteWorkHoursPerMonth": "Used to convert salaries from hourly to monthly or yearly salary.",
                        "gender": "Used for all gender specific analysis and calculations.",
                        "identification": "Unique identifier for the employee.",
                        "isManager": "Used solely to move managers up one organization unit if they are placed within the same unit as their employees. This is to avoid managers setting their own salary during salary reviews.",
                        "legalEntityName": "Legal entity can be used to adapt the workflow in Sysarb to be per legal entity instead of only country.",
                        "organizationalLevel": "Used to limit what data users have access to.",
                        "parentalLeave": "Used to highlight which employees that's been on parental leave during analysis.",
                        "payFactor": "Possible @.lower:glossary.payFactor when calculating adjusted pay gap. Will be calculated as a {factorType} factor.",
                        "payGapCalculation": "Can be included in total salary used for pay gap calculations and analysis.",
                        "salaryType": "Used to determine what salary type the imported value is when converting between salary types.",
                        "statisticalCode": "Can be used in Sysarb job architectures to help you assign employees to the correct job profile.",
                        "statutoryGrade": "Used for creating category of workers in the pay equity audit based on a statutory framework.",
                        "unitNo": "Can be used as a replacement for organization levels once the structure is imported. Allows for modification in organization's names without disrupting existing structure.",
                        "work": "To create equal jobs in the pay equity audit. This works only if you don't have a job architecture.",
                        "yearlyPayouts": "Used to convert to yearly salaries."
                    },
                    "usedForColumnHeading": "Used for"
                },
                "settings": {
                    "editWatchedFields": "Edit watched fields",
                    "watchedFields": "@:modules.jobArchitecture.pages.employees.watchedFields",
                    "watchedFieldsDescription": "@:modules.settings.pages.copilot.preamble",
                    "watchedFieldsHeadingList": "Your watched fields"
                }
            }
        },
        "jobArchitecture": {
            "pages": {
                "employees": {
                    "watchedFields": "Watched fields"
                },
                "payRanges": {
                    "addPayRange": "Add pay range",
                    "applyPercentage": "Apply a percentage increase or decrease",
                    "clearPayRange": "Clear pay range",
                    "convertSalaryType": "Convert to a different salary type",
                    "deleteDisabled": "You can’t delete grades. Select other rows to delete them.",
                    "deleteFailed": "Failed to delete selected pay ranges",
                    "deleteModalDescription": "The following will happen when you delete pay ranges:",
                    "deleteModalReasonOne": "All selected rows will be deleted",
                    "deleteModalReasonThree": "Grade rows will remain",
                    "deleteModalReasonTwo": "Any children to the selected rows will be deleted",
                    "deletePayRange": "Delete pay range",
                    "editPayRange": "Edit pay range",
                    "editSalaryTypeDisabled": "Switch to edit mode in order to change the pay ranges’ salary type.",
                    "editSalaryTypeModalDescription": "If we need to normalize a salary and present it in relation to a pay range, we need to know what salary type it has. Changing a salary type for a country won’t change the values you have already inserted.",
                    "editSalaryTypeModalHeading": "Edit pay ranges salary type",
                    "editSalaryTypes": "Edit salary types",
                    "exportPayRanges": "Export (.xlsx)",
                    "moreOptions": "More options",
                    "setPayRangeFromActualMedian": "Set pay range spread from actual median",
                    "setPayRangeFromMid": "Set pay range spread from midpoint",
                    "title": "Pay ranges"
                }
            },
            "payRanges": {
                "actualMedianLabel": "Actual median ±",
                "actualSalaries": "Actual salaries",
                "addPayRanges": "Add pay ranges",
                "addingPayRanges": "Adding pay ranges...",
                "addingPayRangesProgress": "Adding pay ranges... {done} of {total}",
                "applyPercentageHeader": "Apply a percentage increase or decrease",
                "applySpreadFromActualMedianHeader": "Set pay range spread from actual median",
                "applySpreadFromMidpointHeader": "Set pay range spread from midpoint",
                "bulkMaxCrossValidationError": "Couldn't save one or more Max values since it was smaller than the pay ranges' Min values",
                "bulkMaxSmallerThanMin": "Max is smaller than min",
                "bulkMinCrossValidationError": "Couldn't save one or more Min values since it was larger than the pay ranges' Max values",
                "bulkMinLargerThanMax": "Min is larger than max",
                "bulkNegativeValue": "Value can't be negative",
                "conversionFactorLabel": "Factor",
                "convertSalaryTypeHeader": "Convert to a different salary type",
                "divideBy": "Divide by",
                "filters": {
                    "noItemsTooltip": "There are no created pay ranges based on this type of data",
                    "otherAll": "Other/All {type}"
                },
                "hasEmployees": "Has employees",
                "maxSmallerThanMin": "Couldn't save Max since it was smaller than Min",
                "midpointLabel": "Midpoint ±",
                "midpointNotCentered": "Midpoint is not centred between min and max",
                "minLargerThanMax": "Couldn't save Min since it was larger than Max",
                "multiplyBy": "Multiply by",
                "negativeValue": "Couldn't save value since it can't be negative",
                "noEmployees": "No employees",
                "noEmployeesWithField": "You have no employees in your organisation with this {field}.",
                "noItemsLeftToAdd": "There are no more items left to add",
                "noMedianForSelection": "Couldn't set a pay range for one or more rows since they have no employees to take a median salary from",
                "nodeTypes": {
                    "career": "Career",
                    "contract": "Contract",
                    "country": "Country",
                    "grade": "Grade",
                    "jobFamily": "Job family",
                    "jobProfile": "Job profile",
                    "legalEntity": "Legal entity",
                    "locality": "Locality",
                    "subFamily": "Sub-family"
                },
                "nothingToAdd": "There are no pay ranges to add to this row. | There are no pay ranges to add to the selected rows.",
                "nothingToEdit": "Placeholder rows can't be edited.",
                "payRangesCleared": "Pay ranges have been cleared",
                "payRangesDecreased": "Pay ranges have been decreased by {percent}%",
                "payRangesIncreased": "Pay ranges have been increased by {percent}%",
                "payRangesUpdated": "Pay ranges have been updated",
                "payRangesUpdatedWithMedian": "Pay ranges have been updated with actual median salary",
                "percentageLabel": "Change by",
                "placeholderName": "All {type}",
                "placeholderNameOther": "Other {type}",
                "placeholderTooltipAll": "This pay range applies to employees belonging to any {type}.",
                "placeholderTooltipOther": "This pay range applies to employees not belonging to any of the specified {type}.",
                "rows": "row | rows",
                "salaryTypesUpdated": "Salary type has successfully been updated for {count} country | Salary type has successfully been updated for {count} countries",
                "sections": {
                    "addParentTo": "Add parent to: {name}",
                    "addTo": "Add to: {name}",
                    "addToOther": "Add to: Other {type} in {name}",
                    "addToOtherLegalEntities": "Add to: Other legal entities in {name}"
                },
                "selectOperation": "Select operation"
            }
        },
        "login": {
            "criticalSettingsMissing": {
                "description": "This is most likely caused by a scheduled update running in the background. Please wait a few minutes and refresh the page. If the problem persists after that, contact your administrator.",
                "header": "Access temporarily unavailable"
            }
        },
        "payEquityAudit": {
            "pages": {
                "onboarding": {
                    "general": {
                        "comparativeJobAnalysisDescription": "In the comparative job analysis you analyze salary differences between female dominated jobs against non-female dominated jobs with same or lower grade. This analysis is meant to spot gender discrimination between jobs.",
                        "comparativeJobAnalysisQuestion": "Do you want to do a comparative job analysis?",
                        "includeComparativeJobAnalysis": "Include comparative job analysis",
                        "includeComparativeJobAnalysisLine1": "Analyze salary differences between female dominated and non-female dominated jobs.",
                        "includeComparativeJobAnalysisLine2": "Required to comply with Swedish legislation.",
                        "skipComparativeJobAnalysis": "Skip comparative job analysis",
                        "skipComparativeJobAnalysisLine1": "Is not compliant with Swedish legislation."
                    }
                },
                "pay-philosophy": {
                    "analysisLoading": "Analyzing pay factors...",
                    "detailedPanel": {
                        "summary": {
                            "biggestImpact": "{factors} have the biggest impact.",
                            "paragraph": "Without accounting for any pay factors your unadjusted pay gap is {unadjustedPayGap}. But {explainedPayGap} can be explained by your pay factors. However, {adjustedPayGap} remains unexplained and is your adjusted pay gap.",
                            "smallestImpact": "{factors} have the smallest impact."
                        }
                    },
                    "factorTable": {
                        "factorLinkAriaLabel": "Scroll to {factor} breakdown",
                        "goToFactor": "Go to factor",
                        "seeDetails": "See details"
                    },
                    "modelStrength": {
                        "ariaLabel": "{heading}, {value}, scale from {min} to {max}",
                        "descriptions": {
                            "good": "The regression analysis for both men and women is reliable and can give meaningful insights.",
                            "moderate": "The regression analysis for both men and women can give insights but can miss nuances.",
                            "strong": "The regression analysis for both men and women is reliable and can give meaningful insights.",
                            "weak": "The regression analysis for both men and women is weak meaning it won't give any meaningful insights."
                        },
                        "directMethod": {
                            "descriptions": {
                                "good": "The regression analysis is reliable and can give meaningful insights.",
                                "moderate": "The regression analysis can give insights but can miss nuances.",
                                "strong": "The regression analysis is reliable and can give meaningful insights.",
                                "weak": "The regression analysis is weak meaning it won't give any meaningful insights."
                            }
                        },
                        "levels": {
                            "good": "Strong model fit",
                            "moderate": "Moderate model fit",
                            "strong": "Excellent model fit",
                            "weak": "Weak model fit"
                        },
                        "noModelFit": "No model fit",
                        "noModelFitDescription": "We couldn't calculate your regression model.",
                        "r2KeyValues": {
                            "direct": "Adjusted r²",
                            "men": "Adjusted r² Men",
                            "women": "Adjusted r² Women"
                        }
                    }
                },
                "report": {
                    "currentTotalSalary": "@:glossary.current @.lower:glossary.fields.totalSalary",
                    "newTotalSalary": "@:glossary.new @.lower:glossary.fields.totalSalary"
                },
                "review": {
                    "analysisType": "Analysis",
                    "analysisTypeLite": "Lite",
                    "analysisTypeStandard": "Standard",
                    "analyzeManually": "Manually",
                    "analyzePredictedSalaries": "Predicted salaries"
                },
                "settingsModal": {
                    "salaryReviews": {
                        "salaryType": {
                            "hourlySalaries": "@:modules.payEquityAudit.salaryTypes.hourlySalaries",
                            "monthlySalaries": "@:modules.payEquityAudit.salaryTypes.monthlySalaries",
                            "yearlySalaries": "@:modules.payEquityAudit.salaryTypes.yearlySalaries"
                        }
                    }
                }
            },
            "salary-factors": {
                "age": {
                    "distribution": "{genderHigherMean} are generally older than {genderLowerMean} in your organisation.",
                    "salaryProgression": "Men's salary {maleVerb} by {maleSalaryIncrease} per year while women's salary {femaleVerb} by {femaleSalaryIncrease}"
                },
                "categorical": {
                    "aliasExcludedFactors": "{count} {factor} is aliased and has been excluded. This - {factor} can't be used to determine the effect on adjusted pay gap nor predicted salaries | {count} {factor}s are aliased and have been excluded. These {factor}s can't be used to determine the effect on adjusted pay gap nor predicted salaries",
                    "excluded": {
                        "aliased": "This category is too closely correlated with another factor and its individual effect cannot be calculated.",
                        "referenceCategory": "This is the reference category used as the baseline for comparing other categories in the analysis. {menPercentage} of men and {womenPercentage} of women belong to this category.",
                        "singleGender": "This category only has employees of one gender and we can't calculate the effect on the adjusted pay gap nor its impact on employees' predicted salary."
                    },
                    "referenceCategoryDisclaimer": "The values below are with respect to the dropped reference {factor} and will change if a different reference is used.",
                    "salaryProgression": {
                        "femaleDecrease": "women's decreases by {effect}",
                        "femaleIncrease": "women's increases by {effect}",
                        "maleDecrease": "Men's salary decreases by {effect}",
                        "maleIncrease": "Men's salary increase by {effect}",
                        "noChange": "no change",
                        "summary": "{maleProgression} while {femaleProgression} from working in this {term}",
                        "summaryWithReference": "{maleProgression} while {femaleProgression} from working in {term} compared to {referenceTerm}"
                    },
                    "singleGenderExcludedFactors": "{count} {factor} is single gendered and has been excluded. This {childName} {factor} can't be used to determine the effect on adjusted pay gap nor predicted salaries | {count} {factor}s are single gendered and have been excluded. These {factor}s can't be used to determine the effect on adjusted pay gap nor predicted salaries"
                },
                "decreasesPayGapBy": "Changes the adjusted pay gap by",
                "employmentTime": {
                    "distribution": "{genderHigherMean} generally have longer company tenure than {genderLowerMean} in your organisation.",
                    "salaryProgression": "Men's salary {maleVerb} by {maleSalaryIncrease} per year of tenure while women's salary {femaleVerb} by {femaleSalaryIncrease}"
                },
                "errors": {
                    "001": {
                        "description": "Your selected pay factors are too similar to each other. This prevents the model from distinguishing their individual effects on salary. Deselect one or more pay factors.",
                        "title": "Too many correlations"
                    },
                    "001s": {
                        "description": "Some factors were automatically excluded due to high correlation: {factors}",
                        "title": "Factors are too closely correlated"
                    },
                    "002": {
                        "description": "You have a weak model fit meaning the results isn't reliable. Remove insignificant factors and add more pay factors.",
                        "title": "Weak model"
                    },
                    "003": {
                        "description": "The adjusted pay gap is already within range of the required pay gap.",
                        "title": "Pay gap within range"
                    },
                    "004": {
                        "description": "Something went wrong when calculating the pay gap. Please try deselecting some pay factors.",
                        "title": "Something went wrong"
                    },
                    "005": {
                        "description": "You haven't imported any employees to the audit meaning we can't calculate your adjusted pay gap.",
                        "title": "No employments in the audit"
                    },
                    "006": {
                        "description": "No cost to close strategy was provided for this audit.",
                        "title": "No strategy provided"
                    },
                    "007": {
                        "description": "We couldn't successfully calculate the regression model. This may be due to data quality issues. Please check your data for anomalies and try again.",
                        "title": "Model failed"
                    },
                    "008": {
                        "description": "You have more factors selected than your data can reliably support. This can lead to overfitting and unreliable results. Deselect one or more pay factors.",
                        "title": "Perfect fit"
                    },
                    "009": {
                        "description": "Something went wrong when calculating the pay gap. Please try deselecting some pay factors.",
                        "title": "Something went wrong"
                    },
                    "010": {
                        "description": "You have only one gender represented in your audit meaning we can't calculate your adjusted pay gap.",
                        "title": "Single gender"
                    },
                    "011": {
                        "description": "Employees all have the same value in {factors}. The factors don't offer any meaningful insights. Remove them from the model.",
                        "title": "Constant predictors"
                    },
                    "012": {
                        "description": "We couldn't successfully calculate the regression model. This may be due to data quality issues. Please check your data for anomalies and try again.",
                        "title": "Model failed"
                    },
                    "013": {
                        "description": "We couldn't successfully calculate the regression model. This may be due to data quality issues. Please check your data for anomalies and try again.",
                        "title": "Model failed"
                    },
                    "014": {
                        "description": "We were unable to calculate the individual impact of each pay factor on the adjusted pay gap. Rest assured, it doesn't affect the adjusted pay gap.",
                        "title": "Results may have reduced precision"
                    },
                    "default": {
                        "description": "Something went wrong when calculating the pay gap. Please try deselecting some pay factors.",
                        "title": "Something went wrong"
                    }
                },
                "increasesPayGapBy": "Increases the adjusted pay gap by",
                "menHasHigherMeanThanWomen": "Men has higher mean grade than women.",
                "numerical": {
                    "decreaseVerb": "decreases",
                    "impact": "{factor} is generally higher for {higherGender} than {lowerGender} which accounts for {percentage} of the pay gap.",
                    "increaseVerb": "increases",
                    "noImpact": "This factor has no significant impact on the pay gap."
                },
                "numericalFactor": {
                    "distribution": "Men are generally higher than Women in your organisation"
                },
                "overallEffect": {
                    "decreases": "When adding up the effects on the adjusted pay gap from each {factor} the final result is that {factor} decreases the adjusted pay gap by {effect}",
                    "increases": "When adding up the effects on the adjusted pay gap from each {factor} the final result is that {factor} increases the adjusted pay gap by {effect}"
                },
                "performance": {
                    "distribution": "{genderHigherMean} generally achieve higher performance scores than {genderLowerMean} in your organisation.",
                    "salaryProgression": "Men's salary {maleVerb} by {maleSalaryIncrease} per performance point while women's salary {femaleVerb} by {femaleSalaryIncrease}"
                },
                "positionLevel": {
                    "distribution": "{genderHigherMean} are generally at a higher position level than {genderLowerMean} in your organisation.",
                    "salaryProgression": "Men's salary {maleVerb} by {maleSalaryIncrease} per position level while women's salary {femaleVerb} by {femaleSalaryIncrease}"
                },
                "significanceEffect": {
                    "affectedByBoth": "Salary is highly likely to be affected by {factor} for both men and women",
                    "affectedByMen": "Salary is highly likely to be affected by {factor} for men, but unlikely for women",
                    "affectedByNone": "Salary is unlikely to be affected by {factor} for both men and women",
                    "affectedByWomen": "Salary is highly likely to be affected by {factor} for women, but unlikely for men"
                },
                "timeInCurrentPosition": {
                    "distribution": "{genderHigherMean} generally have longer job tenure than {genderLowerMean} in your organisation.",
                    "salaryProgression": "Men's salary {maleVerb} by {maleSalaryIncrease} per year in current position while women's salary {femaleVerb} by {femaleSalaryIncrease}"
                },
                "valuationPoints": {
                    "distribution": "{genderHigherMean} generally have higher valuation points than {genderLowerMean} in your organisation.",
                    "salaryProgression": "Men's salary {maleVerb} by {maleSalaryIncrease} per valuation point while women's salary {femaleVerb} by {femaleSalaryIncrease}"
                },
                "verb": {
                    "decreases": "decreases",
                    "increases": "increases"
                },
                "womenHasHigherMeanThanMen": "Women has higher mean grade than men."
            },
            "salaryTypes": {
                "hourlySalaries": "Hourly Salaries",
                "monthlySalaries": "Monthly salaries",
                "yearlySalaries": "Yearly salaries"
            }
        },
        "settings": {
            "pages": {
                "apiKeys": {
                    "backToList": "Back to API keys",
                    "columns": {
                        "actions": "Actions",
                        "created": "Created",
                        "expires": "Expires",
                        "key": "Key",
                        "name": "Name",
                        "scopes": "Scopes",
                        "scopesTooltip": "Scope defines what this API key is allowed to do. It limits the key to specific actions and resources, so a key can only access what it's explicitly granted.",
                        "status": "Status"
                    },
                    "create": "Create new key",
                    "createModalTitle": "Create API key",
                    "description": "Create and manage API keys for the public Sysarb API. Keys grant programmatic access scoped to selected capabilities.",
                    "detail": {
                        "metadata": "Metadata",
                        "revokedNote": "This key has been revoked and can no longer be used.",
                        "scopes": "Scopes"
                    },
                    "docs": "API documentation",
                    "edit": {
                        "action": "Edit scopes",
                        "success": "API key scopes updated."
                    },
                    "empty": {
                        "body": "You have not created any API keys yet. Create one to get programmatic access to Sysarb.",
                        "noActive": {
                            "body": "All your API keys are revoked. Enable 'Show revoked keys' to view them, or create a new one.",
                            "title": "No active API keys"
                        },
                        "title": "No API keys yet"
                    },
                    "errors": {
                        "loadFailed": "Failed to load API keys."
                    },
                    "expiry": {
                        "1y": "1 year",
                        "30d": "30 days",
                        "90d": "90 days",
                        "custom": "Custom date",
                        "never": "Never"
                    },
                    "fields": {
                        "created": "Created at",
                        "environment": "Environment",
                        "expires": "Expires at",
                        "expiry": "Expiry",
                        "expiryInfo": "When the key automatically stops working.",
                        "id": "ID",
                        "name": "Name",
                        "nameInfo": "A short, descriptive label so you recognise this key later.",
                        "nameInvalid": "Name must be between 1 and 200 characters.",
                        "namePlaceholder": "e.g. Integration with Benifex",
                        "revoked": "Revoked at",
                        "revokedReason": "Revocation reason",
                        "scopes": "Scopes",
                        "scopesInfo": "Capabilities this key is allowed to use. At least one is required.",
                        "scopesInvalid": "Select at least one scope.",
                        "subdomain": "Subdomain"
                    },
                    "reveal": {
                        "acknowledgement": "I have copied this secret and stored it somewhere safe.",
                        "secretLabel": "API key (shown only once)",
                        "title": "Copy your new API key",
                        "warning": "This is the only time the full key will be shown. Copy it now — Sysarb will never display it again."
                    },
                    "revoke": {
                        "action": "Revoke key",
                        "body": "Once the key is revoked, any data sent to or from this API key will stop. Are you sure you want to revoke the API key?",
                        "confirm": "Revoke key",
                        "confirmNameLabel": "Type the key name \"{name}\" to confirm.",
                        "confirmNameMismatch": "Name does not match.",
                        "reasonLabel": "Reason for revocation",
                        "reasonPlaceholder": "e.g. Replaced by a new integration",
                        "success": "API key revoked.",
                        "title": "Revoke API key",
                        "warning": "Revoking this key is permanent. Any integration still using it will start receiving 401 errors immediately."
                    },
                    "scopes": {
                        "columns": {
                            "description": "Description",
                            "read": "Read",
                            "scope": "Scope",
                            "write": "Write"
                        },
                        "connectivityLabel": "Connectivity",
                        "involveLabel": "Involve",
                        "involveUpsell": "Involve isn't part of your current package. Upgrade to Involve to let API keys read job profiles and other Involve data.",
                        "readAriaLabel": "Allow read access for {scope}",
                        "readConnectivity": "Read connectivity check endpoints",
                        "readInvolve": "Read Involve endpoints, such as job profiles",
                        "writeAriaLabel": "Allow write access for {scope}"
                    },
                    "showRevoked": "Show revoked keys",
                    "status": {
                        "active": "Active",
                        "expired": "Expired",
                        "revoked": "Revoked"
                    },
                    "title": "API keys",
                    "viewDetail": "View details"
                },
                "copilot": {
                    "preamble": "After you import data into Sysarb we’ll look if any of the watched fields have been updated for your employees. All employees with updates will be compiled into a to-do list where you can review their assigned job profiles."
                },
                "labs": {
                    "payRangesV2": "Pay ranges V2"
                },
                "userProvisioning": {
                    "activateRoleProvisioning": "Activate role provisioning",
                    "activateRoleProvisioningModal": {
                        "activateButton": "Activate user provisioning",
                        "confirmCheckbox": "I have confirmed that I understand that all existing roles will be removed from Sysarb",
                        "consequence1": "Remove all existing roles in Sysarb. All roles will now be managed via your user & role provisioning.",
                        "consequence2": "Create the assigned roles for the groups and users.",
                        "consequence3": "All employees will be given access to Sysarb unless you have blocked access for specific roles.",
                        "description": "Activating role provisioning will do the following:",
                        "title": "Before you activate role provisioning",
                        "warning": "Activating SCIM will remove all current role assignments from Sysarb. Make sure you have at least one assigned role and organization to your administrators to avoid locking yourself out of Sysarb."
                    },
                    "activateUserProvisioning": {
                        "description": "We won't create any roles via user provisioning in Sysarb until you have activated it. This is to give you time to set everything up, since all future role management will be handled via your user provisioning. All existing roles created directly in Sysarb will be removed once you activate it.",
                        "title": "{index} Activate user provisioning (SCIM) in Sysarb"
                    },
                    "allGroupsAssignedCallout": "All groups have been assigned a role and organization. Remember to activate the role provisioning when you're ready.",
                    "apiKeyRegenerateFailed": "Failed to regenerate API key",
                    "apiKeyRegenerated": "API key was successfully regenerated",
                    "assignRoleAndOrganization": {
                        "description": "When the SCIM configuration to Sysarb is set up in your identity provider, we'll receive groups and users that you need to assign a role and organization. The page will be updated and display a table where you can manage groups' and users' roles. If you're using extended SCIM, this step will be partially or fully completed automatically.",
                        "title": "{index} Assign role and organization to your provisioned groups and users"
                    },
                    "assignedRolesAndOrganizations": "Assigned roles and organizations",
                    "contactItSupport": {
                        "description": "To set up user provisioning using SCIM, you'll need to add information in your identity provider (IdP). This is typically managed by either your IT-support or a dedicated resource managing identity and access management (IAM).",
                        "guideLink": "You can find a more detailed guide here.",
                        "title": "{index} Contact your IT-support or your resource responsible for identity and access management"
                    },
                    "deactivateRoleProvisioning": "Deactivate role provisioning",
                    "deactivateRoleProvisioningModal": {
                        "consequence1": "Roles will no longer be updated by changes from the \"User & role provisioning (SCIM)\" page. This applies for both manual changes and updates via identity provider.",
                        "consequence2": "All roles will need to be managed manually via \"employee management\" pages.",
                        "consequence3": "All existing roles will remain.",
                        "description": "When you deactivate role provisioning, the following will happen:"
                    },
                    "delete": {
                        "deleteConsequence1": "We'll delete your API-key.",
                        "deleteConsequence2": "We'll receive no more updates from your identity provider.",
                        "deleteConsequence3": "All users and roles will need to be managed manually via \"employee management\" pages.",
                        "deleteConsequence4": "All existing users and roles will remain.",
                        "deleteScimIntegration": "Delete SCIM integration",
                        "deleteScimIntegrationDescription": "When you delete the SCIM integration the following will happen:"
                    },
                    "description": "SCIM can be used for user provisioning which lets you automate roles. It's recommended that you combine it with using single-sign on (SSO). Setting up SCIM requires you to make preparations beforehand. Follow the step-by-step guide below.",
                    "dividerText": "Following steps are done in Sysarb after the identity provider is configured",
                    "grid": {
                        "createdAt": "Created",
                        "editOrganization": "Edit organization",
                        "editRole": "Edit role",
                        "employees": "Employees",
                        "groupId": "Group ID",
                        "groupName": "Group name",
                        "noGroupsFound": "No groups found",
                        "noGroupsFoundDescription": "Try adjusting your search or filters.",
                        "organization": "Organization",
                        "organizationLockedTooltip": "All selected groups have an organization set by SCIM",
                        "role": "Role",
                        "roleLockedTooltip": "All selected groups have a role set by SCIM",
                        "selectOrganization": "Select organization",
                        "selectRole": "Select role"
                    },
                    "helpArticleTooltip": "Open SCIM integration setup guide",
                    "matchEmployeeAttribute": {
                        "description": "Choose the attribute we should use to match provisioned users to employees in Sysarb. Your IdP must send this attribute for every user. Users without it will not be matched.",
                        "title": "{index} Determine matching attribute for users",
                        "attributeLabel": "Matching attribute",
                        "tooltip": "Provisioned users are matched to employees already imported in Sysarb. Select which attribute/field to match on, and make sure your IdP sends it for users you provision."
                    },
                    "notSelected": "Not selected",
                    "notifications": {
                        "duplicateRoleOrganizationCombination": "This role and organization combination already exists on another group. Please select another role or organization.",
                        "organizationUpdated": "Organization has been updated",
                        "roleProvisioningActivated": "Role provisioning has been activated",
                        "roleProvisioningDeactivated": "Role provisioning has been deactivated",
                        "roleUpdated": "Role has been updated",
                        "scimIntegrationDeleted": "SCIM integration has been deleted"
                    },
                    "reviewRoleAccess": {
                        "button": "Manage role access",
                        "description": "When activating SCIM, all employees that have a role assigned to them will be given access to Sysarb. If you prefer, you can temporarily block certain roles from logging into Sysarb and reactivate them at a later date.",
                        "title": "{index} Ensure you have reviewed your roles' access to Sysarb"
                    },
                    "roleProvisioning": "Role provisioning",
                    "roleProvisioningType": {
                        "title": "{index} Determine whether roles should be group or user provisioned",
                        "description": "Choose whether roles are provisioned per user or from your groups. You can change this later.",
                        "roleTypeLabel": "Roles are provisioned from",
                        "groupButton": "Group Provisioning",
                        "userButton": "User Provisioning",
                        "changeRoleProvisioningType": {
                            "description": "This changes how Sysarb reads roles from your IdP. The following will happen if you update role provisioning:",
                            "consequence1": "All existing roles will be removed",
                            "consequence2": "Roles will be created from your IdP in the next sync",
                            "title": "Update role provisioning",
                            "updateButtonLabel": "Update provisioning"
                        }
                    },
                    "scimConfiguration": "SCIM configuration",
                    "setUpScimConfiguration": {
                        "apiKeyDescription": "The API-key is used to configure your SCIM integration between Sysarb and your identity provider. For security reasons, we can't display the current one. If required, you can regenerate a new one and switch it in your identity provider (IdP).",
                        "apiKeyHint": "Your current API-key remains active until replaced in your IdP",
                        "apiKeyLabel": "API key",
                        "consequence1": "Existing roles and users created in Sysarb via SCIM will remain unchanged.",
                        "consequence2": "No updates to existing or new roles and users will be synced until the new API key have been added to your IdP",
                        "description": "The following details will need to be added to your identity provider. Copy and send these details to the person helping you set up the user provisioning (SCIM).",
                        "generate": "Generate",
                        "regenerate": "Regenerate",
                        "title": "{index} Set up a SCIM configuration to Sysarb in your identity provider",
                        "urlLabel": "URL"
                    },
                    "setUpSingleSignOn": {
                        "button": "Set up single sign-on",
                        "buttonDisabledTooltip": "Single sign-on is currently not available on this domain.",
                        "description": "We strongly recommend you set up your single sign-on (SSO) before getting started with user provisioning (SCIM). User provisioning and single sign-on is typically managed in the same software, so you'll need the help of your IT-support to set it up.",
                        "title": "{index} Set up single sign-on (SSO)"
                    },
                    "title": "User & role provisioning (SCIM)",
                    "userProvisioning": "User provisioning"
                }
            }
        }
    },
    "no": "No",
    "notifications": {
        "newVersionAvailable": "A new version of the application is available. 🎉",
        "openUnsavedSettings": "Open",
        "reloadClient": "Update page",
        "salary_import_complete": "Your salary file was imported successfully.",
        "salary_import_failed": "There was a problem importing your salary file.",
        "unsavedCountrySettings": "Unsaved dashboard changes in {count} country.\nEmployees won't see any details until you save. | Unsaved dashboard changes in {count} countries.\nEmployees won't see any details until you save.",
        "unsavedLegalEntitySettings": "Unsaved dashboard changes in {count} legal entity.\nEmployees won't see any details until you save. | Unsaved dashboard changes in {count} legal entities.\nEmployees won't see any details until you save."
    },
    "options": {
        "AnalysisReasonCodes": {
            "AG-": {
                "Explanation": "Automated analysis identified {count} employments recommended for analysis, as we have found unusual salaries in relation to age.",
                "ShortDescription": "Chosen because of age and salary",
                "category": "Age"
            },
            "CO-": {
                "Explanation": "Automated analysis identified {count} employments recommended for analysis, as we have found salaries that lie outside the defined limit.",
                "ShortDescription": "Outside average",
                "category": "Outside average"
            },
            "CT-": {
                "Explanation": "Cost to close identified {count} employments recommended for analysis, as we have found salaries that standout in relation to the rest of the group.",
                "ShortDescription": "Chosen because of cost to close",
                "category": "Cost to close"
            },
            "ET-": {
                "Explanation": "Automated analysis identified {count} employments recommended for analysis, as we have found unusual salaries in relation to employment length.",
                "ShortDescription": "Chosen because of employment length and salary",
                "category": "Employment date"
            },
            "JG-": {
                "Explanation": "Automated analysis recommends to analyze all {gender} in the group.",
                "ShortDescription": "",
                "category": "Gender"
            },
            "MH-": {
                "Explanation": "Automated analysis identified {count} employments recommended for analysis, as we have found employments that standout in relation to the rest of the group.",
                "ShortDescription": "Chosen because of mahalabonis distance",
                "category": "Outlier"
            },
            "NR-": {
                "ShortDescription": "Employment shouldn't be analyzed"
            },
            "OO-": {
                "ShortDescription": "Other",
                "category": "Other"
            },
            "OU-": {
                "Explanation": "Automated analysis identified {count} employments recommended for analysis, as we have found salaries regarded as outliers in the group.",
                "ShortDescription": "Outliers",
                "category": "Outlier"
            },
            "WG-": {
                "Explanation": "Automated analysis identified {count} employments recommended for analysis, as we have found salaries that standout in relation to the rest of the group.",
                "ShortDescription": "Chosen because of salary",
                "category": "Salary"
            },
            "categories": {
                "age": "Age",
                "all": "All",
                "changeGroup": "New employments in the group",
                "costtofix": "Cost to close",
                "customOutlier": "Outside median",
                "employmentDate": "Company tenure",
                "gender": "Gender",
                "other": "Other",
                "outlier": "Outlier",
                "salary": "Salary"
            }
        },
        "RoleJunctionRoleOption": {
            "-1": "No value",
            "0": "",
            "10": "Root",
            "100": "Union",
            "110": "Equal pay audit assistant",
            "120": "HR Business Partner",
            "20": "System administrator",
            "30": "Consultant",
            "40": "Employee",
            "50": "Manager",
            "60": "Section manager",
            "70": "Operational administrator",
            "80": "Administrator",
            "90": "Read only",
            "null": ""
        }
    },
    "powered-by": "Powered by",
    "regression": {
        "intercept": "Intercept",
        "r": "r",
        "rSquared": "r²",
        "slope": "Slope",
        "standardError": "Standard error"
    },
    "reports": {
        "csrd": {
            "above50": "> 50",
            "below30": "< 30",
            "between30To50": "30 - 50",
            "contractType": "Contract type",
            "countFemales": "Count females",
            "countMales": "Count males",
            "countNotDeclared": "Count non-disclosed",
            "femaleBaseSalary": "Female base salary",
            "femaleTotalSalary": "Female total salary",
            "femaleVariableSalary": "Female variable",
            "fileName": "CSRD - ESRS S1 (Workforce)",
            "fullTimeWorkers": "Full time workers",
            "genderPayGaps": "Gender pay gaps",
            "global": "Global",
            "globalPayGapExcluded": "Employments excluded (unsupported currency)",
            "globalPayGapHeader": "Global pay gap (currency-converted)",
            "globalPayGapMeanBase": "Mean pay gap – base salary",
            "globalPayGapMeanTotal": "Mean pay gap – total salary",
            "globalPayGapMedianBase": "Median pay gap – base salary",
            "globalPayGapMedianTotal": "Median pay gap – total salary",
            "globalTitle": "CSRD - ESRS S1 - Own workforce",
            "headCount": "Headcount",
            "headCountGlobal": "Headcount global",
            "headCountLargeCountries": "Headcount in large countries (≥50 emp, ≥10%)",
            "highestPay": "Highest pay",
            "leftUndertaking": "Left undertaking",
            "maleBaseSalary": "Male base salary",
            "maleTotalSalary": "Male total salary",
            "maleVariableSalary": "Male variable",
            "medianPay": "Median",
            "nullRenumeration": "Annual Renumeration Ratio (highest paid individual vs median)",
            "partTimeWorkers": "Part time workers",
            "payGapBaseSalary": "Pay gap base salary",
            "payGapTotalSalary": "Pay gap total salary",
            "payGapVariableSalary": "Pay gap variable",
            "percentOfGlobal": "Percent of global",
            "percentage30To50": "% 30-50",
            "percentageAbove50": "% > 50",
            "percentageFemales": "Percentage females",
            "percentageMales": "Percentage male",
            "percentageNotDeclared": "Percentage non-disclosed",
            "percentageOfSection": "Percentage of section",
            "ratio": "Ratio",
            "unknownCountry": "Unknown country",
            "workForce": "Workforce",
            "workersAgeBands": "Worker age bands",
            "workersAtTopManagementLevel": "Workers at top management level (workers in \"Executive\" career band)"
        }
    },
    "reservedTerminology": {
        "actionPlan": "action plan",
        "adjustedPayGap": "adjusted pay gap",
        "baseSalary": "base salary",
        "equalWork": "equal work",
        "equivalentWork": "equivalent work",
        "higherPay": "higher pay",
        "lowerPay": "lower pay",
        "payAudit": "pay equity audit",
        "payGap": "pay gap",
        "requiresInvestigation": "requires investigation",
        "salaryAdjustment": "salary adjustment",
        "salarySupplement": "salary supplement",
        "unadjustedPayGap": "unadjusted pay gap",
        "variablePay": "variable pay"
    },
    "reviewStatus": {
        "0": "New",
        "1": "Started",
        "2": "Completed",
        "3": "Answered",
        "4": "Activated",
        "5": "Waiting for verification",
        "6": "Waiting for sending date"
    },
    "salary": {
        "currency": "{salary} {currency}",
        "currencyPerHour": "{salary} {currency}/hour",
        "currencyPerMonth": "{salary} {currency}/month",
        "currencyPerYear": "{salary} {currency}/year",
        "perHour": "{salary}/hour",
        "perMonth": "{salary}/month",
        "perYear": "{salary}/year",
        "salaryTypeAxisLabel": "{salaryType} salary"
    },
    "salaryTypes": [
        "Yearly",
        "Monthly",
        "Hourly",
        "Yearly, Total compensation",
        "Monthly, Total compensation",
        "Hourly, Total compensation"
    ],
    "start": "Start page",
    "system": {
        "absolute": "Absolute",
        "accessDenied": "Due to an unexpected error you have currently been logged out. If you are currently editing something, copy your work before refreshing the page to log in again.",
        "accessNotAllowedForRoleOnInstance": "Access for this role on this instance is not allowed.",
        "accessToNoServerInstances": "Too bad, it seems like you don't have access to any customers.",
        "add": "Add",
        "allOrganisationNodes": "All organisation nodes",
        "analysed": "Analysed",
        "and": "and",
        "averageAge": "Average age",
        "averageYearsOfEmployment": "Average company tenure",
        "back": "Back",
        "backendError": "We encountered an error while fetching the data. Refresh the page or come back later. If the problem persists, don't hesitate to contact Customer Success.",
        "cancel": "Cancel",
        "cannotResetBecauseNoChanges": "Cannot reset because there are no changes made",
        "cannotSaveBecauseNoChanges": "Cannot save because there are no changes made",
        "changesDiscarded": "Changes have been discarded",
        "choose": "- Choose -",
        "clear": "Clear",
        "clearSelection": "Clear selection",
        "close": "Close",
        "completed": "Completed",
        "continue": "Continue",
        "copied": "Copied!",
        "create": "Create",
        "creating": "Creating",
        "currency": "Currency",
        "day": "day | days",
        "delete": "Delete",
        "deleting": "Deleting",
        "description": "Description",
        "deselectAll": "Deselect all",
        "discard": "Discard",
        "discardChanges": "Discard changes",
        "discarding": "Discarding",
        "done": "Done",
        "download": "Download",
        "downloadTemplate": "Download template",
        "downloading": "Downloading",
        "dragToReorder": "Drag to re-order",
        "due": "Due",
        "edit": "Edit",
        "errorAndRetry": "There was an error loading the data.",
        "export": "Export",
        "exported": "Exported",
        "exporting": "Exporting",
        "feedbackError": "We couldn't send the feedback right now. Please try again later or contact customer success if the problem persists",
        "feedbackInfo": "Thank you for wanting to share your thoughts and opinions about our beta feature! 🎉 With your help, we can improve the feature and create an even better user experience.",
        "fileFormat": "File format",
        "gender": "Gender",
        "giveFeedback": "Give feedback",
        "goToLabs": "Go to labs",
        "help": "Help",
        "higher": "Higher",
        "historical": "Historical",
        "import": "Import",
        "importFile": "Import file",
        "importSalary": "Import salary",
        "importTemplate": "Import template",
        "inProgress": "In progress",
        "incompleteTranslation": "Some texts in this language are missing and will appear in English.",
        "information": "Information",
        "instanceChanged": "The active instance has changed",
        "instanceChangedButton": "Continue on",
        "instanceChangedDescription": "While you were away the active instance changed. Make sure it's the one you expected to be on.",
        "instanceChangedDescriptionMore": "Use the button below to contine on the new instance.",
        "invalidDate": "Invalid date",
        "labs": "Labs",
        "languages": {
            "en": "English",
            "es": "Spanish",
            "fr": "French",
            "nb": "Norwegian",
            "nl": "Dutch",
            "selectLanguage": "Select language",
            "sv": "Swedish"
        },
        "lastPublished": "Last published",
        "less": "Less",
        "lessThanOneMonth": "Less than a month",
        "loading": "Loading...",
        "loggedOut": "Logged out",
        "loggingIn": "Logging in",
        "logout": "Logout",
        "lower": "Lower",
        "markFinishedButton": "Mark as done",
        "men": "Men",
        "missingTranslation": "Translation missing",
        "moduleNotAvailable": "This module is currently unavailable.",
        "month": "month | months",
        "more": "More",
        "myUser": "My account",
        "name": "Name",
        "new": "New",
        "next": "Next",
        "no": "No",
        "noData": "There is no data at the moment",
        "noModuleAccessText": "You don't have access to this page. If you think you should, contact your HR department.",
        "noModuleAccessTitle": "This page isn't available to you",
        "noSearchResults": "No matches found",
        "noValue": "No value",
        "nonSelected": "No values selected",
        "none": "None",
        "notAllowed": "You are not permitted to perform that action.",
        "notAnalysed": "Not analysed",
        "notSelected": "Not selected",
        "notStarted": "Not started",
        "of": "of",
        "offline": "No internet connection",
        "ok": "Ok",
        "only": "Only",
        "open": "Open",
        "or": "or",
        "organisationNodesSelected": "{count} organisation nodes selected",
        "other": "Other",
        "overdue": "Overdue",
        "password": "Password",
        "percentIsTranslated": "{count} is translated",
        "pleaseRetry": "Please retry",
        "previous": "Previous",
        "proceed": "Proceed",
        "readLess": "Read less",
        "readMore": "Read more",
        "relative": "Relative",
        "reload": "Refresh",
        "rememberMe": "Remember me",
        "remove": "Remove",
        "reset": "Reset",
        "resetPassword": "Reset password",
        "retry": "Retry",
        "rightClick": "Right-click",
        "roles": {
            "administrator": "Administrator",
            "consultant": "Consultant",
            "developer": "Developer",
            "employee": "Employee",
            "fromEnum": {
                "10": "Root",
                "100": "Union",
                "110": "Pay equity audit assistant",
                "120": "HR Business Partner",
                "130": "Deputy manager",
                "20": "System administrator",
                "30": "Consultant",
                "40": "Employee",
                "50": "Manager",
                "60": "Section manager",
                "70": "Operational administrator",
                "80": "Administrator",
                "90": "Read only"
            },
            "manager": "Manager",
            "operationalAdministrator": "Operational administrator",
            "readOnly": "Read only",
            "root": "Root",
            "salarySurveyAnalyst": "HR Business Partner",
            "salarySurveyAssistant": "Pay equity audit assistant",
            "sectionManager": "Section manager",
            "support": "Support",
            "union": "Union"
        },
        "save": "Save",
        "saveAndClose": "Close",
        "saveError": "Error when saving!",
        "saved": "Saved",
        "saving": "Saving...",
        "search": "Search...",
        "select": "Select",
        "selectAll": "Select all",
        "selectCompany": "Select company",
        "selectRole": "Select role",
        "selectZoomLevel": "Select zoom level",
        "selected": "Selected",
        "send": "Send",
        "sendingFeedback": "Sending feedback",
        "settings": "Settings",
        "shortMonth": "mo",
        "show": "Show",
        "showDuplicates": "Show duplicates",
        "showMore": "Show more",
        "skipToMainContent": "Skip to main content",
        "smallScreenResolution": "This module only works on bigger screen sizes.",
        "sysarb": "Sysarb",
        "template": "Template",
        "thankYouForYourFeedBackInformation": "We will get back to you on what we'll do with your input. If it concerns a bug, we will inform you when we start to address it and keep you in the loop.",
        "thankYouForYourFeedback": "Thank you for your feedback!",
        "total": "Total",
        "undoMarkFinishedButton": "Mark as not done",
        "unreadNotifications": "unread notifications",
        "update": "Update",
        "username": "Username",
        "women": "Women",
        "year": "years | year | years",
        "yes": "Yes",
        "youSaved": "You saved",
        "yourFeedback": "Your feedback",
        "zoomIn": "Zoom in",
        "zoomOut": "Zoom out"
    },
    "totalSalarySet": {
        "baseSalary": "Base salary",
        "benefitsInKind": "Benefits in kind",
        "carAllowance": "Car allowance",
        "longTermIncentive": "Actual long term incentives",
        "occupationalPension": "Occupational pension",
        "oneTimeIncentive": "One time incentive",
        "overtimeCompensation": "Overtime compensation",
        "paidHolidayAllowance": "Paid holiday allowance",
        "salaryIncrement1": "Salary increment 1",
        "salaryIncrement2": "Salary increment 2",
        "salaryIncrement3": "Salary increment 3",
        "shortTermIncentive": "Actual short term incentives"
    },
    "validation": {
        "field_not_unique": "{field} must be unique",
        "field_too_big": "{field} must be at most {max} characters",
        "field_too_short": "{field} must be at least {min} characters",
        "numberMinMax": "Number must be between {min} and {max}",
        "numberRequired": "Number value is required",
        "required": "This field is required"
    },
    "workSplit": {
        "jobArchitecture": {
            "0": "Job profile + Grade",
            "1": "Subfamily + grade",
            "2": "Job family + grade",
            "3": "Grade"
        },
        "jobEvaluation": {
            "0": "Previous Audit",
            "1": "Position",
            "2": "Statistical Code",
            "3": "Custom",
            "statutory_grade": "Statutory grade"
        }
    },
    "yes": "Yes"
}
